webpackJsonp([16],{

/***/ 1237:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(486);

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__(1292);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Isomorphic CSS style loader for Webpack
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

var prefix = 's';
var inserted = {};

// Base64 encoding and decoding - The "Unicode Problem"
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

/**
 * Remove style/link elements for specified node IDs
 * if they are no longer referenced by UI components.
 */
function removeCss(ids) {
  ids.forEach(function (id) {
    if (--inserted[id] <= 0) {
      var elem = document.getElementById(prefix + id);
      if (elem) {
        elem.parentNode.removeChild(elem);
      }
    }
  });
}

/**
 * Example:
 *   // Insert CSS styles object generated by `css-loader` into DOM
 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
 *
 *   // Remove it from the DOM
 *   removeCss();
 */
function insertCss(styles) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$replace = _ref.replace,
      replace = _ref$replace === undefined ? false : _ref$replace,
      _ref$prepend = _ref.prepend,
      prepend = _ref$prepend === undefined ? false : _ref$prepend;

  var ids = [];
  for (var i = 0; i < styles.length; i++) {
    var _styles$i = (0, _slicedToArray3.default)(styles[i], 4),
        moduleId = _styles$i[0],
        css = _styles$i[1],
        media = _styles$i[2],
        sourceMap = _styles$i[3];

    var id = moduleId + '-' + i;

    ids.push(id);

    if (inserted[id]) {
      if (!replace) {
        inserted[id]++;
        continue;
      }
    }

    inserted[id] = 1;

    var elem = document.getElementById(prefix + id);
    var create = false;

    if (!elem) {
      create = true;

      elem = document.createElement('style');
      elem.setAttribute('type', 'text/css');
      elem.id = prefix + id;

      if (media) {
        elem.setAttribute('media', media);
      }
    }

    var cssText = css;
    if (sourceMap && typeof btoa === 'function') {
      // skip IE9 and below, see http://caniuse.com/atob-btoa
      cssText += '\n/*# sourceMappingURL=data:application/json;base64,' + b64EncodeUnicode((0, _stringify2.default)(sourceMap)) + '*/';
      cssText += '\n/*# sourceURL=' + sourceMap.file + '?' + id + '*/';
    }

    if ('textContent' in elem) {
      elem.textContent = cssText;
    } else {
      elem.styleSheet.cssText = cssText;
    }

    if (create) {
      if (prepend) {
        document.head.insertBefore(elem, document.head.childNodes[0]);
      } else {
        document.head.appendChild(elem);
      }
    }
  }

  return removeCss.bind(null, ids);
}

module.exports = insertCss;

/***/ }),

/***/ 1238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(316);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(311);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(313);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(314);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(315);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1289);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(1278);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var contextTypes = {
  insertCss: _propTypes2.default.func
}; /**
    * Isomorphic CSS style loader for Webpack
    *
    * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE.txt file in the root directory of this source tree.
    */

function withStyles() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  return function wrapWithStyles(ComposedComponent) {
    var WithStyles = function (_Component) {
      (0, _inherits3.default)(WithStyles, _Component);

      function WithStyles() {
        (0, _classCallCheck3.default)(this, WithStyles);
        return (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).apply(this, arguments));
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          var _context;

          this.removeCss = (_context = this.context).insertCss.apply(_context, styles);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.removeCss) {
            setTimeout(this.removeCss, 0);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(ComposedComponent, this.props);
        }
      }]);
      return WithStyles;
    }(_react.Component);

    var displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';

    WithStyles.displayName = 'WithStyles(' + displayName + ')';
    WithStyles.contextTypes = contextTypes;
    WithStyles.ComposedComponent = ComposedComponent;

    return (0, _hoistNonReactStatics2.default)(WithStyles, ComposedComponent);
  };
}

exports.default = withStyles;

/***/ }),

/***/ 1239:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),

/***/ 1240:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(87)) === 'object' && __webpack_require__(87)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ 1241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_locale__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      var _this$props = _this.props,
          to = _this$props.to,
          locale = _this$props.locale;


      if (_this.props.onClick) {
        _this.props.onClick(event);
      }

      if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
        return;
      }

      if (event.defaultPrevented === true) {
        return;
      }

      event.preventDefault();

      if (to) {
        __WEBPACK_IMPORTED_MODULE_3_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_4__helpers_locale__["h" /* toLocalized */](to, locale));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          to = _props.to,
          locale = _props.locale,
          children = _props.children,
          elementRef = _props.elementRef,
          shouldSetNoIndex = _props.shouldSetNoIndex,
          dispatch = _props.dispatch,
          props = _objectWithoutProperties(_props, ['to', 'locale', 'children', 'elementRef', 'shouldSetNoIndex', 'dispatch']);

      var title = typeof children === 'string' ? children : '';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        _extends({
          title: title,
          href: __WEBPACK_IMPORTED_MODULE_4__helpers_locale__["h" /* toLocalized */](to, locale)
        }, props, {
          ref: elementRef,
          onClick: this.handleClick
        }),
        children
      );
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.defaultProps = {
  shouldSetNoIndex: false,
  onClick: null,
  children: '',
  elementRef: undefined,
  dispatch: undefined,
  to: undefined
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](function (_ref2) {
  var locale = _ref2.globals.locale;
  return { locale: locale };
})(Link));

/***/ }),

/***/ 1242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withTranslate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var withTranslate = function withTranslate(WrappedComponent) {
  var _class, _temp2;

  return __WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */]((_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.t = function (string) {
        var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

        if (!string) {
          return '';
        }

        return _this.props.intl.formatMessage({ id: string }, values);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { t: this.t }));
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withTranslate(' + __WEBPACK_IMPORTED_MODULE_2__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp2));
};

/***/ }),

/***/ 1243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__payment__ = __webpack_require__(308);
var _business, _advert;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var ADVERT_CLICK = 'clickAddAdButton_';
// const SERVICE = 'service';
var TARIFF_PLAN = 'tariffplan';
var SERVICE = 'service';
var TARIFF_PLAN_BUSINESS = 'tariffplan_business';
var SERVICE_BUSINESS = 'service_business';
var C2C_SLOT = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_SLOT,
    C2C_SINGLE = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_SINGLE,
    C2C_TURBO = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_TURBO,
    C2C_FAST = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_FAST;


var EVENTS = {
  MOBILE: {
    sendMessageToOwner: { event: 'sendlOwnerMessage_button' },
    registrationSuccess: { event: 'successRegistration' },
    adSent0: { event: 'clickAddAdButton_Free' },
    adSent1: { event: 'clickAddAdButton_109' },
    adSent2: { event: 'clickAddAdButton_199' },
    adSent3: { event: 'clickAddAdButton_299' },
    // Page types
    pageMain: { pageType: 'mainpage' },
    pageAdCard: { pageType: 'Ad_card' },
    pageDealer: { pageType: 'Dealer_Page' },
    pageSearch: { pageType: 'catalog' },
    pageAddAdvMainInfo: { pageType: 'Step 1' },
    pageAddAdvContactsPhoto: { pageType: 'Step 2' },
    pageAddAdvSellCar: { pageType: 'Step 3' },

    //
    pageDealers: { pageType: 'Dealers_Page' },
    pageProfile: { pageType: 'Profile_Page' },
    pageGeo: { pageType: 'Geo_Page' },
    pageFilters: { pageType: 'Filters_Page' },
    pageFavorites: { pageType: 'Favorites_Page' }
  },
  // Adverts
  AddCarNumberButton: { event: 'Add__NumberButton' },
  AddChooseBrand: { event: 'Add__ChooseBrand' },
  AddPhotoAdded: { event: 'Add__PhotoAdded' },
  AddPhotoDeleted: { event: 'Add__PhotoDeleted' },
  AddPhotoSort: { event: 'Add__PhotoSort' },
  AddSubmit: { event: 'Add__Submit' },
  AddSubmitFinal: { event: 'Add__SubmitFinall' },
  AddClearWarningMessageAndSubmit: { event: 'Add__SubmitAfterError' },
  AddSubmitForm: { event: 'Add__SubmitForm' },
  AddNextButtonCommon: { event: 'Add__NextButtonAll' },
  AddCommonPublishButton: { event: 'Add__PublishButtonAll' },
  // AddNextButton1: { event: 'Add__NextButton-1' },
  // AddNextButton2: { event: 'Add__NextButton-2' },
  // AddNextButton3: { event: 'Add__NextButton-3' },
  // AddNextButton4: { event: 'Add__NextButton-4' },

  AddCarBrandGroup: { event: 'AddCarBrandGroup' },
  freeAdSent: { event: 'freeAdSent' },
  turboAdvert: { event: ADVERT_CLICK + '333_Turbo' },
  fastAdvert: { event: ADVERT_CLICK + '198_Quick' },
  freeAll: { event: ADVERT_CLICK + '555_All' },
  freeUp: { event: ADVERT_CLICK + '105_Autopromotion' },
  freeVip: { event: ADVERT_CLICK + '225_VIP' },
  freeCol: { event: ADVERT_CLICK + '75_Colour' },
  freeTop: { event: ADVERT_CLICK + '150_TOP' },
  freeUpVipCol: { event: ADVERT_CLICK + '405_Auto+VIP+Colour' },
  freeUpVip: { event: ADVERT_CLICK + '330_Auto+VIP' },
  freeUpCol: { event: ADVERT_CLICK + '180_Auto+Colour' },
  freeUpTop: { event: ADVERT_CLICK + '150_Auto+Top' },
  freeUpTopCol: { event: ADVERT_CLICK + '225_Auto+Top+Colour' },
  freeVipVolTop: { event: ADVERT_CLICK + '450_VIP+Colour+Top' },
  freeVipCol: { event: ADVERT_CLICK + '300_Vip+Colour' },
  freeVipTop: { event: ADVERT_CLICK + '375_Vip+Top' },
  freeVipTopUp: { event: ADVERT_CLICK + '480_Vip+Top+Auto' },
  freeColTop: { event: ADVERT_CLICK + '225_Colour+Top' },
  //
  addToFavorites: { event: 'likeCar_button' },
  sellCarButtonClick: { event: 'sellCarr_Button' },
  seeReviews: { event: 'see_review_Button' },
  showPhoneClick: { event: 'showPhone_button' },
  sendTestDriveForm: { event: 'sendTestDrive_Form' },
  dealerSiteRedirect: { event: 'goDealerSite_Button' },
  showAllDealerAdverts: { event: 'showAllDealerCars_Button' },
  successLogin: { event: 'successRegistration' },
  callOwner: { event: 'callOwner_button' },
  searchButtonClick: { event: 'pressSearchButton' },
  paidAdSent: { event: 'paidAdSent' },
  advert: (_advert = {
    'balance-refill': { event: 'balance_refil' }
  }, _defineProperty(_advert, C2C_SLOT, { event: TARIFF_PLAN + '/4/' }), _defineProperty(_advert, 'sp-slot', { event: TARIFF_PLAN + '/25/' }), _defineProperty(_advert, C2C_SINGLE, { event: TARIFF_PLAN + '/31/' }), _defineProperty(_advert, 'update', { event: SERVICE + '/1/' }), _defineProperty(_advert, 'vip', { event: SERVICE + '/2/' }), _defineProperty(_advert, 'top', { event: SERVICE + '/4/' }), _defineProperty(_advert, 'color', { event: SERVICE + '/3/' }), _defineProperty(_advert, C2C_TURBO, { event: TARIFF_PLAN + '/6/' }), _defineProperty(_advert, C2C_FAST, { event: TARIFF_PLAN + '/5/' }), _defineProperty(_advert, 'b2c', { event: TARIFF_PLAN_BUSINESS + '/2/' }), _defineProperty(_advert, 'business', (_business = {}, _defineProperty(_business, C2C_SINGLE, { event: TARIFF_PLAN_BUSINESS + '/31/' }), _defineProperty(_business, 'b2c', { event: TARIFF_PLAN_BUSINESS + '/2/' }), _defineProperty(_business, 'update', { event: SERVICE_BUSINESS + '/1/' }), _defineProperty(_business, 'vip', { event: SERVICE_BUSINESS + '/2/' }), _defineProperty(_business, 'top', { event: SERVICE_BUSINESS + '/4/' }), _defineProperty(_business, 'color', { event: SERVICE_BUSINESS + '/3/' }), _defineProperty(_business, C2C_FAST, { event: TARIFF_PLAN_BUSINESS + '/5/' }), _defineProperty(_business, C2C_TURBO, { event: TARIFF_PLAN_BUSINESS + '/6/' }), _defineProperty(_business, 'spareparts-500', { event: TARIFF_PLAN_BUSINESS + '/7/' }), _defineProperty(_business, 'spareparts-1000', { event: TARIFF_PLAN_BUSINESS + '/8/' }), _defineProperty(_business, 'spareparts-2000', { event: TARIFF_PLAN_BUSINESS + '/9/' }), _defineProperty(_business, 'spareparts-3000', { event: TARIFF_PLAN_BUSINESS + '/10/' }), _defineProperty(_business, 'spareparts-unlim', { event: TARIFF_PLAN_BUSINESS + '/11/' }), _defineProperty(_business, 'spareparts-batch-update-20', { event: TARIFF_PLAN_BUSINESS + '/18/' }), _defineProperty(_business, 'spareparts-batch-update-35', { event: TARIFF_PLAN_BUSINESS + '/19/' }), _defineProperty(_business, 'spareparts-batch-update-70', { event: TARIFF_PLAN_BUSINESS + '/20/' }), _defineProperty(_business, 'spareparts-batch-update-100', { event: TARIFF_PLAN_BUSINESS + '/21/' }), _defineProperty(_business, 'spareparts-batch-update-150', { event: TARIFF_PLAN_BUSINESS + '/22/' }), _defineProperty(_business, 'spareparts-batch-update-200', { event: TARIFF_PLAN_BUSINESS + '/23/' }), _defineProperty(_business, 'spareparts-batch-update-400', { event: TARIFF_PLAN_BUSINESS + '/24/' }), _business)), _defineProperty(_advert, 'dealership', {
    'spareparts-500': { event: TARIFF_PLAN + '/7/' },
    'spareparts-1000': { event: TARIFF_PLAN + '/8/' },
    'spareparts-2000': { event: TARIFF_PLAN + '/9/' },
    'spareparts-3000': { event: TARIFF_PLAN + '/10/' },
    'spareparts-unlim': { event: TARIFF_PLAN + '/11/' },
    'spareparts-batch-update-20': { event: TARIFF_PLAN + '/18/' },
    'spareparts-batch-update-35': { event: TARIFF_PLAN + '/19/' },
    'spareparts-batch-update-70': { event: TARIFF_PLAN + '/20/' },
    'spareparts-batch-update-100': { event: TARIFF_PLAN + '/21/' },
    'spareparts-batch-update-150': { event: TARIFF_PLAN + '/22/' },
    'spareparts-batch-update-200': { event: TARIFF_PLAN + '/23/' },
    'spareparts-batch-update-400': { event: TARIFF_PLAN + '/24/' }
  }), _advert),
  leasing: {
    'data-lens-event': { event: 'leasingRequestClick' },
    'page-view': { event: 'leasingPageView' },

    // Automoney
    'automoney-monthly-calculation-show-form-click': {
      event: 'automoney-LeasingMonthly-Calculation-Show-Form-Click'
    },
    'automoney-monthly-calculation-form-sumbit': {
      event: 'automoney-LeasingMonthly-Calculation-Form-Sumbit'
    },
    'automoney-monthly-consultation-form-sumbit': {
      event: 'automoney-LeasingMonthly-Consultation-Form-Submit'
    },
    'automoney-questions-form-sumbit': { event: 'automoney-leasingMonthly-questions-Form-Submit' },
    'automoney-lead-create-success': { event: 'automoney-lead-created-success' },
    'automoney-lead-create-fail': { event: 'automoney-lead-create-fail' },
    'automoney-monthly-calculation-show-form-click-advertcard': {
      event: 'automoney-leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'automoney-monthly-calculation-form-sumbit-advertcard': {
      event: 'automoney-leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'automoney-monthly-consultation-form-sumbit-advertcard': {
      event: 'automoney-leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    'automoney-lead-create-success-advertcard': {
      event: 'automoney-myauto-lead-create-success-advertCard'
    },
    'automoney-lead-create-fail-advertcard': {
      event: 'automoney-myauto-lead-create-fail-advertCard'
    },

    // Microcredit
    'microcredit-consultation-show-form-click': {
      event: 'microcredit-Consultation-Show-Form-Click'
    },
    'microcredit-consultation-form-sumbit': { event: 'microcredit-Consultation-Form-Submit' },
    'microcredit-lead-create-success': { event: 'microcredit-lead-created-success' },
    'microcredit-lead-create-fail': { event: 'microcredit-lead-create-fail' },

    'microcredit-consultation-show-form-click-advertcard': {
      event: 'microcredit-Consultation-Show-Form-Click-advertCard'
    },
    'microcredit-consultation-form-sumbit-advertcard': {
      event: 'microcredit-Consultation-Form-Submit-advertCard'
    },
    'microcredit-lead-create-success-advertcard': {
      event: 'microcredit-lead-created-success-advertCard'
    },
    'microcredit-lead-create-fail-advertcard': { event: 'microcredit-lead-create-fail-advertCard' },

    // Creditmarket
    'creditmarket-consultation-show-form-click': {
      event: 'creditmarket-Consultation-Show-Form-Click'
    },
    'creditmarket-consultation-form-sumbit': { event: 'creditmarket-Consultation-Form-Submit' },
    'creditmarket-lead-create-success': { event: 'creditmarket-lead-created-success' },
    'creditmarket-lead-create-fail': { event: 'creditmarket-lead-create-fail' },

    'creditmarket-consultation-show-form-click-advertcard': {
      event: 'creditmarket-Consultation-Show-Form-Click-advertCard'
    },
    'creditmarket-consultation-form-sumbit-advertcard': {
      event: 'creditmarket-Consultation-Form-Submit-advertCard'
    },
    'creditmarket-lead-create-success-advertcard': {
      event: 'creditmarket-lead-created-success-advertCard'
    },
    'creditmarket-lead-create-fail-advertcard': {
      event: 'creditmarket-lead-create-fail-advertCard'
    },
    'creditmarket-questions-form-sumbit': {
      event: 'creditmarket-leasingMonthly-questions-Form-Submit'
    },

    // MyAuto
    'monthly-calculation-show-form-click': { event: 'leasingMonthly-Calculation-Show-Form-Click' },
    'monthly-calculation-form-sumbit': { event: 'leasingMonthly-Calculation-Form-Sumbit' },
    'monthly-consultation-form-sumbit': { event: 'leasingMonthly-Consultation-Form-Submit' },
    'questions-form-sumbit': { event: 'leasingMonthly-questions-Form-Submit' },
    'lead-create-success-questions': { event: 'lead-create-success-questions' },
    'lead-create-fail-questions': { event: 'lead-create-fail-questions' },
    'lead-create-success': { event: 'lead-create-success' },
    'lead-create-fail': { event: 'lead-create-fail' },
    'monthly-calculation-show-form-click-advertcard': {
      event: 'leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'monthly-calculation-form-sumbit-advertcard': {
      event: 'leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'monthly-consultation-form-sumbit-advertcard': {
      event: 'leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    // 'questions-form-sumbit-advertcard': { event: `leasingMonthly-questions-Form-Submit-advertCard` },
    'lead-create-success-advertcard': { event: 'lead-create-success-advertCard' },
    'lead-create-fail-advertcard': { event: 'lead-create-fail-advertCard' },
    'lead-create-success-advertcard-sidebar': { event: 'lead-create-success-advertCard-sidebar' },
    'lead-create-fail-advertcard-sidebar': { event: 'lead-create-fail-advertCard-sidebar' },

    // Hapai
    'hapai-monthly-calculation-show-form-click': {
      event: 'hapai-LeasingMonthly-Calculation-Show-Form-Click'
    },
    'hapai-monthly-calculation-form-sumbit': {
      event: 'hapai-LeasingMonthly-Calculation-Form-Sumbit'
    },
    'hapai-monthly-consultation-form-sumbit': {
      event: 'hapai-LeasingMonthly-Consultation-Form-Submit'
    },
    'hapai-questions-form-sumbit': { event: 'hapai-leasingMonthly-questions-Form-Submit' },
    'hapai-lead-create-success': { event: 'hapai-lead-created-success' },
    'hapai-lead-create-success-questions': { event: 'hapai-lead-create-success-questions' },
    'hapai-lead-create-fail-questions': { event: 'hapai-lead-create-fail-questions' },
    'hapai-lead-create-fail': { event: 'hapai-lead-create-fail' },
    'hapai-monthly-calculation-show-form-click-advertcard': {
      event: 'hapai-leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'hapai-monthly-calculation-form-sumbit-advertcard': {
      event: 'hapai-leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'hapai-monthly-consultation-form-sumbit-advertcard': {
      event: 'hapai-leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    // 'hapai-questions-form-sumbit-advertcard': { event: `hapai-leasingMonthly-questions-Form-Submit-advertCard` },
    'hapai-lead-create-success-advertcard': { event: 'hapai-lead-create-success-advertCard' },
    'hapai-lead-create-fail-advertcard': { event: 'hapai-lead-create-fail-advertCard' },
    'hapai-lead-create-success-advertcard-sidebar': {
      event: 'hapai-lead-create-success-advertCard-sidebar'
    },
    'hapai-lead-create-fail-advertcard-sidebar': {
      event: 'hapai-lead-create-fail-advertCard-sidebar'
    },

    // Ulf24
    'ulf24-monthly-calculation-show-form-click': {
      event: 'ulf24-LeasingMonthly-Calculation-Show-Form-Click'
    },
    'ulf24-monthly-calculation-form-sumbit': {
      event: 'ulf24-LeasingMonthly-Calculation-Form-Sumbit'
    },
    'ulf24-monthly-consultation-form-sumbit': {
      event: 'ulf24-LeasingMonthly-Consultation-Form-Submit'
    },
    'ulf24-questions-form-sumbit': { event: 'ulf24-leasingMonthly-questions-Form-Submit' },
    'ulf24-lead-create-success': { event: 'ulf24-lead-created-success' },
    'ulf24-lead-create-fail': { event: 'ulf24-lead-create-fail' },
    'ulf24-monthly-calculation-show-form-click-advertcard': {
      event: 'ulf24-leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'ulf24-monthly-calculation-form-sumbit-advertcard': {
      event: 'ulf24-leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'ulf24-monthly-consultation-form-sumbit-advertcard': {
      event: 'ulf24-leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    // 'ulf24-questions-form-sumbit-advertcard': { event: `ulf24-leasingMonthly-questions-Form-Submit-advertCard` },
    'ulf24-lead-create-success-advertcard': {
      event: 'ulf24-myauto-lead-create-success-advertCard'
    },
    'ulf24-lead-create-fail-advertcard': { event: 'ulf24-myauto-lead-create-fail-advertCard' },

    'ulf24-monthly-consultation-form-sumbit-advertcard-sidebar': {
      event: 'ulf24-leasingMonthly-Consultation-Form-Submit-advertCard-sidebar'
    },
    'ulf24-lead-create-success-advertcard-sidebar': {
      event: 'ulf24-lead-create-success-advertCard-sidebar'
    },
    'ulf24-lead-create-fail-advertcard-sidebar': {
      event: 'ulf24-lead-create-fail-advertCard-sidebar'
    },

    // Other events
    online: {
      'Popup-Used-Click': { event: 'leasingOnline-Popup-Used-Click' },
      'Popup-New-Click': { event: 'leasingOnline-Popup-New-Click' },
      'Sidebar-Used-Click': { event: 'leasingOnline-Sidebar-Used-Click' },
      'Sidebar-New-Click': { event: 'leasingOnline-Sidebar-New-Click' },
      LinkUnderThePrice: { event: 'leasingOnline_LinkUnderThePrice' }
    },
    consultation: {
      'Popup-Used-Click': { event: 'leasingConsultation-Popup-Used-Click' },
      'Popup-New-Click': { event: 'leasingConsultation-Popup-New-Click' },
      'Sidebar-Used-Click': { event: 'leasingConsultation-Sidebar-Used-Click' },
      'Sidebar-New-Click': { event: 'leasingConsultation-Sidebar-New-Click' },
      'Hapai-Popup-Used-Click': { event: 'hapai-leasingConsultation-Popup-Used-Click' },
      'Hapai-Popup-New-Click': { event: 'hapai-leasingConsultation-Popup-New-Click' },
      'Hapai-Sidebar-Used-Click': { event: 'hapai-leasingConsultation-Sidebar-Used-Click' },
      'Hapai-Sidebar-New-Click': { event: 'hapai-leasingConsultation-Sidebar-New-Click' },
      'Ulf24-Popup-Used-Click': { event: 'ulf24-leasingConsultation-Popup-Used-Click' },
      'Ulf24-Popup-New-Click': { event: 'ulf24-leasingConsultation-Popup-New-Click' },
      'Ulf24-Sidebar-Used-Click': { event: 'ulf24-leasingConsultation-Sidebar-Used-Click' },
      'Ulf24-Sidebar-New-Click': { event: 'ulf24-leasingConsultation-Sidebar-New-Click' }
    },

    codeVerification: {
      'Popup-Used-Click': { event: 'leasingOnlineCodeVerification-Popup-Used-Click' },
      'Popup-New-Click': { event: 'leasingOnlineCodeVerification-Popup-New-Click' },
      'Sidebar-Used-Click': { event: 'leasingOnlineCodeVerification-Sidebar-Used-Click' },
      'Sidebar-New-Click': { event: 'leasingOnlineCodeVerification-Sidebar-New-Click' }
    }
  },

  NAVIGATION_LINK: {
    'headerNavigation/avto/avtosalony/': { event: 'avtosalony_nav_legkovye' },
    'headerNavigation/avtosalony/': { event: 'avtosalony_nav_avtosalony' },
    'headerNavigation/avtosalony/avtosalony/avto/': { event: 'avtosalony_nav_avtosalony_avto' },
    'subHeader/avtosalony/': { event: 'avtosalony_sub-nav_avtosalony' }
  },

  DEALERS: {
    showNubmer: { event: 'avtosalony_listing_show-nubmer' },
    testDrive: { event: 'avtosalony_listing_test-drive' },
    tradeIn: { event: 'avtosalony_listing_trade-in' },

    formTestDrive: { event: 'avtosalony_listing_form_test-drive' },
    formTradeIn: { event: 'avtosalony_listing_form_trade-in' }
  },

  DEALER_ADV: {
    showNubmer: { event: 'avtosalony_car_show-number' },
    tradeIn: { event: 'avtosalony_car_trade-in' },
    testDrive: { event: 'avtosalony_car_testDrive' },
    callback: { event: 'avtosalony_car_callback' },

    formTradeIn: { event: 'avtosalony_car_form_trade-in' },
    formTestDrive: { event: 'avtosalony_car_form_testDrive' },
    formCallback: { event: 'avtosalony_car_form_callback' }
  },

  DEALER_CARD: {
    showNubmer: { event: 'avtosalony_card_show-number' },
    goToSite: { event: 'avtosalony_card_site' },

    tradeIn: { event: 'avtosalony_card_trade-in' },
    testDrive: { event: 'avtosalony_card_test-drive' },

    formTradeIn: { event: 'avtosalony_card_form_trade-in' },
    formTestDrive: { event: 'avtosalony_card_form_test-drive' }
  }
};

/***/ }),

/***/ 1244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withFetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_components_App__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var withFetch = function withFetch(WrappedComponent) {
  var Component = function Component(props) {
    return _jsx(__WEBPACK_IMPORTED_MODULE_1_shared_components_App__["a" /* ContextConsumer */], {}, void 0, function (_ref) {
      var fetch = _ref.fetch;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, props, { fetch: fetch }));
    });
  };
  Component.displayName = 'withFetch(' + __WEBPACK_IMPORTED_MODULE_2__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')';

  return Component;
};

/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1309);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./UIStyle.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./UIStyle.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1356)();
}

/***/ }),

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__ = __webpack_require__(1261);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// Helpers

var withInjectLocations = function withInjectLocations() {
  for (var _len = arguments.length, locationTypes = Array(_len), _key = 0; _key < _len; _key++) {
    locationTypes[_key] = arguments[_key];
  }

  return function (item) {
    return _extends({}, item, {
      injectLocations: locationTypes
    });
  };
};

//

var avto = [{
  title: 'Объявления',
  route: '/avto/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].COUNTRY, __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
},
// {
//   title: 'Каталог',
//   route: '/avto/catalog',
// },
{
  title: 'Автосалоны',
  route: '/avtosalony/',
  slug: '/avtosalony/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var moto = [{
  title: 'Мотоциклы',
  route: '/mototsikl/',
  slug: '/mototsikl/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Скутеры',
  route: '/skuter/',
  slug: '/skuter/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Картинг',
  route: '/karting/',
  slug: '/karting/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Квадроциклы',
  route: '/kvadrotsikl/',
  slug: '/kvadrotsikl/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Мопеды',
  route: '/moped/',
  slug: '/moped/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Багги',
  route: '/baggi/',
  slug: '/baggi/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Трициклы',
  route: '/tritsikl/',
  slug: '/tritsikl/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var truck = [{
  title: 'Грузовики',
  route: '/gruzovye/',
  slug: '/gruzovye/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Автобусы',
  route: '/avtobus/',
  slug: '/avtobus/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Прицепы',
  route: '/pritsepy/',
  slug: '/pritsepy/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Водный транспорт',
  route: '/vodnyi-transport/',
  slug: '/vodnyi-transport/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Спецтехника',
  route: '/spetstehnika/',
  slug: '/spetstehnika/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var AVTOSALONS_LINKS = [{
  title: 'Авто',
  route: '/avtosalony/',
  slug: '/avtosalony/avto/'
}, {
  title: 'Мото',
  route: '/avtosalony/mototsikl/',
  slug: '/avtosalony/mototsikl/'
}, {
  title: 'Автобусы',
  route: '/avtosalony/avtobus/',
  slug: '/avtosalony/avtobus/'
}, {
  title: 'Грузовики',
  route: '/avtosalony/gruzovye/',
  slug: '/avtosalony/gruzovye/'
}, {
  title: 'Водный транспорт',
  route: '/avtosalony/vodnyi-transport/',
  slug: '/avtosalony/vodnyi-transport/'
}, {
  title: 'Спецтехника',
  route: '/avtosalony/spetstehnika/',
  slug: '/avtosalony/spetstehnika/'
}, {
  title: 'Прицепы',
  route: '/avtosalony/pritsepy/',
  slug: '/avtosalony/pritsepy/'
}];

var FIRMS_TAGS_LINKS = [{
  title: 'СТО',
  route: '/katalog-kompaniy/sto/',
  slug: '/katalog-kompaniy/sto/'
}, {
  title: 'Авторазборка',
  route: '/katalog-kompaniy/avtorazborka/',
  slug: '/katalog-kompaniy/avtorazborka//'
}, {
  title: 'Автовыкуп',
  route: '/katalog-kompaniy/avtovykup/',
  slug: '/katalog-kompaniy/avtovykup/'
}, {
  title: 'Запчасти',
  route: '/katalog-kompaniy/zapchasti/',
  slug: '/katalog-kompaniy/zapchasti/'
}, {
  title: 'Автотовары',
  route: '/katalog-kompaniy/avtotovary/',
  slug: '/katalog-kompaniy/avtotovary/'
}, {
  title: 'ТСЦ',
  route: '/katalog-kompaniy/teritorialni-servisni-centri/',
  slug: '/katalog-kompaniy/teritorialni-servisni-centri/'
}];

var HEADER = [{
  title: 'Легковые',
  route: '/avto/',
  name: 'avto',
  items: [{
    title: 'C пробегом',
    route: '/avto/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].COUNTRY, __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  }, {
    title: 'Новые',
    route: '/avto/novye/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  },
  // {
  //   title: 'Каталог',
  //   route: '/avto/catalog',
  // },
  {
    title: 'Автосалоны',
    route: '/avtosalony/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  }, {
    title: 'Лизинг авто',
    route: '/leasing/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  }],
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].COUNTRY, __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Мото',
  route: '/moto/',
  items: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Коммерческие',
  route: '/commercial/',
  items: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  // {
  //   title: 'Спецтехника',
  //   route: '/spetstehnika/',
  //   items: [
  //     {
  //       title: 'Автокран',
  //       route: '/avtokran',
  //     },
  //     {
  //       title: 'Бульдозеры',
  //       route: '/buldozer',
  //     },
  //     {
  //       title: 'Автопогрузчики',
  //       route: '/avtopogruzchik',
  //     },
  //     {
  //       title: 'Эскаваторы',
  //       route: '/ekskavator',
  //     },
  //     {
  //       title: 'Самопогрузчики',
  //       route: '/samopogruzchik',
  //     },
  //     {
  //       title: 'Коммунальная',
  //       route: '/kommunalnaya',
  //     },
  //     {
  //       title: 'Cтроительная техника',
  //       route: '/stroitelnaya',
  //     },
  //   ],
  // },
}, {
  title: 'Запчасти',
  route: '/zapchasti/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY],
  items: [
    // {
    //   title: 'Запчасти',
    //   route: '/zapchasti/',
    //   injectLocations: [LOCATION_TYPES.CITY],
    // },
    // {
    //   title: 'Новые',
    //   route: '/zapchasti?isNew=1',
    // },
    // {
    //   title: 'Б/y',
    //   route: '/zapchasti?isUsed=1',
    // },
    // {
    //   title: 'Каталог компаний',
    //   route: '/katalog-kompaniy/',
    //   injectLocations: [LOCATION_TYPES.CITY],
    // },
  ]
}, {
  title: 'Автосалоны',
  route: '/avtosalony/',
  items: AVTOSALONS_LINKS
}, {
  title: 'Каталог',
  route: '/katalog-kompaniy/sto/',
  items: FIRMS_TAGS_LINKS,
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
},
// {
//   title: 'Журнал',
//   route: '/zhurnal/',
//   items: [
//     {
//       title: 'Видео',
//       route: '/zhurnal/video/',
//     },
//     {
//       title: 'Новости',
//       route: '/zhurnal/',
//     },
//     {
//       title: 'Акции',
//       route: '/zhurnal/aktsii/',
//     },
//     {
//       title: 'Статьи',
//       route: '/zhurnal/stati/',
//     },
//     {
//       title: 'Тест-драйвы',
//       route: '/zhurnal/test-draiv/',
//     },
//     {
//       title: 'Обзоры',
//       route: '/zhurnal/obzory/',
//     },
//   ],
// },
{
  title: 'Сервисы',
  route: '/service/ocenka-avto/',
  items: [{
    title: 'Оценка стоимости авто',
    route: '/service/ocenka-avto/'
  }, {
    title: 'Пригон авто',
    route: '/service/prygon-avto/'
  }, {
    title: 'Страховка',
    route: '/insurance/orders/'
  }, {
    title: 'Подписки на поиск',
    route: '/service/search-subscriptions/'
  }]
}];

var FOOTER = [
//

{
  title: 'Разместить рекламу',
  route: '/advertising/'
}, {
  title: 'Бизнесу',
  route: '/biznes-paket/'
}, {
  title: 'Автосалонам',
  route: '/for-dealers/'
}, {
  title: 'Запчасти',
  route: '/info-zapchasti/'
}, {
  title: 'Автосервисам',
  route: '/for-services/'
}, {
  title: 'Помощь',
  route: '/help/'
}, {
  title: 'Частным лицам',
  route: '/for-privates/'
}];

var SPARES_LINKS = [{
  title: 'Авто',
  route: '/zapchasti/',
  slug: '/zapchasti/avto/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Мото',
  route: '/zapchasti/moto/',
  slug: '/zapchasti/moto/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Автобусы',
  route: '/zapchasti/avtobus/',
  slug: '/zapchasti/avtobus/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Грузовики',
  route: '/zapchasti/gruzovye/',
  slug: '/zapchasti/gruzovye/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Водный транспорт',
  route: '/zapchasti/vodnyi-transport/',
  slug: '/zapchasti/vodnyi-transport/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Спецтехника',
  route: '/zapchasti/spetstehnika/',
  slug: '/zapchasti/spetstehnika/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Прицепы',
  route: '/zapchasti/pritsepy/',
  slug: '/zapchasti/pritsepy/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var PROFILE = [{
  title: 'Мои объявления',
  route: '/my/'
}, {
  title: 'Сообщения',
  route: '/dialogs/'
}, {
  title: 'Баланс',
  route: '/billing/'
}, {
  title: 'Избранное',
  route: '/favorites/'
},
// {
//   title: 'Мои поиски',
//   route: '/my-searches',
// },
{
  title: 'Страховка',
  route: '/insurance/orders/'
}, {
  title: 'Подписки на поиск',
  route: '/service/search-subscriptions/'
}, {
  title: 'Настройки',
  route: '/profile/'
}];

var SEARCH = {
  avto: avto,
  //
  moto: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  mototsikl: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  skuter: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  karting: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  kvadrotsikl: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  tritsikl: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  moped: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  baggi: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  snegohod: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  //
  gruzovye: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  avtobus: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  pritsepy: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  spetstehnika: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  'vodnyi-transport': truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY))
};

var SPARES = [
  // {
  //   title: 'Запчасти',
  //   route: '/zapchasti/',
  // },
  // {
  //   title: 'Новые',
  //   route: '/zapchasti?isNew=1',
  // },
  // {
  //   title: 'Б/y',
  //   route: '/zapchasti?isUsed=1',
  // },
  // {
  //   title: 'Каталог компаний',
  //   route: '/katalog-kompaniy/',
  // },
];

var LINKS = {
  HEADER: HEADER,
  FOOTER: FOOTER,
  PROFILE: PROFILE,
  SEARCH: SEARCH,
  SPARES: SPARES,
  AVTOSALONS_LINKS: AVTOSALONS_LINKS,
  FIRMS_TAGS_LINKS: FIRMS_TAGS_LINKS,
  SPARES_LINKS: SPARES_LINKS,
  moto: moto
};

/* harmony default export */ __webpack_exports__["a"] = (LINKS);

/***/ }),

/***/ 1249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loader_css__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Loader_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







var _ref = _jsx('i', {
  className: 'fa fa-2x fa-spinner fa-spin'
});

function Loader(props) {
  var isLoading = props.isLoading,
      children = props.children,
      isHidden = props.isHidden,
      className = props.className,
      loaderElement = props.loaderElement,
      defaultClassName = props.defaultClassName;


  if (isHidden) {
    return null;
  }

  return isLoading ? _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__Loader_css___default.a.root, className)
  }, void 0, loaderElement || _ref) : _jsx('div', {
    className: defaultClassName
  }, void 0, children);
}

Loader.defaultProps = {
  isLoading: false,
  isHidden: false,
  children: '',
  className: '',
  defaultClassName: '',
  loaderElement: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__Loader_css___default.a)(Loader));

/***/ }),

/***/ 1250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    // Create a div that we'll render the modal into. Because each
    // Modal component has its own element, we can render multiple
    // modal components into the modal container.
    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Append the element into the DOM on mount. We'll render
      // into the modal container element (see the HTML tab).
      var modalRoot = document.getElementById('modal');
      modalRoot.appendChild(this.el);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove the element from the DOM when we unmount
      var modalRoot = document.getElementById('modal');
      modalRoot.removeChild(this.el);
    }
  }, {
    key: 'render',
    value: function render() {
      // Use a portal to render the children into the element
      return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(
      // Any valid React child: JSX, strings, arrays, etc.
      this.props.children,
      // A DOM element
      this.el);
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),

/***/ 1251:
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCustomParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = paramsToSeoData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_modules__ = __webpack_require__(103);
/* eslint-disable no-param-reassign */



var avaliableKeyFields = ['make', 'model', 'city', 'generation', 'gearbox', 'engine', 'body', 'drive',
// 'driveSelected',
'isNew', 'year',
// 'makeTranslate',
'country',
// 'location'
'transport', 'transportType', 'transporttype'];

/**
 * Make pathes to compare and find needed function.
 * Like: body_engine_isnew
 * @param {object} inputParams 
 * @param {object} seoData 
 * @returns {object}
 */
function findSeoPath(inputParams, seoData) {
  var inputKeys = avaliableKeyFields.filter(function (k) {
    return inputParams[k] !== null && inputParams[k] !== undefined && inputParams[k] !== '';
  });

  var pathInput = inputKeys.sort().join('_').toLowerCase();

  var seoDataKeys = Object.keys(seoData || {});

  for (var i = 0, l = seoDataKeys.length; i < l; i += 1) {
    var path = seoDataKeys[i].split('_').sort().join('_');
    var pathLc = path.toLowerCase();
    var func = seoData[pathLc] || seoData[path];
    if (path === pathInput && func) {
      return { path: path, func: func };
    }
  }
  return {};
}

function getCustomParams(data, t) {
  var city = data.city,
      country = data.country,
      engine = data.engine,
      gearbox = data.gearbox;


  var locale = t('locale');
  var buy = t('Купить');
  var newTxt = t('Новый');

  var newTxtLCase = newTxt.toLowerCase();
  var buyLCase = buy.toLowerCase();

  var inCity = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][city] ? ' ' + __WEBPACK_IMPORTED_MODULE_1_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][city][locale].genitive) : __WEBPACK_IMPORTED_MODULE_1_shared_modules__["c" /* buildInGenitiveCityHeader */](t(city) || city) || '';

  var fromCountry = country && country.is_country ? country.from[locale] : '';
  var countryTitle = country && country.is_country ? t(country.title) : '';

  var customEngineAlt = engine;
  var customEngine = engine;
  var customEngineShort = engine;
  var customGearbox = gearbox;
  var customGearboxLCase = gearbox && gearbox.toLowerCase();

  if (engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale]) {
    customEngineAlt = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].altTitle;
    customEngine = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].title;
    customEngineShort = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].short;
  }

  if (gearbox in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */] && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale]) {
    customGearbox = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale].title;
    customGearboxLCase = customGearbox.toLowerCase();
  }
  var makeLocale = 'test'; // make[`${t('locale')}_title`] ? make[`${t('locale')}_title`] : make.title;

  return {
    buy: buy,
    newTxt: newTxt,
    newTxtLCase: newTxtLCase,
    buyLCase: buyLCase,

    customEngineShort: customEngineShort,
    customEngineAlt: customEngineAlt,
    customEngine: customEngine,

    customGearbox: customGearbox,
    customGearboxLCase: customGearboxLCase,

    inCity: (inCity || '').trim(),
    fromCountry: (fromCountry || '').trim(),
    country: countryTitle,
    locale: locale,
    t: t,
    makeLocale: makeLocale
  };
}

/**
 * Parse input params and retrurn Object with 
 * @param {object} data 
 * @param {object} pathes 
 * @param {funciton} t 
 * @returns {object} { head: 'text for H1', title: 'text for eta Title', ... }
 */
function paramsToSeoData(data, pathes, t) {
  try {
    var locale = t('locale');
    var isNew = !!data.isNew;
    if (data.transportCategoryTitleOrigin) {
      var subCategory = data.transportCategoryTitleOrigin;
      var subCategoryObject = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["a" /* crutch */](isNew)[subCategory] || {};

      if (subCategoryObject[locale]) {
        var obj = subCategoryObject[locale];
        data.subCategory = subCategory || '';
        data.subCategoryHeader = obj.transportHeader || '';
        data.subCategoryPluralGenitive = obj.pluralGenitiveTransport || '';
        data.subCategoryPlural = obj.pluralTransport || '';
      }
    }

    if (data.transportTitleOrigin) {
      var transport = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["a" /* crutch */](isNew)[data.transportTitleOrigin] || {};

      if (transport[locale]) {
        var _obj = transport[locale];
        data.category = data.transportTitleOrigin || '';
        data.categoryPluralGenitive = _obj.pluralGenitive || '';
        data.categoryPlural = _obj.plural || '';
      }
    }

    data.transportType = data.subCategoryHeader || data.category;
    data.transportTypePlural = data.subCategoryPlural || data.categoryPlural;
    data.transportTypePluralGenitive = data.subCategoryPluralGenitive || data.categoryPluralGenitive;

    var _findSeoPath = findSeoPath(data, pathes),
        path = _findSeoPath.path,
        func = _findSeoPath.func;

    // ...
    // Here can be added some additional SEO searching by API or something else.
    // We have `path` (brand_model_...) and can use it.
    // ...


    if (path) {
      var customParams = getCustomParams(data, t);
      var res = func(data, customParams);
      var lc = customParams.locale;

      return {
        title: res['title_' + lc] || res.title,
        description: res['description_' + lc] || res.description,
        header: res['header_' + lc] || res.header
      };
    }
    return {};
  } catch (err) {}
  return {};
}

/***/ }),

/***/ 1253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NOTIFICATION_TYPES = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  INFO: 'INFO'
};

/* harmony default export */ __webpack_exports__["a"] = (NOTIFICATION_TYPES);

/***/ }),

/***/ 1254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/avto/templates.js
var avtoPathesHead = {
  city: function city(data, p) {
    return {
      header: p.buy + ' \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity,

      title: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 ' + p.t(data.city) + '. \u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E\u0440\u044B\u043D\u043A\u0435',
      title_uk: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 ' + p.t(data.city) + '. \u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u043D\u043A\u0443',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0443 \u0430\u0432\u0442\u043E \uD83D\uDE97 ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430. \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u044B',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0443 \u0430\u0432\u0442\u043E \uD83D\uDE97 ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0456 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456'
    };
  },

  make: function make(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C. \u0426\u0435\u043D\u0430 \u0430\u0432\u0442\u043E, \u0444\u043E\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C. \u0426\u0456\u043D\u0430 \u0430\u0432\u0442\u043E, \u0444\u043E\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043D\u0430 \u0430\u0432\u0442\u043E \u0431\u0430\u0437\u0430\u0440\u0435. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044E \u043C\u043E\u0434\u0435\u043B\u0438. \u0412\u0435\u0441\u044C \u043C\u043E\u0434\u0435\u043B\u044C\u043D\u044B\u0439 \u0440\u044F\u0434 ' + data.make + ' \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0421\u0442\u0430\u0440\u0456 \u043C\u0430\u0448\u0438\u043D\u0438 ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043D\u0430 \u0430\u0432\u0442\u043E \u0431\u0430\u0437\u0430\u0440\u0456. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u044E \u043C\u043E\u0434\u0435\u043B\u0456. \u0412\u0435\u0441\u044C \u043C\u043E\u0434\u0435\u043B\u044C\u043D\u0438\u0439 \u0440\u044F\u0434 ' + data.make + ' \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0437\u0456 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  country: function country(data, p) {
    return {
      header: p.buy + ' \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.fromCountry,

      title: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 ' + p.country + '. \u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.fromCountry + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E\u0440\u044B\u043D\u043A\u0435',
      title_uk: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 ' + p.country + '. \u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.fromCountry + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u043D\u043A\u0443',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0443 \u0430\u0432\u0442\u043E \u0432 ' + p.country + '. \u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0431\u0443 \u0432 ' + p.country + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430. \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u044B',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0443 \u0430\u0432\u0442\u043E \u0432 ' + p.country + '. \u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E \u0431\u0443 \u0432 ' + p.country + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0456 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456'
    };
  },

  engine: function engine(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.engine).toLowerCase() + ' ' + p.t('автомобиль') + ' \u0431\u0443'
    };
  },

  body: function body(data, p) {
    return {
      title: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      header: p.buy + ' ' + p.t(data.body) + ' \u0431\u0443 ' + p.t('в Украине'),

      description: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  gearbox: function gearbox(data, p) {
    return { header: p.buy + ' \u0430\u0432\u0442\u043E ' + p.customGearbox + ' \u0431\u0443' };
  },

  year: function year(data, p) {
    return {
      title: '\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  // --- //

  gearboxCity: function gearboxCity(data, p) {
    return { header: p.buy + ' \u0430\u0432\u0442\u043E ' + p.customGearbox.toLowerCase() + ' \u0431\u0443 ' + p.t(data.city) };
  },

  cityEngine: function cityEngine(data, p) {
    return { header: p.t(data.engine) + ' \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.buyLCase + ' ' + p.inCity };
  },

  makeModel: function makeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' \u0431\u0443. \u0426\u0435\u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' \u0431\u0443. \u0426\u0456\u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B ' + data.make + ' ' + data.model + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u044B\u043D\u043A\u0435. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E, \u043E\u0431\u0437\u043E\u0440 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438 \u0438 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0441\u0442\u0430\u0440\u0456 \u043C\u0430\u0448\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u0438\u043D\u043A\u0443. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E, \u043E\u0433\u043B\u044F\u0434 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u0457 \u0456 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  makeCity: function makeCity(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' \u0431\u0443 ' + p.t(data.city) + '. \u0426\u0435\u043D\u044B \u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' \u0431\u0443 ' + p.t(data.city) + '. \u0426\u0456\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C ' + data.make + ' \u0431\u0443 ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C ' + p.inCity + '. \u0426\u0435\u043D\u044B \u043D\u0430 \u043F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u044B, \u0444\u043E\u0442\u043E, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044E \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 \u043C\u0430\u0440\u043A\u0438 \u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C ' + data.make + ' \u0431\u0443 ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C ' + p.inCity + '. \u0426\u0456\u043D\u0438 \u043D\u0430 \u0441\u0442\u0430\u0440\u0456 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0438, \u0444\u043E\u0442\u043E, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0456 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u044E \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 \u043C\u0430\u0440\u043A\u0438 \u0434\u0438\u0432\u0456\u0442\u044C\u0441\u044F \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0437\u0456 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  makeCountry: function makeCountry(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + p.fromCountry + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' \u0431\u0443 ' + p.fromCountry + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0426\u0435\u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + p.fromCountry + '. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' \u0431\u0443 ' + p.fromCountry + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0426\u0456\u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C ' + data.make + ' \u0431\u0443 ' + p.fromCountry + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u043D\u044B\u0445 ' + p.fromCountry + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0443. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u043D\u0430 \u043F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E, \u043E\u0431\u0437\u043E\u0440 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C ' + data.make + ' \u0431\u0443 ' + p.fromCountry + '. \u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043F\u0440\u0438\u0432\u0435\u0437\u0435\u043D\u0456 ' + p.fromCountry + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u043D\u0430 \u0441\u0442\u0430\u0440\u0456 \u043C\u0430\u0448\u0438\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E, \u043E\u0433\u043B\u044F\u0434 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0456 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u0457 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  cityYear: function cityYear(data, p) {
    return {
      title: '\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyYear: function bodyYear(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430',
      header_uk: p.buy + ' ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443',

      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + p.t('в Украине'),
      title: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // Купить кроссовер в Украине

  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.body).toLowerCase() + ' \u0431\u0443 ' + p.inCity,
      title: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // Купить кроссовер бу в Киеве

  gearboxIsnew: function gearboxIsnew(data, p) {
    return { header: p.buy + ' \u0430\u0432\u0442\u043E ' + p.customGearbox };
  },
  // Купить авто Механика

  makeBody: function makeBody(data, p) {
    return {
      header: data.make + ' ' + p.t(data.body) + ' \u0431\u0443 ' + p.buyLCase + ' ' + p.t('в Украине'),
      title: p.t(data.body) + ' ' + data.make + ' \u0431\u0443 ' + p.buyLCase + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + p.t(data.body) + ' ' + data.make + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0445 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + p.t(data.body) + ' ' + data.make + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0445 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // BMW Кросовер бу купить в Украине

  makeEngine: function makeEngine(data, p) {
    return { header: data.make + ' ' + p.t(data.engine).toLowerCase() + ' \u0431\u0443' };
  },
  // BMW дизель бу

  makeGearbox: function makeGearbox(data, p) {
    return {
      header: data.make + ' ' + p.customGearboxLCase + ' \u0431\u0443 ' + p.buyLCase + ' ' + p.t('в Украине')
    };
  },
  // BMW механика бу купить в Украине

  bodyIsnewMake: function bodyIsnewMake(data, p) {
    return {
      title: p.newTxt + ' ' + p.t(data.body) + ' ' + data.make + ' ' + p.buyLCase + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      header: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + data.make,

      description: '\u041D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.make + ' \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.make + ' \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyIsnewYear: function bodyIsnewYear(data, p) {
    return {
      header: p.newTxt + ' ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430',
      header_uk: p.newTxt + ' ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443',

      title: '\u041D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  makeGearboxIsnew: function makeGearboxIsnew(data, p) {
    return {
      header: data.make + ' ' + p.customGearboxLCase + ' ' + p.buyLCase + ' ' + p.t('в Украине')
    };
  },
  // BMW механика купить в Украине

  gearboxIsnewCity: function gearboxIsnewCity(data, p) {
    return { header: p.buy + ' \u0430\u0432\u0442\u043E ' + p.t(data.gearbox) + ' ' + p.inCity };
  },
  // Купить авто Механика в Киеве

  makeGearboxCity: function makeGearboxCity(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + p.t(data.gearbox).toLowerCase() + ' \u0431\u0443 ' + p.t(data.city)
    };
  },
  // Купить BMW Механика бу в Киеве

  engineMakeModel: function engineMakeModel(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.customEngineShort + ' \u0431\u0443',

      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },
  // Купить BMW X6 дизель бу

  makeModelCity: function makeModelCity(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u0431\u0443 ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u044B\u043D\u043A\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u0431\u0443 ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u0438\u043D\u043A\u0443 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: data.make + ' ' + data.model + ' \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 ' + p.inCity + '. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B ' + data.make + ' ' + data.model + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u044B\u043D\u043A\u0435 \u0433. ' + p.t(data.city) + '. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E, \u043E\u0431\u0437\u043E\u0440 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438 \u043C\u043E\u0434\u0435\u043B\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: data.make + ' ' + data.model + ' \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 ' + p.inCity + '. \u0421\u0442\u0430\u0440\u0456 \u043C\u0430\u0448\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C\u043D\u043E\u043C\u0443 \u0440\u0438\u043D\u043A\u0443 \u043C. ' + p.t(data.city) + '. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E, \u043E\u0433\u043B\u044F\u0434 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0456 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u0457 \u043C\u043E\u0434\u0435\u043B\u0456 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  makeModelYear: function makeModelYear(data, p) {
    return {
      header: '',
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  gearboxMakeModel: function gearboxMakeModel(data, p) {
    return {
      // header: '',
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  bodyMakeModel: function bodyMakeModel(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.body) + ' ' + data.make + ' ' + data.model,
      title: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },
  // Купить Кросовер BMW X6 бу

  bodyCityIsnew: function bodyCityIsnew(data, p) {
    return {
      header: p.newTxt + ' ' + p.t(data.body) + ' ' + p.buyLCase + ' ' + p.inCity,
      title: p.newTxt + ' ' + p.t(data.body) + ' ' + p.buyLCase + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' \u043A\u0443\u043F\u0438\u0442\u044C ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' \u043A\u0443\u043F\u0438\u0442\u0438 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // Купить Кросовер в Киеве

  bodyCityMake: function bodyCityMake(data, p) {
    return {
      header: data.make + ' ' + p.t(data.body).toLowerCase() + ' \u0431\u0443 ' + p.t(data.city),
      title: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' ' + data.make + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 ' + p.t(data.body) + ' ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 ' + p.t(data.body) + ' ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // BMW Кроссовер бу в Киеве

  bodyCityYear: function bodyCityYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  cityEngineYear: function cityEngineYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyCityIsnewMake: function bodyCityIsnewMake(data, p) {
    return {
      header: p.newTxt + ' ' + data.make + ' ' + p.t(data.body) + ' ' + p.inCity,
      title: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + data.make + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.make + ' ' + p.inCity + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.make + ' ' + p.inCity + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyCityMakeModel: function bodyCityMakeModel(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.body).toLowerCase() + ' ' + data.make + ' ' + data.model + ' \u0431\u0443 ' + p.t(data.city),

      title: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 ' + p.inCity + '. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C ' + p.inCity + '. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  countryMakeModel: function countryMakeModel(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' \u0431\u0443',

      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u043D\u044B\u0439 ' + p.fromCountry + '. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0440\u0430\u0441\u0442\u0430\u043C\u043E\u0436\u0435\u043D\u043D\u044B\u0439 \u0438 \u043D\u0435\u0440\u0430\u0441\u0442\u0430\u043C\u043E\u0436\u0435\u043D\u043D\u044B\u0439. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u0438\u0439 ' + p.fromCountry + '. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0440\u043E\u0437\u043C\u0438\u0442\u043D\u0435\u043D\u0438\u0439 \u0456 \u043D\u0435\u0440\u043E\u0437\u043C\u0438\u0442\u043D\u0435\u043D\u0438\u0439. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  makeModelEngineCity: function makeModelEngineCity(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.customEngineShort + ' \u0431\u0443 ' + p.inCity,
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 ' + p.inCity + '. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C ' + p.inCity + '. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },
  // Купить BMW X6 дизель бу в Киеве

  cityGearboxMakeModel: function cityGearboxMakeModel(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.customGearbox.toLowerCase() + ' \u0431\u0443 ' + p.t(data.city),
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B ' + p.inCity + ', \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 ' + p.inCity + ', \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },
  // Купить BMW X6 Механика бу в Киеве

  cityGearboxIsnewMake: function cityGearboxIsnewMake(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + p.customGearbox + ' ' + p.inCity
    };
  },
  // Купить BMW Механика в Киеве

  cityMakeModelYear: function cityMakeModelYear(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 ' + p.inCity,

      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B ' + p.inCity + ', \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 ' + p.inCity + ', \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  makeModelEngineCityYear: function makeModelEngineCityYear(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 ' + p.inCity
    };
  },

  //
  bodyCityIsnewYear: function bodyCityIsnewYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043E\u0442 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u043E\u0432 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0456\u0432 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  isnewYear: function isnewYear(data, p) {
    return {
      title: '\u041D\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041D\u043E\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityIsnewYear: function cityIsnewYear(data, p) {
    return {
      title: '\u041D\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041D\u043E\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u0430\u0432\u0442\u043E \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0448\u0438\u043D. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430. \u0415\u0449\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u043E\u0432 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0435 \u0430\u0432\u0442\u043E \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 \u0430\u0432\u0442\u043E \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0448\u0438\u043D. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430. \u0429\u0435 \u0431\u0456\u043B\u044C\u0448\u0435 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0456\u0432 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u044B\u0433\u043E\u0434\u043D\u043E\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0438\u0433\u0456\u0434\u043D\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityIsnewMakeModelYear: function cityIsnewMakeModelYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B ' + p.inCity + ', \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 ' + p.inCity + ', \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  gearboxIsnewMakeModel: function gearboxIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u0441\u0430\u043B\u043E\u043D\u0430\u0445, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u0441\u0430\u043B\u043E\u043D\u0430\u0445, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityGearboxIsnewMakeModel: function cityGearboxIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 ' + p.t(data.city) + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u0441\u0430\u043B\u043E\u043D\u0430\u0445 ' + p.t(data.city) + ', \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 ' + p.t(data.city) + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u0441\u0430\u043B\u043E\u043D\u0430\u0445 ' + p.t(data.city) + ', \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  engineIsnewMakeModel: function engineIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityEngineIsnewMakeModel: function cityEngineIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u043E\u0432. \u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0456\u0432. \u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  bodyIsnewMakeModel: function bodyIsnewMakeModel(data, p) {
    return {
      header: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + data.make + ' ' + data.model,
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  bodyCityIsnewMakeModel: function bodyCityIsnewMakeModel(data, p) {
    return {
      header: p.newTxt + ' ' + p.t(data.body) + ' ' + data.make + ' ' + data.model + ' ' + p.inCity,
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  countryIsnewMakeModel: function countryIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u043D\u044B\u0439 ' + p.fromCountry + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u0438\u0439 ' + p.fromCountry + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityEngineIsnewYear: function cityEngineIsnewYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + p.t(data.engine) + ' \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043E\u0442 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u043E\u0432 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + p.t(data.engine) + ' \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0456\u0432 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  }
};

/* harmony default export */ var templates_defaultExport = (avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/avto/index.js
var _AVTO;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// To more readable code, try to use keys in alphabet order " { ab_bc_de: abBcDe }"
// body country city drive engine gearbox generation isNew location make makeTranslate model year
var AVTO = (_AVTO = {
  city: templates_defaultExport.city,
  // city: tpl.city,
  make: templates_defaultExport.make,
  country: templates_defaultExport.country,
  body: templates_defaultExport.body,
  engine: templates_defaultExport.engine,
  gearbox: templates_defaultExport.gearbox,
  year: templates_defaultExport.year,

  // 2
  make_model: templates_defaultExport.makeModel,
  country_make: templates_defaultExport.makeCountry,
  city_make: templates_defaultExport.makeCity,
  body_isnew: templates_defaultExport.bodyIsnew,
  body_city: templates_defaultExport.bodyCity,
  gearbox_isnew: templates_defaultExport.gearboxIsnew,
  city_gearbox: templates_defaultExport.gearboxCity,
  city_year: templates_defaultExport.cityYear,
  body_year: templates_defaultExport.bodyYear,

  city_engine: templates_defaultExport.cityEngine,
  body_make: templates_defaultExport.makeBody,
  engine_make: templates_defaultExport.makeEngine,
  gearbox_make: templates_defaultExport.makeGearbox,
  isnew_year: templates_defaultExport.isnewYear,
  city_isnew: templates_defaultExport.cityIsnew,

  // 3
  gearbox_isnew_make: templates_defaultExport.makeGearboxIsnew,
  city_gearbox_isnew: templates_defaultExport.gearboxIsnewCity,
  city_gearbox_make: templates_defaultExport.makeGearboxCity,
  engine_make_model: templates_defaultExport.engineMakeModel,
  body_make_model: templates_defaultExport.bodyMakeModel,
  body_isnew_make: templates_defaultExport.bodyIsnewMake,
  body_isnew_year: templates_defaultExport.bodyIsnewYear,
  country_make_model: templates_defaultExport.countryMakeModel,
  body_city_isnew: templates_defaultExport.bodyCityIsnew,
  body_city_make: templates_defaultExport.bodyCityMake,
  body_city_year: templates_defaultExport.bodyCityYear,
  city_engine_year: templates_defaultExport.cityEngineYear,
  make_model_year: templates_defaultExport.makeModelYear,
  city_make_model: templates_defaultExport.makeModelCity,
  gearbox_make_model: templates_defaultExport.gearboxMakeModel,
  city_isnew_year: templates_defaultExport.cityIsnewYear,

  // 4
  city_gearbox_isnew_make: templates_defaultExport.cityGearboxIsnewMake,
  city_engine_make_model: templates_defaultExport.makeModelEngineCity,
  city_gearbox_make_model: templates_defaultExport.cityGearboxMakeModel,
  body_city_make_model: templates_defaultExport.bodyCityMakeModel,
  body_city_isnew_make: templates_defaultExport.bodyCityIsnewMake,
  city_make_model_year: templates_defaultExport.cityMakeModelYear,
  body_isnew_make_model: templates_defaultExport.bodyIsnewMakeModel,

  // 5
  city_engine_make_model_year: templates_defaultExport.makeModelEngineCityYear,
  body_city_isnew_make_model: templates_defaultExport.bodyCityIsnewMakeModel,

  body_city_isnew_year: templates_defaultExport.bodyCityIsnewYear,
  city_engine_isnew_year: templates_defaultExport.cityEngineIsnewYear
}, _defineProperty(_AVTO, 'isnew_year', templates_defaultExport.isnewYear), _defineProperty(_AVTO, 'city_isnew_year', templates_defaultExport.cityIsnewYear), _defineProperty(_AVTO, 'city_isnew', templates_defaultExport.cityIsnew), _defineProperty(_AVTO, 'isnew_make_model_year', templates_defaultExport.isnewMakeModelYear), _defineProperty(_AVTO, 'city_isnew_make_model_year', templates_defaultExport.cityIsnewMakeModelYear), _defineProperty(_AVTO, 'gearbox_isnew_make_model', templates_defaultExport.gearboxIsnewMakeModel), _defineProperty(_AVTO, 'city_gearbox_isnew_make_model', templates_defaultExport.cityGearboxIsnewMakeModel), _defineProperty(_AVTO, 'engine_isnew_make_model', templates_defaultExport.engineIsnewMakeModel), _defineProperty(_AVTO, 'city_engine_isnew_make_model', templates_defaultExport.cityEngineIsnewMakeModel), _defineProperty(_AVTO, 'country_isnew_make_model', templates_defaultExport.countryIsnewMakeModel), _AVTO);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/moto/templates.js
var templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0431\u0443 " + p.inCity,

      title: "\u041C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0430 " + p.t(data.city) + ". \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u043E\u0439 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0438 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0430 " + p.t(data.city) + ". \u041F\u0440\u043E\u0434\u0430\u0436 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0430\u043D\u043E\u0457 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u0431\u0443 " + p.inCity + ". \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u043E\u0439 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B. \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u044B",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0431\u0443 " + p.inCity + ". \u041F\u0440\u043E\u0434\u0430\u0436 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0430\u043D\u043E\u0457 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0456 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456"
    };
  }
};

/* harmony default export */ var moto_templates_defaultExport = (templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/moto/index.js


var MOTO = {
  city: moto_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/mototsikl/templates.js
/* harmony default export */ var mototsikl_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },

  make: function make(data, p) {
    return {
      header: "\u041C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B " + data.make,
      header_uk: "\u041C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438 " + data.make,

      title: "\u041C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },

  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443"
    };
  },

  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity
    };
  },

  makeModelCity: function makeModelCity(data, p) {
    return {
      header: p.buy + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/mototsikl/index.js


var MOTOTSIKL = {
  city: mototsikl_templates_defaultExport.city,
  body: mototsikl_templates_defaultExport.body,

  make: mototsikl_templates_defaultExport.make,

  make_model: mototsikl_templates_defaultExport.makeModel,
  city_make: mototsikl_templates_defaultExport.cityMake,
  city_isnew: mototsikl_templates_defaultExport.cityIsnew,
  isnew_make: mototsikl_templates_defaultExport.makeIsnew,
  body_make: mototsikl_templates_defaultExport.makeBody,
  body_isnew: mototsikl_templates_defaultExport.bodyIsnew,
  body_city: mototsikl_templates_defaultExport.bodyCity,

  city_make_model: mototsikl_templates_defaultExport.makeModelCity,
  isnew_make_model: mototsikl_templates_defaultExport.makeModelIsnew,
  city_isnew_make: mototsikl_templates_defaultExport.makeCityIsnew,
  body_make_model: mototsikl_templates_defaultExport.makeModelBody,
  make_model_year: mototsikl_templates_defaultExport.makeModelYear,
  body_isnew_make: mototsikl_templates_defaultExport.isnewMakeBody,
  body_city_make: mototsikl_templates_defaultExport.makeCityBody,
  body_city_isnew: mototsikl_templates_defaultExport.isnewBodyCity,

  isnew_make_model_year: mototsikl_templates_defaultExport.isnewMakeModelYear,
  city_isnew_make_model: mototsikl_templates_defaultExport.isnewMakeModelCity,
  body_isnew_make_model: mototsikl_templates_defaultExport.isnewMakeModelBody,
  body_city_make_model: mototsikl_templates_defaultExport.makeModelCityBody,
  body_city_isnew_make: mototsikl_templates_defaultExport.isnewMakeCityBody,

  body_city_isnew_make_model: mototsikl_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/skuter/templates.js
var skuter_templates_avtoPathesHead = {
  make: function make(data, p) {
    return {
      header: "\u0421\u043A\u0443\u0442\u0435\u0440\u044B " + data.make,
      header_uk: "\u0421\u043A\u0443\u0442\u0435\u0440\u0438 " + data.make,

      title: "\u0421\u043A\u0443\u0442\u0435\u0440\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0421\u043A\u0443\u0442\u0435\u0440\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 \u0431\u0443"
    };
  },

  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0441\u043A\u0443\u0442\u0435\u0440\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0441\u043A\u0443\u0442\u0435\u0440\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0441\u043A\u0443\u0442\u0435\u0440\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0441\u043A\u0443\u0442\u0435\u0440\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440"
    };
  },
  cityBody: function cityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 \u0431\u0443 " + p.inCity
    };
  },

  cityMakeModel: function cityMakeModel(data, p) {
    return {
      header: p.buy + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0441\u043A\u0443\u0442\u0435\u0440\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  cityIsnewMake: function cityIsnewMake(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make
    };
  },
  cityMakeBody: function cityMakeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  cityIsnewBody: function cityIsnewBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var skuter_templates_defaultExport = (skuter_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/skuter/index.js


var SKUTER = {
  make: skuter_templates_defaultExport.make,
  body: skuter_templates_defaultExport.body,

  city_make: skuter_templates_defaultExport.makeCity,
  make_model: skuter_templates_defaultExport.makeModel,
  city_isnew: skuter_templates_defaultExport.cityIsnew,
  isnew_make: skuter_templates_defaultExport.makeIsnew,
  body_make: skuter_templates_defaultExport.makeBody,
  body_isnew: skuter_templates_defaultExport.bodyIsnew,
  body_city: skuter_templates_defaultExport.cityBody,

  city_make_model: skuter_templates_defaultExport.cityMakeModel,
  isnew_make_model: skuter_templates_defaultExport.makeModelIsnew,
  city_isnew_make: skuter_templates_defaultExport.cityIsnewMake,
  body_make_model: skuter_templates_defaultExport.makeModelBody,
  make_model_year: skuter_templates_defaultExport.makeModelYear,
  body_isnew_make: skuter_templates_defaultExport.isnewMakeBody,
  body_city_make: skuter_templates_defaultExport.cityMakeBody,
  body_city_isnew: skuter_templates_defaultExport.cityIsnewBody,

  isnew_make_model_year: skuter_templates_defaultExport.isnewMakeModelYear,
  city_isnew_make_model: skuter_templates_defaultExport.isnewMakeModelCity,
  body_isnew_make_model: skuter_templates_defaultExport.isnewMakeModelBody,
  body_city_make_model: skuter_templates_defaultExport.makeModelCityBody,
  body_city_isnew_make: skuter_templates_defaultExport.isnewMakeCityBody,

  body_city_isnew_make_model: skuter_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/moped/templates.js
var moped_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u043E\u043F\u0435\u0434\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043C\u043E\u043F\u0435\u0434\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },
  make: function make(data, p) {
    return {
      header: "\u041C\u043E\u043F\u0435\u0434\u044B " + data.make,
      header_uk: "\u041C\u043E\u043F\u0435\u0434\u0438 " + data.make,

      title: "\u041C\u043E\u043F\u0435\u0434\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041C\u043E\u043F\u0435\u0434\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u043C\u043E\u043F\u0435\u0434\u044B, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 \u0431\u0443"
    };
  },

  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u043E\u043F\u0435\u0434\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043C\u043E\u043F\u0435\u0434\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity
    };
  },

  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelCity: function makeModelCity(data, p) {
    return {
      header: p.buy + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var moped_templates_defaultExport = (moped_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/moped/index.js


var MOPED = {
    city: moped_templates_defaultExport.city,
    make: moped_templates_defaultExport.make,
    body: moped_templates_defaultExport.body,

    make_model: moped_templates_defaultExport.makeModel,
    city_make: moped_templates_defaultExport.makeCity,
    city_isnew: moped_templates_defaultExport.cityIsnew,
    isnew_make: moped_templates_defaultExport.makeIsnew,
    body_make: moped_templates_defaultExport.makeBody,
    body_isnew: moped_templates_defaultExport.bodyIsnew,
    body_city: moped_templates_defaultExport.bodyCity,

    make_model_year: moped_templates_defaultExport.makeModelYear,
    city_make_model: moped_templates_defaultExport.makeModelCity,
    isnew_make_model: moped_templates_defaultExport.makeModelIsnew,
    city_isnew_make: moped_templates_defaultExport.makeCityIsnew,
    body_make_model: moped_templates_defaultExport.makeModelBody,
    body_isnew_make: moped_templates_defaultExport.isnewMakeBody,
    body_city_make: moped_templates_defaultExport.makeCityBody,
    body_city_isnew: moped_templates_defaultExport.isnewBodyCity,

    isnew_make_model_year: moped_templates_defaultExport.isnewMakeModelYear,
    city_isnew_make_model: moped_templates_defaultExport.isnewMakeModelCity,
    body_isnew_make_model: moped_templates_defaultExport.isnewMakeModelBody,
    body_city_make_model: moped_templates_defaultExport.makeModelCityBody,
    body_city_isnew_make: moped_templates_defaultExport.isnewMakeCityBody,

    body_city_isnew_make_model: moped_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/kvadrotsikl/templates.js
var kvadrotsikl_templates_avtoPathesHead = {
  make: function make(data, p) {
    return {
      header: "\u041A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B " + data.make,
      header_uk: "\u041A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438 " + data.make,

      title: "\u041A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },
  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443"
    };
  },

  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity
    };
  },

  makeModelCity: function makeModelCity(data, p) {
    return {
      header: p.buy + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var kvadrotsikl_templates_defaultExport = (kvadrotsikl_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/kvadrotsikl/index.js


var KVADROTSIKL = {
    make: kvadrotsikl_templates_defaultExport.make,
    city: kvadrotsikl_templates_defaultExport.city,
    body: kvadrotsikl_templates_defaultExport.body,

    city_make: kvadrotsikl_templates_defaultExport.makeCity,
    make_model: kvadrotsikl_templates_defaultExport.makeModel,
    city_isnew: kvadrotsikl_templates_defaultExport.cityIsnew,
    isnew_make: kvadrotsikl_templates_defaultExport.makeIsnew,
    body_make: kvadrotsikl_templates_defaultExport.makeBody,
    body_isnew: kvadrotsikl_templates_defaultExport.bodyIsnew,
    body_city: kvadrotsikl_templates_defaultExport.bodyCity,

    city_make_model: kvadrotsikl_templates_defaultExport.makeModelCity,
    isnew_make_model: kvadrotsikl_templates_defaultExport.makeModelIsnew,
    city_isnew_make: kvadrotsikl_templates_defaultExport.makeCityIsnew,
    body_make_model: kvadrotsikl_templates_defaultExport.makeModelBody,
    make_model_year: kvadrotsikl_templates_defaultExport.makeModelYear,
    body_isnew_make: kvadrotsikl_templates_defaultExport.isnewMakeBody,
    body_city_make: kvadrotsikl_templates_defaultExport.makeCityBody,
    body_city_isnew: kvadrotsikl_templates_defaultExport.isnewBodyCity,

    isnew_make_model_year: kvadrotsikl_templates_defaultExport.isnewMakeModelYear,
    city_isnew_make_model: kvadrotsikl_templates_defaultExport.isnewMakeModelCity,
    body_isnew_make_model: kvadrotsikl_templates_defaultExport.isnewMakeModelBody,
    body_city_make_model: kvadrotsikl_templates_defaultExport.makeModelCityBody,
    body_city_isnew_make: kvadrotsikl_templates_defaultExport.isnewMakeCityBody,

    body_city_isnew_make_model: kvadrotsikl_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/baggi/templates.js
var baggi_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0430\u0433\u0433\u0438 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0431\u0430\u0433\u0433\u0438 \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0430\u0433\u0433\u0456 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0431\u0430\u0433\u0433\u0456 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },
  make: function make(data, p) {
    return {
      header: "\u0411\u0430\u0433\u0433\u0438 " + data.make,
      header_uk: "\u0411\u0430\u0433\u0433\u0456 " + data.make,

      title: "\u0411\u0430\u0433\u0433\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0411\u0430\u0433\u0433\u0456 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u0431\u0430\u0433\u0433\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u0431\u0430\u0433\u0433\u0456, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  body: function body(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 \u0431\u0443"
    };
  },

  makeModel: function makeModel(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0431\u0430\u0433\u0433\u0438 \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0431\u0430\u0433\u0433\u0456 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 \u0431\u0443 " + p.inCity
    };
  },

  makeModelCity: function makeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var baggi_templates_defaultExport = (baggi_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/baggi/index.js


var BAGGI = {
    city: baggi_templates_defaultExport.city,
    make: baggi_templates_defaultExport.make,
    body: baggi_templates_defaultExport.body,

    make_model: baggi_templates_defaultExport.makeModel,
    city_make: baggi_templates_defaultExport.makeCity,
    city_isnew: baggi_templates_defaultExport.cityIsnew,
    isnew_make: baggi_templates_defaultExport.makeIsnew,
    body_make: baggi_templates_defaultExport.makeBody,
    body_isnew: baggi_templates_defaultExport.bodyIsnew,
    body_city: baggi_templates_defaultExport.bodyCity,

    city_make_model: baggi_templates_defaultExport.makeModelCity,
    isnew_make_model: baggi_templates_defaultExport.makeModelIsnew,
    city_isnew_make: baggi_templates_defaultExport.makeCityIsnew,
    body_make_model: baggi_templates_defaultExport.makeModelBody,
    make_model_year: baggi_templates_defaultExport.makeModelYear,
    body_isnew_make: baggi_templates_defaultExport.isnewMakeBody,
    body_city_make: baggi_templates_defaultExport.makeCityBody,
    body_city_isnew: baggi_templates_defaultExport.isnewBodyCity,

    isnew_make_model_year: baggi_templates_defaultExport.isnewMakeModelYear,
    city_isnew_make_model: baggi_templates_defaultExport.isnewMakeModelCity,
    body_isnew_make_model: baggi_templates_defaultExport.isnewMakeModelBody,
    body_city_make_model: baggi_templates_defaultExport.makeModelCityBody,
    body_city_isnew_make: baggi_templates_defaultExport.isnewMakeCityBody,

    body_city_isnew_make_model: baggi_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/tritsikl/templates.js
var tritsikl_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u043E\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0456\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },
  make: function make(data, p) {
    return {
      header: "\u0422\u0440\u0438\u0446\u0438\u043A\u043B\u044B " + data.make,
      header_uk: "\u0422\u0440\u0438\u0446\u0438\u043A\u043B\u0438 " + data.make,

      title: "\u0422\u0440\u0438\u0446\u0438\u043A\u043B\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0422\u0440\u0438\u0446\u0438\u043A\u043B\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u044B, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443"
    };
  },

  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity
    };
  },

  makeModelCity: function makeModelCity(data, p) {
    return {
      header: p.buy + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var tritsikl_templates_defaultExport = (tritsikl_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/tritsikl/index.js


var TRITSIKL = {
    city: tritsikl_templates_defaultExport.city,
    make: tritsikl_templates_defaultExport.make,
    body: tritsikl_templates_defaultExport.body,

    city_make: tritsikl_templates_defaultExport.makeCity,
    make_model: tritsikl_templates_defaultExport.makeModel,
    city_isnew: tritsikl_templates_defaultExport.cityIsnew,
    isnew_make: tritsikl_templates_defaultExport.makeIsnew,
    body_make: tritsikl_templates_defaultExport.makeBody,
    body_isnew: tritsikl_templates_defaultExport.bodyIsnew,
    body_city: tritsikl_templates_defaultExport.bodyCity,

    city_make_model: tritsikl_templates_defaultExport.makeModelCity,
    isnew_make_model: tritsikl_templates_defaultExport.makeModelIsnew,
    city_isnew_make: tritsikl_templates_defaultExport.makeCityIsnew,
    body_make_model: tritsikl_templates_defaultExport.makeModelBody,
    make_model_year: tritsikl_templates_defaultExport.makeModelYear,
    body_isnew_make: tritsikl_templates_defaultExport.isnewMakeBody,
    body_city_make: tritsikl_templates_defaultExport.makeCityBody,
    body_city_isnew: tritsikl_templates_defaultExport.isnewBodyCity,

    isnew_make_model_year: tritsikl_templates_defaultExport.isnewMakeModelYear,
    city_isnew_make_model: tritsikl_templates_defaultExport.isnewMakeModelCity,
    body_isnew_make_model: tritsikl_templates_defaultExport.isnewMakeModelBody,
    body_city_make_model: tritsikl_templates_defaultExport.makeModelCityBody,
    body_city_isnew_make: tritsikl_templates_defaultExport.isnewMakeCityBody,

    body_city_isnew_make_model: tritsikl_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/avto/templates.js
var avto_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city) + ". \u0412\u0441\u0435 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u044B, \u0446\u0435\u043D\u044B, \u0430\u043A\u0446\u0438\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E \u0438\u0437 \u0441\u0430\u043B\u043E\u043D\u0430 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432, \u0441\u043A\u0438\u0434\u043A\u0438 \u043D\u0430 \u043D\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438. \u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0430 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city),
      title_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city) + ". \u0423\u0441\u0456 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0438, \u0446\u0456\u043D\u0438, \u0430\u043A\u0446\u0456\u0457 \u043D\u0430 \u0430\u0432\u0442\u043E \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432, \u0437\u043D\u0438\u0436\u043A\u0438 \u043D\u0430 \u043D\u043E\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456. \u0417\u0430\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0443 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city)
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + data.make + " " + p.inCity + ". \u0426\u0435\u043D\u044B, \u0430\u043A\u0446\u0438\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E \u0438\u0437 \u0441\u0430\u043B\u043E\u043D\u0430 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432 " + data.make + " \u043D\u0430 \u043D\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438. \u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + data.make + " " + p.inCity,
      title_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + data.make + " " + p.inCity + ". \u0426\u0456\u043D\u0438, \u0430\u043A\u0446\u0456\u0457 \u043D\u0430 \u0430\u0432\u0442\u043E \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432 " + data.make + " \u043D\u0430 \u043D\u043E\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456. \u0417\u0430\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + data.make + " " + p.inCity
    };
  }
};

/* harmony default export */ var avto_templates_defaultExport = (avto_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/avto/index.js


var avto_AVTO = {
  city: avto_templates_defaultExport.city,
  city_make: avto_templates_defaultExport.cityMake
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/gruzovye/templates.js
var gruzovye_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0433\u0440\u0443\u0437\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 " + p.t(data.city) + ". \u0412\u0441\u0435 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u044B \u043F\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0433\u0440\u0443\u0437\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432. \u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u0430 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0433\u0440\u0443\u0437\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 " + p.t(data.city),
      title_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0432\u0430\u043D\u0442\u0430\u0436\u043D\u0438\u0445 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 " + p.t(data.city) + ". \u0423\u0441\u0456 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0438 \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0430 \u0432\u0430\u043D\u0442\u0430\u0436\u043D\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432. \u0417\u0430\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043A\u0438 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0432\u0430\u043D\u0442\u0430\u0436\u043D\u0438\u0445 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 " + p.t(data.city)
    };
  }
};

/* harmony default export */ var gruzovye_templates_defaultExport = (gruzovye_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/gruzovye/index.js


var GRUZOVYE = {
  city: gruzovye_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/avtobus/templates.js
var avtobus_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 " + p.t(data.city) + ". \u0412\u0441\u0435 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u044B \u043F\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0431\u0443\u0441\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u043E\u0432. \u0411\u0443\u0441 \u0441 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0435\u0439. \u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u0431\u0443\u0441\u0430 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 " + p.t(data.city),
      title_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0456\u0432 " + p.t(data.city) + ". \u0423\u0441\u0456 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0438 \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0431\u0443\u0441\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0456\u0432 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0456\u0432. \u0411\u0443\u0441 \u0437 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0454\u044E. \u0417\u0430\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u0431\u0443\u0441\u0430 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0456\u0432 " + p.t(data.city)
    };
  }
};

/* harmony default export */ var avtobus_templates_defaultExport = (avtobus_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/avtobus/index.js


var AVTOBUS = {
  city: avtobus_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/vodnyi-transport/templates.js
var vodnyi_transport_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + p.inCity + ". \u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u0441\u0430\u043B\u043E\u043D\u043E\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + p.inCity,
      title_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + p.inCity + ". \u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u0441\u0430\u043B\u043E\u043D\u0456\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + p.inCity
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + data.make + " " + p.inCity + ". \u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0432\u043E\u0434\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + data.make + " \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + data.make + " " + p.inCity,
      title_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + data.make + " " + p.inCity + ". \u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0430 \u0432\u043E\u0434\u043D\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + data.make + " \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + data.make + " " + p.inCity
    };
  }
};

/* harmony default export */ var vodnyi_transport_templates_defaultExport = (vodnyi_transport_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/vodnyi-transport/index.js


var VODNYI_TRANSPORT = {
  city: vodnyi_transport_templates_defaultExport.city,
  city_make: vodnyi_transport_templates_defaultExport.cityMake
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/mototsikl/templates.js
var mototsikl_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city) + ". \u041C\u0430\u0433\u0430\u0437\u0438\u043D\u044B \u043F\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432, \u0441\u043A\u0443\u0442\u0435\u0440\u043E\u0432, \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u0446\u0435\u043D\u044B \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u0441 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0435\u0439 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043C\u043E\u0442\u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city),
      title_uk: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city) + ". \u041C\u0430\u0433\u0430\u0437\u0438\u043D\u0438 \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432, \u0441\u043A\u0443\u0442\u0435\u0440\u0456\u0432, \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u0446\u0456\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0437 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0454\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043C\u043E\u0442\u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city)
    };
  }
};

/* harmony default export */ var avtosalony_mototsikl_templates_defaultExport = (mototsikl_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/mototsikl/index.js


var mototsikl_MOTOTSIKL = {
  city: avtosalony_mototsikl_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/pritsepy/templates.js
var pritsepy_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u0434\u0438\u043B\u0435\u0440\u044B \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u0446\u0435\u043D\u044B \u043D\u0430 \u043F\u0440\u0438\u0446\u0435\u043F\u044B. \u0410\u043A\u0446\u0438\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0434\u0438\u043B\u0435\u0440\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + p.t(data.city),
      title_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u0434\u0438\u043B\u0435\u0440\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u0446\u0456\u043D\u0438 \u043D\u0430 \u043F\u0440\u0438\u0447\u0435\u043F\u0438. \u0410\u043A\u0446\u0456\u0457 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0434\u0438\u043B\u0435\u0440\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + p.t(data.city)
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0434\u0438\u043B\u0435\u0440\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + data.make + " " + p.inCity + ". \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0435 \u0434\u0438\u043B\u0435\u0440\u044B \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + data.make + " " + p.inCity,
      title_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0434\u0438\u043B\u0435\u0440\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + data.make + " " + p.inCity + ". \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0456 \u0434\u0438\u043B\u0435\u0440\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + data.make + " " + p.inCity
    };
  }
};

/* harmony default export */ var pritsepy_templates_defaultExport = (pritsepy_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/pritsepy/index.js

// body country city drive engine gearbox generation isNew location make makeTranslate model year

var PRITSEPY = {
  city: pritsepy_templates_defaultExport.city,
  city_make: pritsepy_templates_defaultExport.cityMake
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/spetstehnika/templates.js
var spetstehnika_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u0434\u0438\u043B\u0435\u0440\u043E\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + p.t(data.city),
      title_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0430 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u0434\u0438\u043B\u0435\u0440\u0456\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + p.t(data.city)
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0443 " + data.make + " \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u0434\u0438\u043B\u0435\u0440\u043E\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + data.make + " " + p.inCity,
      title_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0430 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0443 " + data.make + " \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u0434\u0438\u043B\u0435\u0440\u0456\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + data.make + " " + p.inCity
    };
  }
};

/* harmony default export */ var spetstehnika_templates_defaultExport = (spetstehnika_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/spetstehnika/index.js


var SPETSTEHNIKA = {
  city: spetstehnika_templates_defaultExport.city,
  city_make: spetstehnika_templates_defaultExport.cityMake
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates.js
/* harmony default export */ var zapchasti_avto_templates_defaultExport = ({
  transport: function transport() {
    return {
      title: 'Автозапчасти Украина. Купить запчасти на авто бу и новые. Продажа запчастей для автомобилей иномарок - Автобазар',
      title_uk: 'Автозапчастини Україна. Купити запчастини на авто бу і нові. Продаж запчастин для автомобілів іномарок - Автобазар',

      description: 'Купить автозапчасти в Украине: новые и бу запчасти на авто. Электронный каталог автомобильных запчастей на машины иномарки. Заказ и продажа запчастей на автомобили круглосуточно 24/7 по интернету на сайте Автобазар.',
      description_uk: 'Купити автозапчастини в Україні: нові та бу запчастини на авто. Електронний каталог автомобільних запчастин на іномарки. Заказ та продаж запчастин на автомобілі цілодобово 24/7 по інтернету на сайті Автобазар',

      header: 'Автозапчасти в Украине',
      header_uk: 'Автозапчастини в Україні'
    };
  },

  make: function make(data) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.makeTranslate + ': \u043A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.makeTranslate + ': \u043A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 ' + data.makeTranslate + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u2B50 \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0435',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 ' + data.makeTranslate + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u2B50 \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043E\u0440\u0438\u0433\u0456\u043D\u0430\u043B\u044C\u043D\u0456 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0456',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435',
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456'
    };
  },

  make_model: function make_model(data) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 ' + data.makeTranslate + ' ' + data.modelTranslate + ': \u043A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F  ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 ' + data.makeTranslate + ' ' + data.modelTranslate + ': \u043A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.makeTranslate + ' ' + data.modelTranslate + ' \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u2B50 \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0435',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.makeTranslate + ' ' + data.modelTranslate + ' \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u2B50 \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043E\u0440\u0438\u0433\u0456\u043D\u0430\u043B\u044C\u043D\u0456 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0456',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435',
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456'
    };
  },

  city: function city(data, p) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E \u043A\u0443\u043F\u0438\u0442\u044C ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440\u2122',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u0456 \u0430\u0432\u0442\u043E \u043A\u0443\u043F\u0438\u0442\u0438 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440\u2122',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E ' + p.inCity + ' \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440 \u2705 \u0423\u0434\u043E\u0431\u043D\u044B\u0439 \u043F\u043E\u0438\u0441\u043A \u043F\u043E \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u043C \u043F\u043E\u043C\u043E\u0436\u0435\u0442 \u0412\u0430\u043C \u0431\u044B\u0441\u0442\u0440\u043E \u0438 \u043B\u0435\u0433\u043A\u043E \u043A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E \u043F\u043E \u0432\u044B\u0433\u043E\u0434\u043D\u043E\u0439 \u0446\u0435\u043D\u0435',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u0456 \u0430\u0432\u0442\u043E ' + p.inCity + ' \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440 \u2705 \u0417\u0440\u0443\u0447\u043D\u0438\u0439 \u043F\u043E\u0448\u0443\u043A \u043F\u043E \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u0434\u043E\u043F\u043E\u043C\u043E\u0436\u0435 \u0412\u0430\u043C \u0448\u0432\u0438\u0434\u043A\u043E \u0456 \u043B\u0435\u0433\u043A\u043E \u043A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u0456 \u0430\u0432\u0442\u043E \u0437\u0430 \u0432\u0438\u0433\u0456\u0434\u043D\u043E\u044E \u0446\u0456\u043D\u043E\u044E',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043B\u0435\u0433\u043A\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E ' + p.inCity,
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u0456 \u0430\u0432\u0442\u043E ' + p.inCity
    };
  },

  city_make: function city_make(data, p) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + p.inCity + '. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0434\u043B\u044F ' + data.make + ' ' + p.inCity + ' \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + p.inCity + '. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0434\u043B\u044F ' + data.make + ' ' + p.inCity + ' \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + p.inCity,
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + p.inCity
    };
  },

  city_make_model: function city_make_model(data, p) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + data.model + ' \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.inCity + '. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' ' + p.inCity + '. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.inCity,
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' ' + p.inCity
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_dvigatel_mahovik.js
/* harmony default export */ var templates_dvigatel_mahovik_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u041C\u0430\u0445\u043E\u0432\u0438\u043A " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u0430\u0445\u043E\u0432\u0438\u043A " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_dvigatel_patrubki.js
/* harmony default export */ var templates_dvigatel_patrubki_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u041F\u0430\u0442\u0440\u0443\u0431\u043A\u0438 " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043F\u0430\u0442\u0440\u0443\u0431\u043E\u043A \u0434\u043B\u044F " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_dvigatel_klapan-egr.js
/* harmony default export */ var templates_dvigatel_klapan_egr_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u041A\u043B\u0430\u043F\u0430\u043D EGR \u0434\u043B\u044F " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u043B\u0430\u043F\u0430\u043D EGR \u0434\u043B\u044F " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_elektrika-i-elektronika_datchik-abs.js
/* harmony default export */ var templates_elektrika_i_elektronika_datchik_abs_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u0414\u0430\u0442\u0447\u0438\u043A ABS " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0434\u0430\u0442\u0447\u0438\u043A ABS " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_elektrika-i-elektronika_datchik.js
/* harmony default export */ var templates_elektrika_i_elektronika_datchik_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u0414\u0430\u0442\u0447\u0438\u043A\u0438 \u0434\u043B\u044F " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0434\u0430\u0442\u0447\u0438\u043A\u0438 \u0434\u043B\u044F " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/index.js







var AUTO = {
  transport: zapchasti_avto_templates_defaultExport.transport,
  make: zapchasti_avto_templates_defaultExport.make,
  make_model: zapchasti_avto_templates_defaultExport.make_model,

  city: zapchasti_avto_templates_defaultExport.city,
  city_make: zapchasti_avto_templates_defaultExport.city_make,
  city_make_model: zapchasti_avto_templates_defaultExport.city_make_model
};

var AVTO_DVIGATEL_MAHOVIK = {
  make: templates_dvigatel_mahovik_defaultExport.make
};

var AVTO_DVIGATEL_PATRUBKI = {
  make: templates_dvigatel_patrubki_defaultExport.make
};

var AVTO_DVIGATEL_KLAPANI__EGR = {
  make: templates_dvigatel_klapan_egr_defaultExport.make
};

var AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI = {
  make: templates_elektrika_i_elektronika_datchik_defaultExport.make
};

var AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS = {
  make: templates_elektrika_i_elektronika_datchik_abs_defaultExport.make
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avtobus/templates.js
/* harmony default export */ var zapchasti_avtobus_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 " + p.inCity + ". \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u044B \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 \u043E\u0442 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0445 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u0432, \u0430\u0432\u0442\u043E\u0440\u0430\u0437\u0431\u043E\u0440\u043E\u043A \u0438 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043B\u0438\u0446",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 " + p.inCity + ". \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0456\u0432 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 \u0432\u0456\u0434 \u043E\u0444\u0456\u0446\u0456\u0439\u043D\u0438\u0445 \u0456\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456\u0432, \u0430\u0432\u0442\u043E\u0440\u0430\u0437\u0431\u043E\u0440\u043E\u043A \u0456 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043E\u0441\u0456\u0431",

      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 " + p.inCity,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 " + p.inCity
    };
  },

  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u044B " + data.make + " " + data.model + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435",
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0438 " + data.make + " " + data.model + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avtobus/index.js


var avtobus_AVTOBUS = {
  city: zapchasti_avtobus_templates_defaultExport.city,
  make_model: zapchasti_avtobus_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/gruzovye/templates.js
/* harmony default export */ var zapchasti_gruzovye_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A " + p.inCity + ". \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043A \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u0430\u043C \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 \u043E\u0442 \u043F\u043E \u0432\u044B\u0433\u043E\u0434\u043D\u044B\u043C \u0446\u0435\u043D\u0430\u043C",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A " + p.inCity + ". \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0434\u043B\u044F \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043E \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 \u0432\u0456\u0434 \u0437\u0430 \u0432\u0438\u0433\u0456\u0434\u043D\u0438\u043C\u0438 \u0446\u0456\u043D\u0430\u043C\u0438",

      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 " + p.inCity,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A " + p.inCity
    };
  },

  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A " + data.make + " " + data.model
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/gruzovye/index.js


var gruzovye_GRUZOVYE = {
  city: zapchasti_gruzovye_templates_defaultExport.city,
  make_model: zapchasti_gruzovye_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/moto/templates.js
/* harmony default export */ var zapchasti_moto_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 " + p.inCity + ". \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 " + p.inCity + ". \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E",

      header: "\u041C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 " + p.t(data.city),
      header_uk: "\u041C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0430 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 " + p.t(data.city)
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/moto/index.js


var moto_MOTO = {
  city: zapchasti_moto_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/skuter/templates.js
/* harmony default export */ var zapchasti_skuter_templates_defaultExport = ({
  make: function make(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440  " + data.make
    };
  },
  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/skuter/index.js


var skuter_SKUTER = {
  make: zapchasti_skuter_templates_defaultExport.make,
  make_model: zapchasti_skuter_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/mototsikl/templates.js
/* harmony default export */ var zapchasti_mototsikl_templates_defaultExport = ({
  make: function make(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make
    };
  },
  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/mototsikl/index.js


var zapchasti_mototsikl_MOTOTSIKL = {
  make: zapchasti_mototsikl_templates_defaultExport.make,
  make_model: zapchasti_mototsikl_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/kvadrotsikl/templates.js
/* harmony default export */ var zapchasti_kvadrotsikl_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + p.inCity + ". \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + p.inCity + ". \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E"
    };
  },
  make: function make(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make
    };
  },
  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/kvadrotsikl/index.js


var kvadrotsikl_KVADROTSIKL = {
  city: zapchasti_kvadrotsikl_templates_defaultExport.city,
  make: zapchasti_kvadrotsikl_templates_defaultExport.make,
  make_model: zapchasti_kvadrotsikl_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/moped/templates.js
/* harmony default export */ var zapchasti_moped_templates_defaultExport = ({
  make: function make(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make
    };
  },
  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,

      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434\u044B " + data.make + " " + data.model + " \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434\u0438 " + data.make + " " + data.model + " \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/moped/index.js


var moped_MOPED = {
  make: zapchasti_moped_templates_defaultExport.make,
  make_model: zapchasti_moped_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/spetstehnika/templates.js
/* harmony default export */ var zapchasti_spetstehnika_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0430 " + p.t(data.city),
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0430 " + p.t(data.city),

      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0430 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0430 " + p.inCity + ". \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0430 " + p.inCity + ". \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0430 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0438\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/spetstehnika/index.js


var spetstehnika_SPETSTEHNIKA = {
  city: zapchasti_spetstehnika_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/pritsepy/templates.js
/* harmony default export */ var zapchasti_pritsepy_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + p.t(data.city),
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + p.t(data.city),

      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0446\u0435\u043F\u0430 " + p.inCity + ". \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043B\u0435\u0433\u043A\u043E\u0432\u044B\u0445 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0447\u0435\u043F\u0430 " + p.inCity + ". \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043B\u0435\u0433\u043A\u043E\u0432\u0438\u0445 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/pritsepy/index.js


var pritsepy_PRITSEPY = {
  city: zapchasti_pritsepy_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/tritsikl/templates.js
/* harmony default export */ var zapchasti_tritsikl_templates_defaultExport = ({
    makeModel: function makeModel(data) {
        return {
            header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
            header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model
        };
    }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/tritsikl/index.js


var tritsikl_TRITSIKL = {
    make_model: zapchasti_tritsikl_templates_defaultExport.makeModel
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/vodnyi-transport/templates.js
/* harmony default export */ var zapchasti_vodnyi_transport_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + p.t(data.city),
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + p.t(data.city),

      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + p.inCity + ". \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0441\u0443\u0434\u043E\u0432\u044B\u0445 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043E\u0442 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0438\u043B\u043B\u0435\u0440\u043E\u0432 \u0438 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043B\u0438\u0446",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + p.inCity + ". \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0441\u0443\u0434\u043D\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0431\u0443 \u0442\u0430 \u043D\u043E\u0432\u0438\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E. \u041F\u0440\u043E\u0434\u0430\u0436 \u0432\u0456\u0434 \u043E\u0444\u0456\u0446\u0456\u0439\u043D\u0438\u0445 \u0434\u0438\u043B\u043B\u0435\u0440\u0456\u0432 \u0456 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043E\u0441\u0456\u0431"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/vodnyi-transport/index.js


var vodnyi_transport_VODNYI_TRANSPORT = {
  city: zapchasti_vodnyi_transport_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/commercial/gruzovye/templates.js
var upperCaseFirst = function upperCaseFirst(str) {
  var safeStr = str || '';
  return safeStr.charAt(0).toUpperCase() + safeStr.substr(1);
};

var templates_path = {
  transporttype: function transporttype(data) {
    return {
      header: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.transportTypePluralGenitive + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435',
      header_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.transportTypePluralGenitive + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456',

      title: upperCaseFirst(data.transportTypePlural) + ': \u043A\u0443\u043F\u0438\u0442\u044C ' + data.transportTitle + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: upperCaseFirst(data.transportTypePlural) + ': \u043A\u0443\u043F\u0438\u0442\u0438 ' + data.transportTitle + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.transportTitle + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 ' + data.transportTypePlural + ', \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u0444\u043E\u0442\u043E \u0438 \u0431\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.transportTitle + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 ' + data.transportTypePlural + ', \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u0444\u043E\u0442\u043E \u0442\u0430 \u0432\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043A\u043E\u043C\u0435\u0440\u0446\u0456\u0439\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  make_transporttype: function make_transporttype(data) {
    return {
      header: upperCaseFirst(data.transportTypePlural) + ' ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435',
      header_uk: upperCaseFirst(data.transportTypePlural) + ' ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456',

      title: upperCaseFirst(data.transportTitle) + ' ' + data.makeTranslit + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C ' + data.transportTypePlural + ' ' + data.make + ' \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: upperCaseFirst(data.transportTitle) + ' ' + data.makeTranslit + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 ' + data.transportTypePlural + ' ' + data.make + ' \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.transportTypePlural + ' ' + data.make + ' \u043D\u043E\u0432\u044B\u0435 \u0438\u043B\u0438 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 ' + data.transportTypePlural + ', \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u0444\u043E\u0442\u043E \u0438 \u0431\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.transportTypePlural + ' ' + data.make + ' \u043D\u043E\u0432\u0456 \u0430\u0431\u043E \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 ' + data.transportTypePlural + ', \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u0444\u043E\u0442\u043E \u0442\u0430 \u0432\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043A\u043E\u043C\u0435\u0440\u0446\u0456\u0439\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  make_model_transporttype: function make_model_transporttype(data) {
    return {
      header: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model,
      header_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model,

      title: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.makeTranslit + ' ' + data.modelTranslit + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0445: \u043A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0426\u0435\u043D\u0430 \u043D\u0430 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u0438, \u0444\u043E\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.makeTranslit + ' ' + data.modelTranslit + ' \u0431\u0443 \u0442\u0430 \u043D\u043E\u0432\u0438\u0445: \u043A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0426\u0456\u043D\u0430 \u043D\u0430 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043A\u0438, \u0444\u043E\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u043D\u043E\u0432\u044B\u0435 \u0438 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \uD83D\uDE8C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u2B50 \u0423\u0434\u043E\u0431\u043D\u044B\u0439 \u043F\u043E\u0438\u0441\u043A \u043F\u043E \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u043C \u043F\u043E\u043C\u043E\u0436\u0435\u0442 \u0412\u0430\u043C \u043A\u0443\u043F\u0438\u0442\u044C \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u0438 ' + data.makeTranslit + ' ' + data.modelTranslit + ' \u043F\u043E \u0432\u044B\u0433\u043E\u0434\u043D\u043E\u0439 \u0446\u0435\u043D\u0435 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0435',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u043D\u043E\u0432\u0456 \u0442\u0430 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \uD83D\uDE8C \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u2B50 \u0417\u0440\u0443\u0447\u043D\u0438\u0439 \u043F\u043E\u0448\u0443\u043A \u043F\u043E \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u0434\u043E\u043F\u043E\u043C\u043E\u0436\u0435 \u0412\u0430\u043C \u043A\u0443\u043F\u0438\u0442\u0438 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043A\u0438 ' + data.makeTranslit + ' ' + data.modelTranslit + ' \u0437\u0430 \u0432\u0438\u0433\u0456\u0434\u043D\u043E\u044E \u0446\u0456\u043D\u043E\u044E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0456'
    };
  }
};

/* harmony default export */ var commercial_gruzovye_templates_defaultExport = (templates_path);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/commercial/gruzovye/index.js


var COMMERCIAL_GRUZOVYE = {
  transporttype: commercial_gruzovye_templates_defaultExport.transporttype,
  make_transporttype: commercial_gruzovye_templates_defaultExport.make_transporttype,
  make_model_transporttype: commercial_gruzovye_templates_defaultExport.make_model_transporttype
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/index.js








































/* harmony default export */ var seoTemplates_defaultExport = ({
  AVTO: AVTO,
  MOTO: MOTO,
  MOTOTSIKL: MOTOTSIKL,
  SKUTER: SKUTER,
  KVADROTSIKL: KVADROTSIKL,
  MOPED: MOPED,
  BAGGI: BAGGI,
  TRITSIKL: TRITSIKL,

  AVTOSALONY_AVTO: avto_AVTO,
  AVTOSALONY_GRUZOVYE: GRUZOVYE,
  AVTOSALONY_AVTOBUS: AVTOBUS,
  AVTOSALONY_VODNYI_TRANSPORT: VODNYI_TRANSPORT,
  AVTOSALONY_MOTOTSIKL: mototsikl_MOTOTSIKL,
  AVTOSALONY_PRITSEPY: PRITSEPY,
  AVTOSALONY_SPETSTEHNIKA: SPETSTEHNIKA,

  ZAPCHASTI_AVTO: AUTO,
  ZAPCHASTI_MOTO: moto_MOTO,
  ZAPCHASTI_AVTOBUS: avtobus_AVTOBUS,
  ZAPCHASTI_PRITSEPY: pritsepy_PRITSEPY,
  ZAPCHASTI_GRUZOVYE: gruzovye_GRUZOVYE,
  ZAPCHASTI_TRITSIKL: tritsikl_TRITSIKL,
  ZAPCHASTI_SPETSTEHNIKA: spetstehnika_SPETSTEHNIKA,
  ZAPCHASTI_VODNYI_TRANSPORT: vodnyi_transport_VODNYI_TRANSPORT,

  ZAPCHASTI_AVTO_DVIGATEL_MAHOVIK: AVTO_DVIGATEL_MAHOVIK,

  ZAPCHASTI_AVTO_DVIGATEL_PATRUBKI: AVTO_DVIGATEL_PATRUBKI,
  ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI: AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI,
  ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS: AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS,
  ZAPCHASTI_AVTO_DVIGATEL_KLAPANI__EGR: AVTO_DVIGATEL_KLAPANI__EGR,

  ZAPCHASTI_SKUTER: skuter_SKUTER,
  ZAPCHASTI_MOTOTSIKL: zapchasti_mototsikl_MOTOTSIKL,
  ZAPCHASTI_KVADROTSIKL: kvadrotsikl_KVADROTSIKL,
  ZAPCHASTI_MOPED: moped_MOPED,

  COMMERCIAL_GRUZOVYE: COMMERCIAL_GRUZOVYE
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return seoTextFinder_getSeoDataByParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__seoDataFinder__ = __webpack_require__(1252);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable no-param-reassign */



/* import { AVTO } from './seoTemplates/search/avto';
import { AVTOSALONY } from './avtosalony'; */

var avaliableTransports = {
  легковые: 'AVTO',
  'водный транспорт': 'VODNYI_TRANSPORT',
  автобусы: 'AVTOBUS',
  грузовые: 'GRUZOVYE',
  мотоциклы: 'MOTOTSIKL',
  прицепы: 'PRITSEPY',
  спецтехника: 'SPETSTEHNIKA',

  мототранспорт: 'MOTO',
  грузовики: 'GRUZOVYE',

  // UK
  легкові: 'AVTO',
  'водний транспорт': 'VODNYI_TRANSPORT',
  автобуси: 'AVTOBUS',
  вантажні: 'GRUZOVYE',
  мотоцикли: 'MOTOTSIKL',
  причепи: 'PRITSEPY',
  спецтехніка: 'SPETSTEHNIKA',

  avto: 'AVTO',
  moto: 'MOTO',

  'vodnyi-transport': 'VODNYI_TRANSPORT',
  avtobus: 'AVTOBUS',
  gruzovye: 'GRUZOVYE',
  mototsikl: 'MOTOTSIKL',
  pritsepy: 'PRITSEPY',
  spetstehnika: 'SPETSTEHNIKA',

  kvadrotsikl: 'KVADROTSIKL',
  квадроцикл: 'KVADROTSIKL',

  moped: 'MOPED',
  мопед: 'MOPED',

  skuter: 'SKUTER',
  скутер: 'SKUTER',

  baggi: 'BAGGI',
  багги: 'BAGGI',
  баггі: 'BAGGI',

  трицикл: 'TRITSIKL',
  tritsikl: 'TRITSIKL'
};

var avaliableCategories = {
  avtosalony: 'AVTOSALONY',
  zapchasti: 'ZAPCHASTI',
  commercial: 'COMMERCIAL'
};

var avaliablePartTypes = {
  маховик: 'MAHOVIK',
  // патрубок: 'PATRUBOK',
  патрубки: 'PATRUBKI',
  датчики: 'DATCHIKI',
  'датчик abs': 'DATCHIKI__ABS',
  'клапан egr': 'KLAPANI__EGR'
};

var avaliableRubrics = {
  двигатель: 'DVIGATEL',
  Двигун: 'DVIGATEL',
  'электрика и электроника': 'ELEKTRIKA__I__ELEKTRONIKA'
};

// ZAPCHASTI_AVTO_DVIGATEL_PATRUBOK,
// ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI,
// ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS,
// ZAPCHASTI_AVTO_DVIGATEL_KLAPAN__EGR,

function getTransport(params) {
  // const key = params.transport ? params.transport.toLowerCase() : '';
  var key = params.transport ? params.transport.toLowerCase() : params.transportType ? params.transportType.toLowerCase() : '';
  if (!key || !avaliableTransports[key]) return avaliableTransports.avto;
  return avaliableTransports[key];
}

function getRubric(params) {
  var key = params.rubric ? params.rubric.toLowerCase().replace('-', '__') : '';
  if (!key || !avaliableRubrics[key]) return '';
  return avaliableRubrics[key];
}

function getPartType(params) {
  var key = params.partType ? params.partType.toLowerCase().replace('-', '__') : '';
  var keyUk = params.partTypeUk ? params.partTypeUk.toLowerCase().replace('-', '__') : '';
  if (!key || !avaliablePartTypes[key.toLowerCase()]) return '';
  return avaliablePartTypes[keyUk] || avaliablePartTypes[key];
}

function makePath(params, category) {
  var transportKey = getTransport(params);
  if (!category) return transportKey;

  var partType = getPartType(params);
  var rubric = getRubric(params);
  var path = avaliableCategories[category] + '_' + transportKey;
  return '' + path + (rubric ? '_' + rubric : '') + (partType ? '_' + partType : '');
}

/**
 * Get SEO texts by input params.
 * @param {object} params 
 * @param {object} path 
 * @param {function} t 
 * @returns {object} {header: 'h1 text', title: 'meta tag title', description: 'meta tag '}
 */
var seoTextFinder_getSeoDataByParams = function getSeoDataByParams(params, t, category) {
  var city = '';
  if (_typeof(params.city) === 'object' && params.city.is_city) {
    city = params.city.title || '';
  } else if (params.location && typeof params.location === 'string' && params.location !== (params.country && params.country.title)) {
    city = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][params.location] ? params.location : '';
  }

  var path = makePath(params, category);
  var seoDataLinks = seoTemplates_defaultExport[path];

  if (!seoDataLinks) {
    return {};
  }

  // console.log(params);
  var paramsToSeo = _extends({}, params, { city: city });
  return __WEBPACK_IMPORTED_MODULE_2__seoDataFinder__["b" /* paramsToSeoData */](paramsToSeo, seoDataLinks, t);
};

/***/ }),

/***/ 1255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var RegexpInput = function (_React$Component) {
  _inherits(RegexpInput, _React$Component);

  function RegexpInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RegexpInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegexpInput.__proto__ || Object.getPrototypeOf(RegexpInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
      var value = e.target.value;
      var _this$props = _this.props,
          pattern = _this$props.pattern,
          onChange = _this$props.onChange;


      if (value.match(pattern) || value === '') {
        onChange(value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RegexpInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onChange = _props.onChange,
          inputRef = _props.inputRef,
          type = _props.type,
          props = _objectWithoutProperties(_props, ['onChange', 'inputRef', 'type']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ type: type, onChange: this.handleChange, ref: inputRef }, props));
    }
  }]);

  return RegexpInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RegexpInput.defaultProps = {
  pattern: '',
  value: undefined,
  inputRef: undefined,
  onChange: function onChange() {},
  type: 'text'
};


/* harmony default export */ __webpack_exports__["a"] = (RegexpInput);

/***/ }),

/***/ 1256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_Modal__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ModalContainer_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var isClient = true;

function ModalContainer(props) {
  var children = props.children,
      onClose = props.onClose,
      isOpen = props.isOpen,
      modalCN = props.modalCN;

  if (!isClient) return null;
  return isOpen && _jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Modal__["a" /* default */], {}, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.root
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.background,
    onClick: onClose
  }), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.content, modalCN || __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.contentParams)
  }, void 0, children)));
}

ModalContainer.defaultProps = {
  isOpen: false,
  modalCN: '',
  onClose: undefined
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a)(ModalContainer));

/***/ }),

/***/ 1257:
/***/ (function(module, exports) {

module.exports = ["dvigatel","kuzov","otoplenie-i-konditsionirovanie","pritsepnoe-oborudovanie","razborka","rulevoe-upravlenie","salon","toplivnaya-sistema","tormoznaya-sistema","hodovaya"]

/***/ }),

/***/ 1258:
/***/ (function(module, exports) {

module.exports = ["dopolnitelnoe-oborudovanie","optika-steklo-zerkala","ochistiteli-stekla-i-far","sistema-bezopasnosti","sistema-ohlazhdeniya","transmissiya","filtry","shiny-diski","elektrika-i-elektronika"]

/***/ }),

/***/ 1259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_user__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__ = __webpack_require__(184);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var withBalance = function withBalance(forceUpdate) {
  return function (WrappedComponent) {
    var _class, _temp;

    var Component = (_temp = _class = function (_React$Component) {
      _inherits(Component, _React$Component);

      function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
      }

      _createClass(Component, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (forceUpdate || this.props.balance === null) {
            this.props.fetchBalance();
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              __ = _props.fetchBalance,
              props = _objectWithoutProperties(_props, ['fetchBalance']);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
        }
      }]);

      return Component;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withBalance(' + __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
      balance: null
    }, _temp);

    var mapStateToProps = function mapStateToProps(_ref) {
      var user = _ref.user;
      return {
        balance: user.balance.amount,
        isFetching: user.balance.isFetching
      };
    };
    var mapDispatchToProps = {
      fetchBalance: __WEBPACK_IMPORTED_MODULE_3_shared_actions_user__["g" /* fetchBalance */]
    };

    return __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(Component);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (withBalance);

/***/ }),

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(319);
var TAG = __webpack_require__(86)('toStringTag');
// ES3 wrong here
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),

/***/ 1261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  CITY: 'city',
  COUNTRY: 'country'
});

/***/ }),

/***/ 1262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_routes__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_locationTypes__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__NavigationLink_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var NavigationLink = function (_React$Component) {
  _inherits(NavigationLink, _React$Component);

  function NavigationLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavigationLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavigationLink.__proto__ || Object.getPrototypeOf(NavigationLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
          link = _this$props.link,
          eventPrefix = _this$props.eventPrefix,
          onClick = _this$props.onClick;

      onClick(e);
      if (!eventPrefix) return;

      var route = link.slug || link.route;
      var pattern = new RegExp('[/]{2,}', 'g');
      var slug = ('' + eventPrefix + route).replace(pattern, '/');
      var event = __WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__["a" /* EVENTS */].NAVIGATION_LINK[slug];
      if (event) _this.props.setDataLayer(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavigationLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          including = _props.including,
          locationType = _props.locationType,
          currentRoute = _props.currentRoute,
          link = _props.link,
          className = _props.className,
          activeClassName = _props.activeClassName,
          t = _props.t;
      var route = link.route,
          injectLocations = link.injectLocations,
          title = link.title,
          _link$count = link.count,
          count = _link$count === undefined ? '' : _link$count;


      var isActive = false;
      if (currentRoute) {
        isActive = including ? currentRoute.includes(((link.slug || link.route) + '/').replace(/\/\//g, '/')) : currentRoute === ((link.slug || link.route) + '/').replace(/\/\//g, '/');
      }

      return isActive ? _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(className, activeClassName)
      }, void 0, t(title), count && _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default.a.count
      }, void 0, ' ', count)) : _jsx(__WEBPACK_IMPORTED_MODULE_9_shared_components_Link_Link__["a" /* default */], {
        onClick: this.handleClick,
        to: location && injectLocations && injectLocations.includes(locationType) && __WEBPACK_IMPORTED_MODULE_8_shared_helpers_routes__["b" /* isValidLeasingLocationRoute */](route, location.slug) ? __WEBPACK_IMPORTED_MODULE_7_shared_helpers_locale__["d" /* injectLocationIntoHref */](route, location.slug) : route,
        className: className
      }, void 0, t(title), count && _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default.a.count
      }, void 0, ' ', count));
    }
  }]);

  return NavigationLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NavigationLink.defaultProps = {
  currentRoute: null,
  location: null,
  shouldCalculateActiveState: true,
  including: false,
  className: '',
  activeClassName: '',
  onClick: function onClick() {},
  eventPrefix: ''
};


var mapStateToProps = function mapStateToProps(_ref2) {
  var globals = _ref2.globals;
  return {
    location: globals.location,
    locationType: __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json___default.a.find(function (city) {
      return city.slug === (globals.location && globals.location.slug);
    }) ? __WEBPACK_IMPORTED_MODULE_10_shared_constants_locationTypes__["a" /* default */].COUNTRY : __WEBPACK_IMPORTED_MODULE_10_shared_constants_locationTypes__["a" /* default */].CITY
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setDataLayer: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_13_shared_hocs_withTranslate__["a" /* withTranslate */](NavigationLink))));

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ 1264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4c77a327.svg";

/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1375);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Footer.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Footer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1267:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='iso-8859-1'?%3E %3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='792.033px' height='792.033px' viewBox='0 0 792.033 792.033' style='enable-background:new 0 0 792.033 792.033;' xml:space='preserve'%3E %3Cg%3E %3Cg id='_x38_'%3E %3Cg%3E %3Cpath d='M617.858,370.896L221.513,9.705c-13.006-12.94-34.099-12.94-47.105,0c-13.006,12.939-13.006,33.934,0,46.874 l372.447,339.438L174.441,735.454c-13.006,12.94-13.006,33.935,0,46.874s34.099,12.939,47.104,0l396.346-361.191 c6.932-6.898,9.904-16.043,9.441-25.087C627.763,386.972,624.792,377.828,617.858,370.896z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/UI/InputText/InputText.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UIStyle_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var InputText = function InputText(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      inputParams = _objectWithoutProperties(_ref, ['changeHandler', 'name']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({
    className: __WEBPACK_IMPORTED_MODULE_3__UIStyle_css__["inputGeneral"],
    onChange: function onChange(e) {
      return changeHandler(name, e.target.value);
    }
  }, inputParams));
};

/* harmony default export */ var InputText_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__UIStyle_css__)(InputText));
// CONCATENATED MODULE: ./src/shared/components/UI/InputBirthday/InputBirthday.js
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputBirthday___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(InputBirthday___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UIStyle_css__);
var InputBirthday__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function InputBirthday__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var InputBirthday = function InputBirthday(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      mask = _ref.mask,
      placeholder = _ref.placeholder,
      inputParams = InputBirthday__objectWithoutProperties(_ref, ['changeHandler', 'name', 'mask', 'placeholder']);

  return InputBirthday___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, InputBirthday__extends({
    className: __WEBPACK_IMPORTED_MODULE_4__UIStyle_css__["inputGeneral"],
    onChange: function onChange(e) {
      return changeHandler(name, e.target.value);
    },
    placeholder: placeholder,
    mask: mask,
    maskChar: ' '
  }, inputParams));
};

InputBirthday.defaultProps = {
  value: '',
  mask: '99/99/9999',
  placeholder: '01/01/1990'
};

/* harmony default export */ var InputBirthday_defaultExport = (InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__UIStyle_css__)(InputBirthday));
// CONCATENATED MODULE: ./src/shared/components/UI/ContactButton/ContactButton.js
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ContactButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ContactButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContactButton_css__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ContactButton_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var isMobile = "desktop" === 'mobile';

var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041D\u0435\u0442 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043E\u0432'
});

var ShowedContacts = function ShowedContacts(_ref) {
  var phones = _ref.phones;
  return _jsx('div', {
    className: isMobile ? null : __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.showedContainerDesktop
  }, void 0, phones.length ? phones.map(function (phone) {
    var nPhone = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["j" /* phoneNormalize */](phone);
    return _jsx('a', {
      href: 'tel:' + nPhone,
      className: isMobile ? __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.showedPhoneMobile : null
    }, phone, nPhone);
  }) : _ref2);
};

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0442\u0435\u043B\u0435\u0444\u043E\u043D'
});

var HidedContacts = function HidedContacts(_ref3) {
  var clickHandler = _ref3.clickHandler;
  return _jsx('button', {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hided, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hidedMobile, isMobile)),
    onClick: clickHandler
  }, void 0, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hidedContent
  }, void 0, _ref4, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hiddenPhone
  }, void 0, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.Plus
  }, void 0, '+'), _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.Dots
  }, void 0, '\u2022\u2022\u2022 \u2022\u2022 \u2022\u2022\u2022 \u2022\u2022 \u2022\u2022'))));
};

var ContactButton = function (_React$Component) {
  _inherits(ContactButton, _React$Component);

  function ContactButton() {
    var _ref5;

    var _temp, _this, _ret;

    _classCallCheck(this, ContactButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref5 = ContactButton.__proto__ || Object.getPrototypeOf(ContactButton)).call.apply(_ref5, [this].concat(args))), _this), _this.state = {
      isShowed: false,
      phones: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContactButton, [{
    key: 'onClick',
    value: function onClick(e) {
      var _this2 = this;

      this.props.loadPhones(function (phones) {
        _this2.setState({ isShowed: true, phones: phones });
      });
      this.props.clickHandler(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var phonesState = this.props.phones.length ? this.props.phones : this.state.phones;
      var phones = phonesState.map(function (phone) {
        return phone.number ? phone.number : phone;
      });
      return _jsx(ContactButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, this.state.isShowed ? _jsx(ShowedContacts, {
        phones: phones
      }) : _jsx(HidedContacts, {
        clickHandler: function clickHandler(e) {
          return _this3.onClick(e);
        }
      }));
    }
  }]);

  return ContactButton;
}(ContactButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContactButton.defaultProps = {
  phones: [],
  clickHandler: function clickHandler() {},
  loadPhones: function loadPhones(cb) {
    return cb([]);
  }
};


ShowedContacts.defaultProps = {
  phones: []
};

HidedContacts.defaultProps = {
  clickHandler: function clickHandler() {}
};

/* harmony default export */ var ContactButton_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a)(ContactButton));
// CONCATENATED MODULE: ./src/shared/components/UI/InputPhoneNumber/InputPhoneNumber.js
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(479);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__);
var InputPhoneNumber__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function InputPhoneNumber__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var InputPhoneNumber = function InputPhoneNumber(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      mask = _ref.mask,
      placeholder = _ref.placeholder,
      inputParams = InputPhoneNumber__objectWithoutProperties(_ref, ['changeHandler', 'name', 'mask', 'placeholder']);

  return InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, InputPhoneNumber__extends({
    className: InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__["inputGeneral"],
    onChange: function onChange(e) {
      return changeHandler(name, e.target.value);
    }
  }, inputParams, {
    placeholder: placeholder,
    mask: mask,
    maskChar: ' ',
    type: 'tel'
  }));
};

InputPhoneNumber.defaultProps = {
  value: '',
  mask: '+3\\8 \\099 999 99 99',
  placeholder: '+38 (0**) *** ** **'
};

/* harmony default export */ var InputPhoneNumber_defaultExport = (InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__)(InputPhoneNumber));
// CONCATENATED MODULE: ./src/shared/components/UI/CheckBox/CheckBox.js
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CheckBox___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(CheckBox___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckBox_css__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckBox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CheckBox_css__);
var CheckBox__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CheckBox__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function CheckBox__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var CheckBox = function CheckBox(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      text = _ref.text,
      inputParams = CheckBox__objectWithoutProperties(_ref, ['changeHandler', 'name', 'text']);

  return CheckBox__jsx('label', {
    className: __WEBPACK_IMPORTED_MODULE_4__CheckBox_css___default.a.checkbox
  }, void 0, CheckBox___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', CheckBox__extends({ type: 'checkbox', name: name, onChange: changeHandler }, inputParams)), ' ', CheckBox__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
    id: text
  }));
};

CheckBox.defaultProps = {
  changeHandler: function changeHandler() {}
};

/* harmony default export */ var CheckBox_defaultExport = (CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__CheckBox_css___default.a)(CheckBox));
// CONCATENATED MODULE: ./src/shared/components/UI/TagButton/TagButton.js
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TagButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(TagButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TagButton_css__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TagButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TagButton_css__);
var TagButton__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var TagButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function TagButton__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TagButton__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var TagButton = function TagButton(_ref) {
  var _cx;

  var title = _ref.title,
      clickHandler = _ref.clickHandler,
      Icon = _ref.Icon,
      disabled = _ref.disabled,
      className = _ref.className,
      inputParams = TagButton__objectWithoutProperties(_ref, ['title', 'clickHandler', 'Icon', 'disabled', 'className']);

  return TagButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    TagButton__extends({
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a((_cx = {}, TagButton__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_4__TagButton_css___default.a.tag, true), TagButton__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_4__TagButton_css___default.a.disabled, disabled), TagButton__defineProperty(_cx, className, !!className), _cx)),
      onClick: function onClick(e) {
        clickHandler(e, title);
      }
    }, inputParams),
    Icon ? TagButton__jsx(Icon, {}) : null,
    title
  );
};

TagButton.defaultProps = {
  disabled: false,
  className: '',
  Icon: null,
  clickHandler: function clickHandler() {}
};

/* harmony default export */ var TagButton_defaultExport = (TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__TagButton_css___default.a)(TagButton));
// CONCATENATED MODULE: ./src/shared/components/UI/Select/Select.js
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Select___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(477);
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select_css__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Select_css__);
var Select__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function Select__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var SelectWrapper = function SelectWrapper(params) {
  return Select__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__Select_css___default.a.root, Select__defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__Select_css___default.a['theme-' + params.theme], params.theme && __WEBPACK_IMPORTED_MODULE_4__Select_css___default.a['theme-' + params.theme]))
  }, void 0, Select___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], params));
};

/* harmony default export */ var Select_defaultExport = (Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__Select_css___default.a)(SelectWrapper));
// CONCATENATED MODULE: ./src/shared/components/UI/NumberInputWithSelect/SelectInput/SelectInput.js
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SelectInput___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectInput_css__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SelectInput_css__);
var SelectInput__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SelectInput__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SelectInput__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SelectInput__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SelectInput__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




 // eslint-disable-line css-modules/no-unused-class

var DEFAULT_SELECT_VALUE = 'default';
var stringOrNumberPropType = SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]);

var SelectInput__ref2 = SelectInput__jsx('i', {
  className: 'fa fa-angle-down'
});

var SelectInput = function (_React$Component) {
  SelectInput__inherits(SelectInput, _React$Component);

  function SelectInput() {
    var _ref;

    var _temp, _this, _ret;

    SelectInput__classCallCheck(this, SelectInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SelectInput__possibleConstructorReturn(this, (_ref = SelectInput.__proto__ || Object.getPrototypeOf(SelectInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelectChange = function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name,
          options = _this$props.options;

      var selectedOption = options[e.target.selectedIndex];

      onChange(name, selectedOption);
    }, _temp), SelectInput__possibleConstructorReturn(_this, _ret);
  }

  SelectInput__createClass(SelectInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          options = _props.options,
          value = _props.value,
          disabled = _props.disabled,
          titleKey = _props.titleKey;

      var selected = options.find(function (option) {
        return option.val === value;
      });

      return SelectInput__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.root
      }, void 0, SelectInput__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.selectContainer
      }, void 0, SelectInput__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.hint
      }, void 0, selected && (selected[titleKey] || selected.title) || '', SelectInput__ref2), SelectInput__jsx('select', {
        disabled: disabled,
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.select,
        onChange: this.handleSelectChange,
        value: value || DEFAULT_SELECT_VALUE
      }, void 0, options.map(function (item) {
        return SelectInput__jsx('option', {
          value: item.val || DEFAULT_SELECT_VALUE
        }, item.val + item.title, item[titleKey] || item.title);
      }))));
    }
  }]);

  return SelectInput;
}(SelectInput___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SelectInput.defaultProps = {
  options: [],
  onChange: function onChange() {},
  value: null,
  name: null,
  disabled: false,
  titleKey: 'title'
};


/* harmony default export */ var SelectInput_defaultExport = (SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a)(SelectInput));
// CONCATENATED MODULE: ./src/shared/components/UI/NumberInputWithSelect/NumberInputWithSelect.js
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_NumberInput_NumberInput__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_DecimalInput_DecimalInput__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css__);
var NumberInputWithSelect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var NumberInputWithSelect__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var NumberInputWithSelect__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function NumberInputWithSelect__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function NumberInputWithSelect__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function NumberInputWithSelect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NumberInputWithSelect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NumberInputWithSelect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var NumberInputWithSelect_NumberInputWithSelect = function (_React$Component) {
  NumberInputWithSelect__inherits(NumberInputWithSelect, _React$Component);

  function NumberInputWithSelect() {
    var _ref;

    var _temp, _this, _ret;

    NumberInputWithSelect__classCallCheck(this, NumberInputWithSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = NumberInputWithSelect__possibleConstructorReturn(this, (_ref = NumberInputWithSelect.__proto__ || Object.getPrototypeOf(NumberInputWithSelect)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelectChange = function (name, optionInfo) {
      var val = optionInfo.val,
          option = NumberInputWithSelect__objectWithoutProperties(optionInfo, ['val']);

      _this.props.onUnitsChange(option);
    }, _temp), NumberInputWithSelect__possibleConstructorReturn(_this, _ret);
  }

  NumberInputWithSelect__createClass(NumberInputWithSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          placeholder = _props.placeholder,
          unitsSwitchValue = _props.unitsSwitchValue,
          className = _props.className,
          error = _props.error,
          errorClassName = _props.errorClassName,
          onChange = _props.onChange,
          required = _props.required,
          decimal = _props.decimal,
          disabled = _props.disabled,
          Icon = _props.Icon,
          titleKey = _props.titleKey,
          theme = _props.theme,
          type = _props.type;

      var value = this.props.value || '';
      var unitsSwitchOptions = this.props.unitsSwitchOptions.filter(function (x) {
        return x;
      });

      var inputProps = {
        value: value,
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.input,
        placeholder: placeholder,
        onChange: onChange,
        disabled: disabled,
        type: type
      };

      return NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.root, className, NumberInputWithSelect__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a['theme-' + theme], theme && __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a['theme-' + theme]))
      }, void 0, title && NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.title, NumberInputWithSelect__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.required, required))
      }, void 0, title), NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.inline, NumberInputWithSelect__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.hasIcon, !!Icon))
      }, void 0, !!Icon && NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.icon
      }, void 0, NumberInputWithSelect__jsx(Icon, {})), decimal ? NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_components_DecimalInput_DecimalInput__["a" /* default */], inputProps) : NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_components_NumberInput_NumberInput__["a" /* default */], NumberInputWithSelect__extends({ inputMode: 'numeric' }, inputProps))), unitsSwitchOptions && unitsSwitchOptions.length > 0 && NumberInputWithSelect__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.switch
      }, void 0, NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.switchDivider
      }), unitsSwitchOptions.length === 1 && NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.singleOptionLabel
      }, void 0, unitsSwitchOptions[0][titleKey] || unitsSwitchOptions[0].title || ''), unitsSwitchOptions.length > 1 && NumberInputWithSelect__jsx(SelectInput_defaultExport, {
        options: unitsSwitchOptions.map(function (option) {
          return NumberInputWithSelect__extends({}, option, { val: option.id });
        }),
        onChange: this.handleSelectChange,
        value: unitsSwitchValue && unitsSwitchValue.id,
        titleKey: titleKey
      })), error && NumberInputWithSelect__jsx('p', {
        className: errorClassName
      }, void 0, error));
    }
  }]);

  return NumberInputWithSelect;
}(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NumberInputWithSelect_NumberInputWithSelect.defaultProps = {
  title: null,
  className: '',
  errorClassName: '',
  placeholder: '',
  unitsSwitchOptions: [],
  onChange: function onChange() {},
  onUnitsChange: function onUnitsChange() {},
  value: null,
  unitsSwitchValue: null,
  error: null,
  required: false,
  decimal: false,
  disabled: false,
  Icon: null,
  titleKey: 'title',
  theme: '',
  type: 'text'
};


/* harmony default export */ var NumberInputWithSelect_defaultExport = (NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a)(NumberInputWithSelect_NumberInputWithSelect));
// CONCATENATED MODULE: ./src/shared/components/UI/InputPriceWithCurrencies/InputPriceWithCurrencies.js
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_searchForm__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__UIStyle_css__);
var InputPriceWithCurrencies__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function InputPriceWithCurrencies__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










// import { MoneyIcon } from 'shared/components/Icons';



var sluggifiedCurrency = __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json___default.a.map(function (item) {
  return InputPriceWithCurrencies__extends({}, item, { id: item.slug });
});

var InputPriceWithCurrencies_InputPriceWithCurrencies = function InputPriceWithCurrencies(_ref) {
  var currency = _ref.currency,
      actions = _ref.actions,
      onChange = _ref.onChange,
      inputParams = InputPriceWithCurrencies__objectWithoutProperties(_ref, ['currency', 'actions', 'onChange']);

  return InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NumberInputWithSelect_defaultExport, InputPriceWithCurrencies__extends({}, inputParams, {
    // Icon={MoneyIcon}
    unitsSwitchOptions: sluggifiedCurrency,
    unitsSwitchValue: currency,
    onUnitsChange: function onUnitsChange(e) {
      actions.set.currency(e);
      onChange(inputParams.value);
    },
    onChange: onChange,
    titleKey: 'symbol'
  }));
};

InputPriceWithCurrencies_InputPriceWithCurrencies.defaultProps = {
  currency: sluggifiedCurrency[0],
  onChange: function onChange() {}
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var formState = _ref2.searchForm.selected;
  return {
    currency: formState.currency
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: {
      set: __WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */]({
        currency: __WEBPACK_IMPORTED_MODULE_6_shared_actions_searchForm__["m" /* selectedActions */].set.currency
      }, dispatch)
    }
  };
};

/* harmony default export */ var InputPriceWithCurrencies_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__UIStyle_css__)(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(InputPriceWithCurrencies_InputPriceWithCurrencies)));
// CONCATENATED MODULE: ./src/shared/components/UI/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_Button__ = __webpack_require__(1287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button_Button__["a"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return InputText_defaultExport; });
/* unused concated harmony import InputBirthday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return InputBirthday_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return ContactButton_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return InputPhoneNumber_defaultExport; });
/* unused concated harmony import CheckBox */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return CheckBox_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return TagButton_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return Select_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return NumberInputWithSelect_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return InputPriceWithCurrencies_defaultExport; });












/***/ }),

/***/ 1269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_hocs_withBalance__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Loader_Loader__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// import p24Img from './payment-4.svg';
// import billImg from './receipt.svg';


var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0433\u0440\u043D'
});

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0411\u0430\u043B\u0430\u043D\u0441'
});

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0433\u0440\u043D'
});

var _ref5 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C'
});

var _ref6 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u0438 \u043E\u043F\u043B\u0430\u0442\u0435 \u0443\u0441\u043B\u0443\u0433 \u0438\u043B\u0438 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 \u043B\u0438\u0447\u043D\u043E\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442 \u0441\u0432\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438'
});

var _ref7 = _jsx('a', {
  href: '/public-contract/',
  target: '_blank',
  rel: 'noopener noreferrer'
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430'
}));

var PaymentModal = function (_React$Component) {
  _inherits(PaymentModal, _React$Component);

  function PaymentModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PaymentModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentModal.__proto__ || Object.getPrototypeOf(PaymentModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedItem: _this.props.items[0],
      balanceRefillMode: false,
      isChecked: true
    }, _this.handleItemChosen = function (selectedItem) {
      _this.setState({ selectedItem: selectedItem });
      _this.props.agreeHandler(selectedItem);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PaymentModal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          balance = _props.balance,
          isFetching = _props.isFetching;


      if (prevProps.isFetching && !isFetching) {
        var selectedItem = this.state.selectedItem;
        var _props2 = this.props,
            amount = _props2.amount,
            items = _props2.items,
            balanceRefillMode = _props2.balanceRefillMode;

        var isBalanceEnough = amount <= balance;
        var isPayingForService = !isBalanceEnough || balanceRefillMode;
        var newSelectedItem = isPayingForService ? items.find(function (item) {
          return item.slug !== __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE;
        }) : selectedItem;

        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          selectedItem: newSelectedItem,
          balanceRefillMode: isPayingForService
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var intl = this.props.intl;
      var _props3 = this.props,
          amount = _props3.amount,
          closeHandler = _props3.closeHandler,
          title = _props3.title,
          isLoading = _props3.isLoading,
          items = _props3.items,
          balance = _props3.balance,
          isFetching = _props3.isFetching;
      var _state = this.state,
          balanceRefillMode = _state.balanceRefillMode,
          isChecked = _state.isChecked;

      var isMobile = "desktop" === 'mobile';

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.root
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.bg,
        onClick: closeHandler
      }), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.container
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.column
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Loader_Loader__["a" /* default */], {
        isLoading: isFetching,
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.loader
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.columnWrapper
      }, void 0, _jsx('h3', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.h3
      }, void 0, title && _jsx('span', {}, void 0, title, ' - '), amount, ' ', _ref2), !isFetching && balance > 0 && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.balance
      }, void 0, _ref3, ':', ' ', _jsx('b', {}, void 0, balance, ' ', _ref4)), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.list
      }, void 0, items.map(function (item) {
        var shouldDisable = !item.isBalanceRefillOption && balanceRefillMode || item.isBalanceRefillOption && !balanceRefillMode;
        // || (item.slug === PAYMENT_METHODS.INVOICE && !this.props.balanceRefillMode);
        if (_this2.props.disableBalance) {
          shouldDisable = item.slug === __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE && _this2.props.disableBalance || item.slug === __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].INVOICE && !_this2.props.balanceRefillMode;
        }
        if (item.slug === __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].FONDY_P24) shouldDisable = true;
        // todo delete this functionality when privat24 will working
        return shouldDisable ? null : _jsx('button', {
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.payment, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.disabled, isLoading)),
          onClick: function onClick() {
            return _this2.handleItemChosen(item);
          },
          disabled: isLoading || !isChecked
        }, item.slug, _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.paymentContents
        }, void 0, _jsx('img', {
          src: item.imgSrc,
          width: 60,
          alt: ''
        }), _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.paymentTitle
        }, void 0, intl.formatMessage({ id: item.title }))));
      })), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.actions
      }, void 0, _jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.button,
        onClick: closeHandler
      }, void 0, _ref5)), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.contractOffer
      }, void 0, _jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.checkbox, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.disabled, isChecked), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.mobile, isMobile)),
        onClick: function onClick() {
          return _this2.setState({ isChecked: !isChecked });
        }
      }, void 0, _jsx('input', {
        type: 'checkbox',
        defaultChecked: isChecked
      })), _ref6, ' ', _ref7))))));
    }
  }]);

  return PaymentModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PaymentModal.defaultProps = {
  balance: null,
  items: [{
    title: 'Оплатить с личного счёта',
    imgSrc: __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg___default.a,
    slug: __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE,
    isBalanceRefillOption: false
  }, {
    title: 'Оплатить картой',
    imgSrc: __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg___default.a,
    slug: __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].MONO,
    isBalanceRefillOption: true
  }],
  isLoading: false,
  balanceRefillMode: false,
  disableBalance: false
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_5_shared_hocs_withBalance__["a" /* default */](true)(PaymentModal))));

/***/ }),

/***/ 1270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DesktopButtonMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DesktopButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DesktopRightSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BannersBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_sticky__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_sticky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_modules_googletag_contentRollAdsense__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lazyload__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BannerAll_css__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












var MARGIN_TOP = 63;
var MARGIN_BOTTOM = 100;

var distanceFromBottom = 0;

var _ref2 = _jsx('div', {});

var DesktopButtonMark = function DesktopButtonMark() {
  return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
    topOffset: -68,
    disableCompensation: true
  }, void 0, function (_ref) {
    var distance = _ref.distanceFromBottom;

    distanceFromBottom = Number(distance);
    return _ref2;
  }));
};

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_modules_googletag_contentRollAdsense__["a" /* ContentRollAdsense */], {});

var DesktopButton = __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a)(function () {
  return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
    topOffset: -68,
    disableCompensation: true
  }, void 0, function (_ref3) {
    var distance = _ref3.distanceFromBottom;

    distanceFromBottom = Number(distance);
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.advertContainerButoon,
      id: 'div-gpt-ad-desktop_button-all'
    }, void 0, _ref4);
  }));
}); /* data.children */

var _ref5 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510239331518-1'
}));

var _ref6 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510224251147-0'
}));

var _ref7 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510239331518-1'
}));

var _ref8 = _jsx('div', {
  id: 'height-div-gpt-ad-1510224251147-0'
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510224251147-0'
})));

var _ref10 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510239331518-1'
}));

var _ref11 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510224251147-0'
}));

var DesktopRightSidebar = __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a)(function (data) {
  if (data.scrollNo) {
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.sideBar)
    }, void 0, _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.gptPremium
    }, void 0, _ref5), data && data.children || '', _ref6);
  } else if (data.fixedSecondBanner) {
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.sideBar)
    }, void 0, _jsx('div', {
      id: 'height-div-gpt-ad-1510239331518-1'
    }, void 0, _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.gptPremium
    }, void 0, _ref7), data && data.children || ''), _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.homeSideBar
    }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
      topOffset: -MARGIN_TOP,
      disableCompensation: true
    }, void 0, function (props) {
      var style = props.style,
          bottomDistance = props.distanceFromBottom;

      var customStyle = _extends({}, style, { top: MARGIN_TOP + 'px' });

      if (+bottomDistance < MARGIN_BOTTOM) {
        customStyle = _extends({}, style, { top: bottomDistance - 20 });
      }
      return _jsx('div', {
        style: customStyle
      }, void 0, _ref8);
    })));
  }

  return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
    topOffset: -MARGIN_TOP,
    disableCompensation: true
  }, void 0, function (_ref9) {
    var _ref9$style = _ref9.style,
        style = _ref9$style === undefined ? { transform: 'translateZ(0)' } : _ref9$style,
        distanceFromTop = _ref9.distanceFromTop,
        distanceFromBottomValue = _ref9.distanceFromBottom;

    var padding = 35;
    var scroll = MARGIN_TOP;
    var scrollTwo = 0;
    var bodyABIdBlockHeight = 0;
    var blockHeight = 0;
    var blockHeightAbove600 = false;
    var bodyABIdBlockHeightAbove = false;
    var doNotScroll = 0;

    var bannerBlock1 = 0;
    var bannerBlock2 = 0;

    if (true) {
      var heightDivDptAd1510239331518 = window.document.getElementById('height-div-gpt-ad-1510239331518-1') || {};
      var heightDivGptAd15102242511470 = window.document.getElementById('height-div-gpt-ad-1510224251147-0') || {};
      var bodyABIdBlock = window.document.getElementById('bodyABIdBlock') || {};
      bodyABIdBlockHeight = Number(bodyABIdBlock.clientHeight);
      blockHeight = Number(heightDivDptAd1510239331518.clientHeight);
      scroll = Number('-' + heightDivDptAd1510239331518.clientHeight) || MARGIN_TOP;
      scrollTwo = Number('-' + heightDivGptAd15102242511470.clientHeight) || 0;
      blockHeightAbove600 = blockHeight > 600;
      bodyABIdBlockHeightAbove = bodyABIdBlockHeight > Math.abs(distanceFromTop) + Math.abs(scrollTwo) + padding + 20 + 35;

      bannerBlock1 = Number(heightDivDptAd1510239331518.clientHeight) || 0;
      bannerBlock2 = Number(heightDivGptAd15102242511470.clientHeight) || 0;

      doNotScroll = bodyABIdBlockHeight - 130 < bannerBlock1 + bannerBlock2;
    }

    if (distanceFromBottomValue - padding - bannerBlock2 < 0) {
      scroll += distanceFromBottomValue - padding - bannerBlock2 + 35;
    } else if (!bodyABIdBlockHeightAbove) {
      scroll += bodyABIdBlockHeight - Math.abs(distanceFromTop) - Math.abs(scrollTwo) - padding - 20;
    } else if (blockHeightAbove600) {
      if (distanceFromBottom + scrollTwo + padding < 100) {
        if (distanceFromBottom + scrollTwo - MARGIN_TOP > scroll) {
          scroll = distanceFromBottom + scrollTwo;
        } else {
          scroll += padding;
        }
      } else {
        scroll = MARGIN_TOP;
      }
    } else {
      scroll = distanceFromTop;
    }

    var fun = function fun() {
      var obj = {};
      if (!blockHeightAbove600 && distanceFromTop < Number('-' + blockHeight)) {
        obj.position = 'fixed';
        obj.top = Math.abs(distanceFromTop - MARGIN_TOP) + 'px';
      }
      return obj;
    };

    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.sideBar)
    }, void 0, _jsx('div', {
      style: doNotScroll ? {} : _extends({}, style, { top: scroll + 'px' })
    }, void 0, _jsx('div', {
      id: 'height-div-gpt-ad-1510239331518-1'
    }, void 0, _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.gptPremium
    }, void 0, _ref10), data && data.children || ''), _jsx('div', {
      style: fun(),
      id: 'height-div-gpt-ad-1510224251147-0'
    }, void 0, _ref11)));
  }));
});

var BannersBuffer = __WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](function (_ref12) {
  var globals = _ref12.globals;
  return {
    bannerNotErr: globals.banner && globals.banner.bannerNotErr
  };
})(function () {
  function BannersBuffer(props) {
    var bannerNotErr = props.bannerNotErr;

    return _jsx('div', {
      style: { display: 'none' }
    }, void 0, Object.keys(bannerNotErr).map(function (a) {
      return _jsx('div', {
        id: a
      }, a, '.');
    }));
  }

  BannersBuffer.defaultProps = {
    bannerNotErr: {}
  };
  return BannersBuffer;
}());

/***/ }),

/***/ 1271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return posted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createdDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return shortCreatedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFullDate; });
/* unused harmony export getShotDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_endOfDay__ = __webpack_require__(190);



var posted = function posted(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';

  if (__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](__WEBPACK_IMPORTED_MODULE_1_date_fns_endOfDay__["default"](new Date(time)), 'yyyy-MM-dd') === __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](__WEBPACK_IMPORTED_MODULE_1_date_fns_endOfDay__["default"](new Date()), 'yyyy-MM-dd')) {
    return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'H:mm');
  }
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'MMMM d, yyyy', locale);
};

var createdDate = function createdDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'MMMM d, yyyy', locale);
};

var shortCreatedDate = function shortCreatedDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'dd.MM', locale);
};

var getFullDate = function getFullDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'H:mm, MMMM d, yyyy', locale);
};

var getShotDate = function getShotDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'dd-MM-yyyy', locale);
};

/***/ }),

/***/ 1272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUserThing; });
/* unused harmony export formatPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return verifyYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getYearsOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getParamByKey; });
/* unused harmony export rewriteMinMaxYear */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return correctionYears; });
/* unused harmony export getActiveAdvsCount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isSlotAvailable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_arrays__ = __webpack_require__(104);



var getUserName = function getUserName(_ref) {
  var _ref$first_name = _ref.first_name,
      firstName = _ref$first_name === undefined ? null : _ref$first_name,
      _ref$last_name = _ref.last_name,
      lastName = _ref$last_name === undefined ? null : _ref$last_name;
  return firstName || lastName ? [firstName, lastName].filter(function (i) {
    return !!i;
  }).join(' ') : null;
};

var getUserThing = function getUserThing(_ref2) {
  var email = _ref2.email,
      _ref2$phones = _ref2.phones,
      phones = _ref2$phones === undefined ? [] : _ref2$phones,
      name = _ref2.name;

  var verifiedPhones = phones.filter(function (phone) {
    return phone.is_verified;
  });
  var emailAndPhones = verifiedPhones.length > 0 ? '' + verifiedPhones[0].number : email;
  return name || emailAndPhones;
};

var formatPhone = function formatPhone(phone) {
  var numberPhone = phone.replace(/[+\s_()]/g, '');
  return '380' + numberPhone.slice(-9);
};

var verifyYear = function verifyYear(year) {
  return year && (year < 1900 || year > +Number(__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](new Date(), 'yyyy')));
};

var getYearsOptions = function getYearsOptions() {
  var YEAR_FROM = 1901;
  var YEAR_TO = new Date().getFullYear();
  var YEARS = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_arrays__["c" /* getRange */](YEAR_FROM, YEAR_TO);

  return YEARS.map(function (year) {
    return { title: year, val: year };
  }).reverse();
};

var getParamByKey = function getParamByKey(arr, key) {
  if (arr && arr.length) return arr[0][key];
  return null;
};

var rewriteMinMaxYear = function rewriteMinMaxYear(year) {
  if (!year) return year;else if (+year < 1900) return 1900;else if (+year > +Number(__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](new Date(), 'yyyy'))) return +Number(__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](new Date(), 'yyyy'));
  return +year;
};

var correctionYears = function correctionYears(formState) {
  var yearTo = formState.yearTo,
      yearFrom = formState.yearFrom;


  yearTo = rewriteMinMaxYear(yearTo);
  yearFrom = rewriteMinMaxYear(yearFrom);

  if (yearTo && yearFrom && yearTo < yearFrom) return { yearTo: yearFrom, yearFrom: yearTo };
  return { yearTo: yearTo, yearFrom: yearFrom };
};

/**
 * Get count of activated adverts
 * @returns {Number}
 */
var getActiveAdvsCount = function getActiveAdvsCount(user) {
  if (!user || !user.id) return 0;
  var activeKeys = Object.keys(user.active_adverts);
  var count = activeKeys.reduce(function (acc, value) {
    return acc + user.active_adverts[value];
  }, 0);
  return count;
};

/**
 * Get count of activated adverts
 * @returns {Boolean}
 */
var isSlotAvailable = function isSlotAvailable(user) {
  if (getActiveAdvsCount(user) === 0) return true;
  return !!user.tariff && user.tariff.slots_limit > getActiveAdvsCount(user);
};

/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(1285);

/***/ }),

/***/ 1275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_ModalContainer_ModalContainer__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function ModalWrapper(props) {
  return _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, props.show && _jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_ModalContainer_ModalContainer__["a" /* default */], {
    modalCN: __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.modal,
    onClose: props.toggleModal,
    isOpen: props.show
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.rootModal
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.rootModalContainer
  }, void 0, props.children, _jsx('i', {
    className: 'fa fa-times ' + __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.closeBtnIcon,
    onClick: props.toggleModal
  })))));
}

ModalWrapper.defaultProps = {
  children: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a)(ModalWrapper));

/***/ }),

/***/ 1276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IGNORE_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */

function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          var handlerOptions = null;
          var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

          if (isTouchEvent && passiveEventSupport) {
            handlerOptions = {
              passive: !_this.props.preventDefault
            };
          }

          document.addEventListener(eventName, handlersMap[_this._uid], handlerOptions);
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn);
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */

    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["a"] = (onClickOutsideHOC);

/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1260);
var ITERATOR = __webpack_require__(86)('iterator');
var Iterators = __webpack_require__(187);
module.exports = __webpack_require__(30).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),

/***/ 1280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CircleTimer_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var _ref2 = _jsx('circle', {
  fill: 'rgba(255, 217, 6, 0.2)',
  stroke: 'rgba(255, 217, 6, 0.2)',
  strokeWidth: '2',
  cx: '50%',
  cy: '50%',
  r: '50'
});

var CircleTimer = function (_React$Component) {
  _inherits(CircleTimer, _React$Component);

  function CircleTimer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CircleTimer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CircleTimer.__proto__ || Object.getPrototypeOf(CircleTimer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      formatedTime: '0:00',
      iId: 0,
      time: 0
    }, _this.componentDidMount = function () {
      _this.setState({
        time: _this.props.time,
        formatedTime: _this.formatTime(_this.props.time)
      });
      _this.startTimer();
    }, _this.componentWillUnmount = function () {
      _this.stopTimer();
    }, _this.formatTime = function (time) {
      var minutes = Math.floor(time / 60);
      var seconds = time % 60;
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      return minutes + ':' + seconds;
    }, _this.startTimer = function () {
      var self = _this;
      var _this$props = _this.props,
          time = _this$props.time,
          repeat = _this$props.repeat,
          timeUp = _this$props.timeUp;


      var callCallback = function callCallback() {
        setTimeout(timeUp);
      };

      var iId = setInterval(function () {
        if (self.state.time < 1) {
          if (!repeat) {
            try {
              self.stopTimer();
              callCallback();
            } catch (err) {}
          } else {
            self.state.time = time;
          }
        } else {
          self.state.time -= 1;
        }

        var formatedTime = self.formatTime(self.state.time);
        self.setState({ formatedTime: formatedTime });
      }, 1000);
      self.setState({ iId: iId });
    }, _this.stopTimer = function () {
      clearInterval(_this.state.iId);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CircleTimer, [{
    key: 'render',
    value: function render() {
      var seconds = this.props.time + 's';
      var animationFill = this.props.repeat ? 'remove' : 'freeze';
      return _jsx('svg', {
        className: 'circle-chart',
        viewBox: '0 0 110 110',
        width: '120',
        height: '120',
        xmlns: 'http://www.w3.org/2000/svg'
      }, void 0, _ref2, _jsx('circle', {
        className: __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default.a.circleTimerProgress,
        stroke: '#FFD906',
        strokeWidth: '2',
        strokeDasharray: '0,314',
        strokeDashoffset: '314',
        strokeLinecap: 'round',
        fill: 'none',
        cx: '50%',
        cy: '50%',
        r: '50'
      }, void 0, _jsx('animate', {
        attributeName: 'stroke-dasharray',
        dur: seconds,
        begin: '0',
        values: '0,314;314,0',
        fill: animationFill
      })), _jsx('g', {}, void 0, _jsx('text', {
        className: __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default.a.circleTimerText,
        x: '50%',
        y: '50%',
        alignmentBaseline: 'central',
        textAnchor: 'middle'
      }, void 0, this.state.formatedTime)));
    }
  }]);

  return CircleTimer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CircleTimer.defaultProps = {
  time: 300,
  repeat: false,
  timeUp: function timeUp() {}
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default.a)(CircleTimer));

/***/ }),

/***/ 1281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_components_RegexpInput_RegexpInput__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_regexp__ = __webpack_require__(317);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var NumberInput = function (_React$Component) {
  _inherits(NumberInput, _React$Component);

  function NumberInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NumberInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NumberInput.__proto__ || Object.getPrototypeOf(NumberInput)).call.apply(_ref, [this].concat(args))), _this), _this.setInputRef = function (inputRef) {
      _this.inputRef = inputRef;
    }, _this.updateSelection = function () {
      var length = _this.inputRef.value.length;


      setTimeout(function () {
        if (_this.inputRef && _this.inputRef.setSelectionRange && _this.inputRef.type === 'text') {
          _this.inputRef.setSelectionRange(length, length);
        }
      }, 0);
    }, _this.handleChange = function (value) {
      return _this.props.onChange(value.replace(/\s/g, ''));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NumberInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.inputRef && this.props.autoFocus) {
        this.inputRef.focus();
        this.updateSelection();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.updateSelection();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          separateThousands = _props.separateThousands,
          props = _objectWithoutProperties(_props, ['value', 'separateThousands']);

      var safeValue = value || '';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_components_RegexpInput_RegexpInput__["a" /* default */], _extends({}, props, {
        pattern: __WEBPACK_IMPORTED_MODULE_4_shared_constants_regexp__["c" /* numberWithSpacesRegexp */],
        value: separateThousands ? __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__["k" /* numberWithSpaces */](safeValue) : safeValue,
        onChange: this.handleChange,
        inputRef: this.setInputRef
      }));
    }
  }]);

  return NumberInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NumberInput.defaultProps = {
  onChange: function onChange() {},
  value: '',
  autoFocus: false,
  separateThousands: true
};
/* harmony default export */ __webpack_exports__["a"] = (NumberInput);

/***/ }),

/***/ 1282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/ChooseLanguageDialog/ChooseLanguageDialog.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_components_ModalWrapper_ModalWrapper__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_LeasingOnlineBanner_CircleTimer_CircleTimer__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__history__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// import { FormattedMessage } from 'react-intl';














var cookieKey = 'chlc';

var ChooseLanguageDialog = function (_React$Component) {
  _inherits(ChooseLanguageDialog, _React$Component);

  function ChooseLanguageDialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChooseLanguageDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChooseLanguageDialog.__proto__ || Object.getPrototypeOf(ChooseLanguageDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showModal: true
    }, _this.onChoose = function (lang) {
      __WEBPACK_IMPORTED_MODULE_3_js_cookie__["set"](cookieKey, lang);
      var redirectUrl = __WEBPACK_IMPORTED_MODULE_10_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].location.pathname, lang);
      _this.props.changeLocation(redirectUrl);
      __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].push(redirectUrl);
      window.location.reload();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChooseLanguageDialog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var locale = this.props.intl.locale;


      var pathname = __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].location && __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].location.pathname;
      var lng = __WEBPACK_IMPORTED_MODULE_3_js_cookie__["get"](cookieKey);
      if (locale === 'uk' || lng || pathname !== '/') return null;

      var time = 10;

      return _jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_ModalWrapper_ModalWrapper__["a" /* default */], {
        toggleModal: function toggleModal() {},
        show: this.state.showModal
      }, void 0, _jsx('h3', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.title
      }, void 0, '\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043C\u043E\u0432\u043D\u0443 \u0432\u0435\u0440\u0441\u0456\u044E \u0441\u0430\u0439\u0442\u0443'), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.text
      }, void 0, '\u042F\u043A\u0449\u043E \u0432\u0438 \u043D\u0435 \u0437\u0440\u043E\u0431\u0438\u0442\u0435 \u0432\u0438\u0431\u0456\u0440, \u0412\u0430\u0441 \u0431\u0443\u0434\u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0430 \u0432\u0435\u0440\u0441\u0456\u044E \u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u043E\u044E \u043C\u043E\u0432\u043E\u044E \u0447\u0435\u0440\u0435\u0437 10 \u0441\u0435\u043A\u0443\u043D\u0434\u2026'), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.timer + ' container-center'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_shared_components_LeasingOnlineBanner_CircleTimer_CircleTimer__["a" /* default */], {
        time: time,
        timeUp: function timeUp() {
          _this2.onChoose('uk');
        }
      })), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.buttons
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_UI__["a" /* Button */], {
        type: 'button',
        userTranslate: false,
        text: '\u0417\u0430\u043B\u0438\u0448\u0438\u0442\u0438\u0441\u044C \u043D\u0430 \u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0456\u0439',
        onClick: function onClick() {
          return _this2.onChoose('uk');
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_UI__["a" /* Button */], {
        type: 'button',
        userTranslate: false,
        text: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0443',
        theme: 'DisabledStyle',
        onClick: function onClick() {
          return _this2.onChoose('ru');
        }
      })));
    }
  }]);

  return ChooseLanguageDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    changeLocation: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__["r" /* setLocation */], dispatch)
  };
};
/* harmony default export */ var ChooseLanguageDialog_defaultExport = (__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */](null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](ChooseLanguageDialog))));
// CONCATENATED MODULE: ./src/shared/components/Logo/Logo.js
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Logo___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Logo___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Logo_css__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Logo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Logo_css__);
var Logo__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












function Logo(props) {
  var t = props.t;

  var logo = t('locale') === 'uk' ? __WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg___default.a : __WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg___default.a;
  return Logo__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_7__Logo_css___default.a.brandLogo,
    to: '/'
  }, void 0, Logo__jsx('img', {
    src: logo,
    width: '155',
    height: '36',
    style: { display: 'block' },
    title: t('Купить и продать авто в Украине на Автобазар'),
    alt: t('Покупка и продажа авто в Украине на Автобазар')
  }));
}

Logo.defaultProps = {};


/* harmony default export */ var Logo_defaultExport = (Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__Logo_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__["a" /* withTranslate */](Logo)));
// CONCATENATED MODULE: ./src/shared/helpers/abtesting.js
// import { experimentDebugger, emitter } from '@marvelapp/react-ab-test';

var setToDataLayer = function setToDataLayer() {
  window.dataLayer.push(arguments);
};

// const implementExperiment = (experimentName, value) => {
//   console.log(`Experiment: ${experimentName}, Set value ${value}`);
//   emitter.setActiveVariant(experimentName, value);
// };

// export const initOptimizeExperiment = (
//   experimentName,
//   variants = ['0', '1'],
//   defaultVariant = '0',
// ) => {
//   if (process.env.BROWSER && window.App && window.App.optimize && !window.App.optimize.debug) {
//     const experiment = window.App.optimize.experiments.find(e => e.name === experimentName);
//     if (experiment && experiment.id) {
//       setTimeout(() => {
//         setToDataLayer('event', 'optimize.callback', {
//           name: experiment.id,
//           callback: value => {
//             implementExperiment(experimentName, value);
//           },
//         });
//       }, 1);
//     }
//   } else {
//     experimentDebugger.enable();
//   }

//   emitter.defineVariants(experimentName, variants);
//   emitter.setActiveVariant(experimentName, defaultVariant);
// };

var initOptimizeExperiment = function initOptimizeExperiment(experimentName) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (true && window.App && window.App.optimize && !window.App.optimize.debug) {
    var experiment = window.App.optimize.experiments.find(function (e) {
      return e.name === experimentName;
    });
    if (experiment && experiment.id) {
      setTimeout(function () {
        setToDataLayer('event', 'optimize.callback', {
          name: experiment.id,
          callback: callback
        });
      }, 1);
    }
  } else {
    callback('0');
  }
};
// CONCATENATED MODULE: ./src/desktop/components/Navigation/NavigationItem/NavigationItem.js
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NavigationItem___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NavigationItem___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_NavigationLink_NavigationLink__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__NavigationItem_css__);
var NavigationItem__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function NavigationItem(props) {
  var isActive = props.isActive;

  var _props$item = props.item,
      childItems = _props$item.items,
      item = _objectWithoutProperties(_props$item, ['items']);

  return NavigationItem__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.root, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.active, isActive))
  }, void 0, NavigationItem__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_NavigationLink_NavigationLink__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.link,
    link: item,
    eventPrefix: props.eventPrefix
  }), childItems && childItems.length > 0 && NavigationItem__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.dropdown
  }, void 0, childItems.map(function (child) {
    return NavigationItem__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_NavigationLink_NavigationLink__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.dLink,
      link: child,
      eventPrefix: '' + props.eventPrefix + item.route
    }, child.title);
  })));
}

NavigationItem.defaultProps = {
  isActive: false,
  eventPrefix: ''
};


/* harmony default export */ var NavigationItem_defaultExport = (NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a)(NavigationItem));
// CONCATENATED MODULE: ./src/desktop/components/Navigation/ProfileButton/ProfileButton.js
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ProfileButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ProfileButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_desktop_constants_navigation__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_users__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ProfileButton_css__);
var ProfileButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();











var ProfileButton__ref = ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u044B\u0439\u0442\u0438'
});

function ProfileButton(props) {
  var user = props.user;

  var buttonTitle = __WEBPACK_IMPORTED_MODULE_7_shared_helpers_users__["d" /* getUserThing */](user);
  var avatar = user.avatar;
  var avatarImg = avatar && avatar.replace('http:', 'https:');
  return ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.root
  }, void 0, ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.link,
    to: '/my/'
  }, void 0, avatarImg && ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.avatarContainer
  }, void 0, ProfileButton__jsx('img', {
    alt: '',
    src: avatarImg,
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.avatar
  })), ProfileButton__jsx('div', {
    title: buttonTitle,
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.btnTitle
  }, void 0, buttonTitle)), ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdown
  }, void 0, ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdownList
  }, void 0, __WEBPACK_IMPORTED_MODULE_5_desktop_constants_navigation__["a" /* default */].PROFILE.map(function (link) {
    return ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdownLink,
      to: link.route
    }, link.route, ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
      id: link.title
    }));
  }), ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    onClick: props.logout,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdownLink, __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.logout),
    to: '/login/'
  }, void 0, ProfileButton__ref))));
}

ProfileButton.defaultProps = {
  logout: function logout() {}
};


/* harmony default export */ var ProfileButton_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a)(ProfileButton));
// CONCATENATED MODULE: ./src/desktop/components/Navigation/Navigation.js
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Navigation___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_desktop_constants_navigation__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_actions_user__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Navigation_css__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Navigation_css__);
var Navigation__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Navigation__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Navigation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Navigation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Navigation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var _ref2 = Navigation__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg___default.a,
  width: '16',
  height: '16',
  alt: '\u041F\u0440\u043E\u0434\u0430\u0442\u044C'
});

var _ref3 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u043E\u0434\u0430\u0442\u044C'
});

var _ref4 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u043E\u0439\u0442\u0438'
});

var Navigation_Navigation = function (_React$Component) {
  Navigation__inherits(Navigation, _React$Component);

  function Navigation() {
    var _ref;

    var _temp, _this, _ret;

    Navigation__classCallCheck(this, Navigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Navigation__possibleConstructorReturn(this, (_ref = Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      addLink: '/add/avto/',
      addRel: ''
    }, _this.componentDidMount = function () {
      initOptimizeExperiment('AddFormAB', function (value) {
        var addLinks = {
          '0': { link: '/add/avto/', rel: '' },
          '1': { link: '/addv2/avto/', rel: 'nofollow' }
        };
        if (value && addLinks[value]) {
          _this.setState({
            addLink: addLinks[value].link,
            addRel: addLinks[value].rel
          });
        }
      });
    }, _this.handleSellClick = function () {
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_9_shared_constants_gtmEvents__["a" /* EVENTS */].sellCarButtonClick);
    }, _temp), Navigation__possibleConstructorReturn(_this, _ret);
  }

  Navigation__createClass(Navigation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          history = _props.history,
          current = _props.current,
          shouldSetNoIndex = _props.shouldSetNoIndex;

      var token = user && user.token;

      var currentPath = history.currentPath;

      var currentRoute = current || __WEBPACK_IMPORTED_MODULE_7_desktop_constants_navigation__["a" /* default */].HEADER.filter(function (a) {
        var route = typeof a.route === 'string' && a.route || '';
        currentPath = typeof currentPath === 'string' && currentPath || '';
        return new RegExp('^' + route, 'mi').test(currentPath);
      })[0];

      return Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.root,
        role: 'navigation'
      }, void 0, Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.left
      }, void 0, Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.flexRow
      }, void 0, __WEBPACK_IMPORTED_MODULE_7_desktop_constants_navigation__["a" /* default */].HEADER.map(function (item, i) {
        return Navigation__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.navItem)
        }, i, Navigation__jsx(NavigationItem_defaultExport, {
          item: item,
          isActive: item === currentRoute,
          eventPrefix: 'headerNavigation'
        }));
      }))), Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.right
      }, void 0, Navigation__jsx(Navigation___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
        onClick: this.handleSellClick,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.link, __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.sell),
        to: this.state.addLink,
        rel: this.state.addRel
      }, void 0, _ref2, '\xA0', _ref3), token && user ? Navigation__jsx(ProfileButton_defaultExport, {
        logout: this.props.userLogout,
        user: user.user
      }) : Navigation__jsx(Navigation___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.link, __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.highlight),
        shouldSetNoIndex: shouldSetNoIndex,
        to: '/login',
        rel: 'nofollow'
      }, void 0, _ref4)));
    }
  }]);

  return Navigation;
}(Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Navigation_Navigation.defaultProps = {
  user: {},
  history: {},
  current: null,
  shouldSetNoIndex: true
};


var Navigation_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userLogout: function userLogout() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8_shared_actions_user__["t" /* userLogout */]());
    },
    setDataLayer: __WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_10_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user,
    history: state.history
  };
};

/* harmony default export */ var Navigation_defaultExport = (__WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps, Navigation_mapDispatchToProps)(Navigation_Navigation)));
// CONCATENATED MODULE: ./src/desktop/components/Header/Header.js
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_nprogress__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header_css__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Header_css__);
var Header__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Header__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var NProgresStart = false;
var NProgresTimeoutStart = void 0;
var NProgresTimeoutDone = void 0;

var Header__ref = Header__jsx(Logo_defaultExport, {});

var Header__ref2 = Header__jsx(Navigation_defaultExport, {});

var Header = function (_React$Component) {
  Header__inherits(Header, _React$Component);

  function Header() {
    Header__classCallCheck(this, Header);

    return Header__possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  Header__createClass(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default.a.configure({
        showSpinner: false
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var loading = this.props.loading;

      if (loading.start && !NProgresStart) {
        NProgresStart = true;
        NProgresTimeoutStart = setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default.a.start();
        }, 300);
      }

      if (!loading.start) {
        clearTimeout(NProgresTimeoutDone);
        NProgresTimeoutDone = setTimeout(function () {
          clearTimeout(NProgresTimeoutStart);
          NProgresStart = false;
          __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default.a.done();
        }, 500);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return Header__jsx('div', {
        className: Header___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__Header_css___default.a.root, __WEBPACK_IMPORTED_MODULE_7__Header_css___default.a.fixed)
      }, void 0, Header__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__Header_css___default.a.container
      }, void 0, Header__ref, Header__ref2));
    }
  }]);

  return Header;
}(Header___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Header.defaultProps = {
  location: null,
  locations: null
};


var Header_mapStateToProps = function mapStateToProps(_ref3) {
  var loading = _ref3.loading;
  return {
    loading: loading
  };
};

/* harmony default export */ var Header_defaultExport = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__Header_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](Header_mapStateToProps)(Header)));
// CONCATENATED MODULE: ./src/desktop/components/Balance/Balance.js
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Balance___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Balance___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_onclickoutside__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_desktop_components_BalanceRefill_BalanceRefill__ = __webpack_require__(1288);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_hocs_withBalance__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Balance_css__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Balance_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Balance_css__);
var Balance__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Balance__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Balance__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Balance__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Balance__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Balance = function (_React$Component) {
  Balance__inherits(Balance, _React$Component);

  function Balance() {
    var _ref;

    var _temp, _this, _ret;

    Balance__classCallCheck(this, Balance);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Balance__possibleConstructorReturn(this, (_ref = Balance.__proto__ || Object.getPrototypeOf(Balance)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isPopupOpened: false,
      shouldFreeze: false
    }, _this.togglePopup = function (e) {
      e.preventDefault();
      _this.setState(function (_ref2) {
        var isPopupOpened = _ref2.isPopupOpened;
        return { isPopupOpened: !isPopupOpened };
      });
    }, _this.handleClickOutside = function () {
      if (!_this.state.shouldFreeze) {
        _this.setState({ isPopupOpened: false });
      }
    }, _this.handleModalOpen = function () {
      _this.setState({ shouldFreeze: true });
    }, _this.handleModalClose = function () {
      _this.setState({ shouldFreeze: false });
    }, _temp), Balance__possibleConstructorReturn(_this, _ret);
  }

  Balance__createClass(Balance, [{
    key: 'render',
    value: function render() {
      var balance = this.props.balance;
      var isPopupOpened = this.state.isPopupOpened;


      if (balance === null) {
        return null;
      }

      return Balance__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.root
      }, void 0, Balance__jsx(Balance___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
        to: '/billing/',
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.content,
        onClick: this.togglePopup
      }, void 0, Balance__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.icon,
        src: __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg___default.a,
        alt: '',
        height: 22
      }), '  ', ' ', Balance__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.title
      }, void 0, balance, ' \u0433\u0440\u043D')), Balance__jsx(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default.a, {
        transitionName: 'fadeUp',
        transitionEnterTimeout: 100,
        transitionLeaveTimeout: 100
      }, void 0, isPopupOpened && Balance__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.popup
      }, void 0, Balance__jsx(__WEBPACK_IMPORTED_MODULE_5_desktop_components_BalanceRefill_BalanceRefill__["a" /* default */], {
        onModalOpen: this.handleModalOpen,
        onModalClose: this.handleModalClose
      }))));
    }
  }]);

  return Balance;
}(Balance___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Balance.defaultProps = {
  balance: null
};


/* harmony default export */ var Balance_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a)(__WEBPACK_IMPORTED_MODULE_7_shared_hocs_withBalance__["a" /* default */]()(__WEBPACK_IMPORTED_MODULE_2_react_onclickoutside__["a" /* default */](Balance))));
// CONCATENATED MODULE: ./src/desktop/components/SubHeader/SubHeader.js
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InlineNav_InlineNav__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubHeader_css__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css__);
var SubHeader__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SubHeader__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SubHeader__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SubHeader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SubHeader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SubHeader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SubHeader__ref2 = SubHeader__jsx(Balance_defaultExport, {});

var SubHeader = function (_React$Component) {
  SubHeader__inherits(SubHeader, _React$Component);

  function SubHeader() {
    var _ref;

    var _temp, _this, _ret;

    SubHeader__classCallCheck(this, SubHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SubHeader__possibleConstructorReturn(this, (_ref = SubHeader.__proto__ || Object.getPrototypeOf(SubHeader)).call.apply(_ref, [this].concat(args))), _this), _this.isActive = function (tariff) {
      var expireDate = tariff && tariff.expire_date && new Date(tariff.expire_date);
      var today = new Date();

      return expireDate > today;
    }, _temp), SubHeader__possibleConstructorReturn(_this, _ret);
  }

  SubHeader__createClass(SubHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          navLinks = _props.navLinks,
          currentRoute = _props.currentRoute,
          personalSubheader = _props.personalSubheader,
          user = _props.user,
          including = _props.including,
          intl = _props.intl;

      var sparePartsTariff = user && user.spareparts_tariff;

      return SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.root,
        role: 'navigation'
      }, void 0, SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.container
      }, void 0, SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.left
      }, void 0, SubHeader__jsx(__WEBPACK_IMPORTED_MODULE_7__InlineNav_InlineNav__["a" /* default */], {
        navLinks: navLinks,
        currentRoute: currentRoute,
        including: including,
        eventPrefix: 'subHeader'
      })), SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.right
      }, void 0, personalSubheader && SubHeader__jsx('div', {}, void 0, sparePartsTariff && sparePartsTariff.slug && SubHeader__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
        to: '/profile/',
        className: SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.tariff, SubHeader__defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.nonActiveTariff, !this.isActive(sparePartsTariff))),
        title: this.isActive(sparePartsTariff) ? undefined : intl.formatMessage({ id: 'Действие пакета закончилось' })
      }, void 0, SubHeader__jsx(SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
        id: sparePartsTariff.title
      })), user.tariff && user.tariff.is_business && SubHeader__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
        to: '/profile/',
        className: SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.tariff, SubHeader__defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.nonActiveTariff, !this.isActive(user.tariff))),
        title: this.isActive(user.tariff) ? undefined : intl.formatMessage({ id: 'Действие пакета закончилось' })
      }, void 0, SubHeader__jsx(SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
        id: user.tariff.title
      })), SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.balance
      }, void 0, SubHeader__ref2)))));
    }
  }]);

  return SubHeader;
}(SubHeader___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SubHeader.defaultProps = {
  currentRoute: ''
};


var SubHeader_mapStateToProps = function mapStateToProps(_ref3) {
  var user = _ref3.user;
  return {
    user: user.user
  };
};

/* harmony default export */ var SubHeader_defaultExport = (SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a)(SubHeader___WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](SubHeader_mapStateToProps, {})(SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */](SubHeader))));
// CONCATENATED MODULE: ./src/shared/hocs/withFooterLocations.js
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(withFooterLocations___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__history__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_urls__ = __webpack_require__(312);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var withFooterLocations__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function withFooterLocations__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function withFooterLocations__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function withFooterLocations__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var withFooterLocations = function withFooterLocations(WrappedComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_React$Component) {
    withFooterLocations__inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      withFooterLocations__classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = withFooterLocations__possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.getPath = function (routeName, state, location) {
        var transport = state.transport || _this.props.seoSearchUrlResponse && _this.props.seoSearchUrlResponse.transport;
        var make = state.make && state.make.slug || _this.props.seoSearchUrlResponse && _this.props.seoSearchUrlResponse.make;

        var params = _extends({}, state, { make: make, transport: transport, location: location });

        switch (routeName) {
          case 'search':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["e" /* generateSearchUrl */](params);
          case 'moto':
            return '/moto/' + (location ? location.slug : '') + '/';
          case 'commercial':
            return '/commercial/' + (location ? location.slug : '') + '/';
          case 'dealers':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["a" /* generateDealersSearchUrl */](params);
          case 'firms':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["b" /* generateFirmsSearchUrl */](params);
          case 'auto-parts':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["f" /* generateSparesSearchUrl */](params);

          default:
            if (transport && transport.slug) {
              return '/' + transport.slug + '/' + (location ? location.slug : '') + '/';
            }

            return location ? location.slug : '';
        }
      }, _this.handleLinkClick = function (e, location) {
        var routeName = _this.props.routeName;

        e.preventDefault();
        _this.props.onLocationChange(location);

        if (routeName) {
          __WEBPACK_IMPORTED_MODULE_7__history__["a" /* default */].push(_this.updateUrl(location));
        } else {
          __WEBPACK_IMPORTED_MODULE_7__history__["a" /* default */].push();
        }
      }, _this.updateUrl = function (location, url) {
        var _this$props = _this.props,
            formState = _this$props.formState,
            locale = _this$props.locale,
            routeName = _this$props.routeName;

        var state = _extends({}, formState, { location: location });
        var pathname = _this.getPath(routeName, state, location);

        if (url) {
          return __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_6_shared_modules__["v" /* urlReplaceSlash */](url), locale);
        }

        if (routeName === 'home' && typeof pathname === 'string' && pathname.includes('avto/')) {
          return __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_6_shared_modules__["v" /* urlReplaceSlash */](pathname), locale);
        }

        return __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_6_shared_modules__["v" /* urlReplaceSlash */]('/' + (routeName === 'home' ? 'avto/' : '') + pathname + '/'), locale);
      }, _temp), withFooterLocations__possibleConstructorReturn(_this, _ret);
    }

    withFooterLocations__createClass(_class, [{
      key: 'render',
      value: function render() {
        return withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, {
          getPath: this.getPath,
          updateUrl: this.updateUrl,
          handleLinkClick: this.handleLinkClick
        }));
      }
    }]);

    return _class;
  }(withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withFooterLocations(' + __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    list: [],
    className: '',
    historyStore: {},
    locationLinkBuilder: null,
    routeName: null,
    resetHeader: null,
    seoSearchUrlResponse: {}
  }, _temp2;
};

var withFooterLocations_mapStateToProps = function mapStateToProps(_ref2) {
  var globals = _ref2.globals,
      historyState = _ref2.history,
      searchForm = _ref2.searchForm;
  return {
    locale: globals.locale,
    location: globals.location,
    routeName: historyState && historyState.currentRouteName,
    formState: searchForm && searchForm.selected,
    currentPath: historyState.currentPath,
    seoSearchUrlResponse: globals.seoSearchUrlResponse
  };
};
var withFooterLocations_mapDispatchToProps = {
  onLocationChange: __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["r" /* setLocation */]
};

/* harmony default export */ var withFooterLocations_defaultExport = (function (component) {
  return __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](withFooterLocations_mapStateToProps, withFooterLocations_mapDispatchToProps)(withFooterLocations(component));
});
// CONCATENATED MODULE: ./src/desktop/components/Footer/ColumnList/ColumnList.js
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ColumnList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ColumnList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColumnList_css__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css__);
var ColumnList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ColumnList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ColumnList__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ColumnList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ColumnList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ColumnList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ColumnList__ref2 = ColumnList__jsx('span', {}, void 0, '> ');

var ColumnList = function (_React$Component) {
  ColumnList__inherits(ColumnList, _React$Component);

  function ColumnList() {
    var _ref;

    var _temp, _this, _ret;

    ColumnList__classCallCheck(this, ColumnList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = ColumnList__possibleConstructorReturn(this, (_ref = ColumnList.__proto__ || Object.getPrototypeOf(ColumnList)).call.apply(_ref, [this].concat(args))), _this), _this.buildBreadCrumbs = function (selectedLocation, titleKey) {
      if (selectedLocation.is_admin_center) {
        var region = selectedLocation.parents.find(function (item) {
          return item.is_region;
        });
        return ColumnList__jsx(ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, ColumnList__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__["a" /* default */], {
          to: _this.props.updateUrl(region),
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.curentBreadCrumbs, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.cursorPointer)
        }, void 0, ColumnList__jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.hideHover
        }, void 0, '> '), region[titleKey]), ColumnList__jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.curentBreadCrumbs)
        }, void 0, ColumnList__ref2, selectedLocation[titleKey]));
      }
      return ColumnList__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.curentBreadCrumbs)
      }, void 0, '> ', selectedLocation[titleKey]);
    }, _temp), ColumnList__possibleConstructorReturn(_this, _ret);
  }

  ColumnList__createClass(ColumnList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          list = _props.list,
          className = _props.className,
          resetHeader = _props.resetHeader,
          updateUrl = _props.updateUrl,
          search = _props.search,
          selectedLocation = _props.selectedLocation,
          isRegion = _props.isRegion,
          titleKey = _props.titleKey;


      return ColumnList__jsx('div', {
        className: !isRegion ? __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.root : ''
      }, void 0, ColumnList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.breadCrumbsBlock
      }, void 0, search ? ColumnList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationText
      }, void 0, resetHeader) : isRegion && ColumnList__jsx(ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, ColumnList__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__["a" /* default */], {
        to: updateUrl(null),
        className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink
      }, void 0, resetHeader), selectedLocation && this.buildBreadCrumbs(selectedLocation, titleKey))), ColumnList__jsx('div', {
        className: className
      }, void 0, list.map(function (columnItems) {
        return ColumnList__jsx('ul', {
          className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.column
        }, columnItems[0].id, columnItems.map(function (columnItem) {
          if ((columnItem.disabled || columnItem.selectedLocation) && !search) {
            return ColumnList__jsx('p', {
              className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.disabledCity, ColumnList__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.selLocation, columnItem.selectedLocation))
            }, columnItem.id, columnItem[titleKey]);
          }
          return ColumnList__jsx('li', {
            className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.item
          }, columnItem.id + '-link', ColumnList__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__["a" /* default */], {
            to: search ? updateUrl(null, columnItem.url) : updateUrl(columnItem),
            className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.link,
            title: columnItem.hint
          }, void 0, columnItem[titleKey]));
        }));
      })));
    }
  }]);

  return ColumnList;
}(ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ColumnList.defaultProps = {
  list: [],
  className: '',
  titleKey: 'title',
  locationLinkBuilder: null,
  routeName: null,
  resetHeader: null,
  search: false,
  isRegion: false,
  selectedLocation: undefined
};


/* harmony default export */ var ColumnList_defaultExport = (withFooterLocations_defaultExport(ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a)(ColumnList___WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */](ColumnList))));
// CONCATENATED MODULE: ./src/desktop/components/Footer/LocationList/LocationList.js
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LocationList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LocationList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LocationList_css__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LocationList_css__);
var LocationList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LocationList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function LocationList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocationList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LocationList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var isMobile = "desktop" === 'mobile';

var LocationList_LocationList = function (_Component) {
  LocationList__inherits(LocationList, _Component);

  function LocationList() {
    var _ref;

    var _temp, _this, _ret;

    LocationList__classCallCheck(this, LocationList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LocationList__possibleConstructorReturn(this, (_ref = LocationList.__proto__ || Object.getPrototypeOf(LocationList)).call.apply(_ref, [this].concat(args))), _this), _this.createColumns = function (arr, columnCount) {
      var maxColumnLength = Math.ceil(arr.length / columnCount);

      return arr.reduce(function (result, item, i) {
        return i % (maxColumnLength > 6 ? 6 : maxColumnLength) === 0 ? [].concat(_toConsumableArray(result), [[item]]) : [].concat(_toConsumableArray(result.slice(0, result.length - 1)), [[].concat(_toConsumableArray(result[result.length - 1]), [item])]);
      }, []);
    }, _temp), LocationList__possibleConstructorReturn(_this, _ret);
  }

  LocationList__createClass(LocationList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cities = _props.cities,
          columnCount = _props.columnCount,
          search = _props.search,
          selectedLocation = _props.selectedLocation,
          isRegion = _props.isRegion,
          titleKey = _props.titleKey,
          title = _props.title;

      var citiesColumns = this.createColumns(cities, columnCount);
      var rooClass = isMobile ? __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.rootMobile : __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.root;
      return LocationList__jsx('div', {
        className: rooClass
      }, void 0, title && LocationList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.title
      }, void 0, title), LocationList__jsx('div', {}, void 0, LocationList__jsx(ColumnList_defaultExport, {
        selectedLocation: selectedLocation,
        search: search,
        isRegion: isRegion,
        resetHeader: isRegion ? LocationList__jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
          id: search ? 'Популярные запросы' : 'Вся Украина'
        }) : '',
        list: citiesColumns,
        className: __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.citiesList,
        titleKey: titleKey
      })));
    }
  }]);

  return LocationList;
}(LocationList___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LocationList_LocationList.defaultProps = {
  countries: [],
  cities: [],
  columnCount: 5,
  search: false,
  isRegion: false,
  selectedLocation: undefined,
  titleKey: 'title',
  title: ''
};


/* harmony default export */ var LocationList_defaultExport = (LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a)(LocationList_LocationList));
// CONCATENATED MODULE: ./src/desktop/components/Footer/Footer.js
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer_css__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Footer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_navigation__ = __webpack_require__(1248);
var Footer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
















var Footer__ref4 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438'
});

var _ref5 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439'
});

var _ref6 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440'
});

var _ref7 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u2122'
});

var _ref8 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u2013 \u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u0430\u0432\u0442\u043E \u0438\u043B\u0438 \u043F\u0440\u043E\u0434\u0430\u0442\u044C \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435'
});

function Footer(props) {
  var languages = props.languages,
      currentPath = props.currentPath,
      intl = props.intl,
      locale = props.locale,
      hideLocations = props.hideLocations,
      _props$seoSearchUrlRe = props.seoSearchUrlResponse,
      make = _props$seoSearchUrlRe.make,
      trends = _props$seoSearchUrlRe.trends,
      seoLocations = _props$seoSearchUrlRe.locations,
      selectedLocation = _props$seoSearchUrlRe.location;


  var socialLinks = [{ icon: 'twitter', link: 'https://twitter.com/avtobazar' }, { icon: 'facebook', link: 'https://www.facebook.com/AvtoBazar' }, { icon: 'instagram', link: 'https://www.instagram.com/avtobazar_ua/' }, { icon: 'youtube-play', link: 'https://www.youtube.com/avtobazar' }];
  var allLocations = Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["b" /* getAllLocations */]().map(Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["g" /* setActiveLocations */](seoLocations, selectedLocation));
  var cities = allLocations.filter(function (item) {
    return item.is_admin_center;
  }).sort(__WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__["b" /* compareByTitle */]);
  var regions = allLocations.filter(function (item) {
    return item.is_region;
  }).sort(__WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__["b" /* compareByTitle */]);

  var hideRegLocValues = ['/add/', '/zhurnal/', '/service/'];
  var hideRegLocations = hideRegLocValues.some(function (item) {
    return currentPath.includes(item);
  });

  var formattedTrends = [];
  if (trends) {
    formattedTrends = trends.map(function (a, b) {
      return {
        id: b,
        slug: '',
        title: a['title_' + intl.locale],
        hint: a['text_' + intl.locale],
        url: a.url
      };
    }).filter(function (a, b) {
      return b < 30;
    });
  }
  var titleKey = locale === 'uk' ? 'uk_title' : 'title';

  return Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.root
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.container
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.flexContainer
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.left
  }, void 0, Footer__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.nav
  }, void 0, __WEBPACK_IMPORTED_MODULE_10__constants_navigation__["a" /* default */].FOOTER.map(function (item) {
    return Footer__jsx('li', {}, item.title, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.link,
      to: item.route,
      rel: 'nofollow'
    }, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
      id: item.title
    })));
  }))), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.right
  }, void 0, Footer__jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.tel
  }, void 0, '+380 44 206-56-06'), Footer__jsx('div', {}, void 0, languages.map(function (item) {
    return Footer__jsx('span', {
      className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.lang
    }, item.slug, locale === item.slug ? Footer__jsx('span', {}, void 0, item.title) : Footer__jsx('a', {
      href: Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["e" /* removeLocaleFromHref */](currentPath), item.slug),
      'data-lang-code': item.slug
    }, void 0, item.title));
  })))), trends && trends[0] ? Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, Footer__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.divide,
    style: { margin: '8px 0 8px 0' }
  }), Footer__jsx(LocationList_defaultExport, {
    countries: undefined,
    cities: formattedTrends,
    search: true
  })) : '', !hideLocations && Footer__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.divide,
    style: { margin: '8px 0 0px 0' }
  }), !hideRegLocations && !hideLocations && Footer__jsx(LocationList_defaultExport, {
    cities: regions,
    search: false,
    selectedLocation: selectedLocation,
    isRegion: true,
    titleKey: titleKey
  }), !hideLocations && Footer__jsx(LocationList_defaultExport, {
    cities: cities,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey,
    isRegion: hideRegLocations
  }), Footer__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.divide
  }), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.flexContainer
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.left
  }, void 0, Footer__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.nav
  }, void 0, Footer__jsx('li', {}, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/law/',
    rel: 'nofollow'
  }, void 0, Footer__ref4)), Footer__jsx('li', {}, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/advertising-conditions/',
    rel: 'nofollow'
  }, void 0, _ref5)), Footer__jsx('li', {}, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/public-contract/',
    rel: 'nofollow'
  }, void 0, _ref6)))), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.right
  }, void 0, Footer__jsx('a', {
    href: 'mailto:support@ab.ua',
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.tel,
    rel: 'nofollow'
  }, void 0, 'support@ab.ua'), Footer__jsx(SocialLinks, {
    socialLinks: socialLinks
  })))), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.footerCopyRight
  }, void 0, Footer__jsx('p', {}, void 0, '\xA9 ', new Date().getFullYear(), '\xA0', Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/'
  }, void 0, _ref7), _ref8)));
}

Footer.defaultProps = {
  languages: [{
    title: 'рус',
    slug: 'ru'
  }, {
    title: 'укр',
    slug: 'uk'
  }],
  routeName: null,
  seoSearchUrlResponse: {},
  hideLocations: false
};


function SocialLinks(_ref) {
  var socialLinks = _ref.socialLinks;

  return Footer__jsx('div', {}, void 0, socialLinks.map(function (_ref2) {
    var link = _ref2.link,
        icon = _ref2.icon;
    return Footer__jsx('a', {
      href: link,
      target: '_blank',
      rel: 'nofollow noopener noreferrer',
      className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.socialLink
    }, icon, Footer__jsx('i', {
      className: 'fa fa-' + icon
    }));
  }));
}


var Footer_mapStateToProps = function mapStateToProps(_ref3) {
  var history = _ref3.history,
      searchForm = _ref3.searchForm,
      globals = _ref3.globals;
  return {
    currentPath: history.currentPath,
    routeName: history && history.currentRouteName,
    countries: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json___default.a,
    formState: searchForm && searchForm.selected,
    seoSearchUrlResponse: globals.seoSearchUrlResponse,
    locale: globals.locale
  };
};

/* harmony default export */ var Footer_defaultExport = (Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a)(Footer___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](Footer_mapStateToProps)(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](Footer))));
// CONCATENATED MODULE: ./src/desktop/components/Footer/LanguageList/LanguageList.js
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LanguageList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LanguageList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LanguageList_css__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LanguageList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LanguageList_css__);
var LanguageList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





// / import withFooterLocations from 'shared/hocs/withFooterLocations';
// import Link from 'shared/components/Link/Link';
// import { injectIntl } from 'react-intl';



function LanguageList(props) {
  var languages = props.languages,
      locale = props.locale,
      currentPath = props.currentPath;


  return LanguageList__jsx('div', {}, void 0, languages.map(function (item) {
    return LanguageList__jsx('span', {
      className: __WEBPACK_IMPORTED_MODULE_5__LanguageList_css___default.a.lang
    }, item.slug, locale === item.slug ? LanguageList__jsx('span', {}, void 0, item.title) : LanguageList__jsx('a', {
      href: __WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__["e" /* removeLocaleFromHref */](currentPath), item.slug),
      'data-lang-code': item.slug
    }, void 0, item.title));
  }));
}

LanguageList.defaultProps = {
  languages: [{
    title: 'рус',
    slug: 'ru'
  }, {
    title: 'укр',
    slug: 'uk'
  }]
};


var LanguageList_mapStateToProps = function mapStateToProps(_ref) {
  var globals = _ref.globals,
      history = _ref.history;
  return {
    currentPath: history.currentPath,
    locale: globals.locale
  };
};

/* harmony default export */ var LanguageList_defaultExport = (LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LanguageList_css___default.a)(LanguageList___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](LanguageList_mapStateToProps)(LanguageList)));
// CONCATENATED MODULE: ./src/desktop/components/Footer/FooterLeasing.js
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(FooterLeasing___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(FooterLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Footer_css__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Footer_css__);
var FooterLeasing__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







// import {
//   removeLocaleFromHref,
//   toLocalized,
//   setActiveLocations,
//   getAllLocations,
// } from 'shared/helpers/locale';

// import { compareByTitle } from 'shared/helpers/arrays';







// import LINKS from '../../constants/navigation';




var FooterLeasing__ref4 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438'
});

var FooterLeasing__ref5 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439'
});

var FooterLeasing__ref6 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440'
});

var FooterLeasing__ref7 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u2122'
});

var FooterLeasing__ref8 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u2013 \u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u0430\u0432\u0442\u043E \u0438\u043B\u0438 \u043F\u0440\u043E\u0434\u0430\u0442\u044C \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435'
});

function LeasingFooter(props) {
  var languages = props.languages,
      currentPath = props.currentPath,
      intl = props.intl,
      locale = props.locale,
      hideLocations = props.hideLocations,
      _props$seoSearchUrlRe = props.seoSearchUrlResponse,
      make = _props$seoSearchUrlRe.make,
      trends = _props$seoSearchUrlRe.trends,
      seoLocations = _props$seoSearchUrlRe.locations,
      selectedLocation = _props$seoSearchUrlRe.location;


  var socialLinks = [{ icon: 'twitter', link: 'https://twitter.com/avtobazar' }, { icon: 'facebook', link: 'https://www.facebook.com/AvtoBazar' }, { icon: 'instagram', link: 'https://www.instagram.com/avtobazar_ua/' }, { icon: 'youtube-play', link: 'https://www.youtube.com/avtobazar' }];
  // const allLocations = getAllLocations().map(setActiveLocations(seoLocations, selectedLocation));
  // const cities = allLocations.filter(item => item.is_admin_center).sort(compareByTitle);
  // const regions = allLocations.filter(item => item.is_region).sort(compareByTitle);

  // const hideRegLocValues = ['/add/', '/zhurnal/', '/service/'];
  // const hideRegLocations = hideRegLocValues.some(item => currentPath.includes(item));

  // let formattedTrends = [];
  // if (trends) {
  //   formattedTrends = trends
  //     .map((a, b) => ({
  //       id: b,
  //       slug: '',
  //       title: a[`title_${intl.locale}`],
  //       hint: a[`text_${intl.locale}`],
  //       url: a.url,
  //     }))
  //     .filter((a, b) => b < 30);
  // }
  var titleKey = locale === 'uk' ? 'uk_title' : 'title';
  var listBav = [{
    titleHeader: 'Информация по телефону',
    title: '+380 44 206-56-06'
  }, {
    titleHeader: 'Адрес',
    title: intl.formatMessage({ id: 'Украина, г. Киев, ул. Лейпцигская 15а' })
  }, {
    titleHeader: 'Почта',
    title: 'support@ab.ua'
  }];
  return FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.root
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.container
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.flexContainer
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.left
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasing
  }, void 0, listBav.map(function (item) {
    return FooterLeasing__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasingItem
    }, item.title, FooterLeasing__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasingTitleHeader
    }, void 0, FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
      id: item.titleHeader
    })), FooterLeasing__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasingTitle
    }, void 0, item.title));
  }))), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.right
  }, void 0, FooterLeasing__jsx(LanguageList_defaultExport, {
    languages: languages
  }), FooterLeasing__jsx(FooterLeasing_SocialLinks, {
    socialLinks: socialLinks
  }))), FooterLeasing__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.divide
  }), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.leasingList
  }, void 0, FooterLeasing__jsx(LocationList_defaultExport, {
    title: __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json___default.a.title,
    cities: __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json___default.a.items,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey
  }), FooterLeasing__jsx(LocationList_defaultExport, {
    title: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json___default.a.title,
    cities: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json___default.a.items,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey
  }), FooterLeasing__jsx(LocationList_defaultExport, {
    title: __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json___default.a.title,
    cities: __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json___default.a.items,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey
  })), FooterLeasing__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.divide
  }), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.flexContainer
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.left
  }, void 0, FooterLeasing__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.nav
  }, void 0, FooterLeasing__jsx('li', {}, void 0, FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/law/',
    rel: 'nofollow'
  }, void 0, FooterLeasing__ref4)), FooterLeasing__jsx('li', {}, void 0, FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/advertising-conditions/',
    rel: 'nofollow'
  }, void 0, FooterLeasing__ref5)), FooterLeasing__jsx('li', {}, void 0, FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/public-contract/',
    rel: 'nofollow'
  }, void 0, FooterLeasing__ref6)))))), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.footerCopyRight
  }, void 0, FooterLeasing__jsx('p', {}, void 0, '\xA9 ', new Date().getFullYear(), '\xA0', FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/'
  }, void 0, FooterLeasing__ref7), FooterLeasing__ref8)));
}

LeasingFooter.defaultProps = {
  languages: [{
    title: 'рус',
    slug: 'ru'
  }, {
    title: 'укр',
    slug: 'uk'
  }],
  routeName: null,
  seoSearchUrlResponse: {},
  hideLocations: false
};


function FooterLeasing_SocialLinks(_ref) {
  var socialLinks = _ref.socialLinks;

  return FooterLeasing__jsx('div', {}, void 0, socialLinks.map(function (_ref2) {
    var link = _ref2.link,
        icon = _ref2.icon;
    return FooterLeasing__jsx('a', {
      href: link,
      target: '_blank',
      rel: 'nofollow noopener noreferrer',
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.socialLink
    }, icon, FooterLeasing__jsx('i', {
      className: 'fa fa-' + icon
    }));
  }));
}


var FooterLeasing_mapStateToProps = function mapStateToProps(_ref3) {
  var history = _ref3.history,
      searchForm = _ref3.searchForm,
      globals = _ref3.globals;
  return {
    currentPath: history.currentPath,
    routeName: history && history.currentRouteName,
    countries: __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json___default.a,
    formState: searchForm && searchForm.selected,
    seoSearchUrlResponse: globals.seoSearchUrlResponse,
    locale: globals.locale
  };
};

/* harmony default export */ var FooterLeasing_defaultExport = (FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a)(FooterLeasing___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](FooterLeasing_mapStateToProps)(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](LeasingFooter))));
// CONCATENATED MODULE: ./src/shared/hocs/withNotifications.js
/* harmony import */ var withNotifications___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var withNotifications___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(withNotifications___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var withNotifications__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var withNotifications__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function withNotifications__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function withNotifications__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function withNotifications__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var withNotifications_mapStateToProps = function mapStateToProps(_ref) {
  var notifications = _ref.notifications;
  return { messageQueue: notifications };
};
var withNotifications_mapDispatchToProps = { shift: __WEBPACK_IMPORTED_MODULE_2_shared_actions_notifications__["b" /* shiftNotification */] };

var withNotifications = function withNotifications(WrappedComponent) {
  var _class, _temp2;

  return __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](withNotifications_mapStateToProps, withNotifications_mapDispatchToProps)((_temp2 = _class = function (_React$Component) {
    withNotifications__inherits(_class, _React$Component);

    function _class() {
      var _ref2;

      var _temp, _this, _ret;

      withNotifications__classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = withNotifications__possibleConstructorReturn(this, (_ref2 = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
        activeMessage: null
      }, _this.tick = function () {
        var _this$props = _this.props,
            duration = _this$props.duration,
            shift = _this$props.shift;

        var lastMessage = _this.props.messageQueue[0];

        if (lastMessage) {
          _this.setState({ activeMessage: lastMessage }, function () {
            delay(duration).then(function () {
              shift();
              _this.setState({ activeMessage: null }, function () {
                delay(duration / 4).then(function () {
                  return _this.tick();
                });
              });
            });
          });
        }
      }, _temp), withNotifications__possibleConstructorReturn(_this, _ret);
    }

    withNotifications__createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!this.state.activeMessage) {
          this.tick();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (prevProps.messageQueue.length < this.props.messageQueue.length && !this.state.activeMessage) {
          this.tick();
        }
      }
    }, {
      key: 'render',
      value: function render() {

        return withNotifications___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, withNotifications__extends({ activeMessage: this.state.activeMessage }, this.props));
      }
    }]);

    return _class;
  }(withNotifications___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withNotifications(' + __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    duration: 4000
  }, _temp2));
};

/* harmony default export */ var withNotifications_defaultExport = (withNotifications);
// CONCATENATED MODULE: ./src/desktop/components/Layout/NotificationBar/NotificationBar.js
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_css__);
var NotificationBar__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function NotificationBar__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









function NotificationBar(props) {
  var activeMessage = props.activeMessage;

  var type = activeMessage && activeMessage.type;

  return NotificationBar__jsx('div', {
    className: NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.root, NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.active, activeMessage),
    //
    NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.error, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].ERROR), NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.success, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].SUCCESS), NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.warning, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].WARNING), NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.info, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].INFO))
  }, void 0, activeMessage && NotificationBar__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.label
  }, void 0, activeMessage.text));
}

NotificationBar.defaultProps = {
  activeMessage: null
};


/* harmony default export */ var NotificationBar_defaultExport = (NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a)(withNotifications_defaultExport(NotificationBar)));
// CONCATENATED MODULE: ./src/desktop/components/Layout/Layout.js
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_BannerAll__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_lazyload__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_normalize_css_normalize_css__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_normalize_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_normalize_css_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_datepicker_dist_react_datepicker_min_css__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_datepicker_dist_react_datepicker_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_datepicker_dist_react_datepicker_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_nprogress_nprogress_css__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_global_styles_desktop_css__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_global_styles_desktop_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_global_styles_desktop_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Layout_css__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__Layout_css__);
var Layout__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Layout__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Layout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Layout__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Layout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import { updateBranding } from 'shared/helpers/adsAndMetrics';




















// eslint-disable-next-line css-modules/no-unused-class


var isClient = true;
var localCurrentPage = '';

var Layout__ref = Layout__jsx(NotificationBar_defaultExport, {});

var Layout__ref2 = Layout__jsx(Header_defaultExport, {});

var Layout__ref3 = Layout__jsx(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a, {}, void 0, Layout__jsx(Layout___WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1514298874616-0'
}));

var Layout__ref4 = Layout__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_BannerAll__["a" /* BannersBuffer */], {});

var Layout__ref5 = Layout__jsx(ChooseLanguageDialog_defaultExport, {});

var Layout_Layout = function (_React$Component) {
  Layout__inherits(Layout, _React$Component);

  function Layout() {
    Layout__classCallCheck(this, Layout);

    return Layout__possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).apply(this, arguments));
  }

  Layout__createClass(Layout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!isClient) return;
      var targetNode = window.document.body;
      var bannerTopAB = window.document.getElementById('banner-top-AB');
      var changeObserver = function changeObserver() {
        if (targetNode.style.backgroundImage) {
          window.document.getElementById('bodyABIdBlock').style.margin = '68px auto 0  auto';
        } else if (bannerTopAB && Number(bannerTopAB.clientHeight) > 30) {
          // bannerTopAB.style.marginTop = '20px';
          bannerTopAB.style.display = 'flex';
        }
      };

      var observer = new MutationObserver(changeObserver);
      var observerTop = new MutationObserver(changeObserver);
      observer.observe(targetNode, { attributes: true, childList: true });
      if (bannerTopAB) {
        observerTop.observe(bannerTopAB, { attributes: true, childList: true });
      }
      // updateBranding();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var currentPath = this.props.history.currentPath;

      if (true && '' + location.pathname + location.search !== currentPath && currentPath !== localCurrentPage) {
        // updateBranding();
        localCurrentPage = currentPath;
      }
    }
  }, {
    key: 'getFooter',
    value: function getFooter() {
      var _props = this.props,
          hideLocations = _props.hideLocations,
          footer = _props.footer;

      if (footer === 'leasing') return Layout__jsx(FooterLeasing_defaultExport, {
        hideLocations: hideLocations
      });
      return Layout__jsx(Footer_defaultExport, {
        hideLocations: hideLocations
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          navLinks = _props2.navLinks,
          currentRoute = _props2.currentRoute,
          including = _props2.including,
          personalSubheader = _props2.personalSubheader,
          currentPath = _props2.history.currentPath;


      return Layout__jsx('div', {
        id: !navLinks ? 'fakeSubHeader' : '',
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.root
      }, void 0, Layout__ref, Layout__ref2, navLinks && !!navLinks.length && Layout__jsx(SubHeader_defaultExport, {
        including: including,
        navLinks: navLinks,
        currentRoute: currentRoute,
        personalSubheader: personalSubheader
      }), !new Set(Layout___WEBPACK_IMPORTED_MODULE_6_shared_modules__["g" /* ignoreTopBanner */]).has(currentPath) && !/\/edit\//.test(currentPath) ? Layout__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.brandingAdv,
        id: 'banner-top-AB'
      }, void 0, Layout__ref3) : '', Layout__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.layout,
        id: 'bodyABIdBlock'
      }, void 0, this.props.children), Layout__jsx('main', {
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.mainFooter
      }, void 0, this.getFooter()), Layout__ref4, isClient && Layout__ref5);
    }
  }]);

  return Layout;
}(Layout___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Layout_Layout.defaultProps = {
  history: {},
  currentRoute: null,
  navLinks: null,
  withBranding: false,
  personalSubheader: false,
  including: true,
  targetingArguments: {},
  shouldInitAds: true,
  hideLocations: false,
  string: '',
  footer: ''
};


/* harmony default export */ __webpack_exports__["a"] = (Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a)(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */](function (_ref6) {
  var history = _ref6.history;
  return {
    history: history
  };
})(Layout_Layout)));

/***/ }),

/***/ 1283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DecimalInput = function (_React$Component) {
  _inherits(DecimalInput, _React$Component);

  function DecimalInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DecimalInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DecimalInput.__proto__ || Object.getPrototypeOf(DecimalInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      tempValue: _this.props.value,
      isInDotMode: false
    }, _this.handleChange = function (e) {
      var value = e.target.value;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          delimiters = _this$props.delimiters;


      value = value.replace(new RegExp('[' + delimiters + ']', 'g'), '.');

      if (value && value.startsWith('.')) {
        value = '';
      }

      if (value === '' || value.match(/^\d+(\.\d+)?$/)) {
        _this.setState({ isInDotMode: false });
        onChange(value);
      } else if (value.match(/^\d+\.$/)) {
        _this.setState({
          tempValue: value,
          isInDotMode: true
        });
      }
    }, _this.handleBlur = function () {
      if (_this.state.isInDotMode) {
        _this.setState(function (_ref2) {
          var tempValue = _ref2.tempValue;

          var newValue = '' + parseInt(tempValue, 10);
          _this.props.onChange(newValue);
          return { tempValue: newValue };
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DecimalInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var value = this.props.value;
      var _state = this.state,
          isInDotMode = _state.isInDotMode,
          tempValue = _state.tempValue;


      if (!isInDotMode && '' + tempValue !== '' + value) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ tempValue: value ? '' + value : value });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          inputRef = _props.inputRef,
          props = _objectWithoutProperties(_props, ['inputRef']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, props, {
        type: 'tel',
        ref: inputRef,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        value: this.state.tempValue || ''
      }));
    }
  }]);

  return DecimalInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DecimalInput.defaultProps = {
  value: undefined,
  inputRef: undefined,
  onChange: function onChange() {},
  delimiters: '.,'
};


/* harmony default export */ __webpack_exports__["a"] = (DecimalInput);

/***/ }),

/***/ 1284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_NavigationLink_NavigationLink__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InlineNav_css__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InlineNav_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function InlineNav(props) {
  var navLinks = props.navLinks,
      including = props.including,
      currentRoute = props.currentRoute;

  var route = (currentRoute + '/').replace('//', '/');
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.root,
    role: 'navigation'
  }, void 0, _jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.list
  }, void 0, navLinks.map(function (item) {
    return _jsx('li', {
      className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.item
    }, item.route, _jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_NavigationLink_NavigationLink__["a" /* default */], {
      link: item,
      currentRoute: route,
      including: including,
      className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.link,
      activeClassName: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.active,
      eventPrefix: props.eventPrefix
    }));
  })));
}

InlineNav.defaultProps = {
  including: true,
  currentRoute: null,
  count: null,
  withCount: false,
  eventPrefix: ''
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a)(InlineNav));

/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(1358);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(1361);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(1264);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';

CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ 1286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentRollAdsense; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var isDev = false;

var _ref = _jsx('div', {}, void 0, '________________slot_________________');

var _ref2 = _jsx('div', {}, void 0, '_________ContentRollAdsense__________');

var _ref3 = _jsx('div', {}, void 0, '________________STYLE_________________');

var _ref4 = _jsx('div', {}, void 0, '________________end_block_________________');

function ContentRollAdsenseClass(props) {
  var adClient = props.adClient,
      adSlot = props.adSlot,
      other = _objectWithoutProperties(props, ['adClient', 'adSlot']);

  var devStyle = {
    width: '100%',
    minHeight: '200px',
    backgroundColor: '#ffb900',
    border: '3px solid #a73c3c'
  };
  if (isDev) {
    return _jsx('div', {
      style: devStyle
    }, void 0, _ref, _ref2, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, adSlot), _ref3, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, JSON.stringify(other.style)), _ref4);
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ins', _extends({}, other, { className: 'adsbygoogle', 'data-ad-client': adClient, 'data-ad-slot': adSlot }));
}

ContentRollAdsenseClass.defaultProps = {
  adClient: 'ca-pub-8183181871645898',
  adSlot: '7650493142'
};


var ContentRollAdsense = ContentRollAdsenseClass;

/***/ }),

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Loader_Loader__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UIStyle_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var ButtonGeneral = function ButtonGeneral(_ref) {
  var _cx;

  var text = _ref.text,
      type = _ref.type,
      theme = _ref.theme,
      clickHandler = _ref.clickHandler,
      Icon = _ref.Icon,
      className = _ref.className,
      isProcessing = _ref.isProcessing,
      disabled = _ref.disabled,
      userTranslate = _ref.userTranslate,
      iconAfterText = _ref.iconAfterText,
      inputParams = _objectWithoutProperties(_ref, ['text', 'type', 'theme', 'clickHandler', 'Icon', 'className', 'isProcessing', 'disabled', 'userTranslate', 'iconAfterText']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'button',
    _extends({
      disabled: disabled || isProcessing,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonGeneral"], (_cx = {}, _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonTransparent"], theme === 'Transparent'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonTransparentYellow"], theme === 'TransparentYellow'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonYellow"], theme === 'Yellow'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonWhite"], theme === 'White'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonYellowFlat"], theme === 'YellowFlat'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonDisabledStyle"], theme === 'DisabledStyle'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonProcessing"], isProcessing), _defineProperty(_cx, className, !!className), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["iconAfterText"], iconAfterText), _cx)),
      type: type,
      onClick: clickHandler
    }, inputParams),
    _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Loader_Loader__["a" /* default */], {
      isLoading: isProcessing,
      className: __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonLoader"]
    }),
    Icon && !iconAfterText ? _jsx(Icon, {}) : null,
    userTranslate ? _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
      id: text
    }) : text,
    Icon && iconAfterText ? _jsx(Icon, {}) : null
  );
};

ButtonGeneral.defaultProps = {
  type: 'submit',
  theme: 'Yellow',
  className: '',
  Icon: null,
  disabled: false,
  clickHandler: function clickHandler() {},
  isProcessing: false,
  userTranslate: true,
  iconAfterText: false
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__UIStyle_css__)(ButtonGeneral));

/***/ }),

/***/ 1288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/hocs/withMonoPayment.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_notificationTypes__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__history__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var throwIfResponseNotOkay = function throwIfResponseNotOkay() {
  return function (response) {
    if (!response.ok) {
      throw new Error('Произошла ошибка');
    }

    return response;
  };
};

var getMonoOrderData = function getMonoOrderData(fetch, token, data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].PAYMENT.MONO_ORDER_CHECKOUT, {
    method: 'POST',
    headers: {
      Authorization: 'JWT ' + token
    },
    body: JSON.stringify(data)
  });
};

var updateAdvertParams = function updateAdvertParams(advertParams, fetch, token, advertID, promoteInSocial) {
  if (advertParams.kind && advertParams.kind === __WEBPACK_IMPORTED_MODULE_11__constants_payment__["d" /* PACKAGES */].C2C_TURBO && promoteInSocial) {
    fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].ADVERT.ITEM(advertID), {
      method: 'PATCH',
      headers: {
        Authorization: 'JWT ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ promote_in_social: promoteInSocial })
    });
  }
};

var withMonoPayment = function withMonoPayment(WrappedComponent) {
  var _class, _temp2;

  var Component = (_temp2 = _class = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Component);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        fondyFrameUrl: '',
        fondyCb: null,
        showModal: false,
        showInvoiceModal: false,
        billAmount: null,
        accountNumber: null,
        eventCounter: 1
      }, _this.setGtmEvent = function (gtmId) {
        if (!gtmId) return;

        var eventCounter = _this.state.eventCounter;

        var dataLayer = window && Array.isArray(window.dataLayer) && window.dataLayer;
        var gtmDataLayerValue = dataLayer && dataLayer.find(function (el) {
          return el.event === gtmId.event;
        });

        if (gtmDataLayerValue) {
          var newCounter = eventCounter + 1;
          _this.setState({ eventCounter: newCounter });
          _this.props.setDataLayer(_extends({}, gtmId, { event: '' + gtmId.event + newCounter + '/' }));
        } else {
          _this.props.setDataLayer(gtmId);
        }
      }, _this.getGtmEvent = function (gtmType) {
        var user = _this.props.user;

        var isBusiness = user.user.tariff && user.user.tariff.is_business;
        var isDealership = user.user.tariff && user.user.tariff.slug === 'b2c-plus';

        if (isDealership) {
          return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert.dealership[gtmType];
        } else if (isBusiness) {
          return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert.business[gtmType];
        }
        return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert[gtmType];
      }, _this.sendGtmMetrics = function (params) {
        if (params.kind === 'subscription') _this.setGtmEvent(_this.getGtmEvent(params.details.tariff));else if (params.kind === 'c2c-free' && params.details && params.details.promos) {
          params.details.promos.map(function (item) {
            return _this.setGtmEvent(_this.getGtmEvent(item));
          });
        } else _this.setGtmEvent(_this.getGtmEvent(params.kind));
      }, _this.openMonoOrderWindow = function (token, params, redirectUrl, paymentMethod, cb) {
        var _this$props = _this.props,
            fetch = _this$props.fetch,
            intl = _this$props.intl,
            promoteInSocial = _this$props.promoteInSocial;
        var locale = intl.locale;

        var redirectUrlLocalized = __WEBPACK_IMPORTED_MODULE_10__helpers_locale__["h" /* toLocalized */](redirectUrl, locale);
        var advertId = params.details && params.details.advert_id;

        __WEBPACK_IMPORTED_MODULE_9__helpers_common__["j" /* iniRedirectToCheckout */]();
        return function () {
          return fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].PAYMENT.orders(), {
            method: 'POST',
            headers: {
              Authorization: 'JWT ' + token
            },
            body: JSON.stringify(params)
          }).then(throwIfResponseNotOkay()).then(function (r) {
            return r.json();
          }).then(function (_ref2) {
            var number = _ref2.number,
                status = _ref2.status;

            if (status === __WEBPACK_IMPORTED_MODULE_11__constants_payment__["c" /* ORDER_STATUSES */].PAID || paymentMethod === __WEBPACK_IMPORTED_MODULE_11__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE) {
              _this.sendGtmMetrics(params);
              _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].paidAdSent);
              _this.props.enqueueNotification({
                text: intl.formatMessage({ id: 'Оплата прошла успешно' }),
                type: __WEBPACK_IMPORTED_MODULE_6_shared_actions_notificationTypes__["a" /* default */].SUCCESS
              });
              updateAdvertParams(params, fetch, token, advertId, promoteInSocial);
              if (cb) cb({ number: number, status: status });else __WEBPACK_IMPORTED_MODULE_13__history__["a" /* default */].push(redirectUrlLocalized);
            } else {
              var handlerUrl = __WEBPACK_IMPORTED_MODULE_11__constants_payment__["j" /* URLS */].HANDLER_URL_FULL + '?redirectUrl=' + redirectUrlLocalized;
              return getMonoOrderData(fetch, token, {
                order_number: number,
                response_url: handlerUrl,
                lang: locale
              }).then(throwIfResponseNotOkay()).then(function (r) {
                return r.json();
              }).then(function (data) {
                _this.sendGtmMetrics(params);
                _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].paidAdSent);
                var url = data.checkout_url;
                updateAdvertParams(params, fetch, token, advertId, promoteInSocial);

                __WEBPACK_IMPORTED_MODULE_9__helpers_common__["d" /* doRedirectToCheckout */](url);
              });
            }

            return Promise.resolve();
          });
        }().catch(function (e) {
          _this.props.enqueueNotification(intl.formatMessage({ id: e.message ? e.message : e }));
          if (cb) cb(null, e.message ? e.message : e);
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Component, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { openMonoOrderWindow: this.openMonoOrderWindow }));
      }
    }]);

    return Component;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withOrders(' + __WEBPACK_IMPORTED_MODULE_9__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp2);

  var mapDispatchToProps = {
    enqueueNotification: __WEBPACK_IMPORTED_MODULE_12__actions_notifications__["a" /* enqueueNotification */],
    setDataLayer: __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["j" /* setDataLayer */]
  };

  var mapStateToProps = function mapStateToProps(_ref3) {
    var globals = _ref3.globals,
        user = _ref3.user;
    return {
      promoteInSocial: globals.promoteInSocial,
      user: user
    };
  };

  return __WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_7_shared_hocs_withFetch__["a" /* withFetch */](Component)));
};

/* harmony default export */ var withMonoPayment_defaultExport = (withMonoPayment);
// CONCATENATED MODULE: ./src/desktop/components/BalanceRefill/BalanceRefill.js
/* harmony import */ var BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Modal__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_PaymentModal__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var BalanceRefill__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function BalanceRefill__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BalanceRefill__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BalanceRefill__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u044C'
});

var BalanceRefill = function (_React$Component) {
  BalanceRefill__inherits(BalanceRefill, _React$Component);

  function BalanceRefill() {
    var _ref;

    var _temp, _this, _ret;

    BalanceRefill__classCallCheck(this, BalanceRefill);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = BalanceRefill__possibleConstructorReturn(this, (_ref = BalanceRefill.__proto__ || Object.getPrototypeOf(BalanceRefill)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      refillAmount: 99,
      showModal: false
    }, _this.handleChange = function (e) {
      var value = e.target.value;


      if (value === '') {
        _this.setState({ refillAmount: null });
      } else {
        var intValue = parseInt(value, 10);

        if (intValue) {
          _this.setState({ refillAmount: intValue });
        }
      }
    }, _this.handleShow = function () {
      // this.props.onModalOpen();
      // this.setState({ showModal: true });
      var _this$props = _this.props,
          token = _this$props.token,
          openMonoOrderWindow = _this$props.openMonoOrderWindow;
      var refillAmount = _this.state.refillAmount;


      openMonoOrderWindow(token, {
        kind: __WEBPACK_IMPORTED_MODULE_8_shared_constants_payment__["b" /* KINDS */].BALANCE_REFILL,
        details: {
          refill_amount: refillAmount
        }
      }, '' + window.location.pathname + window.location.search, // return to where we are
      'mono');
    }, _this.handleHide = function () {
      _this.props.onModalClose();
      _this.setState({ showModal: false });
    }, _this.renderModal = function () {
      return _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Modal__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_PaymentModal__["a" /* default */], {
        title: _this.props.intl.formatMessage({ id: 'Пополнение баланса' }),
        description: _this.props.intl.formatMessage({
          id: 'Пополнение внутреннего баланса в аккаунте avtobazar.ua'
        }),
        closeHandler: _this.handleHide,
        amount: _this.state.refillAmount,
        balanceRefillMode: true
      }));
    }, _temp), BalanceRefill__possibleConstructorReturn(_this, _ret);
  }

  // handlePaymentMethodChosen = paymentMethodInfo => {
  //   const { token, openMonoOrderWindow } = this.props;
  //   const { refillAmount } = this.state;

  //   openMonoOrderWindow(
  //     token,
  //     {
  //       kind: KINDS.BALANCE_REFILL,
  //       details: {
  //         refill_amount: refillAmount,
  //       },
  //     },
  //     `${window.location.pathname}${window.location.search}`, // return to where we are
  //     paymentMethodInfo.slug,
  //   );
  // };

  BalanceRefill__createClass(BalanceRefill, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          refillAmount = _state.refillAmount,
          showModal = _state.showModal;


      return _jsx('div', {}, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.inputContainer
      }, void 0, _jsx('input', {
        type: 'text',
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.input),
        value: refillAmount || '',
        onChange: this.handleChange
      }), _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.hrn
      }, void 0, '\u0433\u0440\u043D'), _jsx('button', {
        onClick: this.handleShow,
        className: __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.inlineButton,
        disabled: !refillAmount
      }, void 0, _ref2)), showModal && this.renderModal());
    }
  }]);

  return BalanceRefill;
}(BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BalanceRefill.defaultProps = {
  onModalOpen: function onModalOpen() {},
  onModalClose: function onModalClose() {}
};


var mapStateToProps = function mapStateToProps(_ref3) {
  var user = _ref3.user;
  return {
    token: user.token
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps)(withMonoPayment_defaultExport(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](BalanceRefill)))));

/***/ }),

/***/ 1289:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1290)();
}

/***/ }),

/***/ 1290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1291);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1293);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1296);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1293:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1294), __esModule: true };

/***/ }),

/***/ 1294:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(480);
__webpack_require__(478);
module.exports = __webpack_require__(1295);

/***/ }),

/***/ 1295:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1260);
var ITERATOR = __webpack_require__(86)('iterator');
var Iterators = __webpack_require__(187);
module.exports = __webpack_require__(30).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined || '@@iterator' in O
  // eslint-disable-next-line no-prototype-builtins
  || Iterators.hasOwnProperty(classof(O));
};

/***/ }),

/***/ 1296:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1297), __esModule: true };

/***/ }),

/***/ 1297:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(480);
__webpack_require__(478);
module.exports = __webpack_require__(1298);

/***/ }),

/***/ 1298:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(105);
var get = __webpack_require__(1279);
module.exports = __webpack_require__(30).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),

/***/ 1299:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1300);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BannerAll.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BannerAll.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1300:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2I0F2{margin-bottom:20px}._3DEYy{position:relative}.K2GWo{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:300px}._1VCyV,.K2GWo{display:-webkit-box;display:-ms-flexbox;display:flex}._1VCyV{-ms-flex-pack:distribute;justify-content:space-around;margin-top:20px;padding:0 45px;margin-bottom:20px}._1VCyV>div{margin-bottom:10px;margin-top:10px}._3coG7{height:100%}", ""]);

// exports
exports.locals = {
	"gptPremium": "_2I0F2",
	"flexCell": "_3DEYy",
	"sideBar": "K2GWo",
	"advertContainerButoon": "_1VCyV",
	"homeSideBar": "_3coG7"
};

/***/ }),

/***/ 1301:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1302);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalContainer.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalContainer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1302:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3ubq_{position:fixed;z-index:3005;background-color:rgba(50,50,50,.5);top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;width:100%;height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._8Koz-{position:absolute;top:0;left:0;right:0;bottom:0;z-index:3006;backdrop-filter:blur(4px)}.NhUO6{background-color:#fff;border:1px solid #bfbfbf;-ms-flex-item-align:center;align-self:center;z-index:3007}._2Ncf4{max-width:600px;width:90%;min-height:300px;padding:15px 20px;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
exports.locals = {
	"root": "_3ubq_",
	"background": "_8Koz-",
	"content": "NhUO6",
	"contentParams": "_2Ncf4"
};

/***/ }),

/***/ 1303:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1304);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalWrapper.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalWrapper.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1304:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._cLKp{padding:20px 15px}._21JFC{overflow-y:auto;max-height:100vh;margin:0 auto}._2lSzg{position:relative;border-radius:10px;max-width:330px}._1BONa,._18jW-{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px;color:#c4c4c4}._18jW-:before{content:\"\\D7\"}", ""]);

// exports
exports.locals = {
	"rootModalContainer": "_cLKp",
	"rootModal": "_21JFC",
	"modal": "_2lSzg",
	"closeBtnIcon": "_1BONa",
	"closeBtn": "_18jW-"
};

/***/ }),

/***/ 1305:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1306);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CircleTimer.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CircleTimer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1306:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3B1TS{font-size:32px;color:#000}._1H7x_{-webkit-transform-origin:center center;transform-origin:center center;-webkit-transform:rotate(-92deg);transform:rotate(-92deg)}", ""]);

// exports
exports.locals = {
	"circleTimerText": "_3B1TS",
	"circleTimerProgress": "_1H7x_"
};

/***/ }),

/***/ 1307:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1308);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Loader.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Loader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1308:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._23UJ_{text-align:center;padding:10px 0}", ""]);

// exports
exports.locals = {
	"root": "_23UJ_"
};

/***/ }),

/***/ 1309:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1s4zB{position:relative;padding:7px 8px;border-radius:2px;height:42px;line-height:30px;border:1px solid #c4c4c4;outline:none;font-size:13px;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}._1s4zB::-webkit-input-placeholder{color:gray}._1s4zB::-moz-placeholder{color:gray}._1s4zB:-ms-input-placeholder{color:gray}._1s4zB::placeholder{color:gray}.vJnum{position:relative;margin:0 auto 10px;width:100%;padding:10px 0;font-size:14px;color:#000;font-weight:700;border-width:1px;border-style:solid;outline:none;cursor:pointer;line-height:1.1;border-radius:3px;white-space:nowrap}.vJnum:disabled,.vJnum:disabled>.hX4eV{color:rgba(0,0,0,.25);pointer-events:none}._1F-aN{color:rgba(0,0,0,.25)}._2YtbV,._3bKRW{background-color:#ffd906;border-color:#ffd906}._2YtbV,._3bKRW:hover{background-color:#ffc107;border-color:#ffc107}._2YtbV{border:none}._2YtbV:disabled{background-color:#f5f5f5}._1AWF-{background-color:#fff;border-color:#c4c4c4}._1AWF-:hover{background-color:#fffceb}._2DyKI{background-color:transparent}._2DyKI:hover,._38ptx:hover{background-color:#ffc10744}._38ptx{background-color:transparent;border:1px solid #ffc107}.vJnum.aO6AT>:not(._289M5){visibility:hidden}._15Egm{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);padding:0;font-size:11px}.zoFvb>svg{margin-left:6px}.vJnum:not(.zoFvb)>svg{margin-right:6px}", ""]);

// exports
exports.locals = {
	"inputGeneral": "_1s4zB",
	"ButtonGeneral": "vJnum",
	"btnInfo": "hX4eV",
	"ButtonDisabledStyle": "_1F-aN",
	"ButtonYellowFlat": "_2YtbV",
	"ButtonYellow": "_3bKRW",
	"ButtonWhite": "_1AWF-",
	"ButtonTransparent": "_2DyKI",
	"ButtonTransparentYellow": "_38ptx",
	"buttonLoader": "aO6AT",
	"ButtonProcessing": "_289M5",
	"ButtonLoader": "_15Egm",
	"iconAfterText": "zoFvb"
};

/***/ }),

/***/ 1310:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1311);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ContactButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ContactButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1311:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3z1Cv{min-height:60px;width:190px;background-color:#ffd906;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:auto;text-align:center}._3z1Cv,._3z1Cv a{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3z1Cv a{padding:7px 16px 4px;font-weight:600;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1D5tw{min-height:60px;width:190px}._1D5tw,.a06XJ{font-size:14px;background-color:#ffd906;border-radius:2px;border:1px solid #ffd906;padding:7px 16px 4px;color:#000;cursor:pointer;text-align:center;line-height:1.52;outline:none;font-weight:600;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:auto}._1D5tw a,._3YwyV a,._3z1Cv a,.a06XJ a{color:#000}._3z1Cv{cursor:default;background-color:#f5f5f5;border:1px solid transparent}._1D5tw:hover,._3z1Cv:hover{background-color:#ffc107;border:1px solid #ffc107}._31u6D{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3T3i5,._31u6D{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._254Zh{padding-bottom:2px;padding-left:4px}._3vtyf,._254Zh{line-height:12px;font-size:14px}._3YwyV,.a06XJ{width:100%;min-height:42px}._3YwyV>._31u6D{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.a06XJ{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"showedContainerDesktop": "_3z1Cv",
	"hided": "_1D5tw",
	"showedPhoneMobile": "a06XJ",
	"hidedMobile": "_3YwyV",
	"hidedContent": "_31u6D",
	"hiddenPhone": "_3T3i5",
	"Plus": "_254Zh",
	"Dots": "_3vtyf"
};

/***/ }),

/***/ 1312:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1313);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CheckBox.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CheckBox.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1313:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3Vsl7{position:relative;display:inline-block;cursor:pointer;font-weight:400;font-size:13px;color:#000;padding-left:20px;white-space:nowrap}._3Vsl7:hover{color:#ff5a5f}._3Vsl7 input{position:absolute;left:0;border:1px solid #aaa;border-radius:2px;cursor:pointer}._3Vsl7 input,._3Vsl7 input:checked{-webkit-appearance:none;width:15px;height:15px;outline:none}._3Vsl7 input:checked{border:1px solid #ffd906;background-color:#ffd906;border-radius:2px}._3Vsl7 input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:2;top:1px;left:-1px;overflow:hidden;width:17px;height:9px;margin-top:-6px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}", ""]);

// exports
exports.locals = {
	"checkbox": "_3Vsl7"
};

/***/ }),

/***/ 1314:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1315);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TagButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TagButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1315:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1hjln{white-space:nowrap;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:6px 6px 6px 0;height:32px;padding:0 8px;font-size:12px;color:#333;min-width:90px;border-radius:2px;border:1px solid #ffd906;cursor:pointer}._1hjln>svg{margin-right:8px}._1hjln:hover{background-color:#ffd906;-webkit-transition:.3s;-o-transition:.3s;transition:.3s}._1hjln:last-child{margin-right:0}._1SOx4{border:1px solid #c4c4c4;border-radius:2px;pointer-events:none;color:#c4c4c4}._1SOx4 path{fill:#c4c4c4}", ""]);

// exports
exports.locals = {
	"tag": "_1hjln",
	"disabled": "_1SOx4"
};

/***/ }),

/***/ 1316:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1317);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Select.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Select.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1317:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1pNgY .Select-control{height:42px}._1pNgY .Select-placeholder,._1pNgY .Select-value{line-height:42px;height:42px;font-weight:400}._1dne7 .Select-control{border:none}", ""]);

// exports
exports.locals = {
	"root": "_1pNgY",
	"theme-flat": "_1dne7"
};

/***/ }),

/***/ 1318:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1319);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SelectInput.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SelectInput.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1319:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3hl6h{min-width:65px;font-weight:400}._3hl6h,._3Y3JC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._3Y3JC{position:relative}._3Y3JC:hover ._1ZTEB{background-color:#f1f1f18c}._1ZTEB{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#000;font-size:16px;border-radius:4px;font-weight:400;cursor:pointer;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._1ZTEB .fa{margin-left:8px}._3yfgi{width:100%;opacity:0;cursor:pointer}", ""]);

// exports
exports.locals = {
	"root": "_3hl6h",
	"selectContainer": "_3Y3JC",
	"hint": "_1ZTEB",
	"select": "_3yfgi stretched"
};

/***/ }),

/***/ 1320:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1321);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NumberInputWithSelect.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NumberInputWithSelect.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2CTZv{width:100%;position:relative}._2CTZv,._3nhOc{display:-webkit-box;display:-ms-flexbox;display:flex}._3nhOc{margin:0;margin-right:2px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.DRK7t{width:16px;height:16px;position:absolute;left:15px;top:8px}.jWUNC{width:100%;height:42px}._3Imj3>.jWUNC{padding-left:36px}._2byyi{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;height:42px;position:relative}._2byyi input[type=number]{-moz-appearance:textfield}._2byyi input[type=number]::-webkit-inner-spin-button,._2byyi input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}._3nGhT{color:#000;font-size:16px;margin-left:5px;position:absolute;right:0;height:42px;display:-webkit-box;display:-ms-flexbox;display:flex}._-5BW7{border-right:1px solid rgba(0,0,0,.15);width:0;margin:4px 0}.J0LiY{padding-left:8px}._11n11 .input{border:none}", ""]);

// exports
exports.locals = {
	"root": "_2CTZv",
	"title": "_3nhOc questionTitle",
	"icon": "DRK7t",
	"input": "jWUNC input",
	"hasIcon": "_3Imj3",
	"inline": "_2byyi",
	"switch": "_3nGhT",
	"switchDivider": "_-5BW7",
	"singleOptionLabel": "J0LiY",
	"required": "_1_Rl_ required",
	"theme-flat": "_11n11"
};

/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1323);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ChooseLanguageDialog.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ChooseLanguageDialog.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2zlxK{font-weight:700}._2zlxK,._22XDT{margin-bottom:13px}._22XDT{text-align:justify}._2rIjY{font-weight:700;margin-bottom:13px}._17hGk{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"title": "_2zlxK",
	"text": "_22XDT",
	"timer": "_2rIjY",
	"buttons": "_17hGk"
};

/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1325);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./normalize.css", function() {
        content = require("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./normalize.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1325:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1327);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./font-awesome.min.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./font-awesome.min.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1327:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1329);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-select.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-select.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1329:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1330:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1331);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-datepicker.min.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-datepicker.min.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1331:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1333);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./nprogress.css", function() {
        content = require("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./nprogress.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1333:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1334:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1335);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./slick.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./slick.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1335:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1337);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../node_modules/extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../node_modules/css-loader/index.js??ref--1-rules-1-1!../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./desktop.css", function() {
        content = require("!!../../node_modules/extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../node_modules/css-loader/index.js??ref--1-rules-1-1!../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./desktop.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1337:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function (root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
    module.exports = factory();
  } else {
    root.NProgress = factory();
  }
})(this, function () {
  var NProgress = {};

  NProgress.version = '0.1.6';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function (options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function (n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = n === 1 ? null : n;

    var progress = NProgress.render(!started),
        bar = progress.querySelector(Settings.barSelector),
        speed = Settings.speed,
        ease = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function (next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, {
          transition: 'none',
          opacity: 1
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function () {
          css(progress, {
            transition: 'all ' + speed + 'ms linear',
            opacity: 0
          });
          setTimeout(function () {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function () {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function () {
    if (!NProgress.status) NProgress.set(0);

    var work = function work() {
      setTimeout(function () {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function (force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function (amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function () {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   * 
   * @param $promise jQUery Promise
   */
  (function () {
    var initial = 0,
        current = 0;

    NProgress.promise = function ($promise) {
      if (!$promise || $promise.state() == "resolved") {
        return this;
      }

      if (current == 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function () {
        current--;
        if (current == 0) {
          initial = 0;
          NProgress.done();
        } else {
          NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };
  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function (fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');

    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar = progress.querySelector(Settings.barSelector),
        perc = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent = document.querySelector(Settings.parent),
        spinner;

    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function () {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function () {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function () {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = 'WebkitTransform' in bodyStyle ? 'Webkit' : 'MozTransform' in bodyStyle ? 'Moz' : 'msTransform' in bodyStyle ? 'ms' : 'OTransform' in bodyStyle ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }

  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d(' + toBarPerc(n) + '%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate(' + toBarPerc(n) + '%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n) + '%' };
    }

    barCSS.transition = 'all ' + speed + 'ms ' + ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = function () {
    var pending = [];

    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function (fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  }();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = function () {
    var cssPrefixes = ['Webkit', 'O', 'Moz', 'ms'],
        cssProps = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function (match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function (element, properties) {
      var args = arguments,
          prop,
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    };
  }();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return;

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});

/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3de37e7e.svg";

/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e968b6a0.svg";

/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1342);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Logo.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Logo.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1342:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2DdTy{text-decoration:none!important;font-size:10px;font-weight:600;color:#ffd906;padding-bottom:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:48px}._2DdTy:active,._2DdTy:focus,._2DdTy:hover{color:#ffd906;text-decoration:none}", ""]);

// exports
exports.locals = {
	"brandLogo": "_2DdTy"
};

/***/ }),

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1344);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Header.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Header.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1344:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".CjTMX{position:relative;background-color:#fff;color:#000;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.12);box-shadow:0 2px 8px rgba(0,0,0,.12);z-index:99}._3v0wi{position:fixed;left:0;right:0;top:0;z-index:100}._1KXxC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;padding:0 15px;height:60px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media print{.CjTMX{display:none}}", ""]);

// exports
exports.locals = {
	"root": "CjTMX",
	"fixed": "_3v0wi",
	"container": "_1KXxC container"
};

/***/ }),

/***/ 1345:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f33d7fc5.svg";

/***/ }),

/***/ 1346:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1347);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationLink.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationLink.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1347:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1h7t-{padding:0 4px;font-weight:400;margin-left:-2px;background-color:#ededed;border-radius:10rem}", ""]);

// exports
exports.locals = {
	"count": "_1h7t-"
};

/***/ }),

/***/ 1348:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1349);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationItem.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1349:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._34VVu{position:relative;font-size:13px;border-bottom:2px solid transparent;border-top:2px solid transparent;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}.m5hBM{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#000;font-weight:700;text-decoration:none;padding:13px 12px;height:100%}._1ojmC{display:none;position:absolute;top:100%;left:0;z-index:101;background-color:#fff;border-bottom:1px solid #ddd;border-right:1px solid #ddd;border-left:1px solid #ddd;-webkit-box-shadow:0 12px 16px rgba(0,0,0,.08);box-shadow:0 12px 16px rgba(0,0,0,.08)}._34VVu:hover{background-color:#f5f5f5;color:#e73232}._34VVu._2Rphr,._34VVu:hover{border-top:2px solid #ffd906}._34VVu:hover .m5hBM{color:#e73232}._34VVu:hover ._1ojmC,.BOSU4{display:block}.BOSU4{color:#000;font-weight:400;font-size:14px;text-decoration:none;padding:12px;white-space:nowrap}.BOSU4:hover{background-color:#f5f5f5;color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "_34VVu",
	"link": "m5hBM",
	"dropdown": "_1ojmC",
	"active": "_2Rphr",
	"dLink": "BOSU4"
};

/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1351);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ProfileButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ProfileButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".cSaip{position:relative;font-size:13px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;padding:0 12px;min-width:150px}._2vqlh{color:#000;max-width:150px;font-weight:700;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:0 -12px;padding:0 11px;border-top:0 solid transparent}.cSaip:hover ._2vqlh{background-color:#f5f5f5;border-top:0 solid #ffd906;color:#e73232}.MEvex{max-width:150px;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}._2Esyq{display:none;position:absolute;width:100%;top:100%;left:0;z-index:101;background-color:#fff;border-bottom:1px solid #ddd;border-right:1px solid #ddd;border-left:1px solid #ddd;-webkit-box-shadow:0 12px 16px rgba(0,0,0,.08);box-shadow:0 12px 16px rgba(0,0,0,.08);-webkit-box-sizing:border-box;box-sizing:border-box}.cSaip:hover ._2Esyq{display:block}.r6XJg{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.cdK6z>span{white-space:pre-wrap}.cdK6z{display:block;color:#000;font-weight:400;font-size:14px;text-decoration:none;padding:12px;white-space:nowrap;text-align:left}.cdK6z:hover{background-color:#f5f5f5;color:#000}._1-5lQ{border-top:1px solid #ededed;font-weight:700;padding:12px}._2ST8r{height:35px;width:35px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:50%;overflow:hidden;margin-right:10px}._1JQVF{width:100%}", ""]);

// exports
exports.locals = {
	"root": "cSaip",
	"link": "_2vqlh",
	"btnTitle": "MEvex",
	"dropdown": "_2Esyq",
	"dropdownList": "r6XJg",
	"dropdownLink": "cdK6z",
	"logout": "_1-5lQ",
	"avatarContainer": "_2ST8r",
	"avatar": "_1JQVF"
};

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1353);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Navigation.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Navigation.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".s3Ylh{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;min-width:935px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-item-align:stretch;align-self:stretch}._3BN4_{margin-right:8px;margin-left:8px;border-radius:3px;color:#000}._3BN4_:hover{color:#e73232}._29C-n{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.BZPWi{position:relative;height:100%}.BZPWi,.dmyLG{display:-webkit-box;display:-ms-flexbox;display:flex}.dmyLG{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-left:10px}._1XlLA{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;height:100%}._3L2yd{display:inline-block;text-decoration:none;font-weight:700;font-size:13px;padding:15px 20px 15px 18px}._3PRKw{background-color:#ffd906;color:#000;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3PRKw:hover{background-color:#ffc107;color:#000}._3PRKw img{margin-right:10px}", ""]);

// exports
exports.locals = {
	"root": "s3Ylh",
	"highlight": "_3BN4_",
	"left": "_29C-n",
	"navItem": "BZPWi",
	"right": "dmyLG",
	"flexRow": "_1XlLA",
	"link": "_3L2yd",
	"sell": "_3PRKw"
};

/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1355);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InlineNav.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InlineNav.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3ALPP{z-index:1}._3ALPP,.mCAa6{position:relative;margin:0;padding:0}.mCAa6{list-style:none}._3PRCE{position:relative}._3PRCE,._HsNd{display:inline-block}._HsNd{text-decoration:none;font-weight:400;font-size:12px;padding:15px 10px 9px;border-bottom:4px solid transparent;cursor:pointer;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out;text-transform:uppercase;letter-spacing:.1em}._HsNd:hover{color:#e73232}._HsNd:hover,.A7cFq{border-bottom:4px solid #ffd906}.A7cFq{position:relative;color:#000;font-weight:700}", ""]);

// exports
exports.locals = {
	"root": "_3ALPP",
	"list": "mCAa6",
	"item": "_3PRCE",
	"link": "_HsNd",
	"active": "A7cFq"
};

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1357);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _chainFunction = __webpack_require__(1359);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(318);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(1360);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';

TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ 1359:
/***/ (function(module, exports) {


module.exports = function chain() {
  var len = arguments.length;
  var args = [];

  for (var i = 0; i < len; i++) {
    args[i] = arguments[i];
  }args = args.filter(function (fn) {
    return fn != null;
  });

  if (args.length === 0) return undefined;
  if (args.length === 1) return args[0];

  return args.reduce(function (current, next) {
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  });
};

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(11);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),

/***/ 1361:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _addClass = __webpack_require__(1362);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(1364);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(1365);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(1366);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(38);

var _PropTypes = __webpack_require__(1264);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';

CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1251);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(1363));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),

/***/ 1364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1251);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(1263));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */

var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1251);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(1263));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1368);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PaymentModal.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PaymentModal.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2aYHp{position:fixed;z-index:3005;background-color:rgba(50,50,50,.2);top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;width:100%;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-weight:400}.Qt1yN{position:absolute;top:0;left:0;right:0;bottom:0;z-index:3006}._8VETH{position:relative;background-color:#fff;width:600px;min-height:400px;padding:10px 20px 18px;margin:5px;-ms-flex-item-align:center;align-self:center;z-index:3007}._2ux5J{font-size:21px;font-weight:400;padding-bottom:15px;margin-bottom:11px;border-bottom:1px solid #eee}._1DP-n{margin-bottom:5px}.pu5sx{position:relative;-ms-flex-line-pack:stretch;align-content:stretch;margin:20px 0 35px}.pu5sx,.sMEF2{display:-webkit-box;display:-ms-flexbox;display:flex}.sMEF2{width:100%;max-width:50%;padding:20px 15px;margin:0 20px 0 auto;border:2px solid #eee;border-radius:2px;text-align:center;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;background:transparent;outline:none}.sMEF2:last-of-type{margin-right:auto}._2zCrj{margin:auto}._3ZjNy{padding-top:7px}._3o5Yq{height:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3o5Yq,._3v-gG{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column wrap;flex-flow:column wrap}._3v-gG{position:relative}.sMEF2:not(._2FvZr):hover{color:#000;border-color:#ffd906;background-color:#fffbd3;cursor:pointer;outline:none}.VjrcA{text-align:right}._3gU1v,.VjrcA{position:relative}._3gU1v{margin-left:10px;border:1px solid #d0d0d0;background-color:#fff;color:#000;padding:8px 16px;overflow:hidden}._3gU1v:hover{cursor:pointer;border-color:#ffd906}._3gU1v._2FvZr>:not(._2si0B){visibility:hidden}._1EHnC{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}._1ofkJ{padding-top:21px;padding-left:18px;font-size:13px;font-weight:400;color:#aaa;margin:0 0 6px}._3_uNl{margin:5px;bottom:21px;position:absolute;left:-4px}@media screen and (max-width:380px){.pu5sx{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:0}.sMEF2{margin:10px auto}}._2FvZr{opacity:.6}._3s_hN{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;position:relative;font-weight:400;color:#000;padding-left:20px}._3s_hN:hover{color:#ff5a5f}._3s_hN input{cursor:pointer;position:absolute;left:4px;border:1px solid #aaa;border-radius:2px}._3s_hN input,._3s_hN input:checked{margin-left:-4px;top:1px;-webkit-appearance:none;width:15px;height:15px;outline:none}._3s_hN input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._3s_hN input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:1px;left:-1px;overflow:hidden;width:17px;height:9px;margin-top:-6px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}._3ZsMo input,._3ZsMo input:checked{margin-top:-8px;margin-left:-4px}", ""]);

// exports
exports.locals = {
	"root": "_2aYHp",
	"bg": "Qt1yN",
	"container": "_8VETH",
	"h3": "_2ux5J",
	"balance": "_1DP-n",
	"list": "pu5sx",
	"payment": "sMEF2",
	"paymentContents": "_2zCrj",
	"paymentTitle": "_3ZjNy",
	"column": "_3o5Yq",
	"columnWrapper": "_3v-gG",
	"disabled": "_2FvZr",
	"actions": "VjrcA",
	"button": "_3gU1v",
	"buttonLoader": "_2si0B",
	"loader": "_1EHnC",
	"contractOffer": "_1ofkJ",
	"contractCheckbox": "_3_uNl",
	"checkbox": "_3s_hN",
	"mobile": "_3ZsMo"
};

/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1370);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BalanceRefill.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BalanceRefill.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".DmOcI{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;min-height:44px;line-height:44px;font-size:16px;font-weight:400}._3ZFf5{height:44px;background-color:#ffd906;border:1px solid #ffd906;color:#000;padding:10px 12px;border-radius:0 2px 2px 0;cursor:pointer;font-weight:600;outline:none}._3ZFf5:hover{background:#ffc107;border:1px solid #ffc107}._30C05{position:absolute;top:1px;left:110px}.LY1XA{border:1px solid #e0e0e0;font-size:16px;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out;outline:none;width:150px;padding:12px 43px 12px 12px;text-align:right;max-height:44px}.LY1XA:active,.LY1XA:focus{outline:none;-webkit-box-shadow:none;box-shadow:none;border:1px solid #ffd906}", ""]);

// exports
exports.locals = {
	"inputContainer": "DmOcI",
	"inlineButton": "_3ZFf5",
	"hrn": "_30C05",
	"input": "LY1XA"
};

/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1372);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Balance.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Balance.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1uFAv{position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding-right:8px}._2B6Dt{font-weight:600;color:inherit;text-decoration:none}._2O5JS{position:absolute;top:100%;right:0;padding:10px 8px 8px;background:#fff;-webkit-box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75);box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75)}._3iQnl{vertical-align:text-bottom}._2xW05{vertical-align:top}", ""]);

// exports
exports.locals = {
	"root": "_1uFAv",
	"content": "_2B6Dt",
	"popup": "_2O5JS",
	"icon": "_3iQnl",
	"title": "_2xW05"
};

/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1374);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SubHeader.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SubHeader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1D_Nn{position:relative;background-color:#fff;z-index:7;padding:0 15px}._1ediK{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._1ediK,._2cKE_,.TpfX0{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.TpfX0{display:-webkit-box;display:-ms-flexbox;display:flex;text-align:right;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-right:10px;height:44px;line-height:42px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._3YhcH{border:0;background:none}._3c7Db,._3YhcH,.vuYGG{display:inline-block}.vuYGG{font-weight:600;color:inherit;text-decoration:none}.vuYGG+.vuYGG{margin-left:30px}._3c7Db{margin-left:28px}._1dKSE{color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "_1D_Nn",
	"container": "_1ediK container",
	"left": "_2cKE_",
	"right": "TpfX0",
	"locationSelect": "_3YhcH",
	"tariff": "vuYGG",
	"balance": "_3c7Db",
	"nonActiveTariff": "_1dKSE"
};

/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".zDFkx{position:relative;font-size:13px;line-height:18px;min-width:920px;padding:15px 0 30px;color:hsla(0,0%,100%,.5);background:#212121;z-index:3;min-height:200px}._3RtQ6{padding:0 20px;margin:0 auto}.fb9ID{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._20qxe{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.NYfbf{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:265px;text-align:right;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._35XCD{list-style:none;margin:10px 0;padding:0;min-width:790px}._35XCD li{display:inline-block;margin-right:20px}._19Cat{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0}._2Rxe3{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;margin-bottom:8px}._3EfAE{font-weight:500;font-size:18px;line-height:120%;color:#fff}._2-_Wn{font-size:12px}._2Dlbx{font-weight:400;text-decoration:none;font-size:14px;color:hsla(0,0%,100%,.85);-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}._2xcDA{font-weight:400}._2xcDA,.Oogak{text-decoration:none;font-size:13px;color:hsla(0,0%,100%,.5);-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}.Oogak{position:relative;margin:10px 0;font-weight:700;display:inline-block;letter-spacing:.05em}._2Dlbx:hover,._2xcDA:hover,.Oogak:hover{color:#fff;cursor:pointer}._2-8Mr{border-top:1px solid #4e4e4e;margin:16px 0}._2rdKT{font-size:22px;color:#fff;text-decoration:none;opacity:.8;padding-left:14px}._2rdKT:hover{opacity:1}._1AipK a,span{color:inherit;text-decoration:none}._1AipK:after{content:\" | \";margin:0 10px}._1AipK:last-child:after{content:none}._3pz-l{text-align:center;margin-top:20px}@media print{.zDFkx{display:none}}._3rXoJ ul{padding:0}", ""]);

// exports
exports.locals = {
	"root": "zDFkx",
	"container": "_3RtQ6 container",
	"flexContainer": "fb9ID",
	"left": "_20qxe",
	"right": "NYfbf",
	"nav": "_35XCD",
	"navLeasing": "_19Cat",
	"navLeasingItem": "_2Rxe3",
	"navLeasingTitle": "_3EfAE",
	"navLeasingTitleHeader": "_2-_Wn",
	"link": "_2Dlbx",
	"smallLink": "_2xcDA",
	"tel": "Oogak",
	"divide": "_2-8Mr",
	"socialLink": "_2rdKT",
	"lang": "_1AipK",
	"footerCopyRight": "_3pz-l",
	"leasingList": "_3rXoJ"
};

/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1377);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ColumnList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ColumnList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".JoFQz{margin-top:20px}._3QNtp{width:200px}._2iDdE{list-style:none}._2fQe9{font-size:11px;color:inherit;text-decoration:none;margin-top:0;margin-bottom:1em;white-space:nowrap;overflow:hidden;display:block}._1LE5p{cursor:pointer;text-decoration:none}._1LE5p,._2XVd2{padding:10px;font-size:14px;font-weight:700;display:inline-block;color:hsla(0,0%,100%,.5)}.wcDf5{color:#dedede!important;font-size:12px}._3oo16{color:rgba(64,64,64,.98);font-size:12px;font-weight:700}._35FVL{display:block;padding-left:0;margin-left:-6px;font-size:12px;cursor:auto}.r4Dcm{cursor:pointer}._1gtiU{color:hsla(0,0%,100%,.5)!important}._1mQCi{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}", ""]);

// exports
exports.locals = {
	"root": "JoFQz",
	"column": "_3QNtp",
	"item": "_2iDdE",
	"link": "_2fQe9",
	"resetLocationLink": "_1LE5p",
	"resetLocationText": "_2XVd2",
	"selLocation": "wcDf5",
	"disabledCity": "_3oo16",
	"curentBreadCrumbs": "_35FVL",
	"cursorPointer": "r4Dcm",
	"hideHover": "_1gtiU",
	"breadCrumbsBlock": "_1mQCi"
};

/***/ }),

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1379);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LocationList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LocationList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1379:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1PNMZ,._3G2DH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1PNMZ ._3Lg2h{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row}._1PNMZ ._3Lg2h,._3G2DH ._3Lg2h{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;list-style:none;margin:0}._3G2DH ._3Lg2h{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}._3Lg2h{font-weight:400}.f2F2C{font-size:14px;color:#c4c4c4}", ""]);

// exports
exports.locals = {
	"root": "_1PNMZ",
	"rootMobile": "_3G2DH",
	"citiesList": "_3Lg2h",
	"title": "f2F2C"
};

/***/ }),

/***/ 1380:
/***/ (function(module, exports) {

module.exports = {"title":"Популярные разделы","uk_title":"Популярні розділи","items":[{"id":1,"title":"Б/у авто в лизинг","uk_title":"Б/у авто в лізинг","slug":"/leasing/used-avto/"},{"id":2,"title":"Новые авто в лизинг","uk_title":"Нові авто в лізинг","slug":"/leasing/novyye-avto/"},{"id":3,"title":"Легковые авто в лизинг","uk_title":"Легкові авто в лізинг","slug":"/leasing/leasing-legkovykh-avto/"},{"id":4,"title":"Лизинг авто для физических лиц","uk_title":"Лізинг авто для фізичних осіб","slug":"/leasing/leasing-avto-fizicheskikh-lits/"}]}

/***/ }),

/***/ 1381:
/***/ (function(module, exports) {

module.exports = {"title":"Популярные Марки авто в лизинг","uk_title":"Популярні Марки авто в лізинг","items":[{"id":1,"title":"bmw в лизинг","uk_title":"bmw у лізинг","slug":"/leasing/bmw/"},{"id":2,"title":"peugeot в лизинг","uk_title":"peugeot у лізинг","slug":"/leasing/peugeot/"},{"id":3,"title":"volvo в лизинг","uk_title":"volvo у лізинг","slug":"/leasing/volvo/"},{"id":4,"title":"toyota в лизинг","uk_title":"toyota у лізинг","slug":"/leasing/toyota/"},{"id":5,"title":"mazda в лизинг","uk_title":"mazda у лізинг","slug":"/leasing/mazda/"},{"id":6,"title":"skoda в лизинг","uk_title":"skoda у лізинг","slug":"/leasing/skoda/"},{"id":7,"title":"газель в лизинг","uk_title":"газель у лізинг","slug":"/leasing/gaz/"},{"id":8,"title":"volkswagen в лизинг","uk_title":"volkswagen у лізинг","slug":"/leasing/volkswagen/"},{"id":9,"title":"порше в лизинг","uk_title":"порше у лізинг","slug":"/leasing/porsche/"},{"id":10,"title":"ауди в лизинг","uk_title":"ауди у лізинг","slug":"/leasing/audi/"},{"id":11,"title":"citroen в лизинг","uk_title":"citroen у лізинг","slug":"/leasing/citroen/"},{"id":12,"title":"mercedes benz в лизинг","uk_title":"mercedes benz у лізинг","slug":"/leasing/mercedes-benz/"},{"id":13,"title":"ford в лизинг","uk_title":"ford у лізинг","slug":"/leasing/ford/"},{"id":14,"title":"nissan в лизинг","uk_title":"nissan у лізинг","slug":"/leasing/nissan/"},{"id":15,"title":"hyundai в лизинг","uk_title":"hyundai у лізинг","slug":"/leasing/hyundai/"},{"id":16,"title":"renault в лизинг","uk_title":"renault у лізинг","slug":"/leasing/renault/"}]}

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1383);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LanguageList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LanguageList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._11JjB a,span{color:inherit;text-decoration:none}._11JjB:after{content:\" | \";margin:0 10px}._11JjB:last-child:after{content:none}", ""]);

// exports
exports.locals = {
	"lang": "_11JjB"
};

/***/ }),

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1385);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NotificationBar.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NotificationBar.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".KSaKz{position:fixed;top:0;left:0;width:100%;background:rgba(0,0,0,.8);padding:13px 20px;-webkit-transform:translateY(-100%);transform:translateY(-100%);-webkit-transition:-webkit-transform .1s linear;transition:-webkit-transform .1s linear;-o-transition:transform .1s linear;transition:transform .1s linear;transition:transform .1s linear,-webkit-transform .1s linear;z-index:10000}._2sO61{background:#e73232;color:#fff}._2A3gx{background:#ffd906;color:#000}._1aLfe{background:#4caf10;color:#fff}._2pXnf{background:#2196f3;color:#fff}.bzlx8{-webkit-transform:translateY(0);transform:translateY(0)}._1WJlP{color:#fff;text-align:center;max-width:800px;margin:0 auto}@media print{.KSaKz{display:none}}", ""]);

// exports
exports.locals = {
	"root": "KSaKz",
	"error": "_2sO61",
	"warning": "_2A3gx",
	"success": "_1aLfe",
	"info": "_2pXnf",
	"active": "bzlx8",
	"label": "_1WJlP"
};

/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1387);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".-lRLO{position:relative;padding-top:10px;padding-bottom:10px;margin:0 auto;text-align:center}._35_nZ{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}._3aSLj,._35_nZ{display:-webkit-box;display:-ms-flexbox;display:flex}._3aSLj{-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1I3Gw{font-size:14px;font-weight:400;text-align:center;color:#000}._1I3Gw,.iXl6a{margin-bottom:20px}.iXl6a{float:right}._3w_FE{color:#2196f3;display:inline-block;cursor:pointer}._3w_FE:hover{color:#154088;border-bottom:.07em solid}._3w_FE:active{color:#497ddd;border-bottom:1px dashed}._18Fb4{display:inline-block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;font-weight:400;font-size:15px;color:#000}._18Fb4 input{margin-left:0;position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._18Fb4 input,._18Fb4 input:checked{top:3px;-webkit-appearance:none;width:15px;height:15px;outline:none}._18Fb4 input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._18Fb4 input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:0;left:-1px;overflow:hidden;width:17px;height:9px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}._3IYbg input{margin-left:0;position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._3IYbg input,._3IYbg input:checked{top:0;-webkit-appearance:none;width:15px;height:15px;outline:none}._3IYbg input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._3IYbg input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:-3px;left:-1px;overflow:hidden;width:17px;height:9px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}body{font-family:OpenSans,sans-serif;padding:0 2px 0 0;color:#000;font-weight:400}a:focus{text-decoration:none}:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}.ant-form-item{margin:0}.ant-btn,button,input,optgroup,select,textarea{line-height:normal}._1ONYX{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;padding:17px 16px;width:100%;height:60px;outline:0;border:1px solid #ccc;-webkit-appearance:none;border-radius:2px;background:#fff;color:#616161;font-size:18px;line-height:1.3333333;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;margin:10px 0}._1ONYX::-webkit-input-placeholder{color:#6c6868cf;opacity:1}._1ONYX::-moz-placeholder{color:#6c6868cf;opacity:1}._1ONYX:-ms-input-placeholder{color:#6c6868cf;opacity:1}._1ONYX::placeholder{color:#6c6868cf;opacity:1}._3oObU::-webkit-input-placeholder{color:#6c6868cf;opacity:1}._3oObU::-moz-placeholder{color:#6c6868cf;opacity:1}._3oObU:-ms-input-placeholder{color:#6c6868cf;opacity:1}._3oObU::placeholder{color:#6c6868cf;opacity:1}._3oObU{padding:17px 16px;height:60px;outline:0;border:1px solid #ccc;-webkit-appearance:none;border-radius:2px;background:#fff;color:#616161;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}._2RHEP,._3oObU{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;font-size:16px;line-height:1.3333333;margin-top:10px}._2RHEP{position:relative;margin-bottom:20px;height:46px;border:0;border-radius:3px;background:#ffd906;text-align:center;text-decoration:none;cursor:pointer;outline:none}._2RHEP>p{margin:0}._2RHEP:hover{background:#ffc1076b}._2RHEP:disabled,._2RHEP[disabled]{background:#ffc1077c;cursor:auto;color:rgba(0,0,0,.5)}.has-error>span>input{border-color:#f5222d}.ant-form-explain{color:#f5222d;padding:0 8px}.czsUy{text-align:center;padding:15px 0 40px}.ant-form-item{margin-bottom:5px}.eTG0E{font-size:13px;line-height:18px;margin:25px 0 20px;color:#555;letter-spacing:.34px;font-weight:400}.Nmq1p{text-decoration:none;font-size:15px;cursor:pointer}._2gUqb{cursor:pointer;float:right}._1SYqv{width:100%;text-align:right;margin:10px 0}._37Srk{font-size:14px;font-weight:400;text-align:center;color:#000;margin-top:20px;font-weight:600}._1frkA{position:relative;background-color:#fff}._1frkA,._1gBiv{margin-bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1gBiv{max-width:740px}._1gBiv>div>div>iframe,._1gBiv>div>iframe,._1gBiv>iframe{max-width:100%}._1frkA>div{margin-bottom:0}._1frkA>div>div{padding-top:10px}._1frkA>div>div,._3lJEn,._31HIU{margin-bottom:20px}._3lJEn{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;margin-top:20px;padding:0 45px}._3lJEn>div{margin-bottom:10px;margin-top:10px}#banner{display:none}._2s_Y4{position:relative;margin-top:-18px;padding-left:15px;max-width:1100px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-top:10px;-webkit-box-sizing:border-box;box-sizing:border-box;margin-bottom:20px}._2s_Y4,._30-Va>div{display:-webkit-box;display:-ms-flexbox;display:flex}._30-Va>div{width:100vw;-ms-flex-pack:distribute;justify-content:space-around}.is-focused:not(.is-open)>.Select-control{border-color:#ff5a5f;-webkit-box-shadow:none;box-shadow:none}.Select-control{border-radius:0;border:1px solid #e0e0e0}.Select-placeholder{color:#777}.d-advertSlot{margin-bottom:20px}.adunitContainer,.d-advertSlot{position:relative;text-align:center}.adunitContainer>:last-child{margin-bottom:20px}#app{position:relative;z-index:2;padding-top:63px;height:100%}.ap-script-wrapper>div{padding:20px}.F0IVy{min-width:1100px;position:relative;z-index:auto}._2azA2{margin-top:30px}html{color:#222;font-weight:100;font-size:1em;line-height:1.375}button,html{font-family:OpenSans,sans-serif}body{margin:0;background-color:#f5f5f5}a{color:#0074c2}a[class=meta-title-link-next],a[class=meta-title-link]{text-decoration:none}a[class=meta-title-link]+a[class=meta-title-link]:before,span[class=meta-title-link]+span[class=meta-title-link]:before{content:\"\";background-image:url(" + __webpack_require__(1267) + ");background-size:contain;background-repeat:no-repeat;display:inline-block;cursor:default;height:8px;width:10px}a[class=meta-title-link-next]:before,span[class=meta-title-link-next]:before{content:\"\";background-image:url(" + __webpack_require__(1267) + ");background-size:contain;background-repeat:no-repeat;display:inline-block;cursor:default;height:8px;width:10px}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}hr{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}@media print{*,:after,:before{background:transparent!important;color:#000!important;-webkit-box-shadow:none!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}._3RoS6{min-width:1070px;max-width:1100px;background:#f5f5f5;margin:8px auto 0;z-index:4;position:relative}._1agwl>div>iframe{margin-top:25px}._1HUfQ{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-sizing:border-box;box-sizing:border-box}.imgCover{position:absolute;top:50%;left:50%;width:100%;height:auto;max-width:none;max-height:none;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}@supports ((-o-object-fit:cover) or (object-fit:cover)){.imgCover{position:static;top:auto;left:auto;width:100%;height:100%;-webkit-transform:none;transform:none;-o-object-fit:cover;object-fit:cover}}.page{padding:0;position:relative}.container{min-width:1070px;max-width:1100px;margin:0 auto}.card{background-color:#fff;z-index:1;padding:10px 20px}.flexRow{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.questionTitle{font-size:21px;font-weight:700;margin-bottom:10px}.required:after{content:\"*\";display:inline-block;margin-left:2px;color:#c00}.input:active,.input:focus{outline:none;border:1px solid #ffc107}", ""]);

// exports
exports.locals = {
	"sbsGL": "-lRLO",
	"flexCenterGl": "_35_nZ",
	"flexCenterAlignGl": "_3aSLj",
	"titleNellGl": "_1I3Gw",
	"linkLeahs": "iXl6a",
	"linkLeah": "_3w_FE",
	"checkboxGl": "_18Fb4",
	"checkboxMobileGl": "_3IYbg",
	"inputFormGl": "_1ONYX",
	"inputFormMobilGl": "_3oObU",
	"buttonFormGl": "_2RHEP",
	"submitSectionGl": "czsUy",
	"agreementGl": "eTG0E",
	"urlGl": "Nmq1p",
	"linkTextGl": "_2gUqb",
	"linkBlockGl": "_1SYqv",
	"titleGl": "_37Srk",
	"advertContainerGl": "_1frkA",
	"banerAllStyleGl": "_1gBiv",
	"gptPremium": "_31HIU",
	"advertContainerButoonGl": "_3lJEn",
	"brandingAdvGl": "_2s_Y4",
	"mobileWebTop": "_30-Va",
	"root": "F0IVy",
	"mainFooter": "_2azA2",
	"layout": "_3RoS6",
	"banerTop": "_1agwl",
	"brandingAdv": "_1HUfQ"
};

/***/ }),

/***/ 1388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/seoDescription.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_modules__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var buildFirmsSeoDescription = function buildFirmsSeoDescription(data, t) {
  var cityTitle = data.cityTitle,
      section = data.section,
      regLocation = data.regLocation,
      location = data.location;
  // if (section === 'СТО') {
  //   if (isRegion)
  //     return t(
  //       'Каталог СТО {locationAccusative}, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто  ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //       { locationAccusative },
  //     );
  //   else if (cityTitle)
  //     return t(
  //       'Каталог СТО в {cityTitle}, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто  ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //       { cityTitle },
  //     );
  //   return t(
  //     'Каталог СТО, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто  ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //   );
  // }
  // if (section && cityDescriptions) {
  //   return t(
  //     '{section} в {cityDescriptions}: Полный список организаций ✅ Адреса ✅ Контактные данные {section} в {cityDescriptions}',
  //     data,
  //   );
  // }
  // if (section) {
  //   return t(
  //     '{section} в Украине: Полный список организаций ✅ Адреса ✅ Контактные данные {section} в вашем городе',
  //     data,
  //   );
  // }
  // if (cityDescriptions) {
  //   return t(
  //     'Каталог СТО в {cityDescriptions}, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //     data,
  //   );
  // }

  if (section === 'СТО' && cityTitle) {
    return t('Каталог СТО {cityTitle} с адресами компаний, телефонами и картой проезда. Связаться с автосервисом и записаться на СТО можно на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Авторазборка' || section === 'Авторозборка') && cityTitle) {
    return t('Авторазборка {cityTitle}. Каталог компаний по разбору авто. Адреса, телефоны, карта проезда на сайте Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Автовыкуп' || section === 'Автовикуп') && cityTitle) {
    return t('Автовыкуп {cityTitle}. Каталог компаний по выкупу авто с адресами, телефонами и картой проезда на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Запчасти' || section === 'Запчастини') && cityTitle) {
    return t('Дилеры по продаже автозапчастей {cityTitle}. Адреса, телефоны компаний на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Автотовары' || section === 'Автотовари') && cityTitle) {
    return t('Поставщики автотоваров {cityTitle}. Адреса, телефоны компаний на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Сервисные центры' || section === 'Сервісні центри') && cityTitle) {
    return t('Территориальные сервисные центры {cityTitle}. Адреса, телефоны ТСЦ для регистрации авто, оформления справок, замены водительского удостоверения', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if (cityTitle) {
    return t('Автосервисы {cityTitle} с адресами компаний, телефонами и картой проезда. Связаться с автосервисом и записаться на обслуживание можно на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  return t('Автомобильные организации в Украине: СТО ✅ Авторазборки ✅ Мойки ✅ Шиномонтаж и другие фирмы для владельцев авто');
};

var buildFirmPageSeoDescription = function buildFirmPageSeoDescription(title, tab, t) {
  var car_drive_countries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var tags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var firm = arguments[5];

  if (tab === 'blog') {
    return t('Актуальные новости и действующие акции компании {title} смотрите на Автобазаре', {
      title: title
    });
  }

  var countries = Array.isArray(car_drive_countries) ? car_drive_countries.map(function (item) {
    return item.title;
  }).join(', ') : car_drive_countries;

  if (car_drive_countries.length > 0) {
    return t('Компания {title} по доставке авто из {countries}. Условия выкупа с аукциона и пригона авто под ключ. Стоимость услуг и преимущества сотрудничества с компанией {title}', {
      title: title,
      countries: countries
    });
  }

  if (Array.isArray(tags)) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].slug && tags[i].slug === 'sto') {
        return t('СТО {title}. Адрес, телефон, график работы, услуги СТО, последние новости и акции. Связаться с автосервисом и записаться на СТО можно на Автобазаре', {
          title: title,
          tags: tags
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtorazborka') {
        return t('Авторазборка {title}. Компания по разбору авто. Адреса, телефоны, карта проезда, график работы, услуги компании, новости и акции смотрите на сайте Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtovykup') {
        return t('{title}. Услуги, новости, акции компании по выкупу авто. Адрес, телефоны, карта проезда и график работы смотрите на сайте Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtotovary') {
        return t('Поставщик автотоваров {title}. Адреса, телефоны, график работы компаний на Автобазаре. Самые актуальные предложения по автотоварам от компании', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'teritorialni-servisni-centri') {
        return t('{title}. Адрес, телефон, график работы ТСЦ для регистрации авто, оформления справок, замены водительского удостоверения указаны на сайте Автобазар', {
          title: title
        });
      }
    }
  }

  return t('METATEGS_DESCRIPTION_FIRM_ZAPCHASTI', { title: title });
};

var buildSearchAvtoSeoDescription = function buildSearchAvtoSeoDescription(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
  if (seoData && seoData.description) return seoData.description;

  var _data$make = data.make,
      make = _data$make === undefined ? '' : _data$make,
      _data$model = data.model,
      model = _data$model === undefined ? '' : _data$model,
      _data$location = data.location,
      location = _data$location === undefined ? '' : _data$location,
      _data$generation = data.generation,
      generation = _data$generation === undefined ? '' : _data$generation,
      _data$gearbox = data.gearbox,
      gearbox = _data$gearbox === undefined ? '' : _data$gearbox,
      _data$engine = data.engine,
      engine = _data$engine === undefined ? '' : _data$engine,
      _data$body = data.body,
      body = _data$body === undefined ? '' : _data$body,
      _data$drive = data.drive,
      driveSelected = _data$drive === undefined ? '' : _data$drive,
      _data$isNew = data.isNew,
      isNew = _data$isNew === undefined ? false : _data$isNew,
      _data$makeTranslate = data.makeTranslate,
      makeTranslate = _data$makeTranslate === undefined ? make : _data$makeTranslate,
      _data$modelTranslate = data.modelTranslate,
      modelTranslate = _data$modelTranslate === undefined ? model : _data$modelTranslate,
      yearSelected = data.year,
      _data$country = data.country,
      country = _data$country === undefined ? null : _data$country,
      _data$city = data.city,
      city = _data$city === undefined ? null : _data$city;


  var drive = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["b" /* buildDriveValue */](driveSelected, t);
  var locale = t('locale');
  var inGenitiveLocation = location && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location] ? __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location][locale].genitive) : city && city.title && ' ' + __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](city[locale + '_title'] || city.title) || '\u0432 ' + __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */]['Украина'][locale].genitive;

  var yearVsSpace = yearSelected ? ' ' + yearSelected + ' ' + t('года') : '';
  var yearDotVsSpace = yearSelected ? ' ' + yearSelected + ' ' + t('г.') : '';
  var customGearboxAlt = gearbox in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale].altTitle : gearbox;
  var customGearbox = gearbox in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale].title : gearbox;
  var customEngineAlt = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].altTitle : engine;
  var customEngine = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].title : engine;
  var countryTitle = country && t(country.title);
  var countryFromTitle = country && country.from && country.from[locale];

  var params = _extends({}, data, {
    countryFromTitle: countryFromTitle,
    countryTitle: countryTitle,
    inGenitiveLocation: inGenitiveLocation,
    makeTranslate: makeTranslate,
    modelTranslate: modelTranslate,
    generation: generation ? ' ' + generation : '',
    drive: drive,
    year: yearVsSpace,
    yearDot: yearDotVsSpace
  });

  // {locale}*/avto/{country}/
  if (country && !make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t('SEO_META_DESCRIPTION_AVTO_COUNTRY', { countryFromTitle: countryFromTitle });
  }

  if (make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t(isNew ? 'Купить легковой автомобиль {make}{year} 🚗 {inGenitiveLocation}. Большой выбор новых {makeTranslate}{yearDot} без посредников по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей {make}{year} б/у 🚗 {inGenitiveLocation}. Удобный поиск по объявлениям поможет купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && !generation && !gearbox && !engine && !body && !drive) {
    return t(isNew ? 'Купить легковой автомобиль {make} {model}{year} 🚗 {inGenitiveLocation}. Большой выбор новых {makeTranslate}{yearDot} без посредников по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей {make} {model}{year} б/у 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && body && !generation && !gearbox && !engine && !drive) {
    return t(isNew ? 'Купить {body} {make} {model}{year} 🚗 {inGenitiveLocation}. Выбрать новый {makeTranslate} {body}{yearDot} без посредников по выгодной цене на АвтоБазар.' : 'Продажа {body} {make} {model}{year} б/у 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && generation && !gearbox && !engine && !drive) {
    return t(isNew ? 'Купить {make} {model}{generation}{year} 🚗 {inGenitiveLocation}. Выбрать новый {makeTranslate}{yearDot} без посредников по выгодной цене на АвтоБазар.' : 'Продажа {make} {model}{generation}{year} б/у 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && gearbox && !engine && !drive) {
    return t(isNew ? 'Новые легковые автомобили {gearbox} {make} {model}{generation}{year} 🚗 {inGenitiveLocation}. Удобный поиск по предложениям поможет купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей {make} {model}{generation} {gearbox}{year} 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && gearbox && drive && !engine) {
    return t(isNew ? 'Купить новый легковой автомобиль {make} {model}{generation} {gearbox} {drive}{year} 🚗 {inGenitiveLocation}. Удобный поиск предложений продажи {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей {make} {model}{generation} {gearbox} {drive}{year} 🚗. Подбор предложений {inGenitiveLocation} поможет купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && gearbox && drive && engine) {
    return t(isNew ? 'Купить легковой автомобиль 🚗 {make} {model} {engine} {gearbox} {drive}{generation}{year}. Предложения {inGenitiveLocation} по продаже {makeTranslate} {modelTranslate}{yearDot} по выгодной цене на АвтоБазар.' : 'Легковые автомобили 🚗б/у {make} {model}{generation} {engine} {gearbox} {drive}{year}. Предложения по продаже {makeTranslate}{yearDot} {inGenitiveLocation} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (!make && !model && !gearbox && !drive && engine && !body) {
    return t(isNew ? '{customEngineAlt} новые {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.' : '{customEngineAlt} б/у {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.', _extends({}, params, {
      customEngineAlt: customEngineAlt
    }));
  }
  if (make && !model && gearbox && !drive && !engine && !body) {
    return t(isNew ? 'Продажа новых {make} {customGearboxAlt} {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.' : 'Продажа {make} {customGearboxAlt} б/у {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.', _extends({}, params, {
      customGearboxAlt: customGearboxAlt
    }));
  }
  if (!make && !model && !gearbox && !drive && !engine && body) {
    return t(isNew ? 'Продажа новых автомобилей {body} {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.' : 'Продажа автомобилей {body} б/у {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.', _extends({}, params));
  }
  if (make && !model && !gearbox && !drive && engine && !body) {
    return t(isNew ? 'Продажа {customEngineAlt} {makeTranslate}{year} 🚗 Найти новый {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.' : 'Продажа {customEngineAlt} {makeTranslate}{year} 🚗 Найти б/у {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.', _extends({}, params, {
      customEngineAlt: customEngineAlt,
      customEngine: customEngine
    }));
  }
  if (make && model && !gearbox && !drive && engine && !body) {
    return t(isNew ? 'Продажа {customEngineAlt} {makeTranslate} {model}{year} 🚗 Найти новый {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.' : 'Продажа {customEngineAlt} {makeTranslate} {model}{year} 🚗 Найти б/у {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.', _extends({}, params, {
      customEngineAlt: customEngineAlt,
      customEngine: customEngine
    }));
  }
  if (!make && !model && gearbox && !drive && !engine && !body) {
    return t(isNew ? 'Продажа новых автомобилей {customGearbox}{year} {inGenitiveLocation} 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™.' : 'Продажа автомобилей {customGearbox}{year} б/у {inGenitiveLocation} 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™.', _extends({}, params, {
      customGearbox: customGearbox
    }));
  }
  if (make && !model && !gearbox && !drive && !engine && body) {
    return t(isNew ? 'Продажа новых {body} {make}{year} 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.' : 'Продажа {body} {make}{year} б/у 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.', _extends({}, params, {
      customGearbox: customGearbox
    }));
  }
  return t(isNew ? 'Купить легковой автомобиль 🚗 {inGenitiveLocation}. Большой выбор авто без посредников по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей б/у 🚗 {inGenitiveLocation}. Удобный поиск по объявлениям поможет купить авто по выгодной цене на АвтоБазар.', {
    inGenitiveLocation: inGenitiveLocation
  });
};

var buildDealersSeoDescription = function buildDealersSeoDescription(data, slug, t) {
  var _data$make2 = data.make,
      make = _data$make2 === undefined ? '' : _data$make2,
      _data$model2 = data.model,
      model = _data$model2 === undefined ? '' : _data$model2,
      _data$makeTranslate2 = data.makeTranslate,
      makeTranslate = _data$makeTranslate2 === undefined ? make : _data$makeTranslate2,
      _data$modelTranslate2 = data.modelTranslate,
      modelTranslate = _data$modelTranslate2 === undefined ? model : _data$modelTranslate2,
      _data$location2 = data.location,
      locationRu = _data$location2 === undefined ? '' : _data$location2;

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](_extends({}, data, { transport: data.transport || slug }), t, 'avtosalony');
  if (seoData && seoData.description) return seoData.description;

  var locale = t('locale');

  var cityHeader = locationRu && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu] ? locationRu : 'Украина';
  var location = locationRu && t(locationRu);
  var accusativeCityHeader = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].accusative;
  var inGenitiveCityHeader = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive);

  if (slug === 'avto') {
    if (location && !make && !model) {
      return t('Лучшие предложения автосалонов {inGenitiveCityHeader} – скидки автодилеров на новые автомобили. Запишитесь на тестдрайв ✅ адреса и телефоны ☎️ на сайте  АвтоБазар™.', { location: location, inGenitiveCityHeader: inGenitiveCityHeader });
    }
    if (make && !location && !model) {
      return t('Надежная ✅ покупка {makeTranslate} в автосалонах {make} – запишитесь на тестдрайв. Адреса ☎️ телефоны автодилеров на сайте АвтоБазар™.', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location && !model) {
      return t('Предложения автосалонов {makeTranslate} {inGenitiveCityHeader}  ✅ покупка {make} в автосалонах – запишитесь на тестдрайв. Адреса ☎️ телефоны автодилеров на сайте АвтоБазар™.', {
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model && !location) {
      return t('Предложения автосалонов {make} {model} ✅ купить {makeTranslate} {modelTranslate}  у автодилеров – запишитесь на тестдрайв. Адреса и ☎️ телефоны на сайте АвтоБазар™.', {
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }
    if (make && model && location) {
      return t('Предложения автосалонов {accusativeCityHeader} на {make} {model} ✅ покупка {makeTranslate} {modelTranslate} у автодилера {inGenitiveCityHeader}. Адреса и ☎️ телефоны на сайте АвтоБазар™.', {
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate,
        accusativeCityHeader: accusativeCityHeader,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
  }
  if (slug === 'mototsikl') {
    if (location && !make) {
      return t('Лучшие предложения на покупку мототехники в мотосалонах {inGenitiveCityHeader}. Мотоциклы, скутеры, квадроциклы, электробайки, мопеды и мотоэкипировка. Адреса и ☎️ на сайте АвтоБазар™.', { inGenitiveCityHeader: inGenitiveCityHeader });
    }
    if (make && !location) {
      return t('Лучшие цены на мототехнику {make} и акции мотосалонов. Мотоциклы, скутеры, квадроциклы, электробайки, мопеды  {makeTranslate} и мотоэкипировка. Адреса и ☎️ на сайте АвтоБазар™.', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Лучшие цены на мототехнику {makeTranslate} и акции в мотосалонах {accusativeCityHeader}. Мотоцикли, скутери, квадроцикли, электробайки, мопеди {make} и мотоекипировка. Адреса и ☎️ на сайте АвтоБазар™.', {
        make: make,
        makeTranslate: makeTranslate,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Каталог мотосалонов – лучшие цены мотомагазинов в вашем городе на мототехнику и с гарантией от салона. Сайт АвтоБазар™ ✅ адреса ☎️ телефоны.', {});
  }
  if (slug === 'avtobus') {
    if (location && !make && !model) {
      return t('Надежная ✅ покупка автобуса автосалонов {inGenitiveCityHeader} – запишитесь на тестдрайв буса. Адреса и ☎️ на АвтоБазар™', {
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && !location && !model) {
      return t('Надежная ✅ покупка автобуса {makeTranslate} в автосалонах {make} – запишитесь на тестдрайв буса. Адреса и ☎️ на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Автобусы {makeTranslate} {inGenitiveCityHeader}  ✅ покупка буса {make} в салонах {accusativeCityHeader}. Адреса и ☎️ на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Дилеры автобусов Украины – выберите автодилера в своем городе. Бус с гарантией от салона. Сайт АвтоБазар™ ✅ адреса ☎️ телефоны', {});
  }
  if (slug === 'gruzovye') {
    if (location && !make && !model) {
      return t('Надежная ✅ покупка грузовых автомобилей в автосалонах {accusativeCityHeader} – запишитесь на тестдрайв грузовика. Адреса и ☎️ на АвтоБазар™', { accusativeCityHeader: accusativeCityHeader });
    }
    if (make && !location && !model) {
      return t('Надежная ✅ покупка грузового {makeTranslate} в официальных автосалонах {make} – кредит, лизинг. Адреса и ☎️ на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Грузовик {makeTranslate} {inGenitiveCityHeader} ✅ покупка грузового {make} в салонах {accusativeCityHeader}. Адреса и ☎️ на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Автосалоны грузовиков Украины – выберите автодилера в своем городе. Грузовой автомобиль с гарантией от салона. Сайт АвтоБазар™ ✅ адреса ☎️ телефоны салонов', {});
  }
  if (slug === 'spetstehnika') {
    if (make && !location) {
      return t('Продажа спецтехники {make} и услуги от официальных и проверенных дилеров Украины. Актуальные предложения, цены и акции на технику – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (location && !make) {
      return t('Продажа спецтехники и услуги от официальных и проверенных дилеров {inGenitiveCityHeader}. Актуальные предложения, цены и акции на технику – АвтоБазар™', { inGenitiveCityHeader: inGenitiveCityHeader });
    }
    return t('Продажа спецтехники и услуги от официальных и проверенных дилеров Украины. Актуальные предложения, цены и акции на технику – АвтоБазар™', {});
  }
  if (slug === 'vodnyi-transport') {
    if (make && !location) {
      return t('Продажа водного транспорта {make} и услуги от официальных и проверенных салонов Украины. Актуальные предложения, цены и акции – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (location && !make) {
      return t('Продажа водного транспорта и услуги от официальных и проверенных салонов {inGenitiveCityHeader}. Актуальные предложения, цены и акции – АвтоБазар™', { inGenitiveCityHeader: inGenitiveCityHeader });
    }
    return t('Продажа водного транспорта и услуги от официальных и проверенных салонов Украины. Актуальные предложения, цены и акции – АвтоБазар™', {});
  }
  if (slug === 'pritsepy') {
    if (make && !location) {
      return t('Продажа прицепов {make} и услуги от надежных компаний Украины. Актуальные предложения, цены и акции – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (location && !make) {
      return t('Продажа прицепов и услуги от надежных компаний {inGenitiveCityHeader}. Актуальные предложения, цены и акции – АвтоБазар™', { inGenitiveCityHeader: inGenitiveCityHeader });
    }
    return t('Продажа прицепов и услуги от надежных компаний Украины. Актуальные предложения, цены и акции – АвтоБазар™', {});
  }

  return t('Все автосалоны Украины – актуальные цены и скидки на новые авто ✅ адреса и телефоны дилеров ☎️ каталог АвтоБазар™.', {});
};

var buildSparePartsSeoDescription = function buildSparePartsSeoDescription(data, rubricSlug, t, isRegion) {
  var _data$location3 = data.location,
      locationRu = _data$location3 === undefined ? '' : _data$location3,
      _data$make3 = data.make,
      make = _data$make3 === undefined ? '' : _data$make3,
      _data$model3 = data.model,
      model = _data$model3 === undefined ? '' : _data$model3,
      selectedTransport = data.transport,
      rubricTitle = data.rubric,
      partTypeRu = data.partType,
      partTypeUk = data.partTypeUk;

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'zapchasti');
  if (seoData && seoData.description) {
    return seoData.description;
  }
  var locale = t('locale');

  var cityHeader = locationRu && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu] ? locationRu : 'Украина';
  var location = locationRu && t(locationRu);
  var inGenitiveCityHeader = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive);

  var rubric = rubricTitle;
  var partType = partTypeRu;
  var transport = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["o" /* replaceTransport */](selectedTransport);

  var inCityOrRegion = t('в городе') + ' ' + t(location);
  if (isRegion && locationRu) {
    inCityOrRegion = '\u0432 ' + __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu][locale].genitive;
  }

  if (locale === 'uk' && partTypeUk) partType = partTypeUk;

  if (!location && !rubric && !partType && !rubricSlug) {
    if (make && !model && !location) {
      return t('Продажа запчастей на {make} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти на {transport} по выгодной цене.', {
        make: make,
        transport: transport
      });
    }
    if (make && model) {
      return t('Продажа автозапчастей на {make} {model} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти на {transport} по выгодной цене.', {
        make: make,
        model: model,
        transport: transport
      });
    }
  }
  if (location && !rubric && !partType && !rubricSlug) {
    if (!make && !model) {
      return t('Продажа запчастей на {transport} {inGenitiveCityHeader} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро найти автозапчасти на {transport} по лучшей цене {inCityOrRegion}.', {
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader,
        inCityOrRegion: inCityOrRegion
      });
    }
    if (make && !model) {
      return t('Продажа автозапчастей {make} на {transport} {inGenitiveCityHeader} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти для {make}.', {
        make: make,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader,
        location: location
      });
    }
    if (make && model) {
      return t('Продажа автозапчастей на {make} {model} {inCityOrRegion} ✅ Сравните цены и купите запчасти на {transport} по лучшей цене на АвтоБазар™.', {
        make: make,
        model: model,
        transport: transport,
        inCityOrRegion: inCityOrRegion
      });
    }
  }

  if (__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].accusative;
  } else if (__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].nominative;
  }

  /* ______________________FIRST TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('Продажа автозапчастей {rubric} на {transport} {make} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям в Украине.', {
        rubric: rubric,
        make: make,
        transport: transport
      });
    }
    if (make && model) {
      return t('Продажа автозапчастей {rubric} на {make} {model} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям в Украине.', {
        rubric: rubric,
        make: make,
        model: model
      });
    }

    return t('Продажа автозапчастей {rubric} на {transport} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям – сравните предложения в Украине.', {
      rubric: rubric,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('Продажа автозапчастей {rubric} на {transport} {make} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям {inGenitiveCityHeader}.', {
        rubric: rubric,
        make: make,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('Продажа автозапчастей {rubric} на {transport} {make} {model} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям {inGenitiveCityHeader}.', {
        rubric: rubric,
        make: make,
        model: model,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('Продажа автозапчастей {rubric} на {transport} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям {inGenitiveCityHeader}.', {
      rubric: rubric,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  /* ______________________FIRST TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} по выгодной цене на сайте АвтоБазар™ ✅ Большой выбор автозапчастей {rubric}.', {
        rubric: rubric,
        partType: partType,
        transport: transport,
        make: make
      });
    }
    if (make && model) {
      return t('{partType} на {transport} {make} {model} по выгодной цене на АвтоБазар™ ✅ Большой выбор автозапчастей для {rubric}.', {
        rubric: rubric,
        partType: partType,
        make: make,
        model: model,
        transport: transport
      });
    }

    return t('{partType} на {transport} по выгодной цене на сайте АвтоБазар™ ✅ Большой выбор автозапчастей {rubric}.', {
      rubric: rubric,
      partType: partType,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);

    if (make && !model) {
      return t('{partType} на {transport} {make} по выгодной цене {inGenitiveCityHeader} ✅ Большой выбор запчастей для {rubric} – АвтоБазар™.', {
        rubric: rubric,
        partType: partType,
        make: make,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('{partType} на {make} {model} по выгодной цене {inGenitiveCityHeader} ✅ Большой выбор запчастей для {rubric} – АвтоБазар™.', {
        rubric: rubric,
        partType: partType,
        make: make,
        model: model,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('{partType} на {transport} по выгодной цене {inGenitiveCityHeader} ✅ Большой выбор автозапчастей для {rubric} – АвтоБазар™.', {
      rubric: rubric,
      partType: partType,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} по выгодной цене на {transport} {make} ✅ Найдите нужную деталь в Украине на АвтоБазар™.', {
        rubric: rubric,
        make: make,
        transport: transport
      });
    }
    if (make && model) {
      return t('{rubric} по лучшей цене на {transport} {make} {model} ✅ Найдите нужную деталь в Украине на АвтоБазар™.', {
        rubric: rubric,
        make: make,
        model: model,
        transport: transport
      });
    }

    return t('{rubric} по выгодной цене на {transport} ✅ Найдите нужную деталь в Украине на АвтоБазар™.', {
      rubric: rubric,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} по выгодной цене на {transport} {make} ✅ Найдите нужную деталь {inGenitiveCityHeader} на АвтоБазар™.', {
        rubric: rubric,
        make: make,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('{rubric} по выгодной цене на {transport} {make} {model} ✅ Найдите нужную деталь {inGenitiveCityHeader} на АвтоБазар™.', {
        rubric: rubric,
        make: make,
        model: model,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('{rubric} по выгодной цене на {transport} ✅ Найдите нужную деталь {inGenitiveCityHeader} на АвтоБазар™.', {
      rubric: rubric,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} по выгодной цене на сайте АвтоБазар™ ✅ {rubric} – большой выбор запчастей.', {
        rubric: rubric,
        partType: partType,
        transport: transport,
        make: make
      });
    }
    if (make && model) {
      return t('{partType} на {transport} {make} {model} по выгодной цене на сайте АвтоБазар™ ✅ {rubric} – большой выбор запчастей.', {
        rubric: rubric,
        partType: partType,
        make: make,
        model: model,
        transport: transport
      });
    }

    return t('{partType} на {transport} по выгодной цене на сайте АвтоБазар™ ✅ {rubric} – большой выбор запчастей.', {
      rubric: rubric,
      partType: partType,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);

    if (make && !model) {
      return t('Выбирайте {partType} на {transport} {make} по выгодной цене {inGenitiveCityHeader} ✅ {rubric} на АвтоБазар™.', {
        rubric: rubric,
        partType: partType,
        make: make,
        inGenitiveCityHeader: inGenitiveCityHeader,
        transport: transport
      });
    }
    if (make && model) {
      return t('Выбирайте {partType} на {transport} {make} {model} по выгодной цене {inGenitiveCityHeader} ✅ {rubric} на сайте АвтоБазар™.', {
        rubric: rubric,
        partType: partType,
        make: make,
        model: model,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('Выбирайте {partType} на {transport} по выгодной цене {inGenitiveCityHeader} ✅ {rubric} на АвтоБазар™.', {
      rubric: rubric,
      partType: partType,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  return t('Продажа автозапчастей на {transport} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти на {transport} по выгодной цене.', {
    transport: transport
  });
};

var buildSearchMotoSeoDescription = function buildSearchMotoSeoDescription(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
  if (seoData && seoData.description) return seoData.description;

  var category = data.category,
      type = data.type,
      make = data.make,
      model = data.model,
      location = data.location,
      motoTitle = data.motoTitle,
      yearTitle = data.yearTitle;

  var condition = t('бу и новой');
  var icon = '🏍️';
  var transportWho = t('мототехники');
  var transportWhat = t('мототранспорт');
  return [t('Продажа'), condition, category || type || motoTitle ? (motoTitle || (type && type.title ? type.title.toLowerCase() : '')) + ' ' + (category && category.title ? category.title.toLowerCase() : '') : transportWho, icon, make && make.title, model && model.title, (location || t('в Украине')) + '.', t('Удобный поиск по объявлениям поможет Вам быстро и легко купить'), category || type ? (type && type.title ? type.title.toLowerCase() : '') + ' ' + (category && category.title ? category.title.toLowerCase() : '') : transportWhat || '', '' + (yearTitle || '') + t('по выгодной цене на Автобазаре™.')].filter(function (i) {
    return !!i;
  }).join(' ');
};

var buildSearchCommercialSeoDescription = function buildSearchCommercialSeoDescription(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'commercial');
  if (seoData && seoData.description) return seoData.description;

  var isUkraine = ['Україні', 'Украине'].includes(data.cityDescriptions);

  if (!isUkraine) {
    // eslint-disable-next-line no-param-reassign
    data.cityDescriptions = t('в') + ' ' + t(data.cityDescriptions);
    // eslint-disable-next-line no-param-reassign
  } else data.cityDescriptions = '\u0432 ' + t('Украине');

  var transportDescriptions = data.transportDescriptions,
      transportNextDescriptions = data.transportNextDescriptions,
      transportCategoryTitle = data.transportCategoryTitle,
      make = data.make,
      model = data.model,
      isNew = data.isNew,
      transportType = data.transportType;


  if (transportType === 'avtobus' && transportCategoryTitle) {
    return t('Купить бу и новые {transportCategoryTitle} автобусы {cityDescriptions}. Удобный поиск объявлений - сравните предложения и покупайте автобусы по лучшей цене на АвтоБазар™.', data);
  }
  if (transportType === 'moto' && transportCategoryTitle) {
    return t('Купить бу мототехнику {cityDescriptions} 🏍️ Объявления о продаже мотоциклов, скутеров, мопедов по лучшей цене на АвтоБазар™.', data);
  }
  if (transportType === 'pritsepy' && transportCategoryTitle) {
    return t('Купить бу или новый {transportCategoryTitle} {cityDescriptions} 🏍️ Объявления о продаже прицепного оборудования по лучшей цене на АвтоБазар™.', data);
  }
  if (transportType === 'spetstehnika' && transportCategoryTitle) {
    return t('{transportCategoryTitle} по лучшей цене купить на АвтоБазар™. Все объявления о продаже бу или новой спецтехники {cityDescriptions}.', data);
  }
  if (transportType === 'vodnyi-transport' && transportCategoryTitle) {
    return t('Купить {transportHeader} по лучшей цене {cityDescriptions}. Все объявления о продаже спецтехники на АвтоБазар™.', data);
  }
  if (transportDescriptions && transportType === 'avtobus' && make) {
    return t('Купить бу или новый автобус {makeTranslit} {cityDescriptions}. Удобный поиск объявлений - сравните предложения и покупайте автобусы {make} по лучшей цене на АвтоБазар™.', data);
  }
  if (transportDescriptions && make && !model && isNew) {
    return t('Купить новые {transportDescriptions} {make} 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {makeTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && model && !isNew) {
    return t('Купить {transportDescriptions} {make} {model} бу 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {makeTranslit} {modelTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && !model && !isNew) {
    return t('Купить {transportDescriptions} {make} бу 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {makeTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && !make && !model && isNew) {
    return t('Купить новые {transportDescriptions} 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && model && isNew) {
    return t('Новые {transportDescriptions} {make} {model} 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {makeTranslit} {modelTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && model && !isNew) {
    return t('Купить {transportDescriptions} {make} {model} бу 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {makeTranslit} {modelTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && !model && isNew) {
    return t('Купить новые {transportDescriptions} {make} 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {makeTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && !make && !model && isNew) {
    if (transportType === 'gruzovye') {
      return t('Купить новые {transportDescriptions} 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
        transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
        transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить новую {transportDescriptions} 🚜 {cityDescriptions}. {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
        transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
        transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
      }));
    }
    return t('Продажа новых {transportDescriptions} 🚛 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && !make && !model && !isNew) {
    if (transportType === 'gruzovye') {
      return t('Продажа {transportDescriptions} бу 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре™.', _extends({}, data, {
        transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
        transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить {transportDescriptions} бу 🚜 {cityDescriptions}. {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
        transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
        transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
      }));
    }
    return t('Купить {transportDescriptions} бу 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  return t('Купить бу 🚚 в Украине. Удобный поиск по объявлениям поможет купить {yearDescriptions}по выгодной цене на Автобазаре');
};
// CONCATENATED MODULE: ./src/shared/constants/seoDescriptions.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_moment__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_seoTextFinder_seoDataFinder__ = __webpack_require__(1252);




/*
my test

*/
var buildSearchDescription = function buildSearchDescription(_ref, condition, icon, transportWho, transportWhat, t) {
  var category = _ref.category,
      type = _ref.type,
      make = _ref.make,
      model = _ref.model,
      location = _ref.location,
      motoTitle = _ref.motoTitle,
      yearTitle = _ref.yearTitle;
  return [t('Продажа'), condition, category || type || motoTitle ? (motoTitle || (type && type.title ? type.title.toLowerCase() : '')) + ' ' + (category && category.title ? category.title.toLowerCase() : '') : transportWho, icon, make && make.title, model && model.title, (location || t('в Украине')) + '.', t('Удобный поиск по объявлениям поможет Вам быстро и легко купить'), category || type ? (type && type.title ? type.title.toLowerCase() : '') + ' ' + (category && category.title ? category.title.toLowerCase() : '') : transportWhat || '', '' + (yearTitle || '') + t('по выгодной цене на Автобазаре™.')].filter(function (i) {
    return !!i;
  }).join(' ');
};

var getLocationString = function getLocationString(location, t) {
  return location && location.title ? t('в ') + ' ' + location.title : t('в Украине');
};

var buildAddDescriptionByTransportSlug = function buildAddDescriptionByTransportSlug(slug, t) {
  var firstSlug = 'автомобилей';
  var secondSlug = 'свое авто';
  switch (slug) {
    case 'avto':
      {
        firstSlug = 'машину';
        secondSlug = 'авто';
        break;
      }
    case 'moto':
      {
        firstSlug = 'мотоцикл';
        secondSlug = 'мототехники';
        break;
      }
    case 'avtobus':
      {
        firstSlug = 'бус';
        secondSlug = 'автобуса';
        break;
      }
    case 'gruzovye':
      {
        firstSlug = 'грузовик_а';
        secondSlug = 'грузового авто';
        break;
      }
    case 'spetstehnika':
      {
        firstSlug = 'спецтехнику';
        secondSlug = 'спецтехники';
        break;
      }
    case 'pritsepy':
      {
        firstSlug = 'прицеп';
        secondSlug = 'прицепа';
        break;
      }
    case 'vodnyi-transport':
      {
        firstSlug = 'водный транспорт';
        secondSlug = 'водного транспорта';
        break;
      }
    case 'zapchasti':
      {
        firstSlug = 'запчасти';
        secondSlug = 'автозапчастей';
        break;
      }

    default:
      {
        break;
      }
  }

  return t('Быстро продать') + ' ' + t(firstSlug).toLowerCase() + '\n  ' + t('через интернет на сайте') + ' \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440\u2122.\n  ' + t('Бесплатно разместите объявление о продаже') + '\n  ' + t(secondSlug).toLowerCase() + '\n  ' + t('и его увидят тысячи покупателей со всей Украины') + '.';
};

var getAdvertDate = function getAdvertDate(hotDate, dateCreated, datePublicated, t) {
  var date = hotDate || dateCreated || datePublicated;
  return date ? t('от') + ' ' + __WEBPACK_IMPORTED_MODULE_1_shared_helpers_moment__["a" /* createdDate */](date, t('от') === 'від' ? 'uk' : 'ru').slice(0, -3) : '';
};

var getBodyAltAvtoAdvert = function getBodyAltAvtoAdvert(isNew, modification, body, category, t) {
  // const result =
  //   modification && modification.series && modification.series.title
  //     ? isNew
  //       ? t(modification.series.title).charAt(0).toUpperCase() +
  //         t(modification.series.title).slice(1)
  //       : t(modification.series.title).toLowerCase()
  //     : body && body.title
  //       ? isNew
  //         ? t(body.title).charAt(0).toUpperCase() + t(body.title).slice(1)
  //         : t(body.title).toLowerCase()
  //       : isNew
  //         ? t(category.title).charAt(0).toUpperCase() + category.title.slice(1)
  //         : category && category.title && t(category.title).toLowerCase();

  var result = '';
  if (modification && modification.series && modification.series.title) {
    result = isNew ? t(modification.series.title).charAt(0).toUpperCase() + t(modification.series.title).slice(1) : t(modification.series.title).toLowerCase();
  } else if (body && body.title) {
    result = isNew ? t(body.title).charAt(0).toUpperCase() + t(body.title).slice(1) : t(body.title).toLowerCase();
  } else if (category && category.title) {
    result = isNew ? t(category.title).charAt(0).toUpperCase() + category.title.slice(1) : category && category.title && t(category.title).toLowerCase();
  }
  return result;
};

var DESCRIPTION = {
  HOME: function HOME(props, t) {
    return t('SEO_HOME_DESCRIPTION');
  },

  ADVERT: function ADVERT(_ref2) {
    var id = _ref2.id,
        make = _ref2.make,
        model = _ref2.model,
        category = _ref2.category,
        year = _ref2.year,
        mileage = _ref2.mileage,
        capacity = _ref2.capacity,
        capacityUnit = _ref2.capacityUnit,
        engine = _ref2.engine,
        gearbox = _ref2.gearbox,
        location = _ref2.location,
        color = _ref2.color,
        body = _ref2.body,
        drive = _ref2.drive,
        price = _ref2.price,
        _ref2$isNew = _ref2.isNew,
        isNew = _ref2$isNew === undefined ? false : _ref2$isNew,
        _ref2$dealer = _ref2.dealer,
        dealer = _ref2$dealer === undefined ? false : _ref2$dealer,
        date_created = _ref2.date_created,
        hot_date = _ref2.hot_date,
        date_publicated = _ref2.date_publicated,
        modification = _ref2.modification,
        capacityAlt = _ref2.capacityAlt,
        characteristics = _ref2.characteristics;
    var transportDescriptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var t = arguments[2];

    if (transportDescriptions == 'авто') {
      var _getCustomParams = __WEBPACK_IMPORTED_MODULE_2_shared_helpers_seoTextFinder_seoDataFinder__["a" /* getCustomParams */]({ city: location && location.title }, t),
          inCity = _getCustomParams.inCity;

      var advertDate = getAdvertDate(hot_date, date_created, date_publicated, t);
      var bodyAltAdvert = getBodyAltAvtoAdvert(isNew, modification, body, category, t);
      var bodyAdvert = characteristics && characteristics.category && characteristics.category.title && t(characteristics.category.title);
      var capacityAvto = capacity || (capacityAlt && capacityAlt.title ? capacityAlt.title : '');

      return [!isNew ? 'Продам' : t('Купить'), isNew && t('новое'), t(transportDescriptions), !isNew && 'бу', make && make.title, model && model.title, modification && modification.title, year && year, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + t('тыс км'), [location && location.title && inCity, isNew && dealer && dealer.title && t('в салоне') + ' ' + dealer.title].filter(function (i) {
        return !!i;
      }).join(', ').replace(',', '').concat('.'), isNew && price && t('Цена') + ' ' + price + '.', isNew ? '' : 'Продаю', [[(!isNew ? bodyAdvert && bodyAdvert.toLowerCase() || bodyAltAdvert : bodyAdvert || bodyAltAdvert) || (isNew ? t('Легковые') : t('легковые')), color && color.title && t(color.title).toLowerCase()].filter(function (i) {
        return !!i;
      }).join(', ').replace(',', '').concat(''), [engine && engine.title && t(engine.title).toLowerCase(), capacityAvto + (capacityAvto && capacityUnit && '' + (' ' + t(capacityUnit)))].filter(function (i) {
        return !!i;
      }).join(', ').replace(/,\s*/g, ' / ').concat(''), gearbox && gearbox.title && t('коробка') + ' ' + t(gearbox.title).toLowerCase(), drive && drive.title && t(drive.title).toLowerCase() + ' ' + t('привод')].filter(function (i) {
        return !!i;
      }).join(', ').replace(/$(, )/, '').concat('.'), !isNew && price && t('Цена') + ' ' + price + '.', id && t('Объявление') + ' ' + id, [!isNew && advertDate].filter(function (i) {
        return !!i;
      }).join(', ').replace(/$(, )/, '').concat(' ')].filter(function (i) {
        return !!i;
      }).join(' ');
    } else if (transportDescriptions === 'Водный транспорт' && !isNew && dealer && dealer.title || transportDescriptions === 'Водный транспорт' && !isNew && dealer && dealer.title) {
      return [t('Купить'), t(transportDescriptions), make && make.title, model && model.title, modification && modification.title, year, '\u0432 ' + t(location.title), dealer && dealer.title && t('в автосалоне') + ' ' + dealer.title, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + (t('с пробегом') === 'с пробегом' ? 'тыс км' : 'тис км'), price && t('цена') + ' ' + price, t('на Автобазаре'), id && t('Объявление') + ' ' + id].filter(function (i) {
        return !!i;
      }).join(' ');
    }

    return [t('Продажа'), make && make.title, model && model.title, dealer && dealer.title && t('в автосалоне') + ' ' + dealer.title, '' + t('характеристики'), transportDescriptions && t(transportDescriptions) + ':', [category && category.title && t('кузов') + '- ' + t(category.title).toLowerCase(), year && t('год выпуска') + ' - ' + year, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + (t('с пробегом') === 'с пробегом' ? 'тыс км' : 'тис км'), capacity && capacityUnit && t('объем двигателя') + ' - ' + capacity + ' ' + (t(capacityUnit) || capacityUnit), engine && engine.title && t('тип топлива') + ' - ' + t(engine.title).toLowerCase(), gearbox && gearbox.title && t('КПП') + ' - ' + t(gearbox.title).toLowerCase(), color && color.title && t('цвет') + ' - ' + t(color.title).toLowerCase()].filter(function (i) {
      return !!i;
    }).join(', ').replace(/$(, )/, '').concat('.'), [id && t('Объявление') + ' ' + id].filter(function (i) {
      return !!i;
    }).join(', ').replace(/$(, )/, '').concat(' ')].filter(function (i) {
      return !!i;
    }).join(' ');

    // // old
    // [
    // t('Продажа'),
    // make && make.title,
    // model && model.title,
    // dealer && `${t('в автосалоне')} ${dealer}`,
    // `, ${t('характеристики')}`,
    // `${transportDescriptions}:`,
    // [
    //   category && category.title && `${t('кузов')}- ${category.title.toLowerCase()}`,
    //   year && `${t('год выпуска')} - ${year}`,
    //   mileage && `${t('с пробегом')} ${mileage}`,
    //   capacity &&
    //     capacityUnit &&
    //     `${t('объем двигателя')} - ${capacity} ${t(capacityUnit) || capacityUnit}`,
    //   engine && engine.title && `${t('тип топлива')} - ${engine.title.toLowerCase()}`,
    //   gearbox && gearbox.title && `${t('КПП')} - ${gearbox.title.toLowerCase()}`,
    //   color && color.title && `${t('цвет')} - ${color.title.toLowerCase()}`,

    // ]
    //   .filter(i => !!i)
    //   .join(' ')
  },

  //

  SPARE_ADVERT: function SPARE_ADVERT(_ref3, t) {
    var rubric = _ref3.rubric,
        sparetype = _ref3.sparetype,
        type = _ref3.type,
        make = _ref3.make,
        model = _ref3.model,
        location = _ref3.location,
        id = _ref3.id;
    return [t('Продажа'), rubric && rubric.title, sparetype && (sparetype.title || '').toLowerCase(), (type || make || model) && t('на'), type && (type.title || '').toLowerCase(), make && make.title, model && model.title, getLocationString(location, t), t('на Автобазаре'), [id && t('Объявление') + ' ' + id].filter(function (i) {
      return !!i;
    }).join(', ').replace(/$(, )/, '').concat(' ')].filter(function (i) {
      return !!i;
    }).join(' ');
  },
  //

  SEARCH: {
    avto: function avto(data, translate) {
      return buildSearchAvtoSeoDescription(data, translate);
    },
    moto: function moto(data, translate) {
      return buildSearchMotoSeoDescription(data, translate);
    },
    mototsikl: function mototsikl(props, t) {
      return buildSearchDescription(props, t('бу и новых'), '🏍️', t('мотоциклов'), t('мотоцикл'), t);
    },
    commercial: function commercial(data, translate) {
      return buildSearchCommercialSeoDescription(data, translate);
    }
  },
  SPARE_PARTS: function SPARE_PARTS(data, rubricSlug, t, isRegion) {
    return buildSparePartsSeoDescription(data, rubricSlug, t, isRegion);
  },
  FIRM: function FIRM(data, t) {
    return buildFirmsSeoDescription(data, t);
  },
  FIRM_PAGE: function FIRM_PAGE(title, tab, t, car_drive_countries, transportType, tags, firm) {
    return buildFirmPageSeoDescription(title, tab, t, car_drive_countries, transportType, tags, firm);
  },
  DEALERS: function DEALERS(data, slug, t) {
    return buildDealersSeoDescription(data, slug, t);
  },

  DEALER_PAGE: {
    ADVERTS: function ADVERTS(_ref4, t) {
      var dealer = _ref4.dealer,
          _ref4$isOfficial = _ref4.isOfficial,
          isOfficial = _ref4$isOfficial === undefined ? false : _ref4$isOfficial,
          _ref4$makes = _ref4.makes,
          makes = _ref4$makes === undefined ? [] : _ref4$makes;
      return [t('Купить автомобиль вы можете у'), isOfficial && t('официального'), t('дилера'), makes.map(function (_ref5, i, _ref6) {
        var make = _ref5.title;
        var count = _ref6.length;
        return '' + make + (i !== count - 1 ? ', ' : '');
      }).join(''), t('в Украине') + ' -', dealer || '', t('Все предложения автосалона на Автобазаре')].filter(function (i) {
        return !!i;
      }).join(' ');
    },

    NEWS: function NEWS() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Самые свежие и актуальные предложения автосалона') + ' ' + dealer + ' ' + t('читайте на АвтоБазаре') + '.';
    },

    ABOUT: function ABOUT() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Узнать актуальную информацию об автосалоне') + ' ' + dealer + ' ' + t('на АвтоБазаре');
    },

    CONTACT: function CONTACT() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Узнать контактную информацию автосалона') + ' ' + dealer + ': ' + t('адрес, месторасположения на карте, контактные номера телефонов, режим работы - все контакты на АвтоБазаре');
    }
  },

  //

  INVOICE: function INVOICE(t) {
    return t('Квитанция за оплату на АвтоБазаре');
  },

  //

  JOURNAL: {
    ALL: function ALL(t) {
      return t('Все новости и статьи на Автобазар') + '\u2122';
    },
    NEWS: function NEWS(t, rubric) {
      return t('Все') + ' ' + t(rubric || 'Новости').toLowerCase() + ' ' + t('на Автобазаре');
    }
  },

  //

  SERVICE: {
    CAR_COST_ESTIMATE: function CAR_COST_ESTIMATE(t) {
      return t('Оценка стоимости авто') + ' ' + t('на Автобазаре');
    },
    CAR_DRIVE: function CAR_DRIVE(t) {
      return t('Пригон авто') + ' ' + t('на Автобазаре');
    },
    SEARCH_SUBSCRIPTIONS: function SEARCH_SUBSCRIPTIONS(t) {
      return t('Подписка на поиск') + ' ' + t('на Автобазаре');
    }
  },

  //

  LOGIN: function LOGIN(t) {
    return t('Авторизация на Автобазар') + '\u2122';
  },

  //

  NOT_FOUND: function NOT_FOUND(t) {
    return t('Страница не найдена');
  },

  //

  ADVERT_FORM: {
    ADD: function ADD(slug, t) {
      return buildAddDescriptionByTransportSlug(slug, t);
    },
    EDIT: function EDIT(t) {
      return t('Форма редактирования объявления на Автобазар');
    }
  },

  //

  PROFILE: {
    PROFILE: function PROFILE(t) {
      return t('Профиль пользователя');
    },
    DIALOGS: function DIALOGS(t) {
      return t('Сообщения пользователя');
    },
    FAVORITES: function FAVORITES(t) {
      return t('Избранные пользователя');
    },
    BILLING: function BILLING(t) {
      return t('Баланс пользователя');
    },
    SEARCHES: function SEARCHES(t) {
      return t('Поиски пользователя');
    },
    ADVERTS: function ADVERTS(t) {
      return t('Объявления пользователя');
    },
    INSURANCE: function INSURANCE(t) {
      return t('Страховка');
    },
    SEARCH_SUBSCRIPTIONS: function SEARCH_SUBSCRIPTIONS(t) {
      return t('Подписка на поис');
    }
  },

  //

  MOBILE_FORM: {
    GEO: function GEO(t) {
      return t('Выбор местоположения');
    },
    FILTERS: function FILTERS(t) {
      return t('Выбор по параметрам');
    }
  },

  STATIC_PAGE: {
    LAW: function LAW(t) {
      return t('Политика конфиденциальности – полезная информация от Автобазар');
    },
    PUBLIC_CONTRACT: function PUBLIC_CONTRACT(t) {
      return t('Публичный договор – полезная информация от Автобазар');
    },
    INFO_ZAPCHASTI: function INFO_ZAPCHASTI(t) {
      return t('Запчасти – полезная информация от Автобазар');
    },
    HELP: function HELP(t) {
      return t('Помощь – полезная информация от Автобазар');
    },
    FOR_SERVICES: function FOR_SERVICES(t) {
      return t('Автосервисам – полезная информация от Автобазар');
    },
    FOR_PRIVATES: function FOR_PRIVATES(t) {
      return t('Размещение объявлений – полезная информация от Автобазар');
    },
    FOR_DEALERS: function FOR_DEALERS(t) {
      return t('Пакет “Бизнес Плюс” – полезная информация от Автобазар');
    },
    BIZNES_PAKET: function BIZNES_PAKET(t) {
      return t('Пакет “Бизнес” – полезная информация от Автобазар');
    },
    ADVERTISING: function ADVERTISING(t) {
      return t('Разместить рекламу – полезная информация от Автобазар');
    },
    ABOUT: function ABOUT(t) {
      return t('Что такое автобазар – полезная информация от Автобазар');
    },
    FAQ: function FAQ(t) {
      return t('Часто задаваемые вопросы – полезная информация от Автобазар');
    },
    ENTRANCE: function ENTRANCE(t) {
      return t('Регистрация на avtobazar.ua – полезная информация от Автобазар');
    },
    TRANSPORT_ADS_RULES: function TRANSPORT_ADS_RULES(t) {
      return t('Правила составления объявлений – полезная информация от Автобазар');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (DESCRIPTION);

/***/ }),

/***/ 1389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/seoTitles.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_modules__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var buildSearchAvtoSeoTitle = function buildSearchAvtoSeoTitle(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
  if (seoData && seoData.title) return seoData.title;

  var _data$make = data.make,
      make = _data$make === undefined ? '' : _data$make,
      _data$model = data.model,
      model = _data$model === undefined ? '' : _data$model,
      _data$location = data.location,
      location = _data$location === undefined ? '' : _data$location,
      _data$generation = data.generation,
      generation = _data$generation === undefined ? '' : _data$generation,
      _data$gearbox = data.gearbox,
      gearbox = _data$gearbox === undefined ? '' : _data$gearbox,
      _data$engine = data.engine,
      engine = _data$engine === undefined ? '' : _data$engine,
      _data$body = data.body,
      body = _data$body === undefined ? '' : _data$body,
      _data$drive = data.drive,
      driveSelected = _data$drive === undefined ? '' : _data$drive,
      _data$isNew = data.isNew,
      isNew = _data$isNew === undefined ? false : _data$isNew,
      _data$year = data.year,
      yearSelected = _data$year === undefined ? '' : _data$year,
      _data$country = data.country,
      country = _data$country === undefined ? null : _data$country,
      _data$city = data.city,
      city = _data$city === undefined ? null : _data$city;


  var drive = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["b" /* buildDriveValue */](driveSelected, t);
  var locale = t('locale');
  var inGenitiveLocation = location && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location] ? __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location][locale].genitive) : city && city.title && ' ' + __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](city[locale + '_title'] || city.title) || '\u0432 ' + __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */]['Украина'][locale].genitive;

  var yearVsSpace = yearSelected ? ' ' + yearSelected + ' ' + t('года') : '';
  var customGearbox = gearbox in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale].title : gearbox;
  var customEngine = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].title : engine;
  var customEngineAlt = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].altTitle : engine;

  var countryTitle = country && t(country.title);
  var countryFromTitle = country && country.from && country.from[locale];

  // {locale}*/avto/{country}/
  if (country && !make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t('SEO_META_TITLE_AVTO_COUNTRY', { countryTitle: countryTitle, countryFromTitle: countryFromTitle });
  }

  if (make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t(isNew ? 'Продажа {make}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге' : 'Продажа {make}{year} б/у на АвтоБазар™ {inGenitiveLocation} – купить легковой автомобиль по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && !generation && !gearbox && !engine && !body && !drive) {
    return t(isNew ? 'Продажа {make} {model}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге' : 'Продажа б/у {make} {model}{year} на АвтоБазар™ {inGenitiveLocation} – купить легковой автомобиль по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && body && !generation && !gearbox && !engine && !drive) {
    return t(isNew ? 'Продажа {make} {model} {body}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге' : 'Продажа б/у {body} {make} {model}{year} на АвтоБазар™ {inGenitiveLocation} – купить автомобиль по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && generation && !gearbox && !engine && !drive) {
    return t(isNew ? 'Продажа {make} {model} {generation}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге' : 'Продажа б/у {make} {model} {generation}{year} на АвтоБазар™ {inGenitiveLocation} – купить автомобиль по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && gearbox && !engine && !drive) {
    return t(isNew ? 'Новый {make} {model}{generation} {gearbox}{year} купить {inGenitiveLocation} на АвтоБазар™' : '{make} {model} б/у{generation} {gearbox}{year} купить {inGenitiveLocation} на АвтоБазар™', _extends({}, data, {
      generation: ' ' + generation || '',
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && gearbox && drive && !engine) {
    return t(isNew ? 'Новый {make} {model}{generation} {gearbox} {drive}{year} купить {inGenitiveLocation} на АвтоБазар™' : 'Купить {make} {model}{generation} {gearbox} {drive}{year} {inGenitiveLocation} на АвтоБазар™', _extends({}, data, {
      generation: ' ' + generation || '',
      inGenitiveLocation: inGenitiveLocation,
      drive: drive,
      year: yearVsSpace
    }));
  }
  if (make && model && gearbox && drive && engine) {
    return t(isNew ? 'Новый {make} {model} {engine} {gearbox}{generation} {drive}{year} купить {inGenitiveLocation} на АвтоБазар™' : '{make} {model} {engine} {gearbox} {drive}{generation}{year} б/у купить {inGenitiveLocation} на АвтоБазар™', _extends({}, data, {
      generation: ' ' + generation || '',
      inGenitiveLocation: inGenitiveLocation,
      drive: drive,
      year: yearVsSpace
    }));
  }

  if (make && !model && gearbox && !engine && !drive) {
    return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} – купить новое авто {makeTranslate} {customGearbox}{year} по лучшей цене' : 'АвтоБазар™ {inGenitiveLocation} – купить авто {makeTranslate} {customGearbox}{year} б/у по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customGearbox: customGearbox
    }));
  }

  if (!make && !model && !gearbox && engine && !drive) {
    return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} – купить новый {customEngine}{year} по лучшей цене' : 'АвтоБазар™ {inGenitiveLocation} – купить {customEngine}{year} б/у по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customEngine: customEngine
    }));
  }

  if (!make && !model && !gearbox && !engine && !drive && body) {
    return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} – купить новый авто {body}{year} по лучшей цене' : 'АвтоБазар™ {inGenitiveLocation} – купить авто {body}{year} б/у по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }

  if (make && !model && !gearbox && engine && !drive && !body) {
    return t(isNew ? 'Новые {customEngineAlt} {make}{year} купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}' : '{customEngineAlt} {make}{year} б/у купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customEngineAlt: customEngineAlt
    }));
  }

  if (make && model && !gearbox && engine && !drive && !body) {
    return t(isNew ? 'Новые {customEngineAlt} {make} {model}{year} купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}' : '{customEngineAlt} {make} {model}{year} б/у купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customEngineAlt: customEngineAlt
    }));
  }

  if (!make && !model && gearbox && !engine && !drive && !body) {
    return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} - купить новый авто {customGearbox}{year} по лучшей цене' : 'АвтоБазар™ {inGenitiveLocation} - купить авто {customGearbox}{year} б/у по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customGearbox: customGearbox
    }));
  }
  if (make && !model && !gearbox && !engine && !drive && body) {
    return t(isNew ? 'Новый {body} {make}{year} - купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}' : '{body} {make}{year} б/у - купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }

  return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} – купить легковой автомобиль новый, сравнение цен в каталоге' : 'Автобазар {inGenitiveLocation}. Купить авто бу {inGenitiveLocation} с пробегом на авторынке', {
    inGenitiveLocation: inGenitiveLocation,
    location: location
  });
};

var buildDealersSeoTitle = function buildDealersSeoTitle(data, slug, t) {
  var _data$make2 = data.make,
      make = _data$make2 === undefined ? '' : _data$make2,
      _data$model2 = data.model,
      model = _data$model2 === undefined ? '' : _data$model2,
      _data$makeTranslate = data.makeTranslate,
      makeTranslate = _data$makeTranslate === undefined ? make : _data$makeTranslate,
      _data$modelTranslate = data.modelTranslate,
      modelTranslate = _data$modelTranslate === undefined ? model : _data$modelTranslate,
      _data$location2 = data.location,
      locationRu = _data$location2 === undefined ? '' : _data$location2;


  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](_extends({}, data, { transport: data.transport || slug }), t, 'avtosalony');
  if (seoData && seoData.title) return seoData.title;

  var locale = t('locale');

  var cityHeader = locationRu && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu] ? locationRu : 'Украина';
  var location = locationRu && t(locationRu);
  var accusativeCityHeader = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].accusative;
  var inGenitiveCityHeader = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive);

  if (slug === 'avto') {
    if (location && !make && !model) {
      return t('Автосалоны {location} – надежные автодилеры, цены, акции на авто из салона – АвтоБазар™', { location: location });
    }
    if (make && !location && !model) {
      return t('Автосалоны {make} – официальные дилеры {makeTranslate} на сайте АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location && !model) {
      return t('Автосалоны {make} – цены салонов {makeTranslate} {inGenitiveCityHeader} на сайте АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model && !location) {
      return t('{make} {model} купить в автосалонах – цены на {makeTranslate} {modelTranslate} – АвтоБазар™', {
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }
    if (make && model && location) {
      return t('Продажа {make} {model} в автосалонах {accusativeCityHeader}. Сравнение цен авто дилеров на {modelTranslate} – АвтоБазар™', {
        make: make,
        model: model,
        modelTranslate: modelTranslate,
        accusativeCityHeader: accusativeCityHeader
      });
    }
  }
  if (slug === 'mototsikl') {
    if (location && !make) {
      return t('Мотосалоны {location} – лучшие цены мото магазинов: мотоциклы, скутеры, квадроциклы – АвтоБазар™', { location: location });
    }
    if (make && !location) {
      return t('Мотосалоны {make} – все официальные мото магазины {makeTranslate} на сайте АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Мотосалоны {make} {location} – все официальные мото магазини на сайте АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        location: location
      });
    }
    return t('Мотосалоны Украины – цены мото магазинов на мотоциклы, скутеры, квадроциклы – АвтоБазар™', {});
  }
  if (slug === 'avtobus') {
    if (location && !make && !model) {
      return t('Автосалоны автобусов {location} – надежные дилеры бусов на сайте АвтоБазар™', {
        location: location
      });
    }
    if (make && !location && !model) {
      return t('Автосалоны автобусов {make} – цены дилеров на бусы {makeTranslate} – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Автобусы {make} в автосалонах {accusativeCityHeader} – проверенные бусы {makeTranslate} на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Автосалоны автобусов Украины – все автодилеры по продаже бусов на сайте АвтоБазар™', {});
  }
  if (slug === 'gruzovye') {
    if (location && !make && !model) {
      return t('Автосалоны грузовых автомобилей {location} – надежные автодилеры грузовиков на сайте АвтоБазар™', { location: location });
    }
    if (make && !location && !model) {
      return t('Автосалоны грузовых {make} – проверенные грузовики {makeTranslate} на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Грузовые {make} в автосалонах {accusativeCityHeader} – проверенные грузовики {makeTranslate} на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Автосалоны грузовых автомобилей Украины – все автодилеры по продаже грузовиков на АвтоБазар™', {});
  }
  if (slug === 'spetstehnika') {
    if (!make && location) {
      return t('Дилеры спецтехники {inGenitiveCityHeader} – каталог компаний АвтоБазар™', {
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && !location) {
      return t('Дилеры спецтехники {make} Украины в каталоге компаний АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    return t('Дилеры спецтехники Украины в каталоге компаний АвтоБазар™', {});
  }
  if (slug === 'vodnyi-transport') {
    if (!make && location) {
      return t('Дилеры водного транспорта {location} в каталоге компаний АвтоБазар™', {
        location: location
      });
    }
    if (make && !location) {
      return t('Дилеры водного транспорта {make} Украины в каталоге компаний АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    return t('Дилеры водного транспорта Украины в каталоге компаний АвтоБазар™', {});
  }
  if (slug === 'pritsepy') {
    if (!make && location) {
      return t('Производители прицепов и проверенные дилеры {inGenitiveCityHeader} – каталог компаний АвтоБазар™', {
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && !location) {
      return t('Проверенные дилеры прицепов {make} в Украине – каталог компаний на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    return t('Производители прицепов и проверенные дилеры Украины в каталоге компаний АвтоБазар™', {});
  }

  return t('Автосалоны Украины – все автодилеры, цены, акции на авто из салона – АвтоБазар™', {});
};

var buildFirmsSeoTitle = function buildFirmsSeoTitle(data, t) {
  var cityTitle = data.cityTitle,
      section = data.section,
      regLocation = data.regLocation,
      location = data.location;
  // if (section === 'СТО') {
  //   if (regLocation)
  //     return t('СТО {location} - автосервис по ремонту авто на сайте Автобазар', {
  //       location: regLocation,
  //     });
  //   return t('Все СТО Украины, автосервисы и шиномонтажи на АвтоБазар™');
  // }
  // if (section && cityTitle) {
  //   return t('{section} в {cityTitle} на Автобазаре - Полный каталог фирм в вашем городе', {
  //     ...data,
  //     section: replaceToUpperCase(section),
  //   });
  // }
  // if (section) {
  //   return t('{section} в Украине на Автобазаре - Полный каталог фирм в вашем городе', {
  //     ...data,
  //     section: replaceToUpperCase(section),
  //   });
  // }
  // if (cityTitle) {
  //   return t('СТО {cityTitle} - автосервис по ремонту авто на сайте Автобазар', {
  //     ...data,
  //     cityTitle: t(location),
  //   });
  // }

  if (section === 'СТО' && cityTitle) {
    return t('СТО {cityTitle}. Адреса, телефоны, карта проезда - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Авторазборка' || section === 'Авторозборка') && cityTitle) {
    return t('Авторазборка {cityTitle}. Каталог компаний по разбору авто (адреса, телефоны) - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Автовыкуп' || section === 'Автовикуп') && cityTitle) {
    return t('Автовыкуп {cityTitle}. Каталог компаний по выкупу авто - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Запчасти' || section === 'Запчастини') && cityTitle) {
    return t('Дилеры по продаже автозапчастей {cityTitle}. Телефоны, адреса компаний - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Автотовары' || section === 'Автотовари') && cityTitle) {
    return t('Дистрибьютеры автотоваров {cityTitle}. Каталог поставщиков автотоваров - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Сервисные центры' || section === 'Сервісні центри') && cityTitle) {
    return t('ТСЦ {cityTitle}. Телефоны, адреса сервисных центров авто - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if (cityTitle) {
    return t('Автосервисы {cityTitle}. Каталог компаний с адресами и телефонами - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  return t('Каталог фирм в Украине на Автобазаре - Полный каталог фирм в вашем городе');
};

var buildSparePartsSeoTitles = function buildSparePartsSeoTitles(data, rubricSlug, t) {
  var locale = t('locale');
  var _data$location3 = data.location,
      locationRu = _data$location3 === undefined ? '' : _data$location3,
      _data$make3 = data.make,
      make = _data$make3 === undefined ? '' : _data$make3,
      _data$model3 = data.model,
      model = _data$model3 === undefined ? '' : _data$model3,
      _data$makeTranslate2 = data.makeTranslate,
      makeTranslate = _data$makeTranslate2 === undefined ? make : _data$makeTranslate2,
      _data$modelTranslate2 = data.modelTranslate,
      modelTranslate = _data$modelTranslate2 === undefined ? model : _data$modelTranslate2,
      selectedTransport = data.transport,
      rubricTitle = data.rubric,
      partTypeRu = data.partType,
      partTypeUk = data.partTypeUk;

  var cityHeader = locationRu && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu] ? locationRu : 'Украина';
  var location = locationRu && t(locationRu);

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'zapchasti');
  if (seoData && seoData.title) {
    return seoData.title;
  }

  var inGenitiveCityHeader = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive);

  var transport = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["o" /* replaceTransport */](selectedTransport);

  var rubric = rubricTitle;
  var partType = partTypeRu;

  if (locale === 'uk' && partTypeUk) partType = partTypeUk;

  if (!location && !rubric && !partType && !rubricSlug) {
    if (make && !model && !location) {
      return t('Запчасти для {make} – Купить запчасти на {transport} в Украине - АвтоБазар', {
        make: make,
        transport: transport
      });
    }
    if (make && model) {
      return t('Запчасти для {make} {model} ({makeTranslate} {modelTranslate}) купить в Украине - АвтоБазар', {
        make: make,
        makeTranslate: makeTranslate,
        model: model,
        modelTranslate: modelTranslate
      });
    }
  }
  if (location && !rubric && !partType && !rubricSlug) {
    if (!make && !model) {
      return t('Запчасти на {transport} {location} – купить по лучшей цене на АвтоБазар™', {
        transport: transport,
        location: location
      });
    }
    if (make && !model) {
      return t('Запчасти на {transport} {make} ({makeTranslate}) {location} - лучшие цены на АвтоБазар™', {
        make: make,
        transport: transport,
        location: location,
        makeTranslate: makeTranslate
      });
    }
    if (make && model) {
      return t('Запчасти для {make} {model} ({makeTranslate} {modelTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        model: model,
        modelTranslate: modelTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
  }

  if (__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug) && rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric]) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].accusative;
  } else if (__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug) && rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric]) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].nominative;
  }

  /* ______________________FIRST TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('Запчасти {rubric} на {transport} {make} ({makeTranslate}) купить по лучшей цене - АвтоБазар™', {
        rubric: rubric,
        make: make,
        makeTranslate: makeTranslate,
        transport: transport
      });
    }
    if (make && model) {
      return t('Запчасти {rubric} {make} {model} ({makeTranslate} {modelTranslate}) купить по лучшей цене - АвтоБазар™', {
        rubric: rubric,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }

    return t('Запчасти {rubric} на {transport} – купить по лучшей цене - АвтоБазар™', {
      rubric: rubric,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('Запчасти {rubric} на {transport} {make} ({makeTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        rubric: rubric,
        make: make,
        makeTranslate: makeTranslate,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('Запчасти {rubric} {make} {model} ({makeTranslate} {modelTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        rubric: rubric,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('Запчасти {rubric} на {transport} {location} – купить по лучшей цене - АвтоБазар™', {
      rubric: rubric,
      transport: transport,
      location: location
    });
  }

  /* ______________________FIRST TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} ({makeTranslate}) купить в Украине – АвтоБазар™', {
        partType: partType,
        transport: transport,
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && model) {
      return t('{partType} на {make} {model} ({makeTranslate} {modelTranslate}) купить в Украине – АвтоБазар™', {
        partType: partType,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }

    return t('{partType} на {transport} – купить в Украине – АвтоБазар™', {
      partType: partType,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);

    if (make && !model) {
      return t('{partType} на {make} ({makeTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        partType: partType,
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('{partType} {make} {model} ({makeTranslate} {modelTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        partType: partType,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('{partType} на {transport} – купить {inGenitiveCityHeader} – АвтоБазар™', {
      partType: partType,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} на {transport} {make} ({makeTranslate}) купить запчасти - АвтоБазар™', {
        rubric: rubric,
        make: make,
        makeTranslate: makeTranslate,
        transport: transport
      });
    }
    if (make && model) {
      return t('{rubric} на {make} {model} ({makeTranslate} {modelTranslate}) купить на АвтоБазар™', {
        rubric: rubric,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }

    return t('{rubric} на {transport} – купить запчастини - АвтоБазар™', {
      rubric: rubric,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} на {transport} {make} - купить {location} – АвтоБазар™', {
        rubric: rubric,
        make: make,
        transport: transport,
        location: location
      });
    }
    if (make && model) {
      return t('{rubric} {make} {model} – купить запчасти на {transport} {location} – АвтоБазар™', {
        rubric: rubric,
        make: make,
        model: model,
        transport: transport,
        location: location
      });
    }

    return t('{rubric} на {transport} купить {location} – АвтоБазар™', {
      rubric: rubric,
      transport: transport,
      location: location
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} ({makeTranslate}) купить – АвтоБазар™', {
        partType: partType,
        transport: transport,
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && model) {
      return t('{partType} {make} {model} ({makeTranslate} {modelTranslate}) купить в Украине – АвтоБазар™', {
        partType: partType,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }

    return t('{partType} на {transport} купить в Украине – АвтоБазар™', {
      partType: partType,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);

    if (make && !model) {
      return t('{partType} на {transport} {make} ({makeTranslate}) купить {location} – АвтоБазар™', {
        partType: partType,
        make: make,
        makeTranslate: makeTranslate,
        location: location,
        transport: transport
      });
    }
    if (make && model) {
      return t('{partType} на {make} {model} ({makeTranslate} {modelTranslate}) купить {location} – АвтоБазар™', {
        partType: partType,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate,
        location: location
      });
    }

    return t('{partType} на {transport} – купить {location} – АвтоБазар™', {
      partType: partType,
      transport: transport,
      location: location
    });
  }

  return t('Запчасти на {transport} купить в Украине – АвтоБазар™', {
    transport: transport
  });
};

var buildFirmPageSeoTitle = function buildFirmPageSeoTitle(title, tab, t) {
  var car_drive_countries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var tags = arguments[4];

  if (tab === 'blog') {
    return t('{title} – Новости и акции компании на сайте Автобазар™', {
      title: title
    });
  }

  var countries = car_drive_countries.map(function (item) {
    return item.title;
  }).join(', ');

  if (car_drive_countries.length > 0) {
    return t('Компания {title} по пригону авто из {countries} - Автобазар', {
      title: title,
      countries: countries
    });
  }

  if (Array.isArray(tags)) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].slug && tags[i].slug === 'sto') {
        return t('СТО {title}. Адрес, телефоны, график работы - Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtorazborka') {
        return t('Авторазборка {title}. Адрес, телефоны, график работы - Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtovykup') {
        return t('{title}. Адрес, телефон, график работы компании - Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtotovary') {
        return t('Дистрибьютер автотоваров {title}. Адрес, телефон, график работы компании - Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'teritorialni-servisni-centri') {
        return t('{title}. Адрес, телефон сервисного центра - Автобазар', {
          title: title
        });
      }
    }
  }

  return t('METATEGS_TITLE_FIRM_ZAPCHASTI', { title: title });
};

var buildSearchMotoSeoTitle = function buildSearchMotoSeoTitle(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
  if (seoData && seoData.title) {
    return seoData.title;
  }

  var _data$category = data.category,
      category = _data$category === undefined ? '' : _data$category,
      _data$type = data.type,
      type = _data$type === undefined ? '' : _data$type,
      _data$make4 = data.make,
      make = _data$make4 === undefined ? '' : _data$make4,
      _data$model4 = data.model,
      model = _data$model4 === undefined ? '' : _data$model4,
      locationWhere = data.locationWhere,
      motoTitle = data.motoTitle,
      yearTitle = data.yearTitle;

  return [t('Купить'), motoTitle || category || type ? (motoTitle || (type && type.title ? type.title.toLowerCase() : '')) + ' ' + (category && category.title ? category.title.toLowerCase() : '') + ' ' : t('мототехнику'), make && make.title, model && model.title, '' + (yearTitle || '') + (locationWhere || t('в Украине')) + ':', t('б/у и новая мототехника на АвтоБазар™')].filter(function (i) {
    return !!i;
  }).join(' ');
};

var buildSearchCommercialSeoTitle = function buildSearchCommercialSeoTitle(params, t) {
  var data = params;

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'commercial');
  if (seoData && seoData.title) {
    return seoData.title;
  }

  var isUkraine = ['Україні', 'Украине'].includes(data.cityTitle);
  if (!isUkraine) {
    data.cityTitle = t('в') + ' ' + t(data.cityTitle);
  } else data.cityTitle = '\u0432 ' + t('Украине');

  var transportTitle = data.transportTitle,
      transportNextTitle = data.transportNextTitle,
      make = data.make,
      model = data.model,
      isNew = data.isNew,
      transportType = data.transportType,
      transportCategoryTitle = data.transportCategoryTitle;


  if (transportType === 'avtobus' && transportCategoryTitle) {
    return t('Автобусы {transportCategoryTitle} б/у {cityTitle} купить на АвтоБазар™', data);
  }
  if (transportType === 'moto' && transportCategoryTitle) {
    return t('Мототехника б/у {cityTitle} купить на АвтоБазар™', data);
  }
  if (transportType === 'pritsepy' && transportCategoryTitle) {
    return t('{transportCategoryTitle} б/у и новые купить {cityTitle} на АвтоБазар™', data);
  }
  if (transportType === 'spetstehnika' && transportCategoryTitle) {
    return t('{transportCategoryTitle} - купить б/у и новую спецтехнику {cityTitle} на АвтоБазар™', data);
  }
  if (transportType === 'vodnyi-transport' && transportCategoryTitle) {
    return t('{transportCategoryTitle} - купить водный транспорт б/у и новый {cityTitle} на АвтоБазар™', data);
  }
  if (transportTitle && make && model && isNew) {
    return t('Новый {make} {model} {yearTitle}купить {cityTitle}: {makeTranslit} {modelTranslit} на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }

  if (transportTitle && make && !model && isNew) {
    if (transportType === 'gruzovye') {
      return t('Купить новую {transportTitle} {make} {yearTitle}{cityTitle}: {transportNextTitle} {makeTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить новую {transportTitle} {make} {yearTitle}{cityTitle}: {transportNextTitle} {makeTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    return t('Купить новый {transportTitle} {make} {yearTitle}{cityTitle}: {transportNextTitle} {makeTranslit} на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }
  if (transportTitle && make && model && !isNew) {
    return t('{make} {model} {yearTitle}купить {cityTitle}: б/у и новые {makeTranslit} {modelTranslit} на Автобазаре', data);
  }
  if (transportTitle && make && !model && !isNew) {
    if (transportType === 'spetstehnika') {
      return t('Купить {transportTitle} {make} {yearTitle}{cityTitle}: б/у и новый {reductionTranslit} {makeTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'avtobus') {
      return t('Автобусы {make} {makeTranslit} б/у {yearTitle}{cityTitle} купить на АвтоБазар™',
      // 'Купить новый {transportTitle} {yearTitle}{cityTitle}: {reductionTranslit} на Автобазаре',
      _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    return t('Купить {transportTitle} {make} {yearTitle}{cityTitle}: б/у и новые {transportNextTitle} {makeTranslit} на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }
  if (transportTitle && !make && !model && isNew) {
    if (transportType === 'gruzovye') {
      return t('Купить новый {transportTitle} {yearTitle}{cityTitle}: {transportNextTitle} авто на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'avtobus') {
      return t('Купить новый {transportTitle} {yearTitle}{cityTitle}: {reductionTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить новую {transportTitle} {yearTitle}{cityTitle}: {transportNextTitle} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    return t('Купить новый {transportTitle} {yearTitle}{cityTitle}: {transportNextTitle} на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }
  if (transportTitle && !make && !model && !isNew) {
    if (transportTitle === t('коммерческий транспорт')) {
      return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новая техника на Автобазар™', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle)
      }));
    }
    if (transportType === 'gruzovye') {
      return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новые {transportNextTitle} авто на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'avtobus') {
      return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новый {reductionTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новая {transportNextTitle} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новые {transportNextTitle} авто на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }
  return t('Купить {cityTitle}: б/у и новые авто на Автобазаре');
};
// CONCATENATED MODULE: ./src/shared/constants/seoTitles.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder_seoDataFinder__ = __webpack_require__(1252);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var getLocationString = function getLocationString(location, t) {
  return location && location.title ? t('в ') + ' ' + location.title : t('в Украине');
};

var buildAddTitleByTransportSlug = function buildAddTitleByTransportSlug(slug, t) {
  var transportTitle = 'авто';
  var transportSecondTitle = 'автомобиля';
  switch (slug) {
    case 'avto':
      {
        transportTitle = 'авто';
        transportSecondTitle = 'автомобиля';
        break;
      }
    case 'moto':
      {
        transportTitle = 'мототехнику';
        transportSecondTitle = 'мототехники';
        break;
      }
    case 'avtobus':
      {
        transportTitle = 'автобус';
        transportSecondTitle = 'автобуса';
        break;
      }
    case 'gruzovye':
      {
        transportTitle = 'грузовое авто';
        transportSecondTitle = 'грузового автомобиля';
        break;
      }
    case 'spetstehnika':
      {
        transportTitle = 'спецтехнику';
        transportSecondTitle = 'спецтехники';
        break;
      }
    case 'pritsepy':
      {
        transportTitle = 'прицеп';
        transportSecondTitle = 'прицепа';
        break;
      }
    case 'vodnyi-transport':
      {
        transportTitle = 'водный транспорт';
        transportSecondTitle = 'водного транспорта';
        break;
      }
    case 'zapchasti':
      {
        transportTitle = 'запчасти';
        transportSecondTitle = 'автозапчастей';
        break;
      }

    default:
      {
        break;
      }
  }

  return t('Продать') + ' ' + t(transportTitle).toLowerCase() + ' \u043D\u0430 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440\u2122 - ' + t('подать объявление о продаже') + ' ' + t(transportSecondTitle).toLowerCase() + ' \u043D\u0430 avtobazar.ua';
};

var TITLE = {
  HOME: function HOME(props, t) {
    return t('SEO_HOME_TITLE');
  },

  ADVERT: function ADVERT(_ref) {
    var id = _ref.id,
        make = _ref.make,
        model = _ref.model,
        modification = _ref.modification,
        year = _ref.year,
        price = _ref.price,
        mileage = _ref.mileage,
        location = _ref.location,
        _ref$isNew = _ref.isNew,
        isNew = _ref$isNew === undefined ? false : _ref$isNew,
        _ref$dealer = _ref.dealer,
        dealer = _ref$dealer === undefined ? false : _ref$dealer;
    var transportTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var t = arguments[2];

    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder_seoDataFinder__["a" /* getCustomParams */]({ city: location.title }, t) || '',
        inCity = _ref2.inCity;

    var transportTitles = ['Мотоцикл', 'Скутер', 'Квадроцикл', 'Мопед', 'Баггі', 'Багги', 'Трицикл', 'Грузовые', 'Автобусы', 'Прицепы', 'Водный транспорт', 'Спецтехника'];

    if (transportTitles.includes(transportTitle)) {
      return [t('Купить'), t(transportTitle), make && make.title, model && model.title, modification && modification.title, year, '\u0432 ' + t(location.title), dealer && dealer.title && t('в автосалоне') + ' ' + dealer.title, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + (t('с пробегом') === 'с пробегом' ? 'тыс км' : 'тис км'), price && t('цена') + ' ' + price, t('на Автобазаре'), isNew && ' - ' + t('Новый').toLowerCase(), id && '(' + id + ')'].filter(function (i) {
        return !!i;
      }).join(' ');
    }

    return [t('Купить'), !isNew && transportTitle,
    /* transportNextTitle, */
    make && make.title, model && model.title, modification && modification.title, year, inCity, isNew && dealer && dealer.title && t('в автосалоне') + ' ' + dealer.title, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + t('тыс км'), price && t('цена') + ' ' + price, id && '(' + id + ')', t('- Автобазар')].filter(function (i) {
      return !!i;
    }).join(' ');
  },
  // ...

  SPARE_ADVERT: function SPARE_ADVERT(_ref3, t) {
    var id = _ref3.id,
        rubric = _ref3.rubric,
        sparetype = _ref3.sparetype,
        type = _ref3.type,
        make = _ref3.make,
        model = _ref3.model,
        price = _ref3.price,
        location = _ref3.location;
    return [t('Купить'), rubric && rubric.title, sparetype && (sparetype.title || '').toLowerCase(), (type || make || model) && t('на'), type && (type.title || '').toLowerCase(), make && make.title, model && model.title, getLocationString(location, t), price && t('цена') + ' ' + price, t('на Автобазаре'), id && '- ' + id].filter(function (i) {
      return !!i;
    }).join(' ');
  },
  //

  SEARCH: {
    avto: function avto(data, t) {
      return buildSearchAvtoSeoTitle(data, t);
    },
    moto: function moto(data, t) {
      return buildSearchMotoSeoTitle(data, t);
    },
    mototsikl: function mototsikl(_ref4, t) {
      var _ref4$make = _ref4.make,
          make = _ref4$make === undefined ? '' : _ref4$make,
          _ref4$model = _ref4.model,
          model = _ref4$model === undefined ? '' : _ref4$model,
          category = _ref4.category,
          type = _ref4.type,
          location = _ref4.location,
          motoTitle = _ref4.motoTitle,
          yearTitle = _ref4.yearTitle;
      return [t('Купить')].concat(_toConsumableArray(make ? [motoTitle || t('мотоцикл'), make && make.title, model && model.title] : ['' + (type && type.title ? type.title.toLowerCase() : '')]), [category && category.title ? category.title.toLowerCase() : '', '' + yearTitle + (location || t('в Украине')) + ':', t('б/у и новая мототехника на АвтоБазар™')]).filter(function (i) {
        return !!i;
      }).join(' ');
    },
    commercial: function commercial(params, t) {
      return buildSearchCommercialSeoTitle(params, t);
    }
  },
  //

  SPARE_PARTS: function SPARE_PARTS(data, rubricSlug, t) {
    return buildSparePartsSeoTitles(data, rubricSlug, t);
  },

  FIRM: function FIRM(data, t) {
    return buildFirmsSeoTitle(data, t);
  },

  FIRM_PAGE: function FIRM_PAGE(title, tab, t, car_drive_countries, tags) {
    return buildFirmPageSeoTitle(title, tab, t, car_drive_countries, tags);
  },

  //

  DEALERS: function DEALERS(data, slug, t) {
    return buildDealersSeoTitle(data, slug, t);
  },

  DEALER_PAGE: {
    ADVERTS: function ADVERTS() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return dealer + ' - ' + t('все предложения автосалона с ценами и фото на сайте Автобазар');
    },

    NEWS: function NEWS() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Новости и акции автосалона') + ' ' + dealer + ' ' + t('на сайте Автобазар');
    },

    ABOUT: function ABOUT() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Информация об автосалоне') + ' ' + dealer + ': ' + t('все о компании на АвтоБазаре');
    },

    CONTACT: function CONTACT() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Контакты автосалона') + ' ' + dealer + ': ' + t('адреса, контактный номер телефона, официальный сайт');
    }
  },

  //

  INVOICE: function INVOICE(t) {
    return t('Квитанция за оплату');
  },

  //

  JOURNAL: {
    ALL: function ALL(t) {
      return t('Все новости и статьи на Автобазар');
    },
    NEWS: function NEWS(t, rubric) {
      return t('Все') + ' ' + t(rubric || 'Новости').toLowerCase() + ' ' + t('на Автобазаре');
    }
  },

  //

  SERVICE: {
    CAR_COST_ESTIMATE: function CAR_COST_ESTIMATE(t) {
      return t('Оценка стоимости авто') + ' ' + t('на Автобазаре');
    },
    CAR_DRIVE: function CAR_DRIVE(t) {
      return t('Пригон авто') + ' ' + t('на Автобазаре');
    },
    SEARCH_SUBSCRIPTIONS: function SEARCH_SUBSCRIPTIONS(t) {
      return t('Подписка на поиск') + ' ' + t('на Автобазаре');
    }
  },

  //

  LOGIN: function LOGIN(t) {
    return t('Войти в Автобазар');
  },

  //

  NOT_FOUND: function NOT_FOUND(t) {
    return t('Страница не найдена');
  },

  //

  ADVERT_FORM: {
    ADD: function ADD(slug, t) {
      return buildAddTitleByTransportSlug(slug, t);
    },
    EDIT: function EDIT(t) {
      return t('Редактировать объявление');
    }
  },

  //

  PROFILE: {
    PROFILE: function PROFILE(t) {
      return t('Мой профиль');
    },
    DIALOGS: function DIALOGS(t) {
      return t('Мои сообщения');
    },
    FAVORITES: function FAVORITES(t) {
      return t('Мои избранные');
    },
    BILLING: function BILLING(t) {
      return t('Мой баланс');
    },
    SEARCHES: function SEARCHES(t) {
      return t('Мои поиски');
    },
    ADVERTS: function ADVERTS(t) {
      return t('Мои объявления');
    },
    INSURANCE: function INSURANCE(t) {
      return t('Страховка');
    },
    SEARCH_SUBSCRIPTIONS: function SEARCH_SUBSCRIPTIONS(t) {
      return t('Подписка на поиск');
    }
  },

  //

  MOBILE_FORM: {
    GEO: function GEO(t) {
      return t('Выбор местоположения');
    },
    FILTERS: function FILTERS(t) {
      return t('Выбор по параметрам');
    }
  },

  STATIC_PAGE: {
    LAW: function LAW(t) {
      return t('Справка Автобазар:') + ' ' + t('Политика конфиденциальности');
    },
    INFO_ZAPCHASTI: function INFO_ZAPCHASTI(t) {
      return t('Справка Автобазар:') + ' ' + t('Запчасти');
    },
    HELP: function HELP(t) {
      return t('Справка Автобазар:') + ' ' + t('Помощь');
    },
    FOR_SERVICES: function FOR_SERVICES(t) {
      return t('Справка Автобазар:') + ' ' + t('Автосервисам');
    },
    FOR_PRIVATES: function FOR_PRIVATES(t) {
      return t('Справка Автобазар:') + ' ' + t('Размещение объявлений');
    },
    FOR_DEALERS: function FOR_DEALERS(t) {
      return t('Справка Автобазар:') + ' ' + t('Пакет “Бизнес Плюс”');
    },
    BIZNES_PAKET: function BIZNES_PAKET(t) {
      return t('Справка Автобазар:') + ' ' + t('Пакет “Бизнес”');
    },
    ADVERTISING: function ADVERTISING(t) {
      return t('Справка Автобазар:') + ' ' + t('Разместить рекламу');
    },
    ABOUT: function ABOUT(t) {
      return t('Справка Автобазар:') + ' ' + t('Что такое автобазар');
    },
    FAQ: function FAQ(t) {
      return t('Справка Автобазар:') + ' ' + t('Часто задаваемые вопросы');
    },
    ENTRANCE: function ENTRANCE(t) {
      return t('Справка Автобазар:') + ' ' + t('Регистрация на avtobazar.ua');
    },
    TRANSPORT_ADS_RULES: function TRANSPORT_ADS_RULES(t) {
      return t('Справка Автобазар:') + ' ' + t('Правила составления объявлений');
    },
    PUBLIC_CONTRACT: function PUBLIC_CONTRACT(t) {
      return t('Справка Автобазар:') + ' ' + t('Публичный договор');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TITLE);

/***/ }),

/***/ 1391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import PropTypes from 'prop-types';

// import { setRatio } from 'shared/actions/globals';


var setRatioImage = function setRatioImage(image, ratio, width, height) {
  var fit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'cover';

  if (!image) {
    return image;
  }

  var aS3Regexp = /^(https:\/\/a[\d].s3.ua)/;
  var cndRegexp = /^(https:\/\/cdn.+(ab|s3).ua)/;
  var awsWithoutIRHRegexp = /^((https:\/\/d2wkv3iadoqiil.cloudfront.net\/)(\w*\/)?(\w*\/)?(.{32})(\..*)?)/;
  var awsWithIRHRegexp = /^((https:\/\/d1672trkrgk4ug.cloudfront.net\/)(.*))/;
  var dimensions = [width, height].map(function (x) {
    return x ? Math.round(x * ratio) : '';
  }).join('x');
  var httpsImage = image.replace('http:', 'https:');

  if (width || height) {
    if (httpsImage.match(cndRegexp)) {
      return httpsImage.replace('/image/', '/unsafe/' + dimensions + '/');
    }

    if (httpsImage.match(aS3Regexp)) {
      return httpsImage.replace(aS3Regexp, '$1/' + dimensions);
    }

    if (httpsImage.match(awsWithoutIRHRegexp)) {
      var groups = httpsImage.match(awsWithoutIRHRegexp);
      var size = 'large';
      if (width) {
        if (width * ratio <= 600) {
          size = 'small';
        } else if (width * ratio <= 900) {
          size = 'medium';
        }
      }

      var root = groups[3] && groups[3] === 'original/' ? '' : groups[3];
      return '' + (groups[2] + (root || '')) + size + '/' + (groups[5] + (groups[6] || ''));
    }

    if (httpsImage.match(awsWithIRHRegexp)) {
      var _groups = httpsImage.match(awsWithIRHRegexp);
      var imageRequest = JSON.stringify({
        key: '' + _groups[3],
        edits: {
          resize: {
            width: width ? Math.round(width * ratio) : null,
            height: height ? Math.round(height * ratio) : null,
            fit: fit
          }
        }
      });

      return '' + _groups[2] + Buffer.from(imageRequest).toString('base64');
    }
  }

  return httpsImage;
};

/*
const mapStateToProps = ({ globals }) => ({ ratio: globals.ratio });
const mapDispatchToProps = { setRatio };
*/
var mapStateToProps = function mapStateToProps() {
  return {};
};
var mapDispatchToProps = {};

// TODO: Commented code can be removed after testing, and be sure this code do not have some side effects.

var withPixelRatio = function withPixelRatio(WrappedComponent) {
  var _class, _temp2;

  return __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)((_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.setRatioImage = function (image) {
        var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 240;
        var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var fit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'cover';
        return setRatioImage(image, 1, width, height, fit);
      }, _this.setRatioAlbum = function (images, width, height) {
        return images.map(function (_ref2) {
          var image = _ref2.image,
              rest = _objectWithoutProperties(_ref2, ['image']);

          return _extends({}, rest, {
            image: _this.setRatioImage(image, width, height)
          });
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /*
    static propTypes = {
      // setRatio: PropTypes.func.isRequired,
      ratio: PropTypes.number,
    };
    static defaultProps = {
      ratio: null,
    }; */

    /*
    componentDidMount() {
      if (!this.props.ratio) {
        this.props.setRatio();
      }
    }
    */

    /*
    setRatioImage = (image, width = 240, height = null) =>
      setRatioImage(image, this.props.ratio, width, height);
    */


    _createClass(_class, [{
      key: 'render',
      value: function render() {
        // const { ratio, ...props } = this.props;
        var ratio = 1;

        var props = _objectWithoutProperties(this.props, []);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
          setRatioAlbum: this.setRatioAlbum,
          setRatioImage: this.setRatioImage,
          ratio: ratio
        }, props));
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withPixelRatio(' + __WEBPACK_IMPORTED_MODULE_2__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp2));
};

/* harmony default export */ __webpack_exports__["a"] = (withPixelRatio);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(492).Buffer))

/***/ }),

/***/ 1393:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _assign = __webpack_require__(188);

var ReactCurrentOwner = __webpack_require__(1444);

var warning = __webpack_require__(1401);
var canDefineProperty = __webpack_require__(1443);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(1445);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function warnAboutAccessingKey() {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function warnAboutAccessingRef() {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),

/***/ 1400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),

/***/ 1401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(490);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {}
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1531);

/***/ }),

/***/ 1430:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _assign = __webpack_require__(188);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function warning() {};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {}
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function displayName(Constructor, _displayName) {
      Constructor.displayName = _displayName;
    },
    mixins: function mixins(Constructor, _mixins) {
      if (_mixins) {
        for (var i = 0; i < _mixins.length; i++) {
          mixSpecIntoComponent(Constructor, _mixins[i]);
        }
      }
    },
    childContextTypes: function childContextTypes(Constructor, _childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, _childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, _childContextTypes);
    },
    contextTypes: function contextTypes(Constructor, _contextTypes) {
      if (false) {
        validateTypeDef(Constructor, _contextTypes, 'context');
      }
      Constructor.contextTypes = _assign({}, Constructor.contextTypes, _contextTypes);
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function getDefaultProps(Constructor, _getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, _getDefaultProps);
      } else {
        Constructor.getDefaultProps = _getDefaultProps;
      }
    },
    propTypes: function propTypes(Constructor, _propTypes) {
      if (false) {
        validateTypeDef(Constructor, _propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, _propTypes);
    },
    statics: function statics(Constructor, _statics) {
      mixStaticSpecIntoComponent(Constructor, _statics);
    },
    autobind: function autobind() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName);
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec === 'undefined' ? 'undefined' : _typeof(spec);
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(isMixinValid, "%s: You're attempting to include a mixin that is either null " + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec);
        }
      }

      return;
    }

    _invariant(typeof spec !== 'function', "ReactClass: You're attempting to " + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
    _invariant(!isValidElement(spec), "ReactClass: You're attempting to " + 'use a component as a mixin. Instead, just use a regular object.');

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;

        _invariant(specPolicy === 'DEFINE_MANY_MERGED', 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(one && two && (typeof one === 'undefined' ? 'undefined' : _typeof(one)) === 'object' && (typeof two === 'undefined' ? 'undefined' : _typeof(two)) === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function (newThis) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName);
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName);
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function componentDidMount() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function componentWillUnmount() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function replaceState(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function isMounted() {
      if (false) {
        warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component');
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function ReactClassComponent() {};
  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory');
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant((typeof initialState === 'undefined' ? 'undefined' : _typeof(initialState)) === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');

    if (false) {
      warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component');
      warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component');
      warning(!Constructor.prototype.UNSAFE_componentWillRecieveProps, '%s has a method called UNSAFE_componentWillRecieveProps(). ' + 'Did you mean UNSAFE_componentWillReceiveProps()?', spec.displayName || 'A component');
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;

/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _prodInvariant = __webpack_require__(1400),
    _assign = __webpack_require__(188);

var ReactNoopUpdateQueue = __webpack_require__(1442);

var canDefineProperty = __webpack_require__(1443);
var emptyObject = __webpack_require__(504);
var invariant = __webpack_require__(483);
var lowPriorityWarning = __webpack_require__(1532);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !((typeof partialState === 'undefined' ? 'undefined' : _typeof(partialState)) === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function defineDeprecationWarning(methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function get() {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),

/***/ 1442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(1401);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function isMounted(publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function enqueueCallback(publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function enqueueForceUpdate(publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function enqueueReplaceState(publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function enqueueSetState(publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),

/***/ 1443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function get() {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),

/***/ 1444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */

var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),

/***/ 1446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/MakesSidebar/Title/Title.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Title_css__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Title_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Title_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Title = function (_Component) {
  _inherits(Title, _Component);

  function Title() {
    _classCallCheck(this, Title);

    return _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).apply(this, arguments));
  }

  _createClass(Title, [{
    key: 'render',
    value: function render() {
      var title = this.props.title;


      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__Title_css___default.a.titleContainer
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__Title_css___default.a.title
      }, void 0, title));
    }
  }]);

  return Title;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ var Title_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__Title_css___default.a)(Title));
// CONCATENATED MODULE: ./src/desktop/components/MakesSidebar/MakesItem/MakesItem.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var MakesItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var MakesItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(MakesItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MakesItem_css__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MakesItem_css__);
var MakesItem__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var MakesItem__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MakesItem__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MakesItem__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MakesItem__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import LazyLoad from 'react-lazyload';







var MakesItem = function (_Component) {
  MakesItem__inherits(MakesItem, _Component);

  function MakesItem() {
    var _ref;

    var _temp, _this, _ret;

    MakesItem__classCallCheck(this, MakesItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = MakesItem__possibleConstructorReturn(this, (_ref = MakesItem.__proto__ || Object.getPrototypeOf(MakesItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleLinkClick = function (link) {
      if (window) {
        window.open(link);
      }
    }, _temp), MakesItem__possibleConstructorReturn(_this, _ret);
  }

  MakesItem__createClass(MakesItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          link = _props.link,
          models = _props.models,
          logo = _props.logo,
          className = _props.className,
          setRatioImage = _props.setRatioImage;


      return MakesItem__jsx('div', {
        className: className || __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.makesItem
      }, void 0, MakesItem__jsx('span', {
        onClick: function onClick() {
          return _this2.handleLinkClick(link);
        }
      }, void 0), MakesItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.makeWithModels
      }, void 0, MakesItem__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.make,
        onClick: function onClick() {
          return _this2.handleLinkClick(link);
        }
      }, void 0, title), MakesItem__jsx('p', {
        className: __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.models
      }, void 0, models.map(function (model) {
        return MakesItem__jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.model,
          onClick: function onClick() {
            return _this2.handleLinkClick(model.link);
          }
        }, model.id, '' + model.title);
      }))));
    }
  }]);

  return MakesItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MakesItem.defaultProps = {
  models: [],
  logo: '',
  className: ''
};


/* harmony default export */ var MakesItem_defaultExport = (MakesItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withPixelRatio__["a" /* default */](MakesItem)));
// CONCATENATED MODULE: ./src/desktop/components/MakesSidebar/MakesList/MakesList.js
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MakesList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(MakesList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(MakesList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MakesList_css__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MakesList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MakesList_css__);
var MakesList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var MakesList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MakesList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MakesList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MakesList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var MakesList_MakesList = function (_Component) {
  MakesList__inherits(MakesList, _Component);

  function MakesList() {
    MakesList__classCallCheck(this, MakesList);

    return MakesList__possibleConstructorReturn(this, (MakesList.__proto__ || Object.getPrototypeOf(MakesList)).apply(this, arguments));
  }

  MakesList__createClass(MakesList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          list = _props.list,
          itemCN = _props.itemCN;


      return MakesList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__MakesList_css___default.a.makesList
      }, void 0, list.map(function (make) {
        return MakesList__jsx(MakesItem_defaultExport, {
          title: make.title,
          logo: make.logo,
          models: make.models,
          link: make.link,
          className: itemCN
        }, make.id);
      }));
    }
  }]);

  return MakesList;
}(MakesList___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MakesList_MakesList.defaultProps = {
  list: [],
  itemCN: ''
};


/* harmony default export */ var MakesList_defaultExport = (MakesList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__MakesList_css___default.a)(MakesList_MakesList));
// CONCATENATED MODULE: ./src/desktop/components/MakesSidebar/MakesSidebar.js
/* harmony import */ var MakesSidebar___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var MakesSidebar___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MakesSidebar___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var MakesSidebar___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var MakesSidebar___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(MakesSidebar___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_makes_json__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_makes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_constants_json_makes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css__);
var MakesSidebar__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var MakesSidebar__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MakesSidebar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MakesSidebar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MakesSidebar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var MakesSidebar_MakesSidebar = function (_Component) {
  MakesSidebar__inherits(MakesSidebar, _Component);

  function MakesSidebar() {
    MakesSidebar__classCallCheck(this, MakesSidebar);

    return MakesSidebar__possibleConstructorReturn(this, (MakesSidebar.__proto__ || Object.getPrototypeOf(MakesSidebar)).apply(this, arguments));
  }

  MakesSidebar__createClass(MakesSidebar, [{
    key: 'render',


    // componentDidMount = () => {
    //   document.addEventListener('scroll', this.handleScrollPage);
    // };

    // handleScrollPage = () => {
    //   console.dir(this.sidebar);
    //   const a = this.sidebar.offsetTop;
    //   const parent = this.sidebar.parentNode;
    //   const { top } = parent.getBoundingClientRect();
    //   if (top < a) {
    //     this.sidebar.style.top = `${-top - a}px`;
    //   }
    // };

    value: function render() {
      var intl = this.props.intl;
      var _props = this.props,
          _props$title = _props.title,
          title = _props$title === undefined ? intl.formatMessage({ id: 'Популярные марки и модели' }) : _props$title,
          makes = _props.makes,
          itemCN = _props.itemCN;


      return MakesSidebar__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css___default.a.makesSidebar
      }, void 0, MakesSidebar__jsx(Title_defaultExport, {
        title: title
      }), MakesSidebar__jsx(MakesList_defaultExport, {
        list: makes,
        itemCN: itemCN
      }));
    }
  }]);

  return MakesSidebar;
}(MakesSidebar___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MakesSidebar_MakesSidebar.defaultProps = {
  makes: __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_makes_json___default.a,
  itemCN: '',
  title: undefined
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](MakesSidebar_MakesSidebar)));

/***/ }),

/***/ 1468:
/***/ (function(module, exports) {

module.exports = [{"id":0,"logo":"https://cdn-th1.ab.ua/image/497ad6596a134f46a96bfcc853ac289c/img/classifiers/Volkswagen-logo.png","title":"VW","link":"/avto/volkswagen/","models":[{"id":0,"title":"Passat","link":"/avto/volkswagen/passat/"},{"id":1,"title":"Golf","link":"/avto/volkswagen/golf/"},{"id":3,"title":"Jetta","link":"/avto/volkswagen/jetta/"},{"id":4,"title":"Golf","link":"/avto/volkswagen/touareg/"},{"id":5,"title":"Touareg","link":"/avto/volkswagen/touareg/"},{"id":6,"title":"Tiguan","link":"/avto/volkswagen/tiguan/"},{"id":7,"title":"Touran","link":"/avto/volkswagen/touran/"}]},{"id":1,"logo":"https://cdn-th1.ab.ua/image/dd227bda009c4b02ba53a732c9ad294c/img/classifiers/Ford-logo.png","title":"Ford","link":"/avto/ford/","models":[{"id":0,"title":"Fiesta","link":"/avto/ford/fiesta/"},{"id":1,"title":"Edge","link":"/avto/ford/edge/"},{"id":2,"title":"Kuga","link":"/avto/ford/kuga/"},{"id":3,"title":"Focus","link":"/avto/ford/focus/"},{"id":4,"title":"Focus","link":"/avto/ford/focus/"},{"id":5,"title":"Fusion","link":"/avto/ford/fusion/"},{"id":6,"title":"Escape","link":"/avto/ford/escape/"}]},{"id":2,"logo":"https://cdn-th1.ab.ua/image/b9b1373c2f3342bfaefbd0dd022595a7/img/classifiers/BMW-logo.png","title":"BMW","link":"/avto/bmw/","models":[{"id":0,"title":"X1","link":"/avto/bmw/x1/"},{"id":1,"title":"X3","link":"/avto/bmw/x3/"},{"id":2,"title":"X5","link":"/avto/bmw/x5/"},{"id":3,"title":"3 series","link":"/avto/bmw/3-seriya/"}]},{"id":3,"logo":"https://cdn-th1.ab.ua/image/ca00f6ece6bd43a19d32769a2a038bcc/img/classifiers/Mazda-logo.png","title":"Mazda","link":"/avto/mazda/","models":[{"id":0,"title":"6","link":"/avto/mazda/6/"},{"id":1,"title":"CX-9","link":"/avto/mazda/cx-9/"},{"id":2,"title":"CX-5","link":"/avto/mazda/cx-5/"}]},{"id":4,"logo":"https://cdn-th1.ab.ua/image/dcb79fe827cd4b95967d7b3c3b4fdda1/img/classifiers/Suzuki-logo.png","title":"Suzuki","link":"/avto/suzuki/","models":[{"id":0,"title":"Vitara","link":"/avto/suzuki/vitara/"},{"id":1,"title":"Sx4","link":"/avto/suzuki/sx4/"}]},{"id":5,"logo":"https://cdn-th1.ab.ua/image/ef706262283e475c84cffe15adc6066b/img/classifiers/Kia-logo.png","title":"Kia","link":"/avto/kia/","models":[{"id":0,"title":"Sportage","link":"/avto//kia/sportage"},{"id":1,"title":"Sorento","link":"https://ab.ua/avto/kia/sorento"},{"id":2,"title":"Niro","link":"/avto/kia/niro"}]},{"id":8,"logo":"https://cdn-th1.ab.ua/image/3b3b03df031c41c8b2e3a9d7026d0c1b/img/classifiers/Mitsubishi-logo.png","title":"Mitsubishi","link":"/avto/mitsubishi/","models":[{"id":0,"title":"ASX","link":"/avto/mitsubishi/asx/"},{"id":1,"title":"Outlander","link":"/avto/mitsubishi/outlander/"},{"id":2,"title":"Pajero Sport","link":"/avto/mitsubishi/pajero-sport/"}]},{"id":9,"logo":"https://cdn-th1.ab.ua/image/dedb40ba72e24e2eab443dff021efb8d/img/classifiers/Renault-logo.png","title":"Renault","link":"/avto/renault/","models":[{"id":0,"title":"Duster","link":"/avto/renault/duster/"},{"id":1,"title":"Captur","link":"/avto/renault/captur/"},{"id":2,"title":"Megane","link":"/avto/renault/megane/"},{"id":3,"title":"Sandero","link":"/avto/renault/sandero-1/"},{"id":4,"title":"Logan","link":"/avto/renault/logan/"}]},{"id":10,"logo":"https://cdn-th1.ab.ua/image/aaa7e3f5af0540239a3802b565b7c051/img/classifiers/Peugeot-logo.png","title":"Peugeot","link":"/avto/peugeot/","models":[{"id":0,"title":"208","link":"/avto/peugeot/208/"},{"id":1,"title":"308","link":"/avto/peugeot/308/"},{"id":2,"title":"3008","link":"/avto/peugeot/3008/"}]},{"id":11,"logo":"https://cdn-th1.ab.ua/image/74b998215679498ca93047b032274678/img/classifiers/Skoda-logo.png","title":"Skoda","link":"/avto/skoda/","models":[{"id":0,"title":"Rapid","link":"/avto/skoda/rapid-1/"},{"id":1,"title":"Octavia","link":"/avto/skoda/octavia/"},{"id":2,"title":"Kodiaq","link":"/avto/skoda/octavia/"},{"id":3,"title":"Karoq","link":"/avto/skoda/karoq/"}]},{"id":12,"logo":"https://cdn-th1.ab.ua/image/6cd481e3d49941819ccd6e4c29df2d95/img/classifiers/Mercedes-Benz-logo.png","title":"Mercedes-Benz","link":"/avto/mercedes-benz/","models":[{"id":0,"title":"S","link":"/avto/mercedes-benz/s-klass/"},{"id":1,"title":"GLA","link":"/avto/mercedes-benz/gla-klass/"},{"id":2,"title":"CLA","link":"/avto/mercedes-benz/cla-klass/"}]},{"id":13,"logo":"https://cdn-th1.ab.ua/image/c260d4a2e4a0476a87cd00de992f56cc/img/classifiers/Toyota-logo.png","title":"Toyota","link":"/avto/toyota/","models":[{"id":0,"title":"Corolla","link":"/avto/toyota/"},{"id":1,"title":"Camry","link":"/avto/toyota/camry/"},{"id":2,"title":"RAV 4","link":"/avto/toyota/rav4/"}]}]

/***/ }),

/***/ 1469:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1470);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Title.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Title.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1470:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3V9RQ{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;border-bottom:3px solid #ffeb3b;padding:8px 10px}._2fhat{font-size:16px;font-weight:700;line-height:24px;margin:0;color:#000}", ""]);

// exports
exports.locals = {
	"titleContainer": "_3V9RQ",
	"title": "_2fhat"
};

/***/ }),

/***/ 1471:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1472);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesItem.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1472:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3Kv4F{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;padding:6px 0 8px;font-weight:400}._1QEPi{width:30px;margin-right:10px;border:none;cursor:pointer}._1weVC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-right:5px}.zJ6Ue{margin:0;font-size:16px;font-weight:700;line-height:21px;text-decoration:none;color:#000;padding-bottom:3px;cursor:pointer}._3xqxl{margin:0;font-size:12px;line-height:16px}.qT-Bi{color:#666b6f;text-decoration:none;font-size:13px;line-height:1.43;outline:none;cursor:pointer}.qT-Bi:after{content:\", \";display:inline}.qT-Bi:last-child:after{content:none}.qT-Bi:hover{color:#e73232;text-decoration:none}.qT-Bi:hover:after{color:#666b6f}", ""]);

// exports
exports.locals = {
	"makesItem": "_3Kv4F",
	"logo": "_1QEPi",
	"makeWithModels": "_1weVC",
	"make": "zJ6Ue",
	"models": "_3xqxl",
	"model": "qT-Bi"
};

/***/ }),

/***/ 1473:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1474);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1474:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1dGx7{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;list-style:none;padding:3px 10px 10px;margin:0}", ""]);

// exports
exports.locals = {
	"makesList": "_1dGx7"
};

/***/ }),

/***/ 1475:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1476);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesSidebar.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesSidebar.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1476:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1fc7e{position:relative;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background:#fff;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.04);box-shadow:0 2px 8px rgba(0,0,0,.04);border-radius:2px;margin-bottom:30px}", ""]);

// exports
exports.locals = {
	"makesSidebar": "_1fc7e"
};

/***/ }),

/***/ 1497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/hocs/withPaginate.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__history__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MAX_PAGE_COUNT = 500;

var withPaginate = function withPaginate(WrappedComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.pageChanger = function (_ref2) {
        var selected = _ref2.selected;
        var _history$location = __WEBPACK_IMPORTED_MODULE_4__history__["a" /* default */].location,
            search = _history$location.search,
            pathname = _history$location.pathname;
        var anchor = _this.props.anchor;

        var query = __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(search);
        var searchInfo = __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.stringify(_extends({}, query, { page: selected ? selected + 1 : undefined }));

        __WEBPACK_IMPORTED_MODULE_4__history__["a" /* default */].push('' + pathname + (searchInfo ? '?' + searchInfo : '') + anchor);
      }, _this.hrefBuilder = function (pageIndex) {
        var url = _this.props.url;

        var searchInfo = __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.stringify(_extends({}, pageIndex && pageIndex > 1 ? { page: pageIndex || undefined } : {}));

        return '' + (url || '') + (searchInfo ? '?' + searchInfo : '');
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            pageCount = _props.pageCount,
            url = _props.url,
            query = _props.query,
            props = _objectWithoutProperties(_props, ['pageCount', 'url', 'query']);

        var transformedPageCount = Math.min(parseInt(pageCount, 10), MAX_PAGE_COUNT);

        var key = (url || '') + '-' + JSON.stringify(query || {});

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
          key: key,
          hrefBuilder: this.hrefBuilder,
          pageChanger: this.pageChanger,
          pageCount: transformedPageCount,
          url: url,
          query: query
        }, props));
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withPaginate(' + __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    pageCount: 1,
    url: null,
    query: null,
    anchor: ''
  }, _temp2;
};

/* harmony default export */ var withPaginate_defaultExport = (withPaginate);
// CONCATENATED MODULE: ./src/desktop/components/Paginate/Paginate.js
/* harmony import */ var Paginate___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Paginate___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Paginate___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_paginate__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paginate_css__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Paginate_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();










var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u0441\u0435\u0433\u043E'
});

function Paginate(props) {
  var pageCount = props.pageCount,
      initialPage = props.initialPage,
      pageRangeDisplayed = props.pageRangeDisplayed,
      hrefBuilder = props.hrefBuilder,
      pageChanger = props.pageChanger,
      overallCount = props.overallCount,
      backgroundColor = props.backgroundColor,
      intl = props.intl;

  var prevClassName = initialPage === 1 ? __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.hidden : __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.previous;
  var nextClassName = initialPage === pageCount ? __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.hidden : __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.next;

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.root
  }, void 0, _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_react_paginate___default.a, {
    pageCount: pageCount,
    pageRangeDisplayed: pageRangeDisplayed,
    initialPage: initialPage - 1,
    previousLabel: intl.formatMessage({ id: 'Предыдущая' }),
    nextLabel: intl.formatMessage({ id: 'Следующая' }),
    breakLabel: '...',
    disableInitialCallback: true,
    onPageChange: pageChanger,
    hrefBuilder: hrefBuilder,
    breakClassName: __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.breakMe,
    containerClassName: __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.pagination,
    previousClassName: prevClassName,
    nextClassName: nextClassName,
    activeClassName: backgroundColor || __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.activePage,
    subContainerClassName: '',
    pageClassName: __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.pageItem
  })), overallCount > 0 && _jsx('div', {}, void 0, _ref2, ': ', _jsx('strong', {}, void 0, overallCount)));
}

Paginate.defaultProps = {
  initialPage: 1,
  pageRangeDisplayed: 2,
  overallCount: 0,
  backgroundColor: ''
};


var mapStateToProps = function mapStateToProps(_ref) {
  var globals = _ref.globals;
  return { locale: globals.locale };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */](mapStateToProps)(withPaginate_defaultExport(Paginate)))));

/***/ }),

/***/ 1529:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _PaginationBoxView = __webpack_require__(1530);

var _PaginationBoxView2 = _interopRequireDefault(_PaginationBoxView);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

module.exports = _PaginationBoxView2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(1411);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(1548);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCreateFragment = __webpack_require__(1549);

var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);

var _PageView = __webpack_require__(1550);

var _PageView2 = _interopRequireDefault(_PageView);

var _BreakView = __webpack_require__(1551);

var _BreakView2 = _interopRequireDefault(_BreakView);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PaginationBoxView = function (_Component) {
  _inherits(PaginationBoxView, _Component);

  function PaginationBoxView(props) {
    _classCallCheck(this, PaginationBoxView);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PaginationBoxView).call(this, props));

    _this.handlePreviousPage = function (evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      if (_this.state.selected > 0) {
        _this.handlePageSelected(_this.state.selected - 1, evt);
      }
    };

    _this.handleNextPage = function (evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      if (_this.state.selected < _this.props.pageCount - 1) {
        _this.handlePageSelected(_this.state.selected + 1, evt);
      }
    };

    _this.handlePageSelected = function (selected, evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;

      if (_this.state.selected === selected) return;

      _this.setState({ selected: selected });

      // Call the callback with the new selected item:
      _this.callCallback(selected);
    };

    _this.callCallback = function (selectedItem) {
      if (typeof _this.props.onPageChange !== "undefined" && typeof _this.props.onPageChange === "function") {
        _this.props.onPageChange({ selected: selectedItem });
      }
    };

    _this.pagination = function () {
      var items = {};

      if (_this.props.pageCount <= _this.props.pageRangeDisplayed) {

        for (var index = 0; index < _this.props.pageCount; index++) {
          items['key' + index] = _this.getPageElement(index);
        }
      } else {

        var leftSide = _this.props.pageRangeDisplayed / 2;
        var rightSide = _this.props.pageRangeDisplayed - leftSide;

        if (_this.state.selected > _this.props.pageCount - _this.props.pageRangeDisplayed / 2) {
          rightSide = _this.props.pageCount - _this.state.selected;
          leftSide = _this.props.pageRangeDisplayed - rightSide;
        } else if (_this.state.selected < _this.props.pageRangeDisplayed / 2) {
          leftSide = _this.state.selected;
          rightSide = _this.props.pageRangeDisplayed - leftSide;
        }

        var _index = void 0;
        var page = void 0;
        var breakView = void 0;

        for (_index = 0; _index < _this.props.pageCount; _index++) {

          page = _index + 1;

          var pageView = _this.getPageElement(_index);

          if (page <= _this.props.marginPagesDisplayed) {
            items['key' + _index] = pageView;
            continue;
          }

          if (page > _this.props.pageCount - _this.props.marginPagesDisplayed) {
            items['key' + _index] = pageView;
            continue;
          }

          if (_index >= _this.state.selected - leftSide && _index <= _this.state.selected + rightSide) {
            items['key' + _index] = pageView;
            continue;
          }

          var keys = Object.keys(items);
          var breakLabelKey = keys[keys.length - 1];
          var breakLabelValue = items[breakLabelKey];

          if (_this.props.breakLabel && breakLabelValue !== breakView) {
            breakView = _react2.default.createElement(_BreakView2.default, {
              breakLabel: _this.props.breakLabel,
              breakClassName: _this.props.breakClassName
            });

            items['key' + _index] = breakView;
          }
        }
      }

      return items;
    };

    _this.state = {
      selected: props.initialPage ? props.initialPage : props.forcePage ? props.forcePage : 0
    };
    return _this;
  }

  _createClass(PaginationBoxView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Call the callback with the initialPage item:
      if (typeof this.props.initialPage !== 'undefined' && !this.props.disableInitialCallback) {
        this.callCallback(this.props.initialPage);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.forcePage !== 'undefined' && this.props.forcePage !== nextProps.forcePage) {
        this.setState({ selected: nextProps.forcePage });
      }
    }
  }, {
    key: 'hrefBuilder',
    value: function hrefBuilder(pageIndex) {
      if (this.props.hrefBuilder && pageIndex !== this.state.selected && pageIndex >= 0 && pageIndex < this.props.pageCount) {
        return this.props.hrefBuilder(pageIndex + 1);
      }
    }
  }, {
    key: 'getPageElement',
    value: function getPageElement(index) {
      return _react2.default.createElement(_PageView2.default, {
        onClick: this.handlePageSelected.bind(null, index),
        selected: this.state.selected === index,
        pageClassName: this.props.pageClassName,
        pageLinkClassName: this.props.pageLinkClassName,
        activeClassName: this.props.activeClassName,
        extraAriaContext: this.props.extraAriaContext,
        href: this.hrefBuilder(index),
        page: index + 1 });
    }
  }, {
    key: 'render',
    value: function render() {
      var disabled = this.props.disabledClassName;

      var previousClasses = (0, _classnames2.default)(this.props.previousClassName, _defineProperty({}, disabled, this.state.selected === 0));

      var nextClasses = (0, _classnames2.default)(this.props.nextClassName, _defineProperty({}, disabled, this.state.selected === this.props.pageCount - 1));

      return _react2.default.createElement('ul', { className: this.props.containerClassName }, _react2.default.createElement('li', { className: previousClasses }, _react2.default.createElement('a', { onClick: this.handlePreviousPage,
        className: this.props.previousLinkClassName,
        href: this.hrefBuilder(this.state.selected - 1),
        tabIndex: '0',
        onKeyPress: this.handlePreviousPage }, this.props.previousLabel)), (0, _reactAddonsCreateFragment2.default)(this.pagination()), _react2.default.createElement('li', { className: nextClasses }, _react2.default.createElement('a', { onClick: this.handleNextPage,
        className: this.props.nextLinkClassName,
        href: this.hrefBuilder(this.state.selected + 1),
        tabIndex: '0',
        onKeyPress: this.handleNextPage }, this.props.nextLabel)));
    }
  }]);

  return PaginationBoxView;
}(_react.Component);

PaginationBoxView.propTypes = {
  pageCount: _react.PropTypes.number.isRequired,
  pageRangeDisplayed: _react.PropTypes.number.isRequired,
  marginPagesDisplayed: _react.PropTypes.number.isRequired,
  previousLabel: _react.PropTypes.node,
  nextLabel: _react.PropTypes.node,
  breakLabel: _react.PropTypes.node,
  hrefBuilder: _react.PropTypes.func,
  onPageChange: _react.PropTypes.func,
  initialPage: _react.PropTypes.number,
  forcePage: _react.PropTypes.number,
  disableInitialCallback: _react.PropTypes.bool,
  containerClassName: _react.PropTypes.string,
  pageClassName: _react.PropTypes.string,
  pageLinkClassName: _react.PropTypes.string,
  activeClassName: _react.PropTypes.string,
  previousClassName: _react.PropTypes.string,
  nextClassName: _react.PropTypes.string,
  previousLinkClassName: _react.PropTypes.string,
  nextLinkClassName: _react.PropTypes.string,
  disabledClassName: _react.PropTypes.string,
  breakClassName: _react.PropTypes.string
};
PaginationBoxView.defaultProps = {
  pageCount: 10,
  pageRangeDisplayed: 2,
  marginPagesDisplayed: 3,
  activeClassName: "selected",
  previousClassName: "previous",
  nextClassName: "next",
  previousLabel: "Previous",
  nextLabel: "Next",
  breakLabel: "...",
  disabledClassName: "disabled",
  disableInitialCallback: false
};
exports.default = PaginationBoxView;
;
//# sourceMappingURL=PaginationBoxView.js.map

/***/ }),

/***/ 1531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(188);

var ReactBaseClasses = __webpack_require__(1441);
var ReactChildren = __webpack_require__(1533);
var ReactDOMFactories = __webpack_require__(1538);
var ReactElement = __webpack_require__(1393);
var ReactPropTypes = __webpack_require__(1539);
var ReactVersion = __webpack_require__(1545);

var createReactClass = __webpack_require__(1546);
var onlyChild = __webpack_require__(1547);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function createMixin(mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function __spread() {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function createMixin(mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function get() {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function get() {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),

/***/ 1532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function lowPriorityWarning() {};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {}
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function lowPriorityWarning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),

/***/ 1533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(1534);
var ReactElement = __webpack_require__(1393);

var emptyFunction = __webpack_require__(490);
var traverseAllChildren = __webpack_require__(1535);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;

  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),

/***/ 1534:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(1400);

var invariant = __webpack_require__(483);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function oneArgumentPooler(copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function twoArgumentPooler(a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function threeArgumentPooler(a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function standardReleaser(instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),

/***/ 1535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _prodInvariant = __webpack_require__(1400);

var ReactCurrentOwner = __webpack_require__(1444);
var REACT_ELEMENT_TYPE = __webpack_require__(1445);

var getIteratorFn = __webpack_require__(1536);
var invariant = __webpack_require__(483);
var KeyEscapeUtils = __webpack_require__(1537);
var warning = __webpack_require__(1401);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && (typeof component === 'undefined' ? 'undefined' : _typeof(component)) === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children === 'undefined' ? 'undefined' : _typeof(children);

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),

/***/ 1536:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),

/***/ 1537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),

/***/ 1538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(1393);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),

/***/ 1539:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(1393),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(1540);

module.exports = factory(isValidElement);

/***/ }),

/***/ 1540:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.

var factory = __webpack_require__(1541);
module.exports = function (isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};

/***/ }),

/***/ 1541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var ReactIs = __webpack_require__(505);
var assign = __webpack_require__(188);

var ReactPropTypesSecret = __webpack_require__(1542);
var has = __webpack_require__(1543);
var checkPropTypes = __webpack_require__(1544);

var printWarning = function printWarning() {};

if (false) {
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {}
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] &&
          // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), { expectedType: expectedType });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue)) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1543:
/***/ (function(module, exports) {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

/***/ }),

/***/ 1544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var printWarning = function printWarning() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = require('./lib/has');

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {}
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {/**/}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof(typeSpecs[typeSpecName]) + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + (typeof error === 'undefined' ? 'undefined' : _typeof(error)) + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function () {
  if (false) {
    loggedTypeFailures = {};
  }
};

module.exports = checkPropTypes;

/***/ }),

/***/ 1545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.7.0';

/***/ }),

/***/ 1546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(1441),
    Component = _require.Component;

var _require2 = __webpack_require__(1393),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(1442);
var factory = __webpack_require__(1430);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),

/***/ 1547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(1400);

var ReactElement = __webpack_require__(1393);

var invariant = __webpack_require__(483);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue(arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass(value, newClass) {
		if (!newClass) {
			return value;
		}

		if (value) {
			return value + ' ' + newClass;
		}

		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(87)) === 'object' && __webpack_require__(87)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var React = __webpack_require__(11);

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var emptyFunction = __webpack_require__(490);
var invariant = __webpack_require__(483);
var warning = __webpack_require__(1401);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

var didWarnAboutMaps = false;

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && (typeof component === 'undefined' ? 'undefined' : _typeof(component)) === 'object' && component.key != null) {
    // Explicit key
    return escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children === 'undefined' ? 'undefined' : _typeof(children);

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      if (false) {
        // Warn about using Maps as children
        if (iteratorFn === children.entries) {
          warning(didWarnAboutMaps, 'Using Maps as children is unsupported and will likely yield ' + 'unexpected results. Convert it to a sequence/iterable of keyed ' + 'ReactElements instead.');
          didWarnAboutMaps = true;
        }
      }

      var iterator = iteratorFn.call(children);
      var step;
      var ii = 0;
      while (!(step = iterator.next()).done) {
        child = step.value;
        nextName = nextNamePrefix + getComponentKey(child, ii++);
        subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
      }
      var childrenString = '' + children;
      invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum);
    }
  }

  return subtreeCount;
}

function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

function cloneAndReplaceKey(oldElement, newKey) {
  return React.cloneElement(oldElement, { key: newKey }, oldElement.props !== undefined ? oldElement.props.children : undefined);
}

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

var oneArgumentPooler = function oneArgumentPooler(copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var standardReleaser = function standardReleaser(instance) {
  var Klass = this;
  invariant(instance instanceof Klass, 'Trying to release an instance into a pool of a different type.');
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result;
  var keyPrefix = bookKeeping.keyPrefix;
  var func = bookKeeping.func;
  var context = bookKeeping.context;

  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (React.isValidElement(mappedChild)) {
      mappedChild = cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

var numericPropertyRegex = /^\d+$/;

var warnedAboutNumeric = false;

function createReactFragment(object) {
  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object' || !object || Array.isArray(object)) {
    warning(false, 'React.addons.createFragment only accepts a single object. Got: %s', object);
    return object;
  }
  if (React.isValidElement(object)) {
    warning(false, 'React.addons.createFragment does not accept a ReactElement ' + 'without a wrapper object.');
    return object;
  }

  invariant(object.nodeType !== 1, 'React.addons.createFragment(...): Encountered an invalid child; DOM ' + 'elements are not valid children of React components.');

  var result = [];

  for (var key in object) {
    if (false) {
      if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
        warning(false, 'React.addons.createFragment(...): Child objects should have ' + 'non-numeric keys so ordering is preserved.');
        warnedAboutNumeric = true;
      }
    }
    mapIntoWithKeyPrefixInternal(object[key], result, key, emptyFunction.thatReturnsArgument);
  }

  return result;
}

module.exports = createReactFragment;

/***/ }),

/***/ 1550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(1411);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PageView = function (_React$Component) {
  _inherits(PageView, _React$Component);

  function PageView() {
    _classCallCheck(this, PageView);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(PageView).apply(this, arguments));
  }

  _createClass(PageView, [{
    key: 'render',
    value: function render() {
      var cssClassName = this.props.pageClassName;
      var linkClassName = this.props.pageLinkClassName;
      var onClick = this.props.onClick;
      var href = this.props.href;
      var ariaLabel = 'Page ' + this.props.page + (this.props.extraAriaContext ? ' ' + this.props.extraAriaContext : '');
      var ariaCurrent = null;

      if (this.props.selected) {
        ariaCurrent = 'page';
        ariaLabel = 'Page ' + this.props.page + ' is your current page';
        if (typeof cssClassName !== 'undefined') {
          cssClassName = cssClassName + ' ' + this.props.activeClassName;
        } else {
          cssClassName = this.props.activeClassName;
        }
      }

      return _react2.default.createElement('li', { className: cssClassName }, _react2.default.createElement('a', { onClick: onClick,
        className: linkClassName,
        href: href,
        tabIndex: '0',
        'aria-label': ariaLabel,
        'aria-current': ariaCurrent,
        onKeyPress: onClick }, this.props.page));
    }
  }]);

  return PageView;
}(_react2.default.Component);

exports.default = PageView;
;
//# sourceMappingURL=PageView.js.map

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(1411);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var BreakView = function (_React$Component) {
  _inherits(BreakView, _React$Component);

  function BreakView() {
    _classCallCheck(this, BreakView);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(BreakView).apply(this, arguments));
  }

  _createClass(BreakView, [{
    key: 'render',
    value: function render() {
      var label = this.props.breakLabel;
      var className = this.props.breakClassName || 'break';

      return _react2.default.createElement('li', { className: className }, label);
    }
  }]);

  return BreakView;
}(_react2.default.Component);

exports.default = BreakView;
;
//# sourceMappingURL=BreakView.js.map

/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1553);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Paginate.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Paginate.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1553:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".wp2Sm{background-color:#fff;padding:10px;margin-bottom:10px;position:relative;z-index:10;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-weight:400}.yrL46:nth-of-type(2){border:1px solid #dedede;border-radius:2px 0 0 2px}.yrL46:nth-last-of-type(2){border-radius:0 2px 2px 0}.yrL46{cursor:pointer}._1Xm5w,.yrL46{position:relative;border:1px solid #dedede;border-left:none;display:-webkit-box;display:-ms-flexbox;display:flex}._1Xm5w{padding:0 10px}.yrL46:hover{background-color:#e4f1fb}.YGfgs{background-color:#c9e7ff}.UXnXg{padding:5px 0;margin:0;list-style:none;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}._2e76y,._2Lfan,.UXnXg{display:-webkit-box;display:-ms-flexbox;display:flex}._2e76y,._2Lfan{border:1px solid #dedede;margin:0 10px;border-radius:2px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer}._2e76y:hover,._2Lfan:hover{border-color:#34a7ff}.wp2Sm a{color:#000;line-height:28px;font-size:14px;outline:none;padding:0 10px;text-decoration:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1FlHS{display:none}", ""]);

// exports
exports.locals = {
	"root": "wp2Sm",
	"pageItem": "yrL46",
	"breakMe": "_1Xm5w",
	"activePage": "YGfgs",
	"pagination": "UXnXg",
	"next": "_2Lfan",
	"previous": "_2e76y",
	"hidden": "_1FlHS"
};

/***/ }),

/***/ 1663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildJournalListingUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildJournalItemUrl; });
/* unused harmony export buildStoVoteLink */
/* JOURNAL */

var genericJournalUrlBuilder = function genericJournalUrlBuilder(slug, tagSlug) {
  return '/zhurnal/' + (slug ? slug + '/' : '') + (tagSlug ? '?tag=' + tagSlug : '');
};

var buildJournalListingUrl = function buildJournalListingUrl(rubrics, rubric, tagSlug) {
  var rubricOrDefault = rubric || rubrics[0];

  return genericJournalUrlBuilder(rubricOrDefault.id === rubrics[0].id ? null : rubricOrDefault.seo_slug, tagSlug);
};

var buildJournalItemUrl = function buildJournalItemUrl(itemSlug, tagSlug) {
  return genericJournalUrlBuilder(itemSlug, tagSlug);
};

/* HOME */

var buildStoVoteLink = function buildStoVoteLink(companyID) {
  return 'https://sto.avtobazar.ua/vote/' + companyID + '/';
};

/***/ }),

/***/ 1756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setJournalNews; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setVideoTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setOrderingField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setVideoFilters; });
/* unused harmony export setSelectedVideoParams */
/* unused harmony export setSelectedVideoData */
/* unused harmony export videoCounter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__ = __webpack_require__(17);


var defaultVideoFilters = {
  make: null,
  model: null,
  generation: null,
  topic: null
};

var setJournalNews = function setJournalNews(news) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_NEWS,
    payload: news
  };
};

var setVideoTopics = function setVideoTopics(topics) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_VIDEO_TOPICS,
    payload: topics
  };
};

var setOrderingField = function setOrderingField(selectedHeadFilter) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_VIDEO_HEAD_FILTER,
    payload: selectedHeadFilter
  };
};

var setVideoFilters = function setVideoFilters() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultVideoFilters;
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_VIDEO_FILTERS,
    payload: filters
  };
};

var setSelectedVideoParams = function setSelectedVideoParams(params) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_SELECTED_VIDEO_PARAMS,
    payload: params
  };
};

var setSelectedVideoData = function setSelectedVideoData(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_SELECTED_VIDEO_DATA,
    payload: data
  };
};

var videoCounter = function videoCounter(postId) {
  return function (dispatch, getState, _ref) {
    var fetch = _ref.fetch;

    var userId = getState().user.user.id;
    var counterRequest = {
      event: 'view',
      fingerprint: getState().globals.fingerprint,
      object_id: postId,
      object_type: 'post'
    };

    if (userId) counterRequest.user_id = userId;

    fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].JOURNAL.SET_STATS(), {
      method: 'POST',
      body: JSON.stringify(counterRequest)
    }).then(function (packages) {
      if (packages.status === 200) {
        return packages.json();
      }
      return null;
    });
    return Promise.resolve();
  };
};

var getVideoContent = function getVideoContent(fetch, dispatch, videoId) {
  return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].JOURNAL.ITEM(videoId)).then(function (r) {
    return r.json();
  }).then(function (results) {
    var content = Array.isArray(results) && results[0].content;
    dispatch(setSelectedVideoData(content));
    dispatch(videoCounter(results[0].id));
  });
};

var getVideoById = function getVideoById() {
  var videoParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (dispatch, getState, _ref2) {
    var fetch = _ref2.fetch;

    dispatch(setSelectedVideoParams(videoParams));

    if (videoParams) {
      getVideoContent(fetch, dispatch, videoParams.id);
    } else {
      dispatch(setSelectedVideoData(videoParams));
      dispatch(setSelectedVideoParams(videoParams));
    }
    return Promise.resolve();
  };
};

/***/ }),

/***/ 1793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TYPES; });
/* unused harmony export itemPropType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_moment__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_newspaper_svg__ = __webpack_require__(1854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_newspaper_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_assets_images_newspaper_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NewsItem_css__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__NewsItem_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hocs_withPixelRatio__ = __webpack_require__(1391);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }













var TYPES = {
  TABLE: 'table',
  LIST: 'list'
};
var isMobile = "desktop" === 'mobile';

var itemPropType = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    caption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  // not required
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  author: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(),
  publication_date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  imgHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isPrimary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getSelVideo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var _ref = _jsx('span', {});

function NewsItem(props) {
  var _cx, _cx2, _cx3;

  var isActive = props.isActive,
      title = props.title,
      titleUk = props.title_uk,
      link = props.link,
      image = props.image,
      className = props.className,
      imgHeight = props.imgHeight,
      date = props.publication_date,
      type = props.type,
      author = props.author,
      isPrimary = props.isPrimary,
      setRatioImage = props.setRatioImage,
      intl = props.intl,
      getSelVideo = props.getSelVideo,
      lensEvent = props.lensEvent;
  var _author$first_name = author.first_name,
      firstName = _author$first_name === undefined ? null : _author$first_name,
      _author$last_name = author.last_name,
      lastName = _author$last_name === undefined ? null : _author$last_name;
  var locale = intl.locale;

  var fullDate = __WEBPACK_IMPORTED_MODULE_5_shared_helpers_moment__["b" /* getFullDate */](date, locale);
  var authorName = [firstName, lastName].filter(function (x) {
    return x;
  }).join(' ');
  //
  var isList = type === TYPES.LIST;
  var hasImage = !!image.url;
  var imageSrc = image && setRatioImage.apply(undefined, [image.url].concat(_toConsumableArray(isPrimary ? [750, null] : [240, 200]), ['contain']));
  var localizedTitle = locale === 'ru' ? title || titleUk : titleUk || title;

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(className, (_cx = {}, _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.listNews, isList), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.tableNews, !isList), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.primary, isPrimary), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.active, isActive), _cx)),
    onClick: function onClick() {
      return getSelVideo();
    }
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a((_cx2 = {}, _defineProperty(_cx2, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.listThumb, isList), _defineProperty(_cx2, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.tableThumb, !isList), _defineProperty(_cx2, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.placeholderThumb, !hasImage), _defineProperty(_cx2, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.imageTabletHeight, isMobile), _cx2)),
    style: imgHeight ? { backgroundImage: 'url(' + __WEBPACK_IMPORTED_MODULE_7_shared_modules__["u" /* urlReplace */](imageSrc || __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_newspaper_svg___default.a) + ')', height: imgHeight } : {}
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.stretchedLink,
    to: link,
    'data-lens-event': lensEvent
  }, void 0, _ref)), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a((_cx3 = {}, _defineProperty(_cx3, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.listText, isList), _defineProperty(_cx3, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.tableText, !isList), _cx3))
  }, void 0, _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
    to: link,
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.link,
    'data-lens-event': lensEvent
  }, void 0, localizedTitle), fullDate && !isList && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.tableDate
  }, void 0, fullDate)), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.listBottom
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.listBottomCard
  }, void 0, author.avatar && _jsx('img', {
    src: author.avatar,
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.avatar,
    alt: ''
  }), _jsx('div', {}, void 0, author && author.id && authorName && _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.author
  }, void 0, authorName), fullDate && isList && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.listDate
  }, void 0, fullDate))))));
}

NewsItem.defaultProps = {
  getSelVideo: function getSelVideo() {},
  lensEvent: '',
  className: '',
  author: null,
  date: null,
  isPrimary: false,
  isActive: false,
  imgHeight: 200,
  type: TYPES.TABLE
};


/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_10__hocs_withPixelRatio__["a" /* default */](NewsItem))));

/***/ }),

/***/ 1854:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "da0cfcef.svg";

/***/ }),

/***/ 1902:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1903);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsItem.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1903:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._18KxE{font-size:17px;color:#000;display:inline;font-weight:700;text-decoration:none;cursor:pointer;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out}._18KxE:hover{-webkit-box-shadow:inset 0 -6px 0 #ffeb39;box-shadow:inset 0 -6px 0 #ffeb39}._2ayW3{opacity:0}._2ayW3 a:hover{color:#000}._4-E00{position:relative;-webkit-box-flex:0;-ms-flex:0 0 32%;flex:0 0 32%;cursor:pointer;background-color:#fff;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.04);box-shadow:0 2px 8px rgba(0,0,0,.04);border-radius:2px}._4-E00 ._18KxE{font-weight:400;font-size:16px;line-height:1.68}._2DsrD ._18KxE{font-weight:700}._18Uq7{height:217px}._3FbYi{font-weight:400;padding:15px 25px}._1EOKH,._3FbYi{position:relative}._1EOKH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;width:100%;padding:0;margin-bottom:12px}._1EOKH ._18KxE{font-size:18px;line-height:1.54}._2Eymc{left:0;top:0;height:217px;-webkit-box-flex:0;-ms-flex:0 0 340px;flex:0 0 340px}._2Eymc,._3bmRD{position:relative}._3bmRD{font-weight:400;padding:20px 20px 15px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;background-color:#fff;width:100%}._2CbHG,.tKfJi{color:#a0a0a0;font-size:12px;padding-top:4px}.tKfJi{padding-top:10px}.l76L_{height:45px;border-radius:50%;width:auto;margin-right:10px}.OH5km{-ms-flex-line-pack:center;align-content:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-top:0}._1EKt4,.OH5km{display:-webkit-box;display:-ms-flexbox;display:flex}._1EKt4{-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1NJCk{font-size:14px;color:#444}._2Eymc,._18Uq7{position:relative;background:#f1f1f1 no-repeat 50%/cover}._3Xo7U{background-size:60%}._2oeBk{opacity:.7;pointer-events:none}@media screen and (max-width:768px){._2Eymc{-webkit-box-flex:0;-ms-flex:0 0 180px;flex:0 0 180px}._1EOKH{padding:10px 0;margin-bottom:10px}._3bmRD{padding:0 0 0 20px}._1NJCk,.l76L_{display:none}}@media screen and (max-width:400px){._2Eymc{-webkit-box-flex:0;-ms-flex:0 0 145px;flex:0 0 145px}._1EOKH ._18KxE{font-size:13px}._1EOKH{padding:10px 0;margin-bottom:10px}._2CbHG{font-size:11px}._3bmRD{padding:0 0 0 12px}._1NJCk,.l76L_{display:none}}@media screen and (min-width:769px){._2DLNp{height:170px!important}}", ""]);

// exports
exports.locals = {
	"link": "_18KxE",
	"stretchedLink": "_2ayW3 stretched",
	"tableNews": "_4-E00",
	"primary": "_2DsrD",
	"tableThumb": "_18Uq7",
	"tableText": "_3FbYi",
	"listNews": "_1EOKH",
	"listThumb": "_2Eymc",
	"listText": "_3bmRD",
	"tableDate": "tKfJi",
	"listDate": "_2CbHG",
	"avatar": "l76L_",
	"listBottom": "OH5km",
	"listBottomCard": "_1EKt4",
	"author": "_1NJCk",
	"placeholderThumb": "_3Xo7U",
	"active": "_2oeBk",
	"imageTabletHeight": "_2DLNp"
};

/***/ }),

/***/ 2232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setHomeSpecialCars */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setHomeCounters; });
/* unused harmony export setHomeNews */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__(17);


/* Common action creators */

var setHomeSpecialCars = function setHomeSpecialCars(cars) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["h" /* HOME_SPECIAL_CARS */].SET,
    payload: cars
  };
};

var setHomeCounters = function setHomeCounters(cars) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["f" /* HOME_COUNTERS */].SET,
    payload: cars
  };
};

var setHomeNews = function setHomeNews(news) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["g" /* HOME_NEWS */].SET,
    payload: news
  };
};



/***/ }),

/***/ 2370:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ada41ade.svg";

/***/ }),

/***/ 2371:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "de309d3c.svg";

/***/ }),

/***/ 2790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_urlBuilder__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TagList_css__ = __webpack_require__(2791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TagList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__TagList_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C'
});

var TagList = function (_React$Component) {
  _inherits(TagList, _React$Component);

  function TagList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TagList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TagList.__proto__ || Object.getPrototypeOf(TagList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      collapsed: !!_this.props.activeTag
    }, _this.showAll = function () {
      _this.setState({ collapsed: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TagList, [{
    key: 'render',
    value: function render() {
      if (!this.props.tags) {
        return null;
      }

      var _props = this.props,
          title = _props.title,
          allTags = _props.tags,
          max = _props.max,
          className = _props.className,
          onTagClick = _props.onTagClick,
          activeTag = _props.activeTag,
          query = _props.query,
          url = _props.url,
          currentRubric = _props.currentRubric,
          rubrics = _props.rubrics;
      var collapsed = this.state.collapsed;

      var tags = max && !collapsed ? allTags.slice(0, max) : allTags;
      var clearLink = __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(_extends({}, query, { tag: undefined }));

      return _jsx('div', {
        className: className || __WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.root
      }, void 0, activeTag && _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Link__["a" /* default */], {
        to: '' + url + (clearLink ? '?' + clearLink : ''),
        className: __WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.clearFilters
      }, void 0, _ref2), title && _jsx('h4', {
        className: __WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.title
      }, void 0, title), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.list
      }, void 0, tags.map(function (tag) {
        return _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Link__["a" /* default */], {
          to: __WEBPACK_IMPORTED_MODULE_8__helpers_urlBuilder__["b" /* buildJournalListingUrl */](rubrics, currentRubric, tag.slug),
          onClick: function onClick() {
            return onTagClick(tag.id);
          },
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.tag, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.active, activeTag === tag.slug))
        }, tag.id || tag.title, tag.title, ' ');
      }), tags.length < allTags.length && _jsx('button', {
        onClick: this.showAll,
        className: __WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.tag
      }, void 0, '...')));
    }
  }]);

  return TagList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TagList.defaultProps = {
  tags: null,
  query: null,
  url: null,
  title: null,
  className: '',
  max: null,
  onTagClick: function onTagClick() {},
  activeTag: null
};


var mapStateToProps = function mapStateToProps(_ref3) {
  var globals = _ref3.globals;
  return {
    rubrics: globals.journal.rubrics
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a)(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */](mapStateToProps)(TagList)));

/***/ }),

/***/ 2791:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2792);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TagList.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TagList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2792:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2u9qF{position:relative;background:#fff;padding:15px;margin-bottom:20px}._1MnP2{font-size:13px;font-weight:400;margin:10px 0}._1Kp1S{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:10px 0}._1Kp1S:not(:first-of-type):last-of-type{margin:0}._2BNfs{margin:0 10px 10px 0;font-size:12px;padding:6px 12px;border:1px solid #ccc;border-radius:2px;cursor:pointer;background:transparent;outline:0;text-transform:capitalize;color:inherit;text-decoration:none;max-width:calc(100% - 34px);overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;-webkit-box-sizing:content-box;box-sizing:content-box}._2BNfs:focus,._2BNfs:hover,.U0pd4{color:#e73232}._1M3kG{display:inline-block;margin-top:10px;font-size:14px}", ""]);

// exports
exports.locals = {
	"root": "_2u9qF",
	"title": "_1MnP2",
	"list": "_1Kp1S",
	"tag": "_2BNfs",
	"active": "U0pd4",
	"clearFilters": "_1M3kG"
};

/***/ }),

/***/ 2793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_urlBuilder__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_two_rows_sq_list_svg__ = __webpack_require__(2370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_two_rows_sq_list_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_assets_images_two_rows_sq_list_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_two_rows_line_list_svg__ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_two_rows_line_list_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_assets_images_two_rows_line_list_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NewsList_css__ = __webpack_require__(2794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__NewsList_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var typesToClassNames = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].TABLE, __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.tableItem);

var _ref2 = _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_two_rows_sq_list_svg___default.a,
  width: '20',
  alt: ''
});

var _ref3 = _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_two_rows_line_list_svg___default.a,
  width: '20',
  alt: ''
});

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'По Вашему запросу ничего не найдено'
});

var NewsList = function (_React$Component) {
  _inherits(NewsList, _React$Component);

  function NewsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NewsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewsList.__proto__ || Object.getPrototypeOf(NewsList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentType: __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].TABLE
    }, _this.handleSetTypeClick = function (type) {
      _this.setState({ currentType: type });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NewsList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          news = _props.news,
          tag = _props.tag,
          currentRubric = _props.currentRubric,
          shortView = _props.shortView,
          intl = _props.intl;

      var currentType = shortView ? __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].LIST : this.state.currentType;

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.root
      }, void 0, !shortView && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.header
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.title
      }, void 0, _jsx('h1', {}, void 0, intl.formatMessage({ id: __WEBPACK_IMPORTED_MODULE_9_shared_helpers_common__["h" /* getTitleOrEmpty */](currentRubric) || 'Новости' }))), _jsx('div', {}, void 0, Object.values(__WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */]).map(function (type) {
        return _jsx('button', {
          className: __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.headerButton,
          onClick: function onClick() {
            return _this2.handleSetTypeClick(type);
          },
          disabled: type === currentType
        }, type, type === __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].TABLE && _ref2, type === __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].LIST && _ref3);
      }))), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.table, currentType === __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].TABLE))
      }, void 0, news.length !== 0 ? news.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["b" /* default */], _extends({
          key: item.id
        }, item, {
          className: typesToClassNames[currentType],
          type: currentType,
          link: __WEBPACK_IMPORTED_MODULE_5_shared_helpers_urlBuilder__["a" /* buildJournalItemUrl */](item.slug, tag)
        }));
      }) : _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.emptyBlock
      }, void 0, _ref4)));
    }
  }]);

  return NewsList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NewsList.defaultProps = {
  videoTopics: [],
  videoOrderBy: '',
  tag: null,
  shortView: false,
  currentRubric: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](NewsList)));

/***/ }),

/***/ 2794:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2795);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsList.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2795:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1iljp{position:relative;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:20px}._1iljp,._250Dn{display:-webkit-box;display:-ms-flexbox;display:flex}._250Dn{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:10px 0}._2WPWo h1{font-size:20px;font-weight:700}._1SyMc{position:relative;background:transparent;font-size:20px;height:30px;cursor:pointer;width:40px;text-align:center;outline:none;font-weight:400;margin:0 0 0 -1px;border:0;border-bottom:2px solid transparent}._1SyMc img{opacity:.5}._1SyMc:first-of-type{margin:0}._1SyMc:disabled{cursor:auto;border-bottom:3px solid #ffd906}._1SyMc:disabled img{opacity:1}._1SyMc:focus img,._1SyMc:hover img{z-index:1;opacity:1}._3BInd{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:5px 0;background:#f5f5f5}._1o4gT{margin:10px 15px 10px 0;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:calc(33.33333% - 10px);flex-basis:calc(33.33333% - 10px)}._1o4gT:nth-of-type(3n){margin-right:0}._3Zfhz{margin-bottom:10px}._3Zfhz,.h7LQs{background:#fff;width:100%}.h7LQs{padding:20px 0;text-align:center}", ""]);

// exports
exports.locals = {
	"root": "_1iljp",
	"header": "_250Dn",
	"title": "_2WPWo",
	"headerButton": "_1SyMc",
	"table": "_3BInd",
	"tableItem": "_1o4gT",
	"ads": "_3Zfhz",
	"emptyBlock": "h7LQs"
};

/***/ }),

/***/ 2810:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRubricsNavigation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__urlBuilder__ = __webpack_require__(1663);


var getRubricsNavigation = function getRubricsNavigation(rubrics) {
  return rubrics.map(function (rubric) {
    return {
      title: rubric.title,
      route: __WEBPACK_IMPORTED_MODULE_0__urlBuilder__["b" /* buildJournalListingUrl */](rubrics, rubric)
    };
  });
};

/***/ }),

/***/ 2811:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/routes/journal/components/VideoFiltersHeader/VideoFiltersHeader.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_vdieoSortOptions_json__ = __webpack_require__(3155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_vdieoSortOptions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_vdieoSortOptions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_network_journal__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_actions_journal__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__VideoFiltersHeader_css__ = __webpack_require__(3156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__VideoFiltersHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__VideoFiltersHeader_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var VideoFiltersHeader__this2 = this;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












var CURRENT_RUBRIC = 'video';
var SHOW_IN_VIDEO = 1;

var changFilter = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(filterName, _this) {
    var _fetchNews;

    var _this$props, setOrderField, getSelVideo, setNews, _this$props$videoFilt, make, model, generation, topic, videos;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _this$props = _this.props, setOrderField = _this$props.setOrderField, getSelVideo = _this$props.getSelVideo, setNews = _this$props.setNews, _this$props$videoFilt = _this$props.videoFilters, make = _this$props$videoFilt.make, model = _this$props$videoFilt.model, generation = _this$props$videoFilt.generation, topic = _this$props$videoFilt.topic;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_7_shared_network_journal__["c" /* fetchNews */]((_fetchNews = {
              fetch: fetch,
              rubric: CURRENT_RUBRIC
            }, _defineProperty(_fetchNews, make && 'make', make && make.id), _defineProperty(_fetchNews, model && 'model', model && model.id), _defineProperty(_fetchNews, topic && 'topic', topic && topic.slug), _defineProperty(_fetchNews, generation && 'generation', generation && generation.id), _defineProperty(_fetchNews, 'showInVideo', SHOW_IN_VIDEO), _defineProperty(_fetchNews, 'ordering', filterName.id === 'new' ? '' : '-views'), _fetchNews));

          case 3:
            videos = _context.sent;

            setNews(videos.results || []);
            setOrderField(filterName);
            getSelVideo();

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, VideoFiltersHeader__this2);
  }));

  return function changFilter(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0421\u0430\u043C\u044B\u0435 \u043D\u043E\u0432\u044B\u0435'
});

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0435'
});

var VideoFiltersHeader = function (_React$Component) {
  _inherits(VideoFiltersHeader, _React$Component);

  function VideoFiltersHeader() {
    var _ref2;

    var _temp, _this3, _ret;

    _classCallCheck(this, VideoFiltersHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref2 = VideoFiltersHeader.__proto__ || Object.getPrototypeOf(VideoFiltersHeader)).call.apply(_ref2, [this].concat(args))), _this3), _this3.handleFilterChange = function (filterName) {
      changFilter(filterName, _this3);
    }, _temp), _possibleConstructorReturn(_this3, _ret);
  }

  _createClass(VideoFiltersHeader, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var videoOrderBy = this.props.videoOrderBy;

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__VideoFiltersHeader_css___default.a.root
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__VideoFiltersHeader_css___default.a.item, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__VideoFiltersHeader_css___default.a.active, videoOrderBy.id === 'new')),
        onClick: function onClick() {
          return _this4.handleFilterChange(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_vdieoSortOptions_json___default.a[0]);
        }
      }, void 0, _ref3), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__VideoFiltersHeader_css___default.a.item, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__VideoFiltersHeader_css___default.a.active, videoOrderBy.id === 'popular')),
        onClick: function onClick() {
          return _this4.handleFilterChange(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_vdieoSortOptions_json___default.a[1]);
        }
      }, void 0, _ref4));
    }
  }]);

  return VideoFiltersHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(_ref5) {
  var globals = _ref5.globals;
  return {
    videoOrderBy: globals.journal.videoOrderBy,
    videoFilters: globals.journal.videoFilters
  };
};

var mapDispatchToProps = {
  setNews: __WEBPACK_IMPORTED_MODULE_8_shared_actions_journal__["b" /* setJournalNews */],
  setOrderField: __WEBPACK_IMPORTED_MODULE_8_shared_actions_journal__["c" /* setOrderingField */],
  getSelVideo: __WEBPACK_IMPORTED_MODULE_8_shared_actions_journal__["a" /* getVideoById */]
};

/* harmony default export */ var VideoFiltersHeader_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__VideoFiltersHeader_css___default.a)(VideoFiltersHeader)));
// CONCATENATED MODULE: ./src/desktop/routes/journal/components/VideoFilters/VideoFilters.js
/* harmony import */ var VideoFilters___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var VideoFilters___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(VideoFilters___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_network_journal__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_actions_journal__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_helpers_arrays__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__history__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__VideoFilters_css__ = __webpack_require__(3158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__VideoFilters_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__VideoFilters_css__);
var VideoFilters__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var VideoFilters__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function VideoFilters__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function VideoFilters__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function VideoFilters__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function VideoFilters__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var DIV_STYLE = {
  borderRadius: '4px',
  border: '1px solid #ccc',
  height: '30px',
  lineHeight: '1em',
  fontWeight: 'normal'
};

var _ref7 = VideoFilters__jsx(VideoFiltersHeader_defaultExport, {});

var VideoFilters = function (_React$Component) {
  VideoFilters__inherits(VideoFilters, _React$Component);

  function VideoFilters() {
    var _ref;

    var _temp, _this, _ret;

    VideoFilters__classCallCheck(this, VideoFilters);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = VideoFilters__possibleConstructorReturn(this, (_ref = VideoFilters.__proto__ || Object.getPrototypeOf(VideoFilters)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      models: [],
      generations: []
    }, _this.setSearchUrl = function (value) {
      var _this$props = _this.props,
          location = _this$props.location,
          locale = _this$props.locale,
          videoFilters = _this$props.videoFilters;

      var state = _extends({}, videoFilters, value);
      var pathname = __WEBPACK_IMPORTED_MODULE_5_shared_helpers_urls__["c" /* generateJournalhUrl */](_extends({}, state, { location: location }), location && location.is_country);

      __WEBPACK_IMPORTED_MODULE_13__history__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_7_shared_helpers_locale__["h" /* toLocalized */](('/' + pathname + '/').replace(/\/\//g, '/'), locale));
    }, _this.handleMakeChange = function (selectedMake) {
      var prefSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props2 = _this.props,
          getSelVideo = _this$props2.getSelVideo,
          isSelVideo = _this$props2.isSelVideo,
          videoFilters = _this$props2.videoFilters;

      if (isSelVideo && !prefSearch) getSelVideo(); // clear selected video field

      _this.setState({ models: [], generations: [] });

      var requestParams = prefSearch ? videoFilters : { make: selectedMake, model: null, generation: null, topic: videoFilters.topic };

      _this.props.setMainFilters(requestParams);
      if (!prefSearch) _this.setSearchUrl(requestParams);

      _this.getModels(selectedMake && selectedMake.id, prefSearch);
    }, _this.handleModelChange = function (selectedModel) {
      var prefSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props3 = _this.props,
          getSelVideo = _this$props3.getSelVideo,
          isSelVideo = _this$props3.isSelVideo,
          videoFilters = _this$props3.videoFilters;
      var make = videoFilters.make,
          topic = videoFilters.topic;

      if (isSelVideo && !prefSearch) getSelVideo(); // clear selected video field

      _this.setState({ generations: [] });
      var requestParams = {
        make: make,
        model: selectedModel,
        generation: null,
        topic: topic
      };

      if (!prefSearch) {
        _this.props.setMainFilters(requestParams);
        _this.setSearchUrl(requestParams);
      }

      _this.getGenerations(selectedModel && selectedModel.id, prefSearch);
    }, _this.handleTopicChange = function (value) {
      var prefSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props4 = _this.props,
          videoFilters = _this$props4.videoFilters,
          isSelVideo = _this$props4.isSelVideo,
          getSelVideo = _this$props4.getSelVideo;

      var requestParams = _extends({}, videoFilters, { topic: value });
      if (isSelVideo && !prefSearch) getSelVideo(); // clear selected video field

      if (!prefSearch) {
        _this.props.setMainFilters(requestParams);
        _this.setSearchUrl(requestParams);
      }
    }, _this.generationsRenderer = function (option) {
      return VideoFilters__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__VideoFilters_css___default.a.generations
      }, void 0, option.photo && VideoFilters__jsx('img', {
        src: option.photo,
        className: __WEBPACK_IMPORTED_MODULE_14__VideoFilters_css___default.a.genPhoto,
        alt: ''
      }), VideoFilters__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_14__VideoFilters_css___default.a.genText
      }, void 0, option.title, ' (', option.year_begin, '\xA0-\xA0', option.year_end, ')'));
    }, _temp), VideoFilters__possibleConstructorReturn(_this, _ret);
  }

  VideoFilters__createClass(VideoFilters, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var videoFilters = this.props.videoFilters;


      if (videoFilters) {
        var prefSearch = true;
        if (videoFilters.topic) this.handleTopicChange(videoFilters.topic, prefSearch);
        this.handleMakeChange(this.props.videoFilters.make, prefSearch);
      }
    }
  }, {
    key: 'getModels',
    value: function () {
      var _ref2 = VideoFilters__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var makeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var prefSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var transport, _props, fetch, videoFilters, _ref3, model, models;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                transport = 1;
                _props = this.props, fetch = _props.fetch, videoFilters = _props.videoFilters;
                _ref3 = prefSearch && videoFilters, model = _ref3.model;
                _context.next = 5;
                return makeId && __WEBPACK_IMPORTED_MODULE_8_shared_network_journal__["b" /* fetchModels */](fetch, transport, makeId);

              case 5:
                models = _context.sent;

                // if makeId not selected we getting all videos
                if (models) this.setState({ models: models });
                if (model && models) this.handleModelChange(model, prefSearch);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getModels() {
        return _ref2.apply(this, arguments);
      }

      return getModels;
    }()
  }, {
    key: 'getGenerations',
    value: function () {
      var _ref4 = VideoFilters__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var modelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var prefSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var _props2, fetch, videoFilters, _ref5, generation, generations;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, fetch = _props2.fetch, videoFilters = _props2.videoFilters;
                _ref5 = prefSearch && videoFilters, generation = _ref5.generation;
                _context2.next = 4;
                return modelId && __WEBPACK_IMPORTED_MODULE_8_shared_network_journal__["a" /* fetchGenerations */](fetch, modelId);

              case 4:
                generations = _context2.sent;


                if (generations) this.setState({ generations: generations });
                if (generation && generations) this.handleGenerChange(generation, prefSearch);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getGenerations() {
        return _ref4.apply(this, arguments);
      }

      return getGenerations;
    }()
  }, {
    key: 'handleGenerChange',
    value: function () {
      var _ref6 = VideoFilters__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(selectedGeneration) {
        var prefSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var _props3, videoFilters, isSelVideo, getSelVideo, make, model, topic, requestParams;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props3 = this.props, videoFilters = _props3.videoFilters, isSelVideo = _props3.isSelVideo, getSelVideo = _props3.getSelVideo;
                make = videoFilters.make, model = videoFilters.model, topic = videoFilters.topic;
                requestParams = { make: make, model: model, generation: selectedGeneration, topic: topic };


                if (isSelVideo && !prefSearch) getSelVideo(); // clear selected video field
                if (!prefSearch) {
                  this.props.setMainFilters(requestParams);
                  this.setSearchUrl(requestParams);
                }

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleGenerChange(_x8) {
        return _ref6.apply(this, arguments);
      }

      return handleGenerChange;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          makes = _props4.makes,
          intl = _props4.intl,
          videoFilters = _props4.videoFilters,
          videoTopics = _props4.videoTopics;
      var _state = this.state,
          models = _state.models,
          generations = _state.generations;
      var selectedMake = videoFilters.make,
          selectedModel = videoFilters.model,
          selectedGeneration = videoFilters.generation,
          selectedTopic = videoFilters.topic;


      if (makes) makes.sort(__WEBPACK_IMPORTED_MODULE_10_shared_helpers_arrays__["b" /* compareByTitle */]);
      if (models) models.sort(__WEBPACK_IMPORTED_MODULE_10_shared_helpers_arrays__["b" /* compareByTitle */]);
      if (generations) generations.sort(__WEBPACK_IMPORTED_MODULE_10_shared_helpers_arrays__["b" /* compareByTitle */]);

      return VideoFilters__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__VideoFilters_css___default.a.root,
        id: 'videoFilterItem'
      }, void 0, _ref7, VideoFilters__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__VideoFilters_css___default.a.mainform
      }, void 0, VideoFilters__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__VideoFilters_css___default.a.filterItem
      }, void 0, VideoFilters__jsx(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], {
        style: DIV_STYLE,
        placeholder: intl.formatMessage({ id: 'Марка' }),
        instanceId: 'make-ff',
        name: 'make',
        options: makes,
        labelKey: 'title',
        valueKey: 'id',
        disabled: !makes || !makes.length,
        onChange: this.handleMakeChange,
        value: selectedMake
      })), VideoFilters__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__VideoFilters_css___default.a.filterItem
      }, void 0, VideoFilters__jsx(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], {
        style: DIV_STYLE,
        placeholder: intl.formatMessage({ id: 'Модель' }),
        instanceId: 'model-ff',
        name: 'model',
        labelKey: 'title',
        valueKey: 'id',
        options: models,
        disabled: !selectedMake || !models || !models.length,
        onChange: this.handleModelChange,
        value: selectedModel,
        matchPos: 'start'
      })), VideoFilters__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__VideoFilters_css___default.a.filterItem
      }, void 0, VideoFilters__jsx(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], {
        style: DIV_STYLE,
        instanceId: 'generation-ff',
        name: 'generation',
        placeholder: intl.formatMessage({ id: 'Поколение' }),
        labelKey: 'title',
        valueKey: 'id',
        optionRenderer: this.generationsRenderer,
        options: generations,
        disabled: !generations || !generations.length,
        onChange: this.handleGenerChange,
        value: selectedGeneration,
        matchPos: 'start'
      })), VideoFilters__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__VideoFilters_css___default.a.filterItem
      }, void 0, VideoFilters__jsx(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], {
        style: DIV_STYLE,
        placeholder: intl.formatMessage({ id: 'По темам' }),
        instanceId: 'topic-ff',
        name: 'topic',
        labelKey: 'title',
        valueKey: 'id',
        options: videoTopics,
        onChange: this.handleTopicChange,
        value: selectedTopic,
        matchPos: 'start'
      }))));
    }
  }]);

  return VideoFilters;
}(VideoFilters___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

VideoFilters.defaultProps = {
  location: null,
  selectedTopic: null
};

var VideoFilters_mapDispatchToProps = {
  setMainFilters: __WEBPACK_IMPORTED_MODULE_9_shared_actions_journal__["d" /* setVideoFilters */],
  getSelVideo: __WEBPACK_IMPORTED_MODULE_9_shared_actions_journal__["a" /* getVideoById */]
};

var VideoFilters_mapStateToProps = function mapStateToProps(_ref8) {
  var globals = _ref8.globals;
  return {
    videoFilters: globals.journal.videoFilters,
    isSelVideo: !!globals.journal.selVideoData,
    videoTopics: globals.journal.videoTopics,
    locale: globals.locale,
    location: globals.location
  };
};

/* harmony default export */ var VideoFilters_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](VideoFilters_mapStateToProps, VideoFilters_mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_6_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_11_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_14__VideoFilters_css___default.a)(VideoFilters)))));
// CONCATENATED MODULE: ./src/desktop/routes/journal/components/VideoList/VideoList.js
/* harmony import */ var VideoList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var VideoList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(VideoList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_scroll__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_two_rows_sq_list_svg__ = __webpack_require__(2370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_two_rows_sq_list_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_assets_images_two_rows_sq_list_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_two_rows_line_list_svg__ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_two_rows_line_list_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_assets_images_two_rows_line_list_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__VideoList_css__ = __webpack_require__(3160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__VideoList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__VideoList_css__);
var VideoList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var VideoList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var VideoList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function VideoList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function VideoList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function VideoList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function VideoList__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var typesToClassNames = VideoList__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].TABLE, __WEBPACK_IMPORTED_MODULE_10__VideoList_css___default.a.tableItem);

var _ref2 = VideoList__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_two_rows_sq_list_svg___default.a,
  width: '20',
  alt: ''
});

var VideoList__ref3 = VideoList__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_two_rows_line_list_svg___default.a,
  width: '20',
  alt: ''
});

var VideoList__ref4 = VideoList__jsx('div', {});

var _ref5 = VideoList__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'По Вашему запросу ничего не найдено'
});

var VideoList_VideoList = function (_React$Component) {
  VideoList__inherits(VideoList, _React$Component);

  function VideoList() {
    var _ref;

    var _temp, _this, _ret;

    VideoList__classCallCheck(this, VideoList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = VideoList__possibleConstructorReturn(this, (_ref = VideoList.__proto__ || Object.getPrototypeOf(VideoList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentType: __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].TABLE
    }, _this.handleSetTypeClick = function (type) {
      var _this$props = _this.props,
          selVideoParams = _this$props.selVideoParams,
          getSelVideo = _this$props.getSelVideo;

      _this.setState({ currentType: type });
      if (selVideoParams) getSelVideo();
    }, _temp), VideoList__possibleConstructorReturn(_this, _ret);
  }

  VideoList__createClass(VideoList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          videoContent = _props.videoContent,
          selVideoParams = _props.selVideoParams,
          shortView = _props.shortView,
          makes = _props.makes,
          _getSelVideo = _props.getSelVideo,
          videos = _props.videos,
          intl = _props.intl;

      var currentType = shortView ? __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].LIST : this.state.currentType;

      var activeVideoPlace = null;
      if (selVideoParams) {
        if (currentType === 'table') {
          activeVideoPlace = (Math.ceil((selVideoParams.index + 1) / 3) || 1) * 3 - 1;
          if (activeVideoPlace > videos.length - 1) activeVideoPlace = videos.length - 1;
        } else {
          activeVideoPlace = selVideoParams.index;
        }
      }

      if (selVideoParams) {
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_4_react_scroll__["scroller"].scrollTo('activeVideo', {
            duration: 1800,
            delay: 400,
            smooth: true,
            offset: -200
          });
        });
      }

      return VideoList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__VideoList_css___default.a.root
      }, void 0, !shortView && VideoList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__VideoList_css___default.a.header
      }, void 0, VideoList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__VideoList_css___default.a.title
      }, void 0, VideoList__jsx('h1', {}, void 0, intl.formatMessage({ id: 'Видео' }))), VideoList__jsx('div', {}, void 0, Object.values(__WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */]).map(function (type) {
        return VideoList__jsx('button', {
          className: __WEBPACK_IMPORTED_MODULE_10__VideoList_css___default.a.headerButton,
          onClick: function onClick() {
            return _this2.handleSetTypeClick(type);
          },
          disabled: type === currentType
        }, type, type === __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].TABLE && _ref2, type === __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].LIST && VideoList__ref3);
      }))), VideoList__jsx(VideoFilters_defaultExport, {
        makes: makes
      }), VideoList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(VideoList__defineProperty({}, __WEBPACK_IMPORTED_MODULE_10__VideoList_css___default.a.table, currentType === __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].TABLE))
      }, void 0, videos.length !== 0 ? videos.map(function (item, index) {
        return VideoList__jsx(VideoList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, item.id, VideoList___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["b" /* default */], VideoList__extends({}, item, {
          type: currentType,
          link: '',
          className: typesToClassNames[currentType],
          getSelVideo: function getSelVideo() {
            return _getSelVideo({ id: item.slug, index: index });
          },
          isActive: selVideoParams && selVideoParams.index === index
        })), selVideoParams && activeVideoPlace === index && VideoList__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(typesToClassNames[currentType], __WEBPACK_IMPORTED_MODULE_10__VideoList_css___default.a.activeVideo),
          id: 'activeVideo'
        }, void 0, VideoList__jsx('div', {
          dangerouslySetInnerHTML: { __html: videoContent }
        }), VideoList__ref4));
      }) : VideoList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__VideoList_css___default.a.emptyBlock
      }, void 0, _ref5)));
    }
  }]);

  return VideoList;
}(VideoList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

VideoList_VideoList.defaultProps = {
  shortView: false,
  currentRubric: null,
  selVideoParams: null,
  videoContent: ''
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__VideoList_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](VideoList_VideoList)));

/***/ }),

/***/ 3155:
/***/ (function(module, exports) {

module.exports = [{"id":"new","title":"Самые новые","slug":"new"},{"id":"popular","title":"Популярные","slug":"popular"}]

/***/ }),

/***/ 3156:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3157);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./VideoFiltersHeader.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./VideoFiltersHeader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3157:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3MAwq{border-radius:4px;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:14px;background-color:#ccc;height:32px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:calc(33.3% - 10px)}._3kHbt,._3MAwq{position:relative}._3kHbt{padding:0 8px;line-height:32px;font-size:13px;-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;text-align:center;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;cursor:pointer;font-weight:700}._3kHbt:before{position:absolute;left:1px;top:1px;right:1px;bottom:1px;background-color:#fff;content:\" \"}._3kHbt:first-child:before{border-radius:2px 0 0 2px}._3kHbt:last-child:before{border-radius:0 2px 2px 0}._3kHbt+._3kHbt:before{left:0}._3kHbt:hover:before{background-color:#e4f1fb}._3kHbt span{position:relative;vertical-align:top}._3kHbt._34kMK:before{background-color:#c9e7ff}", ""]);

// exports
exports.locals = {
	"root": "_3MAwq",
	"item": "_3kHbt",
	"active": "_34kMK"
};

/***/ }),

/***/ 3158:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3159);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./VideoFilters.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./VideoFilters.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3159:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".Jmzji{position:relative;padding:15px 5px 5px 15px;background-color:#fff;margin-bottom:20px;z-index:11;font-weight:400;font-size:14px}._2XOa3,.prF1w{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.prF1w{margin-top:8px}._32hV_{position:relative;width:calc(25% - 10px);margin-right:10px;margin-bottom:10px;margin-top:10px}._3PiFc{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._3XWBO{position:relative;margin-left:-1px}._2Lbql,._3XWBO{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}.Fyzj2{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-right:5px;width:50%}.Fyzj2 label{line-height:30px}.RbHhJ{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-left:5px;width:50%}._2yjqh,.RbHhJ label{line-height:30px}._2yjqh{position:relative;padding:7px 8px;border-radius:2px;height:32px;border:1px solid #ccc;outline:none;font-size:13px;font-weight:700}._2yjqh:active,._2yjqh:focus{outline:none;border:1px solid #2196f3;z-index:2;font-size:14px}._2p0wG{position:relative;display:inline-block;cursor:pointer;font-weight:400;font-size:13px;color:#000;padding-left:20px;white-space:nowrap}._2p0wG:hover{color:#ff5a5f}._2p0wG input{position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._2p0wG input,._2p0wG input:checked{top:7px;-webkit-appearance:none;width:15px;height:15px;outline:none}._2p0wG input:checked{border:1px solid #ffd906;background-color:#ffd906;border-radius:2px}._2kPVS{position:relative}._1wAfm{width:195px;margin-bottom:5px}._1wAfm,._3S1En{position:relative;display:block}._3S1En{font-weight:700;padding:3px 0 6px}._2kPVS:hover ._3S1En{color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "Jmzji",
	"mainform": "_2XOa3",
	"fullForm": "prF1w",
	"filterItem": "_32hV_",
	"flexContainer": "_3PiFc",
	"selectTo": "_3XWBO",
	"selectFrom": "_2Lbql",
	"left": "Fyzj2",
	"right": "RbHhJ",
	"input": "_2yjqh",
	"checkbox": "_2p0wG",
	"generations": "_2kPVS",
	"genPhoto": "_1wAfm",
	"genText": "_3S1En"
};

/***/ }),

/***/ 3160:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3161);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./VideoList.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./VideoList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3161:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._21V0f{position:relative;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:20px}._3QXcN,._21V0f{display:-webkit-box;display:-ms-flexbox;display:flex}._3QXcN{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:10px 0}._8fF3n h1{font-size:20px;font-weight:700}.DNoaM{position:relative;background:transparent;font-size:20px;height:30px;cursor:pointer;width:40px;text-align:center;outline:none;font-weight:400;margin:0 0 0 -1px;border:0;border-bottom:2px solid transparent}.DNoaM img{opacity:.5}.DNoaM:first-of-type{margin:0}.DNoaM:disabled{cursor:auto;border-bottom:3px solid #ffd906}.DNoaM:disabled img{opacity:1}.DNoaM:focus img,.DNoaM:hover img{z-index:1;opacity:1}._2mkHg{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:5px 2px;background:#f5f5f5;margin:0 -7px}._2V7yz{margin:10px 5px;-ms-flex-preferred-size:calc(33.33333% - 10px);flex-basis:calc(33.33333% - 10px)}._21sFr{margin-bottom:10px}._21sFr,.ALQU1{background:#fff;width:100%}.ALQU1{padding:20px 0;text-align:center}.qF_k9 .responsive-object{position:relative;padding-bottom:0!important}.qF_k9 iframe{width:100%;height:420px}.qF_k9 table{border-collapse:collapse}.qF_k9 table td,.qF_k9 table th{border:1px solid #000;padding:5px}.qF_k9 .block-table{max-width:100%;overflow:auto}.qF_k9{-ms-flex-preferred-size:100%;flex-basis:100%;max-height:100%;padding-bottom:0}", ""]);

// exports
exports.locals = {
	"root": "_21V0f",
	"header": "_3QXcN",
	"title": "_8fF3n",
	"headerButton": "DNoaM",
	"table": "_2mkHg",
	"tableItem": "_2V7yz",
	"ads": "_21sFr",
	"emptyBlock": "ALQU1",
	"activeVideo": "qF_k9"
};

/***/ }),

/***/ 3162:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3163);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Videos.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Videos.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3163:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1j28L{margin:0 auto}._1OMVv{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.XQE7J{position:relative}._1xteK{width:calc(100% - 300px);margin-right:20px}.I9G5W{margin-bottom:20px}.cmP2m{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.pQzsv{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:300px}._2FdoR{margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"page": "_3G-4f page",
	"container": "_1j28L container",
	"flexRow": "_1OMVv flexRow",
	"flexCell": "XQE7J",
	"mainCell": "_1xteK",
	"primary": "I9G5W",
	"flexGrow1": "cmP2m",
	"sideBar": "pQzsv",
	"Juan": "_2FdoR"
};

/***/ }),

/***/ 3164:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3165);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SidebarFilters.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SidebarFilters.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3165:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".sAbi7{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background:#fff;padding:15px;margin-bottom:20px}._3xHnQ{font-size:18px;margin:4px 0}._11hil{padding:0;margin:0}", ""]);

// exports
exports.locals = {
	"root": "sAbi7",
	"title": "_3xHnQ",
	"list": "_11hil"
};

/***/ }),

/***/ 3166:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3167);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsComponent.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsComponent.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3167:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2hxYy{margin:0 auto}.j3uvV{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._3z_b6{position:relative}.we5rd{width:calc(100% - 300px);margin-right:20px}._1YEEJ{margin-bottom:20px}.ERnjX{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}._1e7ed{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:300px}._3yKdv{margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"page": "_19iU1 page",
	"container": "_2hxYy container",
	"flexRow": "j3uvV flexRow",
	"flexCell": "_3z_b6",
	"mainCell": "we5rd",
	"primary": "_1YEEJ",
	"flexGrow1": "ERnjX",
	"sideBar": "_1e7ed",
	"Juan": "_3yKdv"
};

/***/ }),

/***/ 3349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/routes/journal/videos/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_adsAndMetrics__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions_homeSpecialCars__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_journal__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_snakecase_keys__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_snakecase_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_snakecase_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var action = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
    var fetch = _ref2.fetch,
        baseUrl = _ref2.baseUrl,
        path = _ref2.path,
        query = _ref2.query,
        store = _ref2.store,
        params = _ref2.params;

    var url, seoResponse, page, tag, _store$getState$globa, stateVideoTopics, rubrics, _params$rubricSeoSlug, rubricSeoSlug, currentRubric, _store$getState$globa2, _store$getState$globa3, oldVideoFilters, oldSorting, language, makes, _seoResponse$characte, characteristics, kind, seoQuery, seoResQuery, searchQuery, count, currentPage, q, rubric, videoFilters, _ref3, _ref4, newsResponse, tags, videoTopics, newsData, videos, pageCount, location, targetingArguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = __WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__["e" /* removeLocaleFromHref */](('' + baseUrl + path).replace('//', '/'));
            _context.next = 3;
            return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].SEO.VIDEO_URLS(url, query)).then(function (r) {
              return r.ok ? r.json() : null;
            });

          case 3:
            _context.t0 = _context.sent;

            if (_context.t0) {
              _context.next = 6;
              break;
            }

            _context.t0 = {};

          case 6:
            seoResponse = _context.t0;

            if (!__WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty___default.a(seoResponse)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt('return', null);

          case 9:
            page = parseInt(query.page || 1, 10);
            tag = query.tag;
            _store$getState$globa = store.getState().globals.journal, stateVideoTopics = _store$getState$globa.videoTopics, rubrics = _store$getState$globa.rubrics;
            _params$rubricSeoSlug = params.rubricSeoSlug, rubricSeoSlug = _params$rubricSeoSlug === undefined ? rubrics[5].seo_slug : _params$rubricSeoSlug;
            currentRubric = rubrics.find(function (rubric) {
              return rubric.seo_slug === rubricSeoSlug;
            });

            if (currentRubric) {
              _context.next = 16;
              break;
            }

            return _context.abrupt('return', null);

          case 16:
            _store$getState$globa2 = store.getState().globals, _store$getState$globa3 = _store$getState$globa2.journal, oldVideoFilters = _store$getState$globa3.videoFilters, oldSorting = _store$getState$globa3.videoOrderBy, language = _store$getState$globa2.locale;
            makes = [];

            if (!(store.getState().homeCounters && store.getState().homeCounters.all)) {
              _context.next = 22;
              break;
            }

            makes = store.getState().homeCounters.all;
            _context.next = 24;
            break;

          case 22:
            _context.next = 24;
            return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.MAKES_COUNT + '?' + __WEBPACK_IMPORTED_MODULE_6_query_string___default.a.stringify({
              transport: AUTO_TRANSPORT_ID
            })).then(function (r) {
              return r.ok && r.json();
            }).then(function (resp) {
              makes = resp;
              store.dispatch(__WEBPACK_IMPORTED_MODULE_2_shared_actions_homeSpecialCars__["a" /* setHomeCounters */]({ all: resp }));
            });

          case 24:
            _seoResponse$characte = seoResponse.characteristics, characteristics = _seoResponse$characte === undefined ? {} : _seoResponse$characte, kind = seoResponse.kind, seoQuery = _objectWithoutProperties(seoResponse, ['characteristics', 'kind']);
            seoResQuery = __WEBPACK_IMPORTED_MODULE_7_snakecase_keys___default.a(__WEBPACK_IMPORTED_MODULE_5_shared_helpers_urls__["d" /* generateSearchQuery */](_extends({}, seoQuery, { language: language })));
            searchQuery = __WEBPACK_IMPORTED_MODULE_6_query_string___default.a.stringify(seoResQuery);
            _context.next = 29;
            return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.COUNT + '?' + searchQuery).then(function (r) {
              return r.json();
            }).then(function (response) {
              return response.count;
            });

          case 29:
            count = _context.sent;
            currentPage = query.page ? parseInt(query.page, 10) : 1;
            q = _extends({}, query, seoQuery);
            rubric = seoQuery.rubric, videoFilters = _objectWithoutProperties(seoQuery, ['rubric']);


            if (seoQuery.make) q.make = seoQuery.make.id;
            if (seoQuery.model) q.model = seoQuery.model.id;
            if (oldVideoFilters.generation) q.generation = oldVideoFilters.generation.id;
            if (seoQuery.rubric) q.rubric = seoQuery.rubric.slug;
            if (seoQuery.topic) q.topic = seoQuery.topic.slug;

            _context.next = 40;
            return Promise.all([fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].JOURNAL.LIST(_extends({
              tag: tag,
              page: page,
              perPage: PER_PAGE,
              showInVideo: 1,
              ordering: oldSorting.id === 'new' ? '' : '-views',
              language: language
            }, q))), fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].JOURNAL.TAGS({ rubric: currentRubric.slug, language: language })).then(function (r) {
              return r.json();
            }), stateVideoTopics.length ? stateVideoTopics : fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].JOURNAL.VIDEO_TOPICS({ language: language })).then(function (r) {
              return r.json();
            })]);

          case 40:
            _ref3 = _context.sent;
            _ref4 = _slicedToArray(_ref3, 3);
            newsResponse = _ref4[0];
            tags = _ref4[1];
            videoTopics = _ref4[2];

            if (!(newsResponse.status === 404)) {
              _context.next = 47;
              break;
            }

            return _context.abrupt('return', null);

          case 47:
            _context.next = 49;
            return newsResponse.json();

          case 49:
            newsData = _context.sent;
            videos = newsData.results;
            pageCount = Math.ceil(newsData.count / PER_PAGE);
            location = store.getState().globals.location;
            targetingArguments = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_adsAndMetrics__["a" /* getAdsContext */]({
              location: location,
              page: page,
              rubric: tag
            });


            store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_journal__["d" /* setVideoFilters */](_extends({}, oldVideoFilters, videoFilters)));
            store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_journal__["b" /* setJournalNews */](videos));
            store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_journal__["e" /* setVideoTopics */](videoTopics || []));

            return _context.abrupt('return', {
              count: count,
              makes: makes,
              rubrics: rubrics,
              currentRubric: currentRubric,
              currentPage: currentPage,
              page: page,
              tags: tags,
              tag: tag,
              pageCount: pageCount,
              url: url,
              query: query,
              targetingArguments: targetingArguments
            });

          case 58:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function action(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }











var AUTO_TRANSPORT_ID = 1;
var PER_PAGE = 18;

/* harmony default export */ var videos_defaultExport = (action);
// CONCATENATED MODULE: ./src/desktop/routes/journal/videos/Videos.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actions_journal__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_BannerAll__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_desktop_components_Paginate_Paginate__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_desktop_components_MakesSidebar_MakesSidebar__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_VideoList_VideoList__ = __webpack_require__(2811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Videos_css__ = __webpack_require__(3162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Videos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Videos_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Videos__ref = _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_BannerAll__["b" /* DesktopButton */], {});

var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_BannerAll__["d" /* DesktopRightSidebar */], {
  scrollNo: true
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_desktop_components_MakesSidebar_MakesSidebar__["a" /* default */], {}));

var Videos = function (_React$Component) {
  _inherits(Videos, _React$Component);

  function Videos() {
    _classCallCheck(this, Videos);

    return _possibleConstructorReturn(this, (Videos.__proto__ || Object.getPrototypeOf(Videos)).apply(this, arguments));
  }

  _createClass(Videos, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var selVideoParams = this.props.selVideoParams;

      if (selVideoParams) {
        this.props.getSelVideo(selVideoParams);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.setDefaultVideoFilters();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          query = _props.query,
          videoContent = _props.videoContent,
          pageCount = _props.pageCount,
          currentPage = _props.currentPage,
          currentRubric = _props.currentRubric,
          makes = _props.makes,
          videos = _props.videos,
          videoOrderBy = _props.videoOrderBy,
          getSelVideo = _props.getSelVideo,
          selVideoParams = _props.selVideoParams;


      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__Videos_css___default.a.page
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__Videos_css___default.a.container
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__Videos_css___default.a.flexRow
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_10__Videos_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_10__Videos_css___default.a.mainCell)
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__components_VideoList_VideoList__["a" /* default */], {
        videos: videos,
        makes: makes,
        videoContent: videoContent,
        currentRubric: currentRubric,
        videoOrderBy: videoOrderBy,
        getSelVideo: getSelVideo,
        selVideoParams: selVideoParams
      }), Videos__ref, pageCount > 1 && _jsx(__WEBPACK_IMPORTED_MODULE_7_desktop_components_Paginate_Paginate__["a" /* default */], {
        pageCount: pageCount,
        initialPage: currentPage,
        query: query,
        url: url
      })), _ref2)));
    }
  }]);

  return Videos;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Videos.defaultProps = {
  videoContent: '',
  selVideoParams: null
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var globals = _ref3.globals;
  return {
    videos: globals.journal.news,
    videoTopics: globals.journal.videoTopics,
    videoOrderBy: globals.journal.videoOrderBy,
    selVideoParams: globals.journal.selVideoParams,
    videoContent: globals.journal.selVideoData
  };
};

var mapDispatchToProps = {
  getSelVideo: __WEBPACK_IMPORTED_MODULE_5_shared_actions_journal__["a" /* getVideoById */],
  setDefaultVideoFilters: __WEBPACK_IMPORTED_MODULE_5_shared_actions_journal__["d" /* setVideoFilters */]
};

/* harmony default export */ var Videos_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__Videos_css___default.a)(Videos)));
// CONCATENATED MODULE: ./src/desktop/routes/journal/videos/index.js
/* harmony import */ var videos___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var videos___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(videos___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_seoDescriptions__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_seoTitles__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_journal__ = __webpack_require__(2810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_desktop_components_Layout__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_helpers_common__ = __webpack_require__(184);
var videos__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var videos_action = function () {
  var _ref = videos__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
    var store, translate, pageParams, makes, videoContent, currentPage, pageCount, url, query, targetingArguments, rubrics, currentRubric, title, description, isLastPage;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = params.store, translate = params.translate;
            _context.next = 3;
            return videos_defaultExport(params);

          case 3:
            pageParams = _context.sent;

            if (pageParams) {
              _context.next = 6;
              break;
            }

            return _context.abrupt('return', null);

          case 6:
            if (pageParams.count) {
              _context.next = 8;
              break;
            }

            return _context.abrupt('return', {
              status: 301,
              redirect: '/'
            });

          case 8:
            makes = pageParams.makes, videoContent = pageParams.videoContent, currentPage = pageParams.currentPage, pageCount = pageParams.pageCount, url = pageParams.url, query = pageParams.query, targetingArguments = pageParams.targetingArguments, rubrics = pageParams.rubrics, currentRubric = pageParams.currentRubric;
            title = __WEBPACK_IMPORTED_MODULE_4_shared_constants_seoTitles__["a" /* default */].JOURNAL.NEWS(translate, __WEBPACK_IMPORTED_MODULE_7__shared_helpers_common__["h" /* getTitleOrEmpty */](currentRubric));
            description = __WEBPACK_IMPORTED_MODULE_3_shared_constants_seoDescriptions__["a" /* default */].JOURNAL.NEWS(translate, __WEBPACK_IMPORTED_MODULE_7__shared_helpers_common__["h" /* getTitleOrEmpty */](currentRubric));
            isLastPage = currentPage === pageCount;


            store.dispatch(__WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__["C" /* setTargetingArguments */](targetingArguments));

            return _context.abrupt('return', {
              chunks: ['journal'],
              title: title,
              page: currentPage,
              isLastPage: isLastPage,
              description: description,
              component: videos__jsx(__WEBPACK_IMPORTED_MODULE_6_desktop_components_Layout__["a" /* default */], {
                navLinks: __WEBPACK_IMPORTED_MODULE_5_shared_helpers_journal__["a" /* getRubricsNavigation */](rubrics),
                currentRoute: url,
                including: false,
                hideLocations: true
              }, void 0, videos__jsx(Videos_defaultExport, {
                videoContent: videoContent,
                makes: makes,
                currentPage: currentPage,
                pageCount: pageCount,
                url: url,
                query: query,
                currentRubric: currentRubric
              }))
            });

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function action(_x) {
    return _ref.apply(this, arguments);
  };
}();

function videos__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }











/* harmony default export */ __webpack_exports__["default"] = (videos_action);

/***/ }),

/***/ 3350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/routes/journal/news/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_adsAndMetrics__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions_homeSpecialCars__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_journal__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var action = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
    var fetch = _ref2.fetch,
        baseUrl = _ref2.baseUrl,
        path = _ref2.path,
        query = _ref2.query,
        store = _ref2.store,
        params = _ref2.params;

    var url, page, tag, _store$getState$globa, rubrics, language, _params$rubricSeoSlug, rubricSeoSlug, currentRubric, makes, _ref3, _ref4, newsResponse, tags, videoTopics, newsData, news, pageCount, location, targetingArguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = ('' + baseUrl + path).replace('//', '/');
            page = parseInt(query.page || 1, 10);
            tag = query.tag;
            _store$getState$globa = store.getState().globals, rubrics = _store$getState$globa.journal.rubrics, language = _store$getState$globa.locale;
            _params$rubricSeoSlug = params.rubricSeoSlug, rubricSeoSlug = _params$rubricSeoSlug === undefined ? rubrics[0].seo_slug : _params$rubricSeoSlug;
            currentRubric = rubrics.find(function (rubric) {
              return rubric.seo_slug === rubricSeoSlug;
            });

            if (currentRubric) {
              _context.next = 8;
              break;
            }

            return _context.abrupt('return', null);

          case 8:
            makes = [];

            if (!(store.getState().homeCounters && store.getState().homeCounters.all)) {
              _context.next = 13;
              break;
            }

            makes = store.getState().homeCounters.all;
            _context.next = 15;
            break;

          case 13:
            _context.next = 15;
            return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.MAKES_COUNT + '?' + __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify({
              transport: CURRENT_TRANSPORT_ID
            })).then(function (r) {
              return r.ok && r.json();
            }).then(function (resp) {
              makes = resp;
              store.dispatch(__WEBPACK_IMPORTED_MODULE_2_shared_actions_homeSpecialCars__["a" /* setHomeCounters */]({ all: resp }));
            });

          case 15:
            _context.next = 17;
            return Promise.all([fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].JOURNAL.LIST({
              tag: tag,
              page: page,
              perPage: PER_PAGE,
              rubric: [currentRubric.slug],
              language: language
            })), fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].JOURNAL.TAGS({ rubric: currentRubric.slug, language: language })).then(function (r) {
              return r.json();
            }), fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].JOURNAL.VIDEO_TOPICS({ language: language })).then(function (r) {
              return r.json();
            })]);

          case 17:
            _ref3 = _context.sent;
            _ref4 = _slicedToArray(_ref3, 3);
            newsResponse = _ref4[0];
            tags = _ref4[1];
            videoTopics = _ref4[2];

            if (!(newsResponse.status === 404)) {
              _context.next = 24;
              break;
            }

            return _context.abrupt('return', null);

          case 24:
            _context.next = 26;
            return newsResponse.json();

          case 26:
            newsData = _context.sent;
            news = newsData.results;
            pageCount = Math.ceil(newsData.count / PER_PAGE);
            location = store.getState().globals.location;
            targetingArguments = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_adsAndMetrics__["a" /* getAdsContext */]({
              location: location,
              page: page,
              rubric: tag
            });

            store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_journal__["b" /* setJournalNews */](news));
            store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_journal__["e" /* setVideoTopics */](videoTopics || []));

            return _context.abrupt('return', {
              makes: makes,
              news: news,
              rubrics: rubrics,
              currentRubric: currentRubric,
              tags: tags,
              page: page,
              pageCount: pageCount,
              url: url,
              query: query,
              tag: tag,
              targetingArguments: targetingArguments
            });

          case 34:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function action(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var CURRENT_TRANSPORT_ID = 1;
var PER_PAGE = 19;

/* harmony default export */ var news_defaultExport = (action);
// CONCATENATED MODULE: ./src/desktop/routes/journal/components/SidebarFilters/SidebarFilters.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_TagList_TagList__ = __webpack_require__(2790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarFilters_css__ = __webpack_require__(3164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarFilters_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SidebarFilters_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var SidebarFilters__ref = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0424\u0438\u043B\u044C\u0442\u0440'
});

function SidebarFilters(props) {
  var tags = props.tags,
      activeTag = props.activeTag,
      url = props.url,
      query = props.query,
      currentRubric = props.currentRubric,
      intl = props.intl;


  if (!tags.length) {
    return null;
  }

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__SidebarFilters_css___default.a.root
  }, void 0, _jsx('h4', {
    className: __WEBPACK_IMPORTED_MODULE_5__SidebarFilters_css___default.a.title
  }, void 0, SidebarFilters__ref), _jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_TagList_TagList__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_5__SidebarFilters_css___default.a.list,
    max: 6,
    title: intl.formatMessage({ id: 'Основные темы' }),
    tags: tags,
    activeTag: activeTag,
    url: url,
    query: query,
    currentRubric: currentRubric
  }));
}

SidebarFilters.defaultProps = {
  activeTag: null
};


/* harmony default export */ var SidebarFilters_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__SidebarFilters_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](SidebarFilters)));
// CONCATENATED MODULE: ./src/desktop/routes/journal/NewsComponent/NewsComponent.js
/* harmony import */ var NewsComponent___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NewsComponent___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NewsComponent___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NewsComponent___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NewsComponent___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NewsComponent___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actions_journal__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_BannerAll__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_urlBuilder__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_components_NewsItem_NewsItem__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_desktop_components_Paginate_Paginate__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_desktop_components_MakesSidebar_MakesSidebar__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_NewsList_NewsList__ = __webpack_require__(2793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_VideoList_VideoList__ = __webpack_require__(2811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NewsComponent_css__ = __webpack_require__(3166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NewsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__NewsComponent_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var NewsComponent__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var NewsComponent__ref = NewsComponent__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_BannerAll__["b" /* DesktopButton */], {});

var _ref2 = NewsComponent__jsx(__WEBPACK_IMPORTED_MODULE_10_desktop_components_MakesSidebar_MakesSidebar__["a" /* default */], {});

var NewsComponent_NewsComponent = function (_React$Component) {
  _inherits(NewsComponent, _React$Component);

  function NewsComponent() {
    _classCallCheck(this, NewsComponent);

    return _possibleConstructorReturn(this, (NewsComponent.__proto__ || Object.getPrototypeOf(NewsComponent)).apply(this, arguments));
  }

  _createClass(NewsComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var selVideoParams = this.props.selVideoParams;

      if (selVideoParams) {
        this.props.getSelVideo(selVideoParams);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tags = _props.tags,
          tag = _props.tag,
          url = _props.url,
          query = _props.query,
          videoContent = _props.videoContent,
          pageCount = _props.pageCount,
          currentPage = _props.currentPage,
          currentRubric = _props.currentRubric,
          makes = _props.makes,
          journalNews = _props.journalNews,
          videoTopics = _props.videoTopics,
          getSelVideo = _props.getSelVideo,
          selVideoParams = _props.selVideoParams;

      var _journalNews = _toArray(journalNews),
          primaryItem = _journalNews[0],
          news = _journalNews.slice(1);

      var isVideo = currentRubric.slug === 'video';

      return NewsComponent__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__NewsComponent_css___default.a.page
      }, void 0, NewsComponent__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__NewsComponent_css___default.a.container
      }, void 0, NewsComponent__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__NewsComponent_css___default.a.flexRow
      }, void 0, NewsComponent__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__NewsComponent_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_14__NewsComponent_css___default.a.mainCell)
      }, void 0, !isVideo && NewsComponent___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_shared_components_NewsItem_NewsItem__["b" /* default */], _extends({}, primaryItem, {
        className: __WEBPACK_IMPORTED_MODULE_14__NewsComponent_css___default.a.primary,
        imgHeight: 370,
        isPrimary: true,
        link: __WEBPACK_IMPORTED_MODULE_7_shared_helpers_urlBuilder__["a" /* buildJournalItemUrl */](primaryItem.slug, tag)
      })), !isVideo && news.length > 0 && NewsComponent__jsx(__WEBPACK_IMPORTED_MODULE_12__components_NewsList_NewsList__["a" /* default */], {
        news: news,
        makes: makes,
        tag: tag,
        currentRubric: currentRubric
      }), isVideo && NewsComponent__jsx(__WEBPACK_IMPORTED_MODULE_13__components_VideoList_VideoList__["a" /* default */], {
        news: journalNews,
        makes: makes,
        tag: tag,
        videoContent: videoContent,
        currentRubric: currentRubric,
        videoTopics: videoTopics,
        getSelVideo: getSelVideo,
        selVideoParams: selVideoParams
      }), NewsComponent__ref, pageCount > 1 && NewsComponent__jsx(__WEBPACK_IMPORTED_MODULE_9_desktop_components_Paginate_Paginate__["a" /* default */], {
        pageCount: pageCount,
        initialPage: currentPage,
        query: query,
        url: url
      })), NewsComponent__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_BannerAll__["d" /* DesktopRightSidebar */], {
        scrollNo: true
      }, void 0, NewsComponent__jsx(NewsComponent___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, !isVideo && NewsComponent__jsx(SidebarFilters_defaultExport, {
        tags: tags,
        activeTag: tag,
        url: url,
        query: query,
        currentRubric: currentRubric
      }), _ref2)))));
    }
  }]);

  return NewsComponent;
}(NewsComponent___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NewsComponent_NewsComponent.defaultProps = {
  tag: null,
  videoContent: '',
  selVideoParams: null
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var globals = _ref3.globals;
  return {
    journalNews: globals.journal.news,
    videoTopics: globals.journal.videoTopics,
    selVideoParams: globals.journal.selVideoParams,
    videoContent: globals.journal.selVideoData
  };
};

var mapDispatchToProps = {
  getSelVideo: __WEBPACK_IMPORTED_MODULE_5_shared_actions_journal__["a" /* getVideoById */]
};

/* harmony default export */ var NewsComponent_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_14__NewsComponent_css___default.a)(NewsComponent_NewsComponent)));
// CONCATENATED MODULE: ./src/desktop/routes/journal/NewsComponent/index.js
/* harmony import */ var journal_NewsComponent___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var journal_NewsComponent___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(journal_NewsComponent___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_seoTitles__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_desktop_components_Layout__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_seoDescriptions__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_journal__ = __webpack_require__(2810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_helpers_common__ = __webpack_require__(184);
var journal_NewsComponent__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var NewsComponent_action = function () {
  var _ref = NewsComponent__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context) {
    var store, translate, data, makes, videoContent, tags, currentPage, pageCount, url, query, tag, targetingArguments, rubrics, currentRubric, title, description, isLastPage;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = context.store, translate = context.translate;
            _context.next = 3;
            return news_defaultExport(context);

          case 3:
            data = _context.sent;

            if (data) {
              _context.next = 6;
              break;
            }

            return _context.abrupt('return', null);

          case 6:
            makes = data.makes, videoContent = data.videoContent, tags = data.tags, currentPage = data.page, pageCount = data.pageCount, url = data.url, query = data.query, tag = data.tag, targetingArguments = data.targetingArguments, rubrics = data.rubrics, currentRubric = data.currentRubric;
            title = __WEBPACK_IMPORTED_MODULE_1_shared_constants_seoTitles__["a" /* default */].JOURNAL.NEWS(translate, __WEBPACK_IMPORTED_MODULE_7__shared_helpers_common__["h" /* getTitleOrEmpty */](currentRubric));
            description = __WEBPACK_IMPORTED_MODULE_5_shared_constants_seoDescriptions__["a" /* default */].JOURNAL.NEWS(translate, __WEBPACK_IMPORTED_MODULE_7__shared_helpers_common__["h" /* getTitleOrEmpty */](currentRubric));
            isLastPage = currentPage === pageCount;


            store.dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_globals__["C" /* setTargetingArguments */](targetingArguments));

            return _context.abrupt('return', {
              chunks: ['journal'],
              title: title,
              page: currentPage,
              isLastPage: isLastPage,
              description: description,
              component: journal_NewsComponent__jsx(__WEBPACK_IMPORTED_MODULE_2_desktop_components_Layout__["a" /* default */], {
                navLinks: __WEBPACK_IMPORTED_MODULE_6_shared_helpers_journal__["a" /* getRubricsNavigation */](rubrics),
                currentRoute: url,
                including: false,
                hideLocations: true
              }, void 0, journal_NewsComponent__jsx(NewsComponent_defaultExport, {
                tags: tags,
                videoContent: videoContent,
                makes: makes,
                currentPage: currentPage,
                pageCount: pageCount,
                url: url,
                query: query,
                tag: tag,
                currentRubric: currentRubric
              }))
            });

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function action(_x) {
    return _ref.apply(this, arguments);
  };
}();

function NewsComponent__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












/* harmony default export */ __webpack_exports__["default"] = (NewsComponent_action);

/***/ })

});


// WEBPACK FOOTER //
// 16-journal-d0d3f276.chunk.js